import React, { useState, useRef, useCallback } from "react";

// ─── Bibliothèque de détails constructifs ────────────────────────────────────
const DETAILS_LIBRARY = [
  // ─── Fabricants (Weber, Knauf, Soprema) ─────────────────────────────────
  {
    id: "knauf-1",
    title: "Jonction plancher bas / cloison",
    fabricant: "Knauf",
    systeme: "Cloison W111",
    categorie: "jonction_plancher",
    tags: ["plancher", "cloison", "bas", "dalle", "sol", "partition"],
    description: "Jonction entre plancher bas béton et cloison à ossature métallique. Profilé de sol fixé mécaniquement, montants au pas de 600mm, double plaque BA13.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Knauf+W111",
    source: "Knauf DTA 9/09-893",
    materiaux: ["Rails R48", "Montants M48", "BA13 Standard", "Laine minérale 45mm"],
    points_cles: ["Joint mousse sous profilé de sol", "Désolidarisation phonique obligatoire", "Hauteur max. 4,00m sans renfort"],
  },
  {
    id: "weber-ite-1",
    title: "Appui de fenêtre — ITE",
    fabricant: "Weber",
    systeme: "webertherm ITE",
    categorie: "jonction_menuiserie",
    tags: ["fenêtre", "appui", "ITE", "façade", "isolation", "menuiserie", "ouverture", "baie"],
    description: "Détail de raccord entre appui de fenêtre et système d'isolation thermique par l'extérieur. Bavette aluminium + profilé d'about + retour d'enduit.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Weber+ITE+Appui",
    source: "Weber Carnet de détails ITE — Menuiseries",
    materiaux: ["webertherm Classic", "Profilé appui départ", "Bavette alu laquée", "Cheville façade Ø8"],
    points_cles: ["Pente minimum 5% vers l'extérieur", "Retour d'enduit 2cm minimum", "Joint mousse comprimé côté menuiserie"],
  },
  {
    id: "soprema-1",
    title: "Relevé d'étanchéité — Acrotère",
    fabricant: "Soprema",
    systeme: "Sopralène Flam 180",
    categorie: "toiture",
    tags: ["toiture", "terrasse", "acrotère", "étanchéité", "relevé", "membrane", "toit plat"],
    description: "Relevé d'étanchéité bitumineuse sur acrotère béton. Membrane SBS thermosoudée, protection aluminium, couvertine métallique.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Soprema+Acrotère",
    source: "Soprema ATec 5/18-2456",
    materiaux: ["Sopralène Flam 180 S5", "EIF aluminium", "Soprasolin", "Couvertine inox"],
    points_cles: ["Hauteur relevé minimum 100mm au-dessus du complexe d'étanchéité", "Fixation mécanique basse obligatoire", "Pontage d'angle sur couvre-joint"],
  },
  {
    id: "weber-ite-2",
    title: "Soubassement — ITE",
    fabricant: "Weber",
    systeme: "webertherm ITE",
    categorie: "soubassement",
    tags: ["soubassement", "ITE", "plinthe", "façade", "fondation", "socle", "rez-de-chaussée"],
    description: "Traitement du soubassement en isolation par l'extérieur. Profil de départ + isolant haute densité + enduit hydraulique.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Weber+ITE+Soubassement",
    source: "Weber Carnet de détails ITE — Soubassements",
    materiaux: ["webertherm EPS 032", "Profilé de départ", "Enduit weber.pral", "Grillage anti-rongeur"],
    points_cles: ["Isolant hydrophobé obligatoire sous 30cm du sol fini", "Drain périphérique recommandé", "Protection mécanique H=50cm minimum"],
  },
  {
    id: "knauf-2",
    title: "Jonction toiture / mur pignon",
    fabricant: "Knauf",
    systeme: "Plafond D112",
    categorie: "jonction_toiture",
    tags: ["toiture", "pignon", "rampant", "comble", "plafond", "charpente", "toit pentu"],
    description: "Doublage sous rampant et traitement du nœud de jonction mur pignon en comble aménagé. Continuité du pare-vapeur obligatoire.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Knauf+D112",
    source: "Knauf DTA combles aménagés",
    materiaux: ["Ossature M48 cintrable", "BA13 H3", "Pare-vapeur Vario KM Duplex", "Laine de verre 200mm"],
    points_cles: ["Continuité pare-vapeur absolue au nœud", "Ventilation lame d'air 30mm minimum", "Fixation chevrons tous les 600mm"],
  },
  {
    id: "soprema-2",
    title: "Toiture-terrasse — Nœud de trop-plein",
    fabricant: "Soprema",
    systeme: "Soprasolin + Sopralène",
    categorie: "toiture",
    tags: ["toiture", "terrasse", "évacuation", "trop-plein", "eau", "drainage", "EP"],
    description: "Détail d'évacuation des eaux pluviales en toiture-terrasse inaccessible. Bondes à collier + pontage membrane + grille de protection.",
    thumbnail: "https://placehold.co/400x300/1a1a1a/666666?text=Soprema+Trop-plein",
    source: "Soprema Guide Conception Toitures-Terrasses",
    materiaux: ["Bonde à collier Ø 125", "Sopralène Flam 180", "Soprasolin 40", "Grille anti-feuilles inox"],
    points_cles: ["Pontage de la bonde sur 20cm minimum", "Pente minimum 1% vers bonde", "Trop-plein de sécurité obligatoire Standards 43.1"],
  }, ,

  // ─── Detail Magazine (289 entrees, 78 projets) ───────────────────────────
  {
    "id": "detail-2001-tokyo-01",
    "title": "Structure poteau aluminium avec noyau cruciforme stabilisateur",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature aluminium extrudé - système poteaux-poutres",
    "categorie": "structure",
    "tags": [
      "aluminium",
      "poteau",
      "section creuse carrée",
      "noyau cruciforme",
      "ossature métallique",
      "profil extrudé",
      "structure légère",
      "squelette aluminium",
      "trame 3600",
      "section minimale"
    ],
    "description": "Système de poteaux en tube aluminium carré de 70/70/2 mm avec noyau cruciforme intérieur assurant la stabilisation. La trame structurelle est de 3,6 x 3,6 m avec 1,8 m en périphérie. Les poutres en profil Å extrudé de 146/70/6 mm sont disposées tous les 300 mm pour former un gril de plancher assurant le contreventement horizontal de l'édifice.",
    "thumbnail": "/images/thumb-toyo-ito.jpg",
    "source": "Detail Magazine n4/2001 - Wohnhaus in Sakurajosui, Toyo Ito & Associates",
    "materiaux": [
      "tube aluminium carré 70/70/2 mm",
      "profil aluminium Å 146/70/6 mm",
      "profil aluminium C 146/70/8 mm",
      "noyau cruciforme aluminium"
    ],
    "points_cles": [
      "Section de poteau extrêmement réduite de 70x70 mm grâce au noyau cruciforme stabilisateur inséré dans le profil rectangulaire",
      "Gril de plancher en profilés Å espacés de 300 mm assurant le contreventement horizontal",
      "Trame régulière de 3600 mm avec demi-trame de 1800 mm en rive"
    ]
  },
  {
    "id": "detail-2001-tokyo-02",
    "title": "Jonction plancher-façade avec habillage aluminium et isolation",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher sur gril aluminium avec façade rapportée en tôle",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "aluminium",
      "parquet",
      "panneau bois",
      "lattage",
      "isolation thermique",
      "gipskarton",
      "plaque de plâtre",
      "tôle aluminium",
      "façade ventilée",
      "appui caoutchouc"
    ],
    "description": "Plancher composé de parquet 15 mm sur panneau dérivé du bois 12 mm et lattage 30/30 mm, reposant sur le gril de profilés aluminium Å. La façade est revêtue de tôle aluminium 4 mm posée sur appuis en caoutchouc. L'isolation thermique de 30 mm est doublée intérieurement par une plaque de plâtre de 10 mm.",
    "thumbnail": "/images/thumb-toyo-ito.jpg",
    "source": "Detail Magazine n4/2001 - Wohnhaus in Sakurajosui, Toyo Ito & Associates",
    "materiaux": [
      "parquet 15 mm",
      "panneau bois reconstitué 12 mm",
      "lattage 30/30 mm",
      "profil aluminium Å 146/70/6 mm",
      "profil aluminium C 146/70/8 mm",
      "tôle aluminium 4 mm",
      "isolation thermique 30 mm",
      "plaque de plâtre 10 mm",
      "appuis caoutchouc"
    ],
    "points_cles": [
      "Superposition parquet 15 mm / panneau bois 12 mm / lattage 30/30 mm sur gril de profilés aluminium",
      "Tôle aluminium 4 mm de façade posée sur appuis caoutchouc pour découplage acoustique et tolérance",
      "Isolation thermique limitée à 30 mm doublée de plaque de plâtre 10 mm côté intérieur"
    ]
  },
  {
    "id": "detail-2001-tokyo-03",
    "title": "Jonction menuiserie coulissante aluminium et bois en façade aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiseries coulissantes mixtes aluminium/bois en ossature aluminium",
    "categorie": "jonction_menuiserie",
    "tags": [
      "porte coulissante",
      "schiebetür",
      "aluminium",
      "épicéa",
      "vitrage trempé",
      "ESG",
      "menuiserie bois",
      "menuiserie aluminium",
      "fenêtre",
      "châssis",
      "verre securit",
      "façade légère"
    ],
    "description": "Système de menuiseries coulissantes intégrées à l'ossature aluminium comprenant des portes coulissantes aluminium de 20 mm et des portes coulissantes en épicéa de 32 mm, toutes équipées de vitrage trempé ESG 6 mm. Les fenêtres fixes en châssis aluminium de 20 mm complètent le dispositif. La transition entre façade opaque en tôle aluminium 4 mm et parties vitrées est assurée par un bandeau en tôle aluminium 4 mm.",
    "thumbnail": "/images/thumb-toyo-ito.jpg",
    "source": "Detail Magazine n4/2001 - Wohnhaus in Sakurajosui, Toyo Ito & Associates",
    "materiaux": [
      "porte coulissante aluminium 20 mm",
      "porte coulissante épicéa 32 mm",
      "vitrage trempé ESG 6 mm",
      "châssis aluminium 20 mm",
      "bandeau tôle aluminium 4 mm"
    ],
    "points_cles": [
      "Double système de portes coulissantes : aluminium 20 mm extérieur et épicéa 32 mm intérieur, toutes avec vitrage trempé 6 mm",
      "Contraste matériau entre aluminium extérieur et bois intérieur reflétant le concept architectural global",
      "Bandeau de raccord en tôle aluminium 4 mm assurant la transition entre parties opaques et vitrées"
    ]
  },
  {
    "id": "detail-2001-tokyo-04",
    "title": "Toiture-terrasse avec dallage béton sur structure aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture-terrasse accessible sur gril de profilés aluminium",
    "categorie": "toiture",
    "tags": [
      "toiture terrasse",
      "dalle béton",
      "terrasse accessible",
      "aluminium",
      "profil extrudé",
      "étanchéité",
      "plat aluminium",
      "dallage",
      "toit plat",
      "roof terrace"
    ],
    "description": "Toiture-terrasse accessible composée de dalles béton de 30 mm posées sur la structure de profilés aluminium Å 96/70/6 mm et C 96/70/8 mm. Un plat aluminium 150/15 mm assure le raccord en rive. La tôle aluminium 4 mm sur appuis caoutchouc forme le relevé d'acrotère et la continuité de l'enveloppe avec les profilés de rive Å 146/70/6 mm et C 146/70/8 mm.",
    "thumbnail": "/images/thumb-toyo-ito.jpg",
    "source": "Detail Magazine n4/2001 - Wohnhaus in Sakurajosui, Toyo Ito & Associates",
    "materiaux": [
      "dalles béton 30 mm",
      "profil aluminium Å 96/70/6 mm",
      "profil aluminium C 96/70/8 mm",
      "plat aluminium 150/15 mm",
      "profil aluminium Å 146/70/6 mm",
      "profil aluminium C 146/70/8 mm",
      "tôle aluminium 4 mm",
      "barre aluminium 10/10 mm",
      "appuis caoutchouc"
    ],
    "points_cles": [
      "Dalles béton 30 mm comme revêtement de terrasse accessible sur structure aluminium légère",
      "Profilés de toiture de section réduite Å 96/70/6 mm distincts des profilés de plancher courant Å 146/70/6 mm",
      "Plat aluminium 150/15 mm en rive assurant la liaison structurelle et le support du relevé en tôle aluminium"
    ]
  },
  {
    "id": "detail-2003-kobe-01",
    "title": "Toiture en panneaux composites acier galvanisé avec isolation",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture en bacs acier trapézoïdaux avec isolation thermique intégrée",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "bac acier",
      "trapézoïdal",
      "acier galvanisé",
      "isolation thermique",
      "plaque de plâtre",
      "profilés légers",
      "couverture métallique",
      "toiture chaude",
      "Japon"
    ],
    "description": "Élément de toiture composite constitué d'un double bac acier trapézoïdal galvanisé de 0,5 mm enserrant 100 mm d'isolation thermique, avec pente intégrée au bac inférieur. Le plafond intérieur est réalisé en plaques de plâtre de 12,5 mm peintes, fixées sur une sous-structure en profilés métalliques légers.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Toiture",
    "source": "Detail Magazine n1-2/2003 - House in Kobe, Toshiaki Kawai",
    "materiaux": [
      "bac acier trapézoïdal galvanisé 0,5 mm",
      "isolation thermique 100 mm",
      "plaque de plâtre 12,5 mm",
      "profilés métalliques légers"
    ],
    "points_cles": [
      "Double peau en bac acier trapézoïdal galvanisé avec isolation prise en sandwich",
      "Pente assurée par le bac inférieur pour l'évacuation des eaux",
      "Finition intérieure en plaque de plâtre peinte sur sous-structure métallique légère"
    ]
  },
  {
    "id": "detail-2003-kobe-02",
    "title": "Paroi de façade en tôle acier galvanisé peinte avec isolation et doublage intérieur",
    "fabricant": "Detail Magazine",
    "systeme": "Façade en tôle profilée galvanisée avec complexe isolant et parement intérieur",
    "categorie": "facade",
    "tags": [
      "façade",
      "tôle acier",
      "galvanisé",
      "peint",
      "rouge-brun",
      "isolation",
      "étanchéité bitume",
      "panneau bois",
      "plaque de plâtre",
      "profilés légers",
      "Japon",
      "résidentiel"
    ],
    "description": "Paroi de façade composée d'un parement extérieur en tôle profilée galvanisée de 0,4 mm peinte en rouge-brun, doublée d'une étanchéité bitumineuse, d'un panneau de bois reconstitué de 25 mm, d'une sous-structure en profilés métalliques légers intégrant 70 mm d'isolation thermique, et d'une finition intérieure en plaque de plâtre peinte de 12,5 mm. Ce système assure à la fois l'étanchéité à l'eau, l'isolation et la finition.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Facade",
    "source": "Detail Magazine n1-2/2003 - House in Kobe, Toshiaki Kawai",
    "materiaux": [
      "tôle profilée acier galvanisé peinte 0,4 mm",
      "étanchéité bitumineuse",
      "panneau bois reconstitué 25 mm",
      "profilés métalliques légers",
      "isolation thermique 70 mm",
      "plaque de plâtre 12,5 mm"
    ],
    "points_cles": [
      "Parement extérieur en tôle galvanisée peinte rouge-brun assurant la protection aux intempéries",
      "Étanchéité bitumineuse derrière le parement métallique comme seconde barrière",
      "Complexe isolant de 70 mm dans la sous-structure métallique avec finition plâtre intérieure"
    ]
  },
  {
    "id": "detail-2003-kobe-03",
    "title": "Escalier en structure acier avec marches en bois magashiro et cage vitrée en verre armé",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier sur structure acier avec marches bois et enveloppe en verre armé",
    "categorie": "structure",
    "tags": [
      "escalier",
      "structure acier",
      "tube acier",
      "profil T",
      "marches bois",
      "magashiro",
      "verre armé",
      "cage d'escalier",
      "tour escalier",
      "transparence",
      "Japon"
    ],
    "description": "Escalier intérieur structuré par des tubes acier carrés de 100x100x5 mm et des profils en T de 50x50x5/7 mm, recevant des marches en bois magashiro de 20 mm. La cage d'escalier est largement vitrée en verre armé à trame fine, créant une transparence qui révèle la structure complexe du bâtiment et assure les liaisons visuelles entre les niveaux et les espaces extérieurs.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Escalier",
    "source": "Detail Magazine n1-2/2003 - House in Kobe, Toshiaki Kawai",
    "materiaux": [
      "tube acier carré 100x100x5 mm",
      "profil T acier 50x50x5/7 mm",
      "marches bois magashiro 20 mm",
      "verre armé"
    ],
    "points_cles": [
      "Structure porteuse en tubes acier carrés SHS et profils T acier soudés",
      "Marches en bois magashiro de 20 mm pour une finition chaleureuse contrastant avec l'acier",
      "Cage d'escalier vitrée en verre armé à trame fine assurant transparence et liaisons visuelles"
    ]
  },
  {
    "id": "detail-2003-kobe-04",
    "title": "Jonction intérieur-extérieur avec sol en gravier lié au mortier et plancher bois",
    "fabricant": "Detail Magazine",
    "systeme": "Transition intérieur-extérieur par revêtement de sol continu gravier-mortier et platelage bois",
    "categorie": "jonction_plancher",
    "tags": [
      "sol",
      "gravier",
      "mortier",
      "transition intérieur extérieur",
      "terrasse",
      "platelage bois",
      "bois imprégné",
      "cèdre",
      "seuil",
      "continuité",
      "Japon",
      "traditionnel",
      "moderne"
    ],
    "description": "Traitement du sol assurant une transition fluide entre intérieur et extérieur, caractéristique de l'architecture japonaise contemporaine. Le revêtement en gravier lié au mortier est utilisé de manière continue à l'entrée et dans les espaces ouverts des étages supérieurs, tandis que les terrasses reçoivent un platelage en lames de bois imprégnées de 20 mm. À l'intérieur, les sols sont en lames de cèdre cirées de 19 mm, créant un enchaînement de matériaux naturels.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Jonction+Sol",
    "source": "Detail Magazine n1-2/2003 - House in Kobe, Toshiaki Kawai",
    "materiaux": [
      "gravier lié au mortier",
      "lames de bois imprégnées 20 mm",
      "lames de cèdre cirées 19 mm",
      "panneau fibre tendre revêtu 6 mm"
    ],
    "points_cles": [
      "Revêtement continu en gravier lié au mortier effaçant la limite entre intérieur et extérieur",
      "Platelage extérieur en bois imprégné de 20 mm prolongeant les sols intérieurs sur les terrasses",
      "Interprétation moderne du seuil traditionnel japonais par la continuité des matériaux"
    ]
  },
  {
    "id": "detail-2003-fukuoka-01",
    "title": "Façade en profilés de verre (Profilbauglas) avec verre armé intérieur",
    "fabricant": "Detail Magazine",
    "systeme": "Façade translucide en verre profilé U sur structure béton précontraint",
    "categorie": "facade",
    "tags": [
      "profilbauglas",
      "verre profilé",
      "verre armé",
      "façade translucide",
      "lumière diffuse",
      "shoji",
      "béton précontraint",
      "fertigteile",
      "préfabriqué",
      "japon",
      "fukuoka",
      "luminare",
      "U-glass"
    ],
    "description": "Façade composée de profilés de verre en U de 70 mm d'épaisseur avec verre armé côté intérieur, fixée sur une structure de poteaux préfabriqués en béton précontraint de section 160x160 mm à profil en H rainuré. Cette double peau de verre crée une lumière diffuse comparable aux écrans traditionnels japonais en papier Shoji, donnant son nom 'Luminare' à l'école de mode.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Facade",
    "source": "Detail Magazine n4/2003 - Fashion Centre Fukuoka, Takamatsu Architects and Associates",
    "materiaux": [
      "profilé de verre en U 70 mm",
      "verre armé (Drahtglas)",
      "poteaux béton précontraint préfabriqué 160x160 mm",
      "panneau aluminium isolé 80 mm"
    ],
    "points_cles": [
      "Profilés de verre en U de 70 mm créant une lumière diffuse inspirée des Shoji traditionnels",
      "Poteaux préfabriqués en béton précontraint à section H rainurée de 160x160 mm servant de montants de façade",
      "Verre armé posé côté intérieur en complément des profilés de verre pour assurer sécurité et isolation"
    ]
  },
  {
    "id": "detail-2003-fukuoka-02",
    "title": "Toiture sur dalles préfabriquées en béton précontraint",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture béton léger sur dalles Filigran préfabriquées",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "béton léger",
      "étanchéité bitumineuse",
      "filigrandecke",
      "dalle préfabriquée",
      "béton précontraint",
      "toiture plate",
      "leichtbeton",
      "japon",
      "fukuoka"
    ],
    "description": "Complexe de toiture composé de 80 mm de béton léger en forme de pente posé sur une étanchéité en membrane bitumineuse, le tout reposant sur des dalles Filigran en béton armé préfabriqué de 160 mm d'épaisseur. La structure porteuse est constituée de poutres préfabriquées en béton précontraint de 200x500 mm assemblées par post-tension avec câbles de précontrainte.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Toiture",
    "source": "Detail Magazine n4/2003 - Fashion Centre Fukuoka, Takamatsu Architects and Associates",
    "materiaux": [
      "béton léger 80 mm",
      "membrane bitumineuse d'étanchéité",
      "dalle Filigran béton armé 160 mm",
      "poutres béton précontraint 200x500 mm"
    ],
    "points_cles": [
      "Béton léger de 80 mm en couche de forme et protection sur l'étanchéité bitumineuse",
      "Dalles Filigran préfabriquées en béton armé de 160 mm comme support structurel de toiture",
      "Poutres préfabriquées précontraintes de 200x500 mm assemblées par post-tension pour la stabilité sismique"
    ]
  },
  {
    "id": "detail-2003-fukuoka-03",
    "title": "Jonction plancher courant - structure précontrainte préfabriquée",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher en dalles Filigran sur ossature béton précontraint préfabriqué",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "dalle filigran",
      "béton précontraint",
      "préfabriqué",
      "fertigteile",
      "assemblage",
      "post-tension",
      "câbles de précontrainte",
      "spannbeton",
      "poteaux",
      "poutres",
      "japon",
      "fukuoka",
      "construction sèche"
    ],
    "description": "Système de plancher constitué de dalles Filigran en béton armé de 160 mm revêtues d'un coating, portant sur des poutres préfabriquées en béton précontraint de 200x500 mm doubles (2x200x500 mm). Les poutres sont assemblées aux poteaux de section H 160x160 mm par des câbles de précontrainte verticaux, avec fixation provisoire par équerres métalliques pendant le montage. Ce système s'inspire directement des techniques d'assemblage du charpentier japonais traditionnel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Plancher",
    "source": "Detail Magazine n4/2003 - Fashion Centre Fukuoka, Takamatsu Architects and Associates",
    "materiaux": [
      "dalle Filigran béton armé 160 mm",
      "poutres béton précontraint 2x200x500 mm",
      "poteaux béton précontraint H 160x160 mm",
      "câbles de précontrainte (Spannstähle)",
      "équerres métalliques provisoires"
    ],
    "points_cles": [
      "Double poutre préfabriquée précontrainte 2x200x500 mm assemblée par post-tension verticale dans les poteaux",
      "Fixation provisoire des éléments préfabriqués par équerres en acier (Winkeleisen) pendant le montage avant mise en tension",
      "Technique d'assemblage inspirée de la charpenterie traditionnelle japonaise des temples et sanctuaires"
    ]
  },
  {
    "id": "detail-2003-fukuoka-04",
    "title": "Soubassement et plancher bas sur radier épais - cour intérieure",
    "fabricant": "Detail Magazine",
    "systeme": "Radier béton armé épais avec plancher pierre naturelle et drainage de cour",
    "categorie": "soubassement",
    "tags": [
      "soubassement",
      "radier",
      "dalle de fondation",
      "pierre naturelle",
      "drainage",
      "cour intérieure",
      "innenhof",
      "sous-sol",
      "gaine technique",
      "grille caillebotis",
      "garde-corps inox",
      "japon",
      "fukuoka"
    ],
    "description": "Plancher bas du sous-sol constitué d'un radier en béton armé de 850 mm d'épaisseur surmonté d'un caniveau technique de 50 mm, d'une dalle béton armé de 140 mm et d'un revêtement en pierre naturelle de 22 mm posé sur lit de mortier. La cour intérieure est équipée d'un drainage diamètre 120 mm, d'un caillebotis de 30 mm et d'un garde-corps en tubes ronds inox diamètre 80 mm, le mur extérieur étant en béton armé de 280 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Soubassement",
    "source": "Detail Magazine n4/2003 - Fashion Centre Fukuoka, Takamatsu Architects and Associates",
    "materiaux": [
      "béton armé radier 850 mm",
      "béton armé dalle 140 mm",
      "pierre naturelle 22 mm sur mortier",
      "caniveau technique 50 mm",
      "mur béton armé 280 mm",
      "caillebotis 30 mm",
      "garde-corps tubes inox Ø80 mm",
      "drainage Ø120 mm"
    ],
    "points_cles": [
      "Radier massif de 850 mm d'épaisseur en béton armé dimensionné pour la résistance sismique japonaise",
      "Plancher bas multicouche avec gaine technique intégrée de 50 mm entre radier et dalle de finition",
      "Cour intérieure drainée (Ø120 mm) avec caillebotis 30 mm et garde-corps inox, créant espace et lumière dans un contexte urbain dense"
    ]
  },
  {
    "id": "detail-2003-tokyo-01",
    "title": "Sitzstufen / Gradins intérieurs - Espace convivialité étage Famille",
    "fabricant": "Detail Magazine",
    "systeme": "Structure acier avec parement bois massif hêtre - mobilier architectural intégré",
    "categorie": "amenagement_interieur",
    "tags": [
      "gradins",
      "sitzstufen",
      "stepped seating",
      "hêtre",
      "beech",
      "parquet",
      "acier",
      "steel",
      "mobilier intégré",
      "aménagement intérieur",
      "bureau",
      "espace convivialité",
      "chat space",
      "estrade",
      "tribune",
      "assises"
    ],
    "description": "Gradins intérieurs formant assises en tribune pour espace de rencontre informelle. Structure en profilés acier tubulaires carrés 50/50/2 mm recouverts de tôle acier 2,3 mm et 6 mm, avec finition en parquet hêtre massif 12 mm sur double couche de contreplaqué 2x12 mm. Les marches sont bordées d'un plat inox de 3 mm en nez de marche.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Gradins+Interieurs",
    "source": "Detail Magazine n5/2003 - Werbeagentur in Tokio, Klein Dytham architecture",
    "materiaux": [
      "parquet hêtre massif 12 mm",
      "contreplaqué 2x12 mm",
      "plat inox 3 mm",
      "profilé acier tubulaire carré 50/50/2 mm",
      "tôle acier 2,3 mm",
      "tôle acier 6 mm",
      "profilé acier tubulaire carré 25/25/1,6 mm",
      "tôle acier 1,6 mm",
      "boulons M10"
    ],
    "points_cles": [
      "Structure primaire en profilés acier SHS 50/50/2 mm formant ossature des gradins",
      "Revêtement des assises en parquet hêtre 12 mm sur double contreplaqué pour rigidité et confort",
      "Nez de marche en plat inox 3 mm assurant protection et finition soignée"
    ]
  },
  {
    "id": "detail-2003-tokyo-02",
    "title": "Bande sinueuse multifonctionnelle - Parement acier étage Hommes",
    "fabricant": "Detail Magazine",
    "systeme": "Élément ruban continu en tôle acier sur ossature tubulaire - plafond, paroi et estrade",
    "categorie": "amenagement_interieur",
    "tags": [
      "bande",
      "ruban",
      "strip",
      "acier",
      "steel",
      "tôle",
      "sheet steel",
      "plafond",
      "paroi",
      "bureau",
      "aménagement intérieur",
      "curving strip",
      "cloison",
      "faux-plafond",
      "multifonctionnel",
      "hommes"
    ],
    "description": "Élément architectural continu en forme de ruban sinueux qui se transforme tour à tour en plafond, en paroi murale et en estrade scénique. Sur l'étage dédié aux hommes, le parement est réalisé en tôle d'acier 1,6 mm fixée sur ossature de profilés tubulaires carrés 25/25/1,6 mm, avec assemblages par boulons M10. Cette bande définit spatialement la zone intermédiaire entre les postes de travail en façade et le noyau central.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Bande+Acier",
    "source": "Detail Magazine n5/2003 - Werbeagentur in Tokio, Klein Dytham architecture",
    "materiaux": [
      "tôle acier 1,6 mm",
      "profilé acier tubulaire carré 25/25/1,6 mm",
      "tôle acier 6 mm",
      "boulons M10"
    ],
    "points_cles": [
      "Ruban continu jouant alternativement le rôle de plafond, de cloison et de plancher surélevé",
      "Ossature secondaire en SHS acier 25/25/1,6 mm permettant le cintrage et les courbes du ruban",
      "Assemblages démontables par boulonnage M10 facilitant adaptations futures"
    ]
  },
  {
    "id": "detail-2003-tokyo-03",
    "title": "Bande sinueuse multifonctionnelle - Parement bois hêtre étage Famille",
    "fabricant": "Detail Magazine",
    "systeme": "Élément ruban continu en placage hêtre sur ossature acier - plafond, paroi et estrade",
    "categorie": "amenagement_interieur",
    "tags": [
      "bande",
      "ruban",
      "strip",
      "bois",
      "hêtre",
      "beech",
      "placage",
      "veneer",
      "furnier",
      "parquet",
      "plafond",
      "paroi",
      "bureau",
      "famille",
      "family",
      "aménagement intérieur",
      "curving strip"
    ],
    "description": "Variante bois de l'élément ruban sur l'étage thématique Famille. L'ossature en profilés acier tubulaires 25/25/1,6 mm et tôle acier 2,3 mm est revêtue d'un placage hêtre de 2 mm en parties verticales et plafond, tandis que les surfaces horizontales praticables reçoivent un parquet hêtre massif 12 mm sur double contreplaqué. Des lames de hêtre massif 100/20 mm complètent le dispositif en zones de transition.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Bande+Bois+Hetre",
    "source": "Detail Magazine n5/2003 - Werbeagentur in Tokio, Klein Dytham architecture",
    "materiaux": [
      "placage hêtre 2 mm",
      "parquet hêtre massif 12 mm",
      "lames hêtre massif 100/20 mm",
      "contreplaqué 2x12 mm",
      "tôle acier 2,3 mm",
      "tôle acier 1,6 mm",
      "profilé acier tubulaire carré 25/25/1,6 mm",
      "plat inox 3 mm",
      "boulons M10"
    ],
    "points_cles": [
      "Placage hêtre 2 mm sur tôle acier 2,3 mm pour les surfaces courbes non praticables du ruban",
      "Parquet hêtre massif 12 mm sur double contreplaqué 2x12 mm pour les surfaces praticables et gradins",
      "Lames hêtre 100/20 mm en éléments de transition entre surfaces horizontales et verticales"
    ]
  },
  {
    "id": "detail-2003-tokyo-04",
    "title": "Bande sinueuse multifonctionnelle - Revêtement PVC rose peau de serpent étage Femmes",
    "fabricant": "Detail Magazine",
    "systeme": "Élément ruban continu en PVC décoratif sur ossature acier - plafond, paroi et estrade",
    "categorie": "amenagement_interieur",
    "tags": [
      "bande",
      "ruban",
      "strip",
      "PVC",
      "rose",
      "pink",
      "snakeskin",
      "peau de serpent",
      "Schlangenleder",
      "revêtement souple",
      "plafond",
      "paroi",
      "bureau",
      "femmes",
      "women",
      "aménagement intérieur",
      "curving strip",
      "décoration"
    ],
    "description": "Variante décorative de l'élément ruban sur l'étage thématique Femmes. L'ossature acier identique aux autres niveaux (SHS 25/25/1,6 mm et tôle acier) est revêtue d'un PVC souple de 2 mm en finition rose imitation peau de serpent. Ce traitement de surface uniforme sur l'ensemble du ruban - plafond, parois et sol de l'estrade - crée une identité visuelle forte intégrant un salon de coiffure et un institut de beauté dans le programme fonctionnel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Bande+PVC+Rose",
    "source": "Detail Magazine n5/2003 - Werbeagentur in Tokio, Klein Dytham architecture",
    "materiaux": [
      "revêtement PVC 2 mm imitation peau de serpent rose",
      "tôle acier 2,3 mm",
      "tôle acier 1,6 mm",
      "profilé acier tubulaire carré 25/25/1,6 mm",
      "profilé acier tubulaire carré 50/50/2 mm",
      "tôle acier 6 mm",
      "boulons M10"
    ],
    "points_cles": [
      "Revêtement PVC souple 2 mm permettant l'application sur surfaces courbes complexes du ruban",
      "Finition décorative imitation peau de serpent rose définissant l'identité thématique de l'étage Femmes",
      "Même ossature acier standardisée que les autres étages, seul le parement de surface change selon la thématique"
    ]
  },
  {
    "id": "detail-2003-hagi-01",
    "title": "Toiture végétalisée extensive sur dalle béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée extensive sur structure béton avec couvertine inox",
    "categorie": "toiture",
    "tags": [
      "toiture vegetalisee",
      "extensive",
      "beton arme",
      "bitume",
      "isolation thermique",
      "substrat",
      "couvertine inox",
      "acier inoxydable",
      "toit plat",
      "begrünung"
    ],
    "description": "Toiture plate végétalisée extensive composée d'une dalle béton armé de 250 mm, d'une isolation thermique de 30 mm, d'une étanchéité bitumineuse de 2 mm et d'un substrat de 50 mm pour plantation extensive. L'acrotère est coiffé d'une couvertine en tôle d'acier inoxydable de 6 mm. Ce système léger de végétalisation contribue à l'intégration paysagère du bâtiment dans le site de la manufacture céramique.",
    "thumbnail": "/images/thumb-hagi.jpg",
    "source": "Detail Magazine n6/2003 - Store and Studio in Hagi, Sambuichi Architects",
    "materiaux": [
      "béton armé 250mm",
      "isolation thermique 30mm",
      "étanchéité bitumineuse 2mm",
      "substrat 50mm",
      "tôle acier inoxydable 6mm",
      "végétalisation extensive"
    ],
    "points_cles": [
      "Dalle béton armé de 250 mm servant de support structurel à la toiture",
      "Couvertine en acier inoxydable massif de 6 mm d'épaisseur en rive de toiture",
      "Composition simplifiée avec seulement 30 mm d'isolation et substrat léger de 50 mm pour végétalisation extensive"
    ]
  },
  {
    "id": "detail-2003-hagi-02",
    "title": "Volets pivotants en coffrage bois de cèdre recyclé sur façade béton",
    "fabricant": "Detail Magazine",
    "systeme": "Panneaux de coffrage béton réemployés comme volets pivotants toute hauteur",
    "categorie": "jonction_menuiserie",
    "tags": [
      "volet pivotant",
      "coffrage reutilise",
      "cedre",
      "bois",
      "reemploi",
      "recyclage",
      "facade beton",
      "klappladen",
      "charniere inox",
      "economie circulaire",
      "menuiserie bois"
    ],
    "description": "Les panneaux de coffrage extérieur en lattes de cèdre, utilisés pour le coulage des murs en béton armé, sont directement réemployés comme volets pivotants toute hauteur devant les ouvertures. Chaque volet est composé de deux couches de planches de cèdre de 12 mm séparées par des tasseaux de 50x30 mm, fixés par des paumelles invisibles en acier inoxydable. La surface du béton conserve l'empreinte négative du veinage du bois, créant une correspondance visuelle entre les deux matériaux.",
    "thumbnail": "/images/thumb-hagi.jpg",
    "source": "Detail Magazine n6/2003 - Store and Studio in Hagi, Sambuichi Architects",
    "materiaux": [
      "planches de cèdre 12mm",
      "tasseaux bois 50x30mm",
      "charnières acier inoxydable",
      "béton armé brut de décoffrage"
    ],
    "points_cles": [
      "Réemploi direct des panneaux de coffrage extérieur comme volets pivotants sans transformation majeure",
      "Dimensionnement calculé dès la conception pour que la surface de coffrage extérieur corresponde exactement à la surface des ouvertures",
      "Double parement de planches de cèdre de 12 mm sur ossature de tasseaux 50x30 mm avec paumelles invisibles en inox"
    ]
  },
  {
    "id": "detail-2003-hagi-03",
    "title": "Plancher sur dalle béton avec revêtement en coffrage de cèdre réemployé",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher surélevé en panneaux de coffrage de plafond réemployés sur dalle béton armé",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "coffrage reutilise",
      "cedre",
      "reemploi",
      "dalle beton",
      "plancher sureleve",
      "lambourde",
      "economie circulaire",
      "bodenaufbau",
      "recyclage coffrage"
    ],
    "description": "Les panneaux de coffrage utilisés pour le coulage de la dalle de plafond de l'étage supérieur sont réemployés comme revêtement de sol. Le système se compose de planches de cèdre de 12 mm posées sur des lambourdes de 50x30 mm, elles-mêmes portées par des solives en bois massif de 105x45 mm et 100x40 mm formant seuil, le tout reposant sur la dalle béton armé de 250 mm. Ce principe de réemploi intégral du coffrage constitue le concept fondamental du projet.",
    "thumbnail": "/images/thumb-hagi.jpg",
    "source": "Detail Magazine n6/2003 - Store and Studio in Hagi, Sambuichi Architects",
    "materiaux": [
      "planches de cèdre 12mm",
      "lambourdes bois 50x30mm",
      "solives bois 105x45mm",
      "solives bois 100x40mm",
      "béton armé 250mm"
    ],
    "points_cles": [
      "Réemploi des panneaux de coffrage de la dalle de plafond comme revêtement de sol fini de l'étage",
      "Structure sèche sur lambourdes et solives en bois massif posée sur dalle béton armé de 250 mm",
      "Cohérence visuelle entre le relief positif du plancher bois et l'empreinte négative sur le plafond béton"
    ]
  },
  {
    "id": "detail-2003-hagi-04",
    "title": "Soubassement avec dallage béton sur terre-plein isolé",
    "fabricant": "Detail Magazine",
    "systeme": "Dallage sur terre-plein en béton armé avec isolation et pavés béton extérieurs",
    "categorie": "soubassement",
    "tags": [
      "dallage",
      "terre-plein",
      "beton arme",
      "isolation",
      "film polyethylene",
      "lit de gravier",
      "chape ciment",
      "pave beton",
      "soubassement",
      "fondation"
    ],
    "description": "Le plancher bas sur terre-plein est constitué d'un film polyéthylène en fond, d'un lit de gravier de 150 mm, d'une isolation thermique de 40 mm, d'une chape ciment de 50 mm et d'une dalle béton armé de 350 mm. À l'extérieur, la transition se fait par un lit de gravier drainant et des pavés béton de 100 mm. Ce système assure l'isolation et la protection contre les remontées d'humidité du sol pour les espaces de stockage de la manufacture céramique.",
    "thumbnail": "/images/thumb-hagi.jpg",
    "source": "Detail Magazine n6/2003 - Store and Studio in Hagi, Sambuichi Architects",
    "materiaux": [
      "béton armé 350mm",
      "chape ciment 50mm",
      "isolation thermique 40mm",
      "lit de gravier 150mm",
      "film polyéthylène",
      "pavés béton 100mm"
    ],
    "points_cles": [
      "Dalle béton armé épaisse de 350 mm au rez-de-chaussée pour les espaces de stockage et de production",
      "Barrière anti-remontées capillaires par film polyéthylène sous lit de gravier drainant de 150 mm",
      "Transition extérieure par lit de gravier drainant et pavés béton de 100 mm en pied de façade"
    ]
  },
  {
    "id": "detail-2003-kobe-01",
    "title": "Façade vitrée suspendue avec maille métallique laiton/inox",
    "fabricant": "Detail Magazine",
    "systeme": "Façade rideau vitrée double peau avec tissage métallique",
    "categorie": "facade",
    "tags": [
      "facade vitrée",
      "double peau",
      "verre feuilleté",
      "maille métallique",
      "laiton",
      "inox",
      "façade suspendue",
      "schwert",
      "ailette verre acier",
      "vitrine intégrée",
      "louis vuitton",
      "kobe",
      "commerce",
      "retail",
      "VSG",
      "verre blanc",
      "weissglas"
    ],
    "description": "Façade vitrée de 8,20 m de hauteur composée de verre feuilleté sécurit (2x10 mm verre blanc) suspendue à la structure acier par des ailettes mixtes acier/verre (2x plats 230/32 mm + verre trempé ESG 19 mm). Derrière la peau vitrée extérieure, un tissage métallique en bandes de laiton et inox brossé à la main (0,6 mm) évoque les motifs traditionnels japonais et le label Louis Vuitton. Les vitrines intégrées subdivisent la façade permettant des panneaux de verre de 7,60 m sans joints horizontaux.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Facade+Vitree",
    "source": "Detail Magazine n7-8/2003 - Laden in Kobe, Barthélémy & Griño Architectes",
    "materiaux": [
      "verre feuilleté sécurit 2x10 mm verre blanc",
      "maille métallique laiton/inox brossé 0.6 mm",
      "ailettes acier plat 2x230/32 mm",
      "verre trempé ESG 19 mm verre blanc",
      "acrylique 4 mm",
      "silicone structurel"
    ],
    "points_cles": [
      "Façade suspendue par ailettes mixtes acier/verre (Stahl-/Glasschwert) au lieu d'appui en pied",
      "Double peau : vitrage extérieur + maille métallique décorative intérieure en laiton et inox",
      "Vitrines intégrées dans la façade permettant des verres de 7,60 m sans joint horizontal"
    ]
  },
  {
    "id": "detail-2003-kobe-02",
    "title": "Jonction vitrine commerciale sur façade rideau vitrée",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrine intégrée en façade avec cadre acier et fixation silicone",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrine",
      "cadre acier",
      "silikonverklebung",
      "silicone",
      "pressleiste",
      "laiton poli",
      "commerce",
      "retail",
      "façade vitrée",
      "jonction",
      "kobe"
    ],
    "description": "Vitrine commerciale intégrée dans la façade vitrée de 8,20 m, articulée par un cadre en profilé acier en I (114/59/8/6 mm). Le vitrage est fixé par collage silicone et pressé par une baguette en tôle acier (75/10 mm). La face intérieure de la vitrine est habillée d'une tôle de laiton poli de 2 mm assurant le fond réfléchissant pour la mise en scène des produits.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Vitrine",
    "source": "Detail Magazine n7-8/2003 - Laden in Kobe, Barthélémy & Griño Architectes",
    "materiaux": [
      "profilé acier I 114/59/8/6 mm",
      "tôle laiton poli 2 mm",
      "baguette de pression acier 75/10 mm",
      "silicone structurel",
      "verre feuilleté sécurit 2x10 mm"
    ],
    "points_cles": [
      "Cadre vitrine en profilé acier I intégré dans le plan de la façade vitrée",
      "Fixation du vitrage par collage silicone structurel et baguette de pression acier",
      "Fond de vitrine en tôle de laiton poli 2 mm pour reflet et mise en valeur"
    ]
  },
  {
    "id": "detail-2003-kobe-03",
    "title": "Habillage parking en lamelles aluminium avec motifs graphiques",
    "fabricant": "Detail Magazine",
    "systeme": "Bardage ventilé en lamelles aluminium extrudé anodisé",
    "categorie": "facade",
    "tags": [
      "lamelles aluminium",
      "aluminium extrudé",
      "anodisé",
      "parking",
      "bardage ventilé",
      "film adhésif",
      "motif graphique",
      "signalétique",
      "perméabilité",
      "ventilation naturelle",
      "kobe",
      "louis vuitton"
    ],
    "description": "Les quatre niveaux de parking sont habillés de lamelles en aluminium extrudé anodisé orientées à différents angles, recouvertes d'un film adhésif imprimé de motifs graphiques formant les logos de la marque par effet optique. Ce bardage assure simultanément la ventilation naturelle des parkings, la protection visuelle et une fonction de support publicitaire. La couverture arrière est en tôle aluminium anodisé de 2 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Lamelles+Alu",
    "source": "Detail Magazine n7-8/2003 - Laden in Kobe, Barthélémy & Griño Architectes",
    "materiaux": [
      "lamelles aluminium extrudé anodisé",
      "film adhésif imprimé",
      "tôle aluminium anodisé 2 mm",
      "tubes fluorescents pour éclairage"
    ],
    "points_cles": [
      "Lamelles orientées à différents angles créant un effet optique de logo vu depuis la rue",
      "Double fonction : ventilation naturelle des parkings et support de communication visuelle",
      "Éclairage intégré par tubes fluorescents derrière les lamelles pour effet nocturne"
    ]
  },
  {
    "id": "detail-2003-kobe-04",
    "title": "Structure porteuse acier avec poteau tubulaire et poutres en I ignifugées",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier poteaux-poutres avec protection feu",
    "categorie": "structure",
    "tags": [
      "structure acier",
      "poteau tubulaire",
      "SHS",
      "poutre IPE",
      "protection feu",
      "ignifugation",
      "riegel",
      "stütze",
      "ossature",
      "kobe",
      "commerce",
      "parking"
    ],
    "description": "Structure porteuse en acier composée de poteaux tubulaires carrés (500/500/1,6 mm) et de poutres en profilé I : traverses courantes (340/250/9/14 mm) et poutre principale (588/300/12/12 mm) avec enrobage ignifuge. Cette ossature supporte les quatre niveaux de parking au-dessus des espaces de vente et permet la suspension de la façade vitrée par les ailettes acier/verre.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kobe+Structure+Acier",
    "source": "Detail Magazine n7-8/2003 - Laden in Kobe, Barthélémy & Griño Architectes",
    "materiaux": [
      "poteau acier tubulaire carré SHS 500/500/1.6 mm",
      "profilé acier I 340/250/9/14 mm",
      "profilé acier I 588/300/12/12 mm",
      "enrobage ignifuge"
    ],
    "points_cles": [
      "Poteaux tubulaires carrés SHS 500 mm de forte section mais faible épaisseur (1,6 mm) pour élancement visuel",
      "Poutre principale 588/300 mm avec protection feu réglementaire par enrobage",
      "Ossature dimensionnée pour supporter 4 niveaux de parking et suspendre la façade vitrée en partie basse"
    ]
  },
  {
    "id": "detail-1992-fukuoka-01",
    "title": "Escalier-meuble en bois (Schranktreppe) - Interprétation moderne du tansu japonais",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier-rangement intégré en contreplaqué teinté",
    "categorie": "amenagement_interieur",
    "tags": [
      "escalier",
      "meuble",
      "tansu",
      "contreplaqué",
      "rangement",
      "bois",
      "teinté",
      "escalier intérieur",
      "schranktreppe",
      "meuble escalier",
      "japonais",
      "multifonctionnel",
      "accès toiture terrasse"
    ],
    "description": "Escalier autoportant en bois positionné librement dans l'espace, servant à la fois de rangement et de circulation verticale menant à une terrasse en toiture. Constitué de panneaux de contreplaqué teintés dans des tons de rouge, jaune, noir et vert, cet élément est une réinterprétation contemporaine du meuble traditionnel japonais tansu. Présenté en trois élévations (côté séjour, côté couloir, face des marches) à l'échelle 1:50.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Escalier+Meuble",
    "source": "Detail Magazine n°2/1992 - Nexus World Housing, Fukuoka, Mark Mack Architects",
    "materiaux": [
      "contreplaqué teinté",
      "bois",
      "teinte rouge",
      "teinte jaune",
      "teinte noire",
      "teinte verte"
    ],
    "points_cles": [
      "Élément autoportant positionné librement dans l'espace intérieur",
      "Double fonction : meuble de rangement et escalier d'accès à la terrasse en toiture",
      "Panneaux de contreplaqué teintés en différentes couleurs reprenant la palette chromatique des façades extérieures",
      "Interprétation moderne du tansu, meuble à tiroirs traditionnel japonais"
    ]
  },
  {
    "id": "detail-1992-fukuoka-02",
    "title": "Façade géométrique polychrome - Composition volumétrique Le Corbusier",
    "fabricant": "Detail Magazine",
    "systeme": "Façade enduite polychrome sur trame tridimensionnelle",
    "categorie": "facade",
    "tags": [
      "façade",
      "polychrome",
      "géométrie",
      "Le Corbusier",
      "jaune",
      "rouge",
      "couleur",
      "composition",
      "logement collectif",
      "résidentiel",
      "Fukuoka",
      "Nexus World",
      "cubes",
      "trame",
      "enduit"
    ],
    "description": "Façade à composition géométrique décomposée inspirée du canon formel et chromatique de Le Corbusier. Les 29 unités de logement sont insérées comme des cubes dans une trame d'ordonnancement tridimensionnelle, chaque logement ayant une configuration individuelle. Les deux volumes bâtis sont clairement distingués par une opposition colorée jaune et rouge.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Facade+Polychrome",
    "source": "Detail Magazine n°2/1992 - Nexus World Housing, Fukuoka, Mark Mack Architects",
    "materiaux": [
      "enduit jaune",
      "enduit rouge",
      "béton",
      "maçonnerie"
    ],
    "points_cles": [
      "Composition géométrique décomposée de la façade avec jeu de pleins et de vides",
      "Différenciation chromatique nette entre les deux corps de bâtiment (jaune et rouge)",
      "29 unités de logement individualisées insérées dans une trame tridimensionnelle régulière",
      "Référence directe au vocabulaire formel et coloré de Le Corbusier"
    ]
  },
  {
    "id": "detail-1992-fukuoka-03",
    "title": "Jonction volumétrique entre corps de bâtiment d'angle",
    "fabricant": "Detail Magazine",
    "systeme": "Articulation de deux volumes bâtis à l'angle de deux rues",
    "categorie": "structure",
    "tags": [
      "jonction",
      "angle",
      "volumes",
      "nexus",
      "connexion",
      "bâtiment d'angle",
      "logement",
      "commerce",
      "rez-de-chaussée",
      "place publique",
      "cour intérieure",
      "passage",
      "R+4",
      "R+6",
      "articulation"
    ],
    "description": "Articulation structurelle et volumétrique entre un bloc résidentiel plus élevé avec activités commerciales au rez-de-chaussée et un corps en L plus bas, situés à l'intersection de deux rues de gabarits différents. La jonction crée une place publique accueillant un café, une sculpture et une fontaine, tandis que la cour intérieure et le jardin sont accessibles par un passage traversant.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Jonction+Volumes",
    "source": "Detail Magazine n°2/1992 - Nexus World Housing, Fukuoka, Mark Mack Architects",
    "materiaux": [
      "béton",
      "enduit coloré",
      "structure porteuse"
    ],
    "points_cles": [
      "Connexion architecturale de deux volumes de hauteurs différentes à un angle de rues",
      "Bloc principal plus élevé (4-6 niveaux) avec commerce en rez-de-chaussée relié à un corps en L plus bas",
      "Création d'une place publique à l'articulation des deux volumes avec café, sculpture et fontaine",
      "Accès à la cour intérieure et au jardin par un passage couvert traversant"
    ]
  },
  {
    "id": "detail-1993-osaka-01",
    "title": "Façade étroite acier et verre - Remplissage de dent creuse",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier et verre en façade étroite sur parcelle urbaine",
    "categorie": "facade",
    "tags": [
      "facade",
      "acier",
      "verre",
      "dent creuse",
      "parcelle etroite",
      "2.5m",
      "osaka",
      "japon",
      "vitrage",
      "structure metallique",
      "remplissage urbain",
      "waro kishi"
    ],
    "description": "Façade de seulement 2,5 m de largeur comblant une dent creuse en centre-ville d'Osaka. L'assemblage acier et verre est traité comme un meuble-étagère aux proportions soigneusement calibrées, offrant une lisibilité constructive totale depuis la rue. La structure métallique et les panneaux vitrés sont dimensionnés pour exprimer la logique portante du bâtiment sur toute sa hauteur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Facade",
    "source": "Detail Magazine n1/1993 - Nipponbashi House, Waro Kishi",
    "materiaux": [
      "acier",
      "verre",
      "profiles metalliques"
    ],
    "points_cles": [
      "Largeur de façade de seulement 2,5 m remplissant intégralement la dent creuse",
      "Expression constructive claire : structure acier et remplissage verre lisibles depuis l'extérieur",
      "Proportions soigneusement étudiées rappelant un meuble-étagère en acier et verre"
    ]
  },
  {
    "id": "detail-1993-osaka-02",
    "title": "Escalier métallique suspendu avec caillebotis",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier acier avec limons plats, caillebotis et garde-corps en fer plat",
    "categorie": "amenagement_interieur",
    "tags": [
      "escalier",
      "acier",
      "caillebotis",
      "limon",
      "garde-corps",
      "fer plat",
      "suspendu",
      "detail 1:20",
      "marches metalliques",
      "structure legere",
      "waro kishi"
    ],
    "description": "Escalier intérieur en acier composé de limons en fer plat de 70x9 mm, de marches en caillebotis (690x228x25 mm) et d'un garde-corps en fer plat de 50x12 mm. Les cornières de fixation de 40x25x5 mm assurent la liaison entre caillebotis et limons. L'ensemble est détaillé au 1:20 en coupe longitudinale, transversale et en plan.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Escalier",
    "source": "Detail Magazine n1/1993 - Nipponbashi House, Waro Kishi",
    "materiaux": [
      "acier",
      "fer plat",
      "caillebotis metallique",
      "cornieres acier"
    ],
    "points_cles": [
      "Limons en fer plat 70x9 mm et garde-corps en fer plat 50x12 mm pour une expression minimale",
      "Marches en caillebotis 690x228x25 mm fixées par cornières 40x25x5 mm",
      "Détail complet documenté en coupe longitudinale, transversale, élévation et plan au 1:20"
    ]
  },
  {
    "id": "detail-1993-osaka-03",
    "title": "Palier suspendu sur tiges d'acier",
    "fabricant": "Detail Magazine",
    "systeme": "Palier d'escalier suspendu par tirants en acier rond diamètre 16 mm",
    "categorie": "structure",
    "tags": [
      "palier suspendu",
      "tirant",
      "acier rond",
      "suspension",
      "barre 16mm",
      "escalier",
      "structure legere",
      "detail constructif",
      "axonometrie",
      "waro kishi"
    ],
    "description": "Palier intermédiaire d'escalier suspendu par des barres rondes en acier de 16 mm de diamètre, éliminant tout appui inférieur et créant un effet de légèreté structurelle. Le système de suspension par tirants permet de libérer l'espace sous le palier et renforce l'expression constructive minimale du projet. Le détail est documenté en axonométrie éclatée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Palier+Suspendu",
    "source": "Detail Magazine n1/1993 - Nipponbashi House, Waro Kishi",
    "materiaux": [
      "acier rond diametre 16 mm",
      "acier",
      "plateforme metallique"
    ],
    "points_cles": [
      "Palier suspendu par tirants en barre ronde acier de 16 mm de diamètre",
      "Suppression des appuis inférieurs pour une expression structurelle de légèreté",
      "Détail documenté en axonométrie permettant la compréhension tridimensionnelle de l'assemblage"
    ]
  },
  {
    "id": "detail-1993-osaka-04",
    "title": "Toiture-terrasse accessible avec salle à manger double hauteur",
    "fabricant": "Detail Magazine",
    "systeme": "Terrasse en toiture ouverte avec volume intérieur de 6 m sous plafond en structure acier",
    "categorie": "toiture",
    "tags": [
      "toiture terrasse",
      "toit jardin",
      "le corbusier",
      "double hauteur",
      "6m",
      "espace exterieur",
      "salle a manger",
      "acier",
      "parcelle etroite",
      "osaka",
      "waro kishi"
    ],
    "description": "Au dernier niveau, le bâtiment se divise entre une salle à manger de 6 m de hauteur sous plafond occupant les deux tiers de la profondeur du bâtiment (13 m) et une terrasse ouverte sur le tiers restant. Cette terrasse en toiture, conçue comme un espace de vie extérieur supplémentaire, s'inscrit dans la filiation des toits-jardins de Le Corbusier, adaptée au contexte ultra-dense d'Osaka.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Toiture+Terrasse",
    "source": "Detail Magazine n1/1993 - Nipponbashi House, Waro Kishi",
    "materiaux": [
      "acier",
      "verre",
      "etancheite toiture"
    ],
    "points_cles": [
      "Volume intérieur de 6 m sous plafond occupant deux tiers de la profondeur totale de 13 m",
      "Terrasse ouverte en toiture conçue comme prolongement habitable en référence au toit-jardin corbuséen",
      "Optimisation des hauteurs : étages inférieurs comprimés au profit du volume généreux du dernier niveau"
    ]
  },
  {
    "id": "detail-2014-rotterdam-01",
    "title": "Bassin de rétention ouvert avec rampe skatepark",
    "fabricant": "Detail Magazine",
    "systeme": "Watersquare - Bassin de rétention paysager à ciel ouvert",
    "categorie": "amenagement_interieur",
    "tags": [
      "bassin de rétention",
      "eaux pluviales",
      "skatepark",
      "espace public",
      "gestion des eaux",
      "rampe",
      "Rotterdam",
      "climat",
      "infrastructure urbaine",
      "watersquare",
      "paysage",
      "récupération eau de pluie"
    ],
    "description": "Bassin de rétention à ciel ouvert conçu comme une rampe de skatepark en temps sec. L'eau de pluie provenant des toitures plates adjacentes jaillit d'une fontaine et s'écoule via des rigoles ouvertes en acier inoxydable jusque dans le bassin profilé en rampe. Le bassin se remplit uniquement lors d'épisodes de fortes précipitations et reste utilisable comme espace sportif le reste de l'année.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Bassin+Skatepark",
    "source": "Detail Magazine landscape - Watersquare Benthemplein Rotterdam 2014, De Urbanisten / Dirk van Peijpe",
    "materiaux": [
      "béton coulé",
      "acier inoxydable",
      "revêtement étanche"
    ],
    "points_cles": [
      "Double fonction : rétention d'eau pluviale et rampe de skatepark",
      "Rigoles ouvertes en acier inoxydable pour acheminement visible de l'eau depuis les toitures",
      "Pas de raccordement au réseau d'assainissement - rejet direct vers les cours d'eau ou infiltration dans le sol"
    ]
  },
  {
    "id": "detail-2014-rotterdam-02",
    "title": "Bassin de rétention basketball avec réservoir souterrain",
    "fabricant": "Detail Magazine",
    "systeme": "Watersquare - Bassin sportif avec cuve de stockage enterrée et trop-plein",
    "categorie": "soubassement",
    "tags": [
      "réservoir souterrain",
      "trop-plein",
      "basketball",
      "rétention",
      "eaux pluviales",
      "cuve enterrée",
      "espace public",
      "Rotterdam",
      "watersquare",
      "infrastructure hybride",
      "gestion hydraulique"
    ],
    "description": "Terrain de basketball aménagé en creux servant de bassin de rétention en cas de fortes pluies. Un réservoir souterrain collecte l'eau de pluie en premier lieu. Ce n'est qu'à saturation complète du réservoir lors d'épisodes de pluies intenses que l'eau déborde dans le bassin ouvert en surface, offrant ainsi une double capacité de stockage tout en maintenant l'usage sportif quotidien.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Bassin+Basketball",
    "source": "Detail Magazine landscape - Watersquare Benthemplein Rotterdam 2014, De Urbanisten / Dirk van Peijpe",
    "materiaux": [
      "béton étanche",
      "réservoir enterré",
      "revêtement sportif drainant"
    ],
    "points_cles": [
      "Système à deux niveaux : réservoir souterrain puis débordement dans le bassin de surface",
      "Le bassin ouvert ne se remplit que lors d'épisodes de pluies exceptionnelles",
      "Terrain de basketball fonctionnel en temps sec grâce à la conception en creux modéré"
    ]
  },
  {
    "id": "detail-2014-rotterdam-03",
    "title": "Bassin paysager avec île-scène et bacs plantés",
    "fabricant": "Detail Magazine",
    "systeme": "Watersquare - Bassin de rétention paysager multifonctionnel",
    "categorie": "amenagement_interieur",
    "tags": [
      "île",
      "scène",
      "bassin paysager",
      "place de quartier",
      "végétalisation",
      "bacs plantés",
      "rétention",
      "espace public",
      "Rotterdam",
      "watersquare",
      "biodiversité urbaine",
      "convivialité"
    ],
    "description": "Bassin de rétention intégrant une île centrale servant de scène pour événements de quartier et bordé de bacs plantés végétalisés. Le concept paysager global transforme l'infrastructure hydraulique en place de quartier végétalisée attractive au quotidien, les trois bassins interconnectés collectant les eaux de ruissellement de surface du quartier environnant.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Bassin+Paysager",
    "source": "Detail Magazine landscape - Watersquare Benthemplein Rotterdam 2014, De Urbanisten / Dirk van Peijpe",
    "materiaux": [
      "béton",
      "terre végétale",
      "végétation",
      "mobilier urbain"
    ],
    "points_cles": [
      "Île centrale en surélévation servant de scène événementielle même en cas de remplissage partiel",
      "Intégration de bacs plantés dans le concept global de rétention paysagère",
      "Triple bassin interconnecté offrant des usages différenciés : sport, détente, événements"
    ]
  },
  {
    "id": "detail-2014-rotterdam-04",
    "title": "Jardins de pluie et réseau de collecte en surface du quartier ZoHo",
    "fabricant": "Detail Magazine",
    "systeme": "Climate Proof District ZoHo - Réseau d'infiltration et collecte pluviale à l'échelle du quartier",
    "categorie": "soubassement",
    "tags": [
      "jardin de pluie",
      "infiltration",
      "quartier résilient",
      "climat",
      "réseau pluvial de surface",
      "passerelle piétonne",
      "Hofbogen",
      "Luchtsingel",
      "ZoHo",
      "Rotterdam",
      "toiture végétalisée",
      "urbanisme climatique",
      "noue"
    ],
    "description": "Plan d'aménagement à l'échelle du quartier Zomerhofkwartier (ZoHo) intégrant des jardins de pluie pour l'infiltration des eaux pluviales des toitures et des rues, reliés au Watersquare comme bassin de collecte central. Le réseau comprend la passerelle piétonne en bois Luchtsingel prolongée vers le nouveau parc Hofplein aménagé sur l'ancienne voie ferrée surélevée Hofbogen, créant un système de gestion des eaux pluviales entièrement déconnecté du réseau d'assainissement.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+ZoHo+Jardins+Pluie",
    "source": "Detail Magazine landscape - Climate Proof District ZoHo Rotterdam 2014, De Urbanisten / Dirk van Peijpe",
    "materiaux": [
      "bois",
      "terre végétale",
      "substrat drainant",
      "végétation pluviale",
      "béton perméable"
    ],
    "points_cles": [
      "Jardins de pluie assurant l'infiltration des eaux pluviales des toitures et voiries à l'échelle du quartier",
      "Déconnexion totale du réseau d'assainissement : infiltration locale ou pompage direct vers les cours d'eau",
      "Intégration de la passerelle piétonne Luchtsingel et réhabilitation de la voie ferrée surélevée Hofbogen en parc linéaire"
    ]
  },
  {
    "id": "detail-2009-saiki-01",
    "title": "Toiture plate sur murs en blocs de béton creux - Couvertine acier",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate inversée sur structure béton armé avec acrotère en blocs de béton",
    "categorie": "toiture",
    "tags": [
      "toiture plate",
      "gravier",
      "polystyrène",
      "étanchéité plastique",
      "dalle béton armé",
      "couvertine acier",
      "acrotère",
      "bloc béton creux",
      "maçonnerie armée",
      "Japon",
      "monolithique"
    ],
    "description": "Toiture plate composée d'un lit de gravier de 50 mm sur isolation polystyrène de 40 mm, étanchéité synthétique bicouche posée sur dalle béton armé de 120 à 150 mm formant pente. L'acrotère est réalisé en blocs de béton creux armés et remplis de béton, couronné d'une couvertine en tôle d'acier revêtue de 1,6 mm. Les volumes en surélévation de hauteurs différentes émergent au-dessus du plan de toiture principal.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Saiki+Toiture",
    "source": "Detail Magazine n10/2009 - Sommerhaus bei Saiki, Takao Shiotsuka Atelier",
    "materiaux": [
      "gravier 50 mm",
      "polystyrène 40 mm",
      "étanchéité plastique bicouche",
      "dalle béton armé 120-150 mm",
      "tôle acier revêtue 1,6 mm",
      "bloc béton creux 390x190x190 mm"
    ],
    "points_cles": [
      "Isolation légère en polystyrène de seulement 40 mm adaptée au climat subtropical de Kyushu",
      "Couvertine en tôle acier revêtue assurant la protection de la tête de mur en maçonnerie de blocs",
      "Volumes en surélévation au-dessus du toit créant des hauteurs intérieures variées avec le même système constructif"
    ]
  },
  {
    "id": "detail-2009-saiki-02",
    "title": "Mur en blocs de béton creux armés et remplis - Double peau avec coursive intermédiaire",
    "fabricant": "Detail Magazine",
    "systeme": "Maçonnerie porteuse en blocs de béton creux armés avec revêtement hydrofuge transparent",
    "categorie": "facade",
    "tags": [
      "bloc béton creux",
      "maçonnerie armée",
      "béton rempli",
      "acier d10",
      "double peau",
      "coursive",
      "umgang",
      "revêtement hydrofuge",
      "monolithique",
      "calepinage",
      "modulaire",
      "perforations façade",
      "Japon"
    ],
    "description": "Façade en double paroi de blocs de béton creux de 390x190x190 mm, armés d'acier de diamètre 10 mm et remplis de béton coulé en place. La peau extérieure perforée d'ouvertures non vitrées et la peau intérieure équipée de menuiseries coulissantes délimitent un passage périphérique de 80 cm de large, intermédiaire entre intérieur et extérieur selon la tradition japonaise. Les blocs reçoivent un revêtement transparent hydrofuge en finition extérieure, conservant l'aspect brut de la maçonnerie.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Saiki+Facade",
    "source": "Detail Magazine n10/2009 - Sommerhaus bei Saiki, Takao Shiotsuka Atelier",
    "materiaux": [
      "bloc béton creux 390x190x190 mm",
      "acier d'armature Ø10 mm",
      "béton de remplissage",
      "revêtement transparent hydrofuge"
    ],
    "points_cles": [
      "Système modulaire intégral basé sur les dimensions du bloc béton 390x190x190 mm régissant toute la conception",
      "Double peau maçonnée créant un espace intermédiaire de 80 cm rappelant l'engawa traditionnel japonais",
      "Ouvertures de la peau extérieure non vitrées assurant ventilation naturelle et protection solaire pour les menuiseries intérieures"
    ]
  },
  {
    "id": "detail-2009-saiki-03",
    "title": "Jonction menuiseries coulissantes - Moustiquaire, vitrage et claustra bois dans paroi intérieure",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiseries coulissantes japonaises traditionnelles sur rails dans mur en blocs de béton",
    "categorie": "jonction_menuiserie",
    "tags": [
      "porte coulissante",
      "simple vitrage",
      "float 8 mm",
      "cadre bois",
      "moustiquaire polypropylène",
      "claustra bois",
      "shoji",
      "kumiko",
      "rails",
      "ventilation",
      "Japon",
      "bloc béton"
    ],
    "description": "Système de fermeture de la paroi intérieure composé de trois types d'éléments coulissants sur rails : une porte coulissante en simple vitrage float de 8 mm en cadre bois, un panneau moustiquaire en film polypropylène en cadre bois et une porte coulissante à claustra bois de 36 mm. Ces éléments permettent de moduler le degré d'ouverture entre les pièces de vie et la coursive périphérique, offrant ventilation, protection contre les insectes ou intimité selon les besoins.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Saiki+Menuiserie",
    "source": "Detail Magazine n10/2009 - Sommerhaus bei Saiki, Takao Shiotsuka Atelier",
    "materiaux": [
      "verre float simple 8 mm",
      "cadre bois",
      "film polypropylène moustiquaire",
      "claustra bois 36 mm"
    ],
    "points_cles": [
      "Triple registre de fermeture coulissante permettant de moduler lumière, ventilation et intimité",
      "Simple vitrage suffisant grâce à la protection de la double peau extérieure non vitrée",
      "Vocabulaire constructif minimaliste inspiré des éléments traditionnels japonais (shoji, sudare) dans une écriture contemporaine"
    ]
  },
  {
    "id": "detail-2009-saiki-04",
    "title": "Planchers sur béton armé - Galerie bois et tatami sur dallage",
    "fabricant": "Detail Magazine",
    "systeme": "Planchers différenciés selon usage : solivage bois sur dalle béton et tatami sur dallage béton",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "cryptomeria",
      "cèdre japonais",
      "tatami",
      "dalle béton armé",
      "solivage",
      "contreplaqué",
      "dallage",
      "hérisson",
      "étanchéité",
      "béton lissé",
      "coursive",
      "Japon"
    ],
    "description": "Trois types de planchers distincts selon les espaces : la coursive extérieure en dalle béton armé lissé de 500 mm sur étanchéité et hérisson ; le séjour avec tatami de 40 mm sur dallage béton armé de 250 mm avec étanchéité sur forme et hérisson ; la galerie en mezzanine avec parquet en cèdre du Japon ciré de 18 mm sur contreplaqué de 12 mm et solivage 60x140 mm posé sur dalle béton armé de 140 mm. Chaque traitement de sol exprime la hiérarchie et la fonction des espaces.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Saiki+Plancher",
    "source": "Detail Magazine n10/2009 - Sommerhaus bei Saiki, Takao Shiotsuka Atelier",
    "materiaux": [
      "béton armé lissé 500 mm",
      "tatami 40 mm",
      "dalle béton armé 250 mm",
      "lames cèdre du Japon ciré 18 mm",
      "contreplaqué 12 mm",
      "solivage 60x140 mm",
      "dalle béton armé 140 mm",
      "hérisson pierreux",
      "étanchéité"
    ],
    "points_cles": [
      "Différenciation des sols exprimant la hiérarchie spatiale : béton brut pour la coursive, tatami pour le séjour-chambre, bois ciré pour la galerie",
      "Dallage béton armé épais de 250 à 500 mm sur terre-plein avec étanchéité assurant protection contre l'humidité du sol",
      "Plancher bois de la galerie en mezzanine avec solivage léger sur dalle béton structurelle de 140 mm"
    ]
  },
  {
    "id": "detail-2006-shimane-01",
    "title": "Toiture vitrée ventilée multicouche - couverture en verre flotté",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture vitrée avec cavités ventilées multiples sur charpente bois",
    "categorie": "toiture",
    "tags": [
      "toiture vitrée",
      "verre flotté",
      "lame air ventilée",
      "multicouche",
      "charpente bois",
      "pin",
      "teak",
      "aluminium",
      "acier inoxydable",
      "hinterlüftung",
      "buffer thermique",
      "sparren",
      "plafond suspendu",
      "convection naturelle",
      "isolation par lames d'air",
      "toiture inclinée sud",
      "gain solaire"
    ],
    "description": "Toiture vitrée composée d'une couverture en verre flotté de 12 mm à joints étanchéifiés, posée sur des profils aluminium 60/10 mm insérés dans des profils acier inoxydable en U 70/12/2 mm. La structure principale est constituée de chevrons en pin 120/300 mm avec trois cavités ventilées successives (185 mm, 120 mm et 75 mm) séparées par des panneaux de contreplaqué (24 mm et 6 mm), créant un système de buffer thermique multicouche. Un plafond suspendu en teak de 15 mm ferme l'ensemble côté intérieur, offrant un jeu de lumière et d'ombre dans les espaces habités.",
    "thumbnail": "/images/thumb-manfredlux.jpg",
    "source": "Detail Magazine n10/2006 - House in Shimane, Sambuichi Architects (Hiroshi Sambuichi)",
    "materiaux": [
      "verre flotté 12 mm",
      "profil aluminium 60/10 mm",
      "profil acier inoxydable U 70/12/2 mm",
      "liteaux pin 105 mm",
      "chevrons pin 120/300 mm",
      "contreplaqué 24 mm",
      "contreplaqué 6 mm",
      "teak 15 mm plafond suspendu"
    ],
    "points_cles": [
      "Trois cavités ventilées superposées (185 mm, 120 mm, 75 mm) assurant un buffer thermique passif par convection",
      "Couverture en verre flotté orientée sud pour maximiser les apports solaires en hiver",
      "Ventilation naturelle réglable intégrée au faîtage pour la régulation thermique estivale",
      "Fixation du vitrage par profils aluminium encastrés dans des U en acier inoxydable garantissant durabilité et étanchéité"
    ]
  },
  {
    "id": "detail-2006-shimane-02",
    "title": "Plancher bois sur structure pin avec finition teak",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher bois sur solives avec sous-face en contreplaqué plaqué pin",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "parquet teak",
      "solives pin",
      "contreplaqué",
      "sous-face",
      "furniersperrholz",
      "structure bois",
      "plancher sur vide",
      "finition intérieure"
    ],
    "description": "Plancher constitué d'un parquet en teak de 15 mm posé sur un panneau de contreplaqué de 28 mm, supporté par des solives en pin de section 120/300 mm. La sous-face visible est réalisée en contreplaqué plaqué pin de 15 mm, assurant une finition soignée pour les espaces en double hauteur et les vides traversants du projet.",
    "thumbnail": "/images/thumb-manfredlux.jpg",
    "source": "Detail Magazine n10/2006 - House in Shimane, Sambuichi Architects (Hiroshi Sambuichi)",
    "materiaux": [
      "parquet teak 15 mm",
      "contreplaqué 28 mm",
      "solives pin 120/300 mm",
      "contreplaqué plaqué pin 15 mm"
    ],
    "points_cles": [
      "Solives de forte section 120/300 mm en pin identiques aux chevrons de toiture, assurant une cohérence structurelle",
      "Sous-face en contreplaqué plaqué pin offrant un traitement architectural des plafonds vus depuis les doubles hauteurs",
      "Parquet teak massif 15 mm en continuité avec les volets coulissants et le plafond suspendu pour une unité matérielle"
    ]
  },
  {
    "id": "detail-2006-shimane-03",
    "title": "Soubassement en pierre brute dans filet d'acier sur mur béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Mur enterré béton armé avec remblai de pierres brutes en gabion soudé",
    "categorie": "soubassement",
    "tags": [
      "soubassement",
      "pierre brute",
      "gabion",
      "filet acier soudé",
      "béton armé",
      "mur enterré",
      "masse thermique",
      "inertie",
      "protection vent",
      "protection neige",
      "bruchstein",
      "stahlnetz",
      "contreplaqué plaqué pin",
      "isolation par masse"
    ],
    "description": "Le soubassement est constitué d'un mur en béton armé de 275 mm doublé côté intérieur d'un contreplaqué plaqué pin 15 mm sur tasseaux bois 40/40 mm. Côté extérieur, le bâtiment est enveloppé d'un remblai de pierres brutes maintenues dans un filet d'acier soudé formant un tertre artificiel. Cette masse de pierre non absorbante protège le rez-de-chaussée du froid et du vent en hiver (enfouie sous la neige) et assure une régulation thermique par inertie en été.",
    "thumbnail": "/images/thumb-manfredlux.jpg",
    "source": "Detail Magazine n10/2006 - House in Shimane, Sambuichi Architects (Hiroshi Sambuichi)",
    "materiaux": [
      "béton armé 275 mm",
      "contreplaqué plaqué pin 15 mm",
      "tasseaux bois 40/40 mm",
      "pierres brutes",
      "filet acier soudé"
    ],
    "points_cles": [
      "Pierres brutes non absorbantes maintenues dans un treillis d'acier soudé formant un tertre protecteur autour du rez-de-chaussée",
      "Masse thermique de pierre exploitant l'enfouissement sous la neige hivernale comme isolation naturelle",
      "Mur béton armé 275 mm doublé intérieurement de contreplaqué sur tasseaux pour la finition des espaces habités",
      "Stratégie bioclimatique passive combinant inertie de la pierre et protection contre les vents dominants"
    ]
  },
  {
    "id": "detail-2006-shimane-04",
    "title": "Jonction menuiserie - baie coulissante et volets teak avec structure poteaux-poutres bois",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiseries coulissantes vitrées et volets bois intégrés à ossature poteaux-poutres pin",
    "categorie": "jonction_menuiserie",
    "tags": [
      "menuiserie coulissante",
      "hebeschiebefenster",
      "volet coulissant teak",
      "porte coulissante",
      "poteaux pin",
      "structure bois",
      "ventilation traversante",
      "patio",
      "baie vitrée",
      "querlüftung",
      "verre flotté",
      "cloison vitrée",
      "profil rive acier inoxydable",
      "ossature bois"
    ],
    "description": "Le système de façade repose sur des poteaux en pin 240/120 mm et des poutres 120/120 mm formant une ossature ouverte. Les baies sont équipées de fenêtres levantes-coulissantes, de fenêtres coulissantes tripartites et de volets coulissants en teak massif 60 mm en trois parties. Des portes coulissantes en teak de 60 mm et des cloisons en verre flotté 12 mm complètent le dispositif, le tout bordé d'un profil de rive en acier inoxydable 3 mm. L'ensemble permet une ouverture totale pour la ventilation traversante via le patio.",
    "thumbnail": "/images/thumb-manfredlux.jpg",
    "source": "Detail Magazine n10/2006 - House in Shimane, Sambuichi Architects (Hiroshi Sambuichi)",
    "materiaux": [
      "poteaux pin 240/120 mm",
      "poutres pin 120/120 mm",
      "fenêtre levante-coulissante",
      "volets coulissants teak 60 mm",
      "porte coulissante teak 60 mm",
      "verre flotté 12 mm",
      "profil rive acier inoxydable 3 mm"
    ],
    "points_cles": [
      "Système de ventilation traversante totale par ouverture simultanée des portes d'entrée, baies coulissantes et volets via le patio central",
      "Volets coulissants tripartites en teak massif 60 mm assurant protection solaire, intimité et résistance aux intempéries",
      "Ossature poteaux-poutres en pin de forte section permettant de grandes portées vitrées sans montants intermédiaires",
      "Profil de rive en acier inoxydable 3 mm assurant la transition étanche entre la toiture vitrée et les menuiseries de façade"
    ]
  },
  {
    "id": "detail-2007-osaka-01",
    "title": "Toiture métallique avec évacuation intégrée invisible",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture acier sur bac acier avec drainage dissimulé en rive",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "acier",
      "évacuation invisible",
      "bac acier",
      "trapèze",
      "polyuréthane",
      "isolation acoustique",
      "plafond suspendu",
      "drainage caché",
      "rive",
      "chapelle",
      "couverture blanche"
    ],
    "description": "Complexe de toiture composé d'une couverture en tôle d'acier de 2,3 mm avec revêtement polyuréthane sur distanceurs, posée sur une couche porteuse d'eau en bac acier trapézoïdal de 0,8 mm avec pente de 1%. L'isolation acoustique en mousse PU de 20 mm est intégrée, avec un plafond acoustique suspendu en sous-face. L'évacuation des eaux pluviales est totalement invisible, réalisée par une fente étroite périphérique en rive de toiture, imperceptible depuis les étages supérieurs de l'hôtel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Toiture",
    "source": "Detail Magazine n10/2007 - Wedding Chapel in Osaka, Jun Aoki & Associates",
    "materiaux": [
      "tôle acier 2,3 mm revêtement PUR",
      "bac acier trapézoïdal 0,8 mm",
      "mousse polyuréthane 20 mm",
      "plafond acoustique suspendu"
    ],
    "points_cles": [
      "Évacuation des eaux pluviales invisible intégrée en rive périphérique par fente étroite",
      "Double couche métallique avec couche porteuse d'eau en bac trapézoïdal à 1% de pente",
      "Isolation acoustique en mousse PU 20 mm entre structure et plafond suspendu"
    ]
  },
  {
    "id": "detail-2007-osaka-02",
    "title": "Façade sud : structure porteuse en anneaux d'acier soudés derrière vitrage sans cadre",
    "fabricant": "Detail Magazine",
    "systeme": "Structure tétraédrique en anneaux acier tubulaires avec vitrage frameless",
    "categorie": "facade",
    "tags": [
      "façade",
      "anneaux acier",
      "tétraèdre",
      "vitrage sans cadre",
      "float glass",
      "structure décorative",
      "soudure",
      "acier tubulaire",
      "préfabrication",
      "revêtement acrylique silicone",
      "chapelle",
      "structure porteuse"
    ],
    "description": "Façade sud constituée d'un maillage d'anneaux en acier tubulaire creux (section 25x25 mm, diamètre 600 mm) soudés et organisés géométriquement en surfaces tétraédriques régulières, formant à la fois la structure porteuse et l'ornementation. Les anneaux, revêtus d'un enduit acrylique-silicone blanc, ont été préfabriqués en atelier en neuf éléments puis assemblés sur site à la charpente métallique du toit. Un vitrage float de 22 mm sans cadre protège l'ensemble côté extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Facade",
    "source": "Detail Magazine n10/2007 - Wedding Chapel in Osaka, Jun Aoki & Associates",
    "materiaux": [
      "anneaux acier tubulaire creux 25/25 mm Ø 600 mm",
      "revêtement acrylique-silicone blanc",
      "verre float 22 mm",
      "acier de charpente"
    ],
    "points_cles": [
      "Fusion totale entre structure porteuse et décoration en une couche homogène",
      "Géométrie tétraédrique régulière formée par les anneaux soudés, préfabriqués en 9 éléments",
      "Vitrage frameless float 22 mm en protection extérieure sans cadre visible"
    ]
  },
  {
    "id": "detail-2007-osaka-03",
    "title": "Paroi intérieure en tissu coton tendu avec fixations Velcro et magnétiques",
    "fabricant": "Detail Magazine",
    "systeme": "Revêtement mural textile tendu sur structure avec éclairage intégré",
    "categorie": "amenagement_interieur",
    "tags": [
      "paroi textile",
      "coton organdi",
      "velcro",
      "fixation magnétique",
      "tissu tendu",
      "ignifugé",
      "dématérialisation",
      "jeu d'ombre",
      "miroir",
      "contreplaqué",
      "éclairage intégré",
      "chapelle",
      "mur intérieur"
    ],
    "description": "Parois intérieures habillées d'un tissu de coton organdi ignifugé tendu sur la structure, créant un effet de dématérialisation totale. La fixation du textile est assurée en partie haute par des bandes Velcro et en partie basse par des aimants, permettant un montage et démontage propre. Derrière le tissu, des luminaires intégrés et un miroir collé en plein sur panneau de contreplaqué de 19 mm complètent le dispositif, projetant les ombres de la structure en anneaux sur les parois de jour et illuminant la chapelle de nuit.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Paroi+Textile",
    "source": "Detail Magazine n10/2007 - Wedding Chapel in Osaka, Jun Aoki & Associates",
    "materiaux": [
      "coton organdi ignifugé",
      "fixations Velcro",
      "fixations magnétiques",
      "miroir collé",
      "contreplaqué 19 mm",
      "luminaires intégrés"
    ],
    "points_cles": [
      "Tissu coton organdi feuerhemmend tendu pour effet de dématérialisation des parois",
      "Double système de fixation textile : Velcro en haut et aimants en bas",
      "Miroir collé pleine surface sur contreplaqué 19 mm pour effets lumineux et jeux d'ombres"
    ]
  },
  {
    "id": "detail-2007-osaka-04",
    "title": "Sol chapelle en cubes de marbre collés et mosaïque avec jonction plan d'eau",
    "fabricant": "Detail Magazine",
    "systeme": "Revêtement de sol marbre et mosaïque avec transition vers plan d'eau",
    "categorie": "soubassement",
    "tags": [
      "sol",
      "marbre",
      "cubes marbre",
      "mosaïque",
      "mortier",
      "collage",
      "couche de nivellement",
      "plan d'eau",
      "jonction sol eau",
      "gaine ventilation",
      "chapelle"
    ],
    "description": "Sol de la chapelle constitué de cubes de marbre de 20x20x20 mm collés sur une couche de nivellement de 15 mm, créant une surface blanche texturée continue. La transition vers le plan d'eau extérieur s'effectue via un revêtement en mosaïque circulaire (Ø 19 mm) posée sur lit de mortier de 15 mm. Une gaine de ventilation est intégrée dans l'épaisseur du sol entre les deux zones de revêtement.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Sol",
    "source": "Detail Magazine n10/2007 - Wedding Chapel in Osaka, Jun Aoki & Associates",
    "materiaux": [
      "cubes marbre 20/20/20 mm",
      "couche de nivellement 15 mm",
      "mosaïque circulaire Ø 19 mm",
      "mortier 15 mm",
      "gaine de ventilation"
    ],
    "points_cles": [
      "Cubes de marbre 20x20x20 mm collés sur couche de ragréage pour surface texturée homogène blanche",
      "Transition sol intérieur vers plan d'eau par mosaïque ronde Ø 19 mm sur lit de mortier",
      "Gaine de ventilation intégrée dans l'épaisseur du complexe de sol"
    ]
  },
  {
    "id": "detail-2005-amsterdam-01",
    "title": "Mur de façade ventilée en maçonnerie noire sur ossature légère",
    "fabricant": "Detail Magazine",
    "systeme": "Façade ventilée maçonnerie avec isolation par l'intérieur sur structure béton",
    "categorie": "facade",
    "tags": [
      "facade ventilee",
      "maconnerie",
      "brique noire",
      "hinterlüftung",
      "isolation minerale",
      "vapour barrier",
      "plaque de platre",
      "mur rideau brique",
      "amsterdam",
      "logement etudiant",
      "schottenbauweise"
    ],
    "description": "Paroi extérieure composée d'une maçonnerie noire de 100 mm avec lame d'air ventilée de 60 mm, membrane ouverte à la diffusion, 140 mm de laine minérale et pare-vapeur sur doublage en plaques de plâtre 2×12,5 mm. Ce système de façade légère vient remplir les travées entre les voiles porteurs en béton armé de 250 mm dans une construction de type Schottenbauweise (murs de refend transversaux).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Facade+Ventilee",
    "source": "Detail Magazine n10/2005 - Student Hall of Residence in Amsterdam, Claus en Kaan Architecten",
    "materiaux": [
      "maçonnerie enduite noire 100 mm",
      "laine minérale 140 mm",
      "membrane ouverte à la diffusion",
      "pare-vapeur",
      "plaques de plâtre 2×12,5 mm",
      "béton armé 250 mm"
    ],
    "points_cles": [
      "Lame d'air ventilée de 60 mm entre la maçonnerie extérieure et l'isolant pour évacuation de l'humidité",
      "Double plaque de plâtre (2×12,5 mm) côté intérieur pour performance acoustique et résistance au feu",
      "Ancrage de la maçonnerie par consoles en tôle d'acier soudées (Konsolanker) fixées à la structure béton"
    ]
  },
  {
    "id": "detail-2005-amsterdam-02",
    "title": "Jonction menuiserie coulissante aluminium en façade ventilée",
    "fabricant": "Detail Magazine",
    "systeme": "Fenêtre coulissante aluminium avec vitrage acoustique isolant en tableau de maçonnerie ventilée",
    "categorie": "jonction_menuiserie",
    "tags": [
      "fenetre coulissante",
      "aluminium",
      "vitrage acoustique",
      "isolation phonique",
      "double vitrage",
      "verre trempe",
      "deep reveal",
      "tableau profond",
      "store enrouleur",
      "protection solaire"
    ],
    "description": "Fenêtre coulissante en aluminium équipée d'un vitrage isolant acoustique composé de float 8 mm + lame d'air 9 mm + 2×ESG 6 mm, encastrée profondément dans le tableau de la façade ventilée en maçonnerie. Le cadre est bordé d'un habillage en tôle d'aluminium anodisé sur contreplaqué plaqué de 18 mm, avec store pare-soleil enrouleur intégré côté intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Menuiserie",
    "source": "Detail Magazine n10/2005 - Student Hall of Residence in Amsterdam, Claus en Kaan Architecten",
    "materiaux": [
      "aluminium anodisé",
      "vitrage float 8 mm",
      "verre trempé ESG 2×6 mm",
      "contreplaqué plaqué 18 mm",
      "profil acier laqué 60/150/4 mm",
      "store enrouleur"
    ],
    "points_cles": [
      "Vitrage acoustique performant (float 8 + SZR 9 + 2×ESG 6 mm) adapté au contexte urbain bruyant d'Amsterdam",
      "Fenêtres positionnées en profondeur dans le tableau créant un jeu d'ombres animant la façade",
      "Habillage du tableau en aluminium anodisé sur contreplaqué formant un cadre précis et durable"
    ]
  },
  {
    "id": "detail-2005-amsterdam-03",
    "title": "Couverture en bardeaux fibrociment sur toiture ventilée béton",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture ventilée en bardeaux de fibrociment sur lattage avec isolation sur dalle béton armé",
    "categorie": "toiture",
    "tags": [
      "toiture ventilee",
      "fibrociment",
      "bardeau",
      "lattage",
      "contrelattage",
      "laine minerale",
      "beton arme",
      "couverture",
      "membrane diffusante"
    ],
    "description": "Couverture en bardeaux de fibrociment de 4 mm posés sur lattage 38/19 mm et contrelattage 38/15 mm, avec lame d'air ventilée importante de 117 mm. L'isolation est assurée par 100 mm de laine minérale posée sur une membrane ouverte à la diffusion, le tout reposant sur une dalle béton armé de 170 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Toiture",
    "source": "Detail Magazine n10/2005 - Student Hall of Residence in Amsterdam, Claus en Kaan Architecten",
    "materiaux": [
      "bardeaux fibrociment 4 mm",
      "lattage bois 38/19 mm",
      "contrelattage bois 38/15 mm",
      "membrane ouverte à la diffusion",
      "laine minérale 100 mm",
      "béton armé 170 mm"
    ],
    "points_cles": [
      "Lame d'air ventilée de 117 mm exceptionnellement généreuse assurant une ventilation optimale de la couverture",
      "Bardeaux fibrociment de 4 mm offrant une couverture légère, durable et résistante aux intempéries",
      "Dalle béton armé de 170 mm (plus mince que les voiles de 250 mm) formant le support structurel de la toiture"
    ]
  },
  {
    "id": "detail-2005-amsterdam-04",
    "title": "Plancher courant béton armé avec revêtement linoleum sur chape",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé avec chape ciment et revêtement souple linoleum",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher beton",
      "dalle beton arme",
      "chape ciment",
      "linoleum",
      "revetement de sol",
      "logement etudiant",
      "economique",
      "vitrage allege",
      "verre feuillete",
      "garde-corps vitré"
    ],
    "description": "Plancher courant composé d'une dalle béton armé de 210 mm, d'une chape de ciment de 50 mm et d'un revêtement linoleum de 2,5 mm. En partie basse de façade, un vitrage isolant fixe (float 8 mm + lame d'air 15 mm + verre feuilleté de sécurité 10 mm) forme l'allège, reposant sur un profil acier laqué à arêtes vives de 60/150/4 mm qui assure la transition avec le nez de plancher.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Plancher",
    "source": "Detail Magazine n10/2005 - Student Hall of Residence in Amsterdam, Claus en Kaan Architecten",
    "materiaux": [
      "béton armé 210 mm",
      "chape ciment 50 mm",
      "linoleum 2,5 mm",
      "vitrage isolant float 8 + SZR 15 + VSG 10 mm",
      "profil acier laqué 60/150/4 mm",
      "tôle de zinc pliée sur contreplaqué 40 mm"
    ],
    "points_cles": [
      "Complexe de sol économique et fonctionnel adapté au logement étudiant (linoleum 2,5 mm sur chape ciment 50 mm)",
      "Allège vitrée en verre feuilleté de sécurité 10 mm apportant lumière et transparence au rez-de-chaussée",
      "Profil acier à arêtes vives (60/150/4 mm) avec finition laquée au four assurant la jonction nette entre plancher et façade"
    ]
  },
  {
    "id": "detail-2008-tokyo-01",
    "title": "Écran double couche en aluminium ajouré sur structure acier",
    "fabricant": "Detail Magazine",
    "systeme": "Façade écran aluminium CNC sur tiges inox",
    "categorie": "facade",
    "tags": [
      "aluminium",
      "panneaux ajourés",
      "CNC",
      "écran",
      "double peau",
      "brise-vue",
      "façade paramétrique",
      "tige inox",
      "tokio",
      "résidentiel",
      "acier galvanisé",
      "filtre lumière"
    ],
    "description": "Écran de façade composé de deux panneaux en aluminium laqué de 3 mm, découpés par CNC selon un motif cellulaire paramétrique, espacés de 20 cm. Les panneaux sont suspendus à des tiges en acier inoxydable Ø 6 mm fixées par des agrafes aluminium sur des profilés acier galvanisé pliés (44/9 mm), créant un effet de flottement devant la façade vitrée. Le motif organique varie selon les besoins de vue, de lumière et d'intimité.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Ecran+Aluminium",
    "source": "Detail Magazine n10/2008 - Apartmenthaus und Studios in Tokio, Studio M / Thom Faulders Architecture",
    "materiaux": [
      "aluminium laqué 3 mm",
      "acier inoxydable Ø 6 mm",
      "agrafe aluminium",
      "profilé acier galvanisé plié 44/9 mm",
      "tube acier galvanisé 100/100/12 mm"
    ],
    "points_cles": [
      "Deux couches de panneaux aluminium superposées avec motifs cellulaires non identiques générés par logiciel paramétrique",
      "Fixation sur tiges inox Ø 6 mm quasi invisibles depuis l'extérieur donnant un effet de lévitation",
      "Espacement de 20 cm entre les deux couches de panneaux pour créer profondeur et moiré visuel"
    ]
  },
  {
    "id": "detail-2008-tokyo-02",
    "title": "Toiture acier sur dalle béton nervurée en coffrage perdu",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture tôle acier polyuréthane sur dalle béton armé nervurée",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "coffrage perdu acier",
      "dalle nervurée",
      "béton armé",
      "étanchéité synthétique",
      "tôle acier",
      "polyuréthane",
      "panneau béton préfabriqué",
      "acrotère"
    ],
    "description": "Toiture constituée d'une dalle béton armé nervurée coulée sur coffrage perdu en acier, avec étanchéité par membrane synthétique de 3 mm. Le couronnement est réalisé par un capotage en tôle d'acier de 0,8 mm revêtue de polyuréthane. En rive, un panneau de façade en béton préfabriqué de 60 mm assure la finition et la continuité avec la façade.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Toiture",
    "source": "Detail Magazine n10/2008 - Apartmenthaus und Studios in Tokio, Studio M / Thom Faulders Architecture",
    "materiaux": [
      "tôle acier 0,8 mm revêtement polyuréthane",
      "membrane étanchéité synthétique 3 mm",
      "dalle béton armé nervurée",
      "coffrage perdu acier",
      "panneau béton préfabriqué 60 mm"
    ],
    "points_cles": [
      "Dalle béton armé nervurée coulée en place sur coffrage acier permanent servant de platelage structurel",
      "Étanchéité par membrane plastique de 3 mm directement sur la dalle béton",
      "Capotage d'acrotère en tôle acier 0,8 mm avec revêtement polyuréthane pour protection contre la corrosion"
    ]
  },
  {
    "id": "detail-2008-tokyo-03",
    "title": "Plancher chauffant sur structure acier avec finition PVC",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher chauffant sur chape sèche contreplaqué et isolation thermique",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher chauffant",
      "contreplaqué",
      "PVC",
      "isolation thermique",
      "structure acier",
      "poutre IPE",
      "profilé acier",
      "plaque silicate",
      "faux plafond",
      "cornière galvanisée"
    ],
    "description": "Plancher sur structure acier (poutre IPE 200/100 mm avec protection incendie par enduit projeté) composé d'un complexe de sol : isolation thermique 80 mm, contreplaqué 12 mm, plancher chauffant 12 mm, contreplaqué 9 mm et finition PVC 2 mm. En sous-face, plaque de silicate peinte de 9,5 mm. L'isolation thermique de 100 mm est intégrée dans l'épaisseur de la structure entre les poutres.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Plancher",
    "source": "Detail Magazine n10/2008 - Apartmenthaus und Studios in Tokio, Studio M / Thom Faulders Architecture",
    "materiaux": [
      "revêtement PVC 2 mm",
      "contreplaqué 9 mm et 12 mm",
      "plancher chauffant 12 mm",
      "isolation thermique 80 mm et 100 mm",
      "poutre acier IPE 200/100 mm",
      "enduit projeté coupe-feu",
      "plaque silicate 9,5 mm"
    ],
    "points_cles": [
      "Chape sèche en contreplaqué bicouche intégrant le système de chauffage par le sol avec finition PVC fine",
      "Protection incendie de la structure acier par enduit projeté (Spritzputz) sur les poutres IPE",
      "Isolation thermique de 80 mm dans le complexe de sol complétée par 100 mm en zone de façade"
    ]
  },
  {
    "id": "detail-2008-tokyo-04",
    "title": "Jonction façade vitrée fixe et terrasse bois sur dalle béton nervurée",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage fixe sur profilé acier avec terrasse bois sur lambourdes et étanchéité",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrage fixe",
      "terrasse bois",
      "lambourdes",
      "étanchéité",
      "profilé acier",
      "profilé aluminium",
      "dalle nervurée",
      "coffrage perdu",
      "jonction intérieur-extérieur",
      "loggia",
      "seuil"
    ],
    "description": "Jonction entre le vitrage fixe de 10 mm monté sur profilé acier rectangulaire (75/40/5 mm) et la terrasse extérieure en lames de bois de 15 mm sur lambourdes 45/95 mm. La dalle support est une dalle béton armé nervurée sur coffrage perdu acier avec étanchéité 3 mm. Le cadre de menuiserie est constitué de profilés aluminium 30/30/3 mm combinés à des cornières acier galvanisé 75/75/6 mm fixées sur la structure porteuse en poutres IPE 200/200 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Jonction+Vitrage+Terrasse",
    "source": "Detail Magazine n10/2008 - Apartmenthaus und Studios in Tokio, Studio M / Thom Faulders Architecture",
    "materiaux": [
      "vitrage fixe 10 mm",
      "profilé acier 75/40/5 mm",
      "profilé aluminium 30/30/3 mm",
      "cornière acier galvanisé 75/75/6 mm",
      "lames bois 15 mm",
      "lambourdes 45/95 mm",
      "étanchéité 3 mm",
      "dalle béton nervurée sur coffrage perdu acier",
      "poutre acier IPE 200/200 mm"
    ],
    "points_cles": [
      "Vitrage fixe de 10 mm toute hauteur assurant la transparence maximale entre intérieur et terrasse/loggia",
      "Terrasse bois sur lambourdes avec étanchéité 3 mm sur dalle béton nervurée en coffrage perdu acier",
      "Double registre de protection visuelle : loggia en retrait et écran aluminium paramétrique en avant"
    ]
  },
  {
    "id": "detail-2006-zurich-01",
    "title": "Façade ventilée en tôle ondulée aluminium sur isolation extérieure",
    "fabricant": "Detail Magazine",
    "systeme": "Façade ventilée avec bardage aluminium ondulé sur maçonnerie existante rénovée",
    "categorie": "facade",
    "tags": [
      "facade ventilee",
      "renovation",
      "isolation exterieure",
      "tole ondulee aluminium",
      "lame air",
      "laine minerale",
      "bardage metallique",
      "surisolation",
      "minergie",
      "rehabilitation",
      "annees 70",
      "maconnerie beton",
      "bronze",
      "aluminium ondule"
    ],
    "description": "Façade ventilée composée d'un bardage en tôle ondulée d'aluminium revêtu couleur bronze (170/30/1 mm) sur lame d'air de 50 mm et isolation en laine minérale de 160 mm, appliquée sur la maçonnerie existante en blocs de copeaux de bois remplis de béton (250-300 mm). Le système inclut des profilés aluminium continus (50/50/4-7 mm) pour la fixation et des gaines de ventilation en aluminium (213/57 mm) intégrées dans l'épaisseur de la nouvelle façade pour la distribution d'air neuf.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Zurich+Facade+Ventilee",
    "source": "Detail Magazine n11/2006 - Gesamterneuerung Wohnsiedlung Heumatt Zürich-Seebach, Urs Primas / Proplaning",
    "materiaux": [
      "tôle ondulée aluminium revêtu 170/30/1 mm",
      "laine minérale 160 mm",
      "maçonnerie blocs copeaux bois remplis béton 250-300 mm",
      "profilé aluminium continu 50/50/4-7 mm",
      "zarge tôle aluminium 2 mm",
      "joint élastique permanent",
      "profilé aluminium perforé",
      "gaines aluminium ventilation 213/57 mm avec bande acoustique"
    ],
    "points_cles": [
      "Lame d'air ventilée de 50 mm entre l'isolant et le bardage assurant l'évacuation de l'humidité",
      "Intégration des conduits de ventilation contrôlée (air neuf) dans l'épaisseur du nouveau complexe de façade pour atteindre le standard Minergie",
      "Profilé aluminium continu et profilé d'angle revêtu aluminium assurant la jonction et l'étanchéité des joints de bardage"
    ]
  },
  {
    "id": "detail-2006-zurich-02",
    "title": "Toiture-terrasse végétalisée extensive sur dalle béton existante",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée extensive avec isolation laine de roche sur structure existante",
    "categorie": "toiture",
    "tags": [
      "toiture vegetalisee",
      "toiture terrasse",
      "extensif",
      "laine de roche",
      "etancheite bitume",
      "renovation",
      "acrotere",
      "couvertine inox",
      "dalle beton existante",
      "minergie"
    ],
    "description": "Complexe de toiture-terrasse végétalisée extensive (80 mm) sur étanchéité bicouche en bitume, isolation thermique en laine de roche de 120 mm et construction de toiture existante (60 mm) reposant sur une dalle béton armé existante de 150 mm avec enduit intérieur de 15 mm. La couvertine en tôle d'acier inoxydable de 2 mm assure la protection de l'acrotère.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Zurich+Toiture+Vegetalisee",
    "source": "Detail Magazine n11/2006 - Gesamterneuerung Wohnsiedlung Heumatt Zürich-Seebach, Urs Primas / Proplaning",
    "materiaux": [
      "couvertine acier inoxydable 2 mm",
      "végétalisation extensive 80 mm",
      "étanchéité bitume bicouche 10 mm",
      "laine de roche 120 mm",
      "construction toiture existante 60 mm",
      "dalle béton armé existante 150 mm",
      "enduit intérieur 15 mm"
    ],
    "points_cles": [
      "Surcharge thermique de 120 mm de laine de roche ajoutée sur la construction de toiture existante pour atteindre le standard Minergie",
      "Végétalisation extensive de 80 mm contribuant à la rétention des eaux pluviales et à l'inertie thermique",
      "Couvertine en acier inoxydable 2 mm assurant la durabilité de la jonction toiture-façade"
    ]
  },
  {
    "id": "detail-2006-zurich-03",
    "title": "Jardin d'hiver - Wintergarten avec fenêtres pliantes-coulissantes aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Balcon fermé en jardin d'hiver avec porte levante-coulissante bois et fenêtres pliantes-coulissantes aluminium",
    "categorie": "jonction_menuiserie",
    "tags": [
      "wintergarten",
      "jardin hiver",
      "fenetre pliante coulissante",
      "porte levante coulissante",
      "balcon ferme",
      "double vitrage",
      "aluminium",
      "bois",
      "isolation interieure",
      "relevé etancheite",
      "epoxy",
      "briquette",
      "loggia",
      "conservatory"
    ],
    "description": "Transformation des balcons des étages supérieurs de la tour en jardins d'hiver par fermeture avec des fenêtres pliantes-coulissantes en aluminium à double vitrage isolant. L'accès depuis le séjour se fait par une porte levante-coulissante en bois à double vitrage. Le raccord au sol existant est assuré par un relevé en résine époxy, et le garde-corps est constitué d'une allège en maçonnerie de briques armée de 125 mm, doublée intérieurement d'un enduit armé sur 40 mm d'isolation laine minérale collée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Zurich+Wintergarten",
    "source": "Detail Magazine n11/2006 - Gesamterneuerung Wohnsiedlung Heumatt Zürich-Seebach, Urs Primas / Proplaning",
    "materiaux": [
      "fenêtres pliantes-coulissantes aluminium double vitrage",
      "porte levante-coulissante bois double vitrage",
      "relevé résine époxy",
      "allège maçonnerie briques armée 125 mm",
      "enduit armé treillis 10 mm",
      "laine minérale collée 40 mm",
      "laine de roche 160 mm sur linteau existant",
      "isolation laine minérale 160 mm"
    ],
    "points_cles": [
      "Fermeture des balcons en hauteur par fenêtres pliantes-coulissantes aluminium offrant flexibilité d'ouverture totale en été et protection contre les intempéries en hiver",
      "Relevé d'étanchéité en résine époxy raccordé au sol existant assurant la transition intérieur/extérieur sans infiltration",
      "Isolation intérieure de l'allège maçonnée (40 mm laine minérale collée + enduit armé) complétant le traitement thermique du jardin d'hiver"
    ]
  },
  {
    "id": "detail-2006-zurich-04",
    "title": "Loggia avec seuil de porte levante-coulissante et caillebotis bois",
    "fabricant": "Detail Magazine",
    "systeme": "Loggia rénovée avec porte levante-coulissante bois, caillebotis chêne et isolation périphérique",
    "categorie": "jonction_plancher",
    "tags": [
      "loggia",
      "seuil",
      "porte levante coulissante",
      "caillebotis chene",
      "etancheite liquide",
      "caoutchouc recycle",
      "renovation balcon",
      "isolation soubassement",
      "zarge acier",
      "raccord fenetre",
      "plastique liquide",
      "natte caoutchouc"
    ],
    "description": "Détail de loggia rénovée avec porte levante-coulissante en bois à double vitrage posée sur un élargissement de cadre en panneaux dérivés du bois isolé thermiquement. Le sol de la loggia est constitué d'un caillebotis en lattes de chêne chanfreinées (35/35 mm) sur lattage conique en chêne (40 mm) et natte en granulat de caoutchouc recyclé (8 mm) sur étanchéité en bitume polymère. Le raccord de la menuiserie est assuré par un produit d'étanchéité en plastique liquide.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Zurich+Loggia+Seuil",
    "source": "Detail Magazine n11/2006 - Gesamterneuerung Wohnsiedlung Heumatt Zürich-Seebach, Urs Primas / Proplaning",
    "materiaux": [
      "porte levante-coulissante bois double vitrage",
      "élargissement cadre panneaux bois isolé",
      "caillebotis chêne 35/35 mm chanfreiné",
      "lattage chêne conique 40 mm",
      "natte granulat caoutchouc 8 mm",
      "bitume polymère",
      "étanchéité plastique liquide raccord fenêtre",
      "zarge tôle acier pliée revêtue 4 mm",
      "isolation laine minérale 100 mm",
      "étrier fixation aluminium"
    ],
    "points_cles": [
      "Caillebotis chêne sur lattage conique permettant l'écoulement des eaux vers l'extérieur avec natte caoutchouc recyclé comme couche de drainage et protection",
      "Raccord d'étanchéité fenêtre-gros œuvre en plastique liquide assurant une continuité parfaite de l'étanchéité au seuil",
      "Élargissement du cadre de menuiserie en panneaux dérivés du bois avec isolation thermique intégrée compensant l'épaisseur de la nouvelle isolation de façade"
    ]
  },
  {
    "id": "detail-2008-kumamura-01",
    "title": "Toiture vitrée sur structure bois massif empilé",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage feuilleté posé à plat sur poutres de cèdre empilées",
    "categorie": "toiture",
    "tags": [
      "toiture vitrée",
      "verre feuilleté",
      "bois massif empilé",
      "cèdre japonais",
      "étanchéité",
      "toiture plate",
      "vitrage sans pente",
      "joint périphérique",
      "cornière inox"
    ],
    "description": "Toiture plate constituée d'un verre feuilleté de 15 mm posé sans pente sur des supports en contreplaqué 2×12,5 mm. L'étanchéité périphérique est assurée par un joint continu avec cornière de serrage en acier inoxydable. Ce dispositif permet un apport de lumière zénithale tout en assurant l'étanchéité sur la structure de poutres de cèdre 350×350 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kumamura+Toiture",
    "source": "Detail Magazine n11/2008 - Final Wooden House Kumamura, Sou Fujimoto Architects",
    "materiaux": [
      "verre feuilleté 15 mm",
      "contreplaqué 2×12,5 mm",
      "cornière acier inoxydable",
      "joint d'étanchéité périphérique",
      "cèdre japonais 350×350 mm"
    ],
    "points_cles": [
      "Vitrage feuilleté posé sans pente nécessitant une étanchéité périphérique soignée",
      "Cornière de serrage inox assurant la pression sur le joint d'étanchéité continu",
      "Appui sur cales en contreplaqué 2×12,5 mm pour répartir les charges sur les poutres de cèdre"
    ]
  },
  {
    "id": "detail-2008-kumamura-02",
    "title": "Vitrage incliné latéral fixé sur poutres de cèdre",
    "fabricant": "Detail Magazine",
    "systeme": "Simple vitrage incliné à 30° fixé par équerres métalliques et silicone",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrage incliné",
      "simple vitrage",
      "fixation silicone",
      "équerres métalliques",
      "cèdre",
      "baie vitrée",
      "sans châssis",
      "frameless",
      "fenêtre fixe inclinée"
    ],
    "description": "Vitrage simple de 6 mm posé avec une inclinaison de 30° dans les interstices entre les poutres de cèdre empilées. La fixation est assurée latéralement par des équerres métalliques et des joints silicone, sans cadre de menuiserie conventionnel. Ce système frameless maximise la transparence et le rapport visuel avec la forêt environnante.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kumamura+Vitrage+Incline",
    "source": "Detail Magazine n11/2008 - Final Wooden House Kumamura, Sou Fujimoto Architects",
    "materiaux": [
      "simple vitrage 6 mm",
      "équerres métalliques",
      "silicone",
      "cèdre japonais 350×350 mm"
    ],
    "points_cles": [
      "Inclinaison à 30° favorisant le ruissellement de l'eau de pluie sur le vitrage",
      "Fixation sans châssis par équerres métalliques et silicone pour un effet frameless",
      "Simple vitrage adapté au contexte de résidence de vacances non isolée thermiquement"
    ]
  },
  {
    "id": "detail-2008-kumamura-03",
    "title": "Structure empilée en poutres de cèdre boulonnées",
    "fabricant": "Detail Magazine",
    "systeme": "Empilement de poutres de cèdre 350×350 mm assemblées par boulons filetés",
    "categorie": "structure",
    "tags": [
      "bois massif empilé",
      "cèdre japonais",
      "boulons filetés",
      "structure bois",
      "log cabin",
      "poutres empilées",
      "assemblage boulonné",
      "Sou Fujimoto",
      "section carrée",
      "empilement"
    ],
    "description": "Structure porteuse constituée de poutres de cèdre japonais de section carrée 350×350 mm empilées en onze couches horizontales sur un plan carré de 4×4 m. L'assemblage entre les poutres est assuré par des boulons filetés en acier de diamètre 18 mm traversant les couches successives. Les poutres remplissent simultanément les fonctions de structure, d'enveloppe et de mobilier intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kumamura+Structure",
    "source": "Detail Magazine n11/2008 - Final Wooden House Kumamura, Sou Fujimoto Architects",
    "materiaux": [
      "cèdre japonais 350×350 mm",
      "boulons filetés acier Ø18 mm",
      "protection hydrofuge transparente",
      "protection hydrofuge blanche"
    ],
    "points_cles": [
      "Section unique de 350×350 mm pour toutes les poutres assurant une simplicité constructive radicale",
      "Boulons filetés Ø18 mm assurant la solidarisation verticale des couches entre elles",
      "Double traitement de surface : protection hydrofuge transparente à l'intérieur, blanche à l'extérieur"
    ]
  },
  {
    "id": "detail-2008-kumamura-04",
    "title": "Soubassement béton et jonction dalle-structure bois",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé avec chape ciment et appui direct des poutres de cèdre",
    "categorie": "soubassement",
    "tags": [
      "dalle béton armé",
      "chape ciment",
      "soubassement",
      "jonction bois-béton",
      "fondation",
      "plancher bas",
      "radier",
      "cèdre sur béton"
    ],
    "description": "Soubassement constitué d'une dalle en béton armé de 350 mm d'épaisseur surmontée d'une chape ciment de 220 mm, formant l'assise de la structure en poutres de cèdre empilées. La jonction entre le béton et les premières poutres de cèdre reçoit un traitement hydrofuge blanc pour protéger le bois des remontées d'humidité. Ce socle massif assure la stabilité du cube de 4×4 m sur le terrain en pente forestier.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kumamura+Soubassement",
    "source": "Detail Magazine n11/2008 - Final Wooden House Kumamura, Sou Fujimoto Architects",
    "materiaux": [
      "béton armé 350 mm",
      "chape ciment 220 mm",
      "protection hydrofuge blanche",
      "cèdre japonais 350×350 mm"
    ],
    "points_cles": [
      "Dalle béton armé épaisse de 350 mm servant de radier stabilisant sur terrain forestier",
      "Chape ciment de 220 mm intégrant les réseaux techniques (chauffage, eau, électricité)",
      "Protection hydrofuge blanche à la jonction bois-béton pour prévenir les remontées capillaires"
    ]
  },
  {
    "id": "detail-2009-utsunomiya-01",
    "title": "Paroi extérieure en acier soudé avec isolation et parement intérieur",
    "fabricant": "Detail Magazine",
    "systeme": "Façade acier préfabriquée avec isolation projetée et doublage plâtre",
    "categorie": "facade",
    "tags": [
      "acier soudé",
      "tôle acier",
      "isolation rigide",
      "mousse polyuréthane",
      "plaque de plâtre",
      "façade préfabriquée",
      "cube acier",
      "lattage ponctuel",
      "cornière acier",
      "revêtement PU",
      "Sou Fujimoto",
      "Japon",
      "construction modulaire"
    ],
    "description": "Paroi extérieure constituée d'une tôle d'acier de 3,2 mm soudée sur des plats en acier de 5/50 mm, avec un revêtement polyuréthane extérieur. L'isolation en mousse rigide de 30 mm est insérée entre les plats acier, complétée par un lattage de 12/45 mm fixé ponctuellement par des cornières acier 6/50/50 mm, et un parement intérieur en plaque de plâtre de 12,5 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utsunomiya+Facade",
    "source": "Detail Magazine n12/2009 - House before House, Sou Fujimoto Architects",
    "materiaux": [
      "tôle acier 3,2 mm soudée",
      "revêtement polyuréthane",
      "plat acier 5/50 mm",
      "mousse rigide isolation 30 mm",
      "lattage bois 12/45 mm",
      "cornière acier 6/50/50 mm",
      "plaque de plâtre 12,5 mm"
    ],
    "points_cles": [
      "Construction préfabriquée en atelier : tôles soudées sur ossature acier, posées par grue sur site",
      "Isolation projetée en mousse rigide entre éléments structurels acier, épaisseur limitée à 30 mm",
      "Fixation ponctuelle du lattage intérieur par cornières acier évitant les ponts thermiques linéaires"
    ]
  },
  {
    "id": "detail-2009-utsunomiya-02",
    "title": "Plancher sur structure acier avec parquet et isolation",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher acier soudé avec isolation, lattage et parquet résineux ciré",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher acier",
      "parquet épicéa",
      "contreplaqué",
      "isolation plancher",
      "tôle acier soudée",
      "plat acier",
      "mousse rigide",
      "lattage",
      "cornière acier",
      "plancher préfabriqué",
      "construction modulaire"
    ],
    "description": "Plancher composé d'une tôle d'acier soudée de 3,2 mm, avec isolation en mousse rigide de 50 mm entre plats acier de 5/75 mm. Le lattage de 45/45 mm est fixé ponctuellement par des cornières acier 6/50/50 mm avec 45 mm d'isolation intercalée, recouvert d'un panneau contreplaqué de 12 mm et d'un parquet en épicéa ciré de 12 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utsunomiya+Plancher",
    "source": "Detail Magazine n12/2009 - House before House, Sou Fujimoto Architects",
    "materiaux": [
      "tôle acier 3,2 mm soudée",
      "plat acier 5/75 mm",
      "mousse rigide isolation 50 mm",
      "lattage bois 45/45 mm",
      "isolation 45 mm",
      "cornière acier 6/50/50 mm",
      "contreplaqué 12 mm",
      "parquet épicéa ciré 12 mm"
    ],
    "points_cles": [
      "Double couche d'isolation : 50 mm de mousse rigide entre plats acier et 45 mm entre lattage pour performance thermique",
      "Structure entièrement soudée en tôle acier permettant la préfabrication complète des modules",
      "Finition intérieure légère en parquet résineux ciré sur contreplaqué assurant confort et simplicité"
    ]
  },
  {
    "id": "detail-2009-utsunomiya-03",
    "title": "Toiture-terrasse avec bac à plantes intégré et drainage",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée sur structure acier soudée avec drainage granulaire",
    "categorie": "toiture",
    "tags": [
      "toiture terrasse",
      "bac à plantes",
      "pflanztrog",
      "drainage",
      "étanchéité",
      "protection racinaire",
      "gravier",
      "granulat léger",
      "tôle acier soudée",
      "revêtement polyuréthane",
      "toiture végétalisée",
      "arbre en toiture",
      "Sou Fujimoto"
    ],
    "description": "Toiture-terrasse intégrant des bacs à plantes en tôle d'acier soudée de 3,2 mm avec revêtement polyuréthane et membrane d'étanchéité. Le système comprend une couche de drainage en granulat de 100 mm, un film de protection racinaire, un substrat en granulat léger et une couche de gravier de finition de 50 mm, permettant l'implantation d'arbres sur les cubes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utsunomiya+Toiture",
    "source": "Detail Magazine n12/2009 - House before House, Sou Fujimoto Architects",
    "materiaux": [
      "tôle acier 3,2 mm soudée",
      "revêtement polyuréthane",
      "membrane d'étanchéité",
      "film protection racinaire",
      "granulat drainage 100 mm",
      "granulat léger",
      "gravier 50 mm"
    ],
    "points_cles": [
      "Bacs à plantes intégrés structurellement dans les cubes acier pour accueillir des arbres en toiture",
      "Système de drainage multicouche avec granulat et protection racinaire assurant la pérennité de l'étanchéité",
      "Évacuation par goulotte en tôle acier soudée 150/50/2,3 mm avec revêtement PU intégrée à la structure"
    ]
  },
  {
    "id": "detail-2009-utsunomiya-04",
    "title": "Menuiserie vitrée en cadre bois avec double vitrage trempé et escalier acier",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage isolant en cadre bois sur structure acier avec escalier extérieur",
    "categorie": "jonction_menuiserie",
    "tags": [
      "double vitrage",
      "verre trempé",
      "ESG",
      "cadre bois",
      "menuiserie bois",
      "escalier acier",
      "marche acier",
      "garde-corps",
      "profil carré acier",
      "cornière acier",
      "jonction vitrage structure",
      "Sou Fujimoto",
      "transparence"
    ],
    "description": "Les ouvertures généreuses des cubes sont équipées de vitrages isolants composés de deux verres trempés ESG de 5 mm avec lame d'air de 15 mm, montés dans des cadres en bois. Les escaliers extérieurs sont constitués de marches en tôle acier de 4,5 mm avec revêtement PU, fixées sur des cornières acier 7/100/100 mm, avec garde-corps en profil tubulaire carré acier de 22/22 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utsunomiya+Menuiserie",
    "source": "Detail Magazine n12/2009 - House before House, Sou Fujimoto Architects",
    "materiaux": [
      "verre trempé ESG 5 mm",
      "lame d'air 15 mm",
      "cadre bois",
      "tôle acier marche 4,5 mm",
      "revêtement polyuréthane",
      "cornière acier 7/100/100 mm",
      "profil tubulaire carré acier 22/22 mm",
      "verre trempé simple ESG 5 mm"
    ],
    "points_cles": [
      "Double vitrage trempé ESG 5+15+5 mm en cadre bois pour grandes ouvertures sur l'extérieur",
      "Escaliers extérieurs filiformes en marches acier 4,5 mm sur cornières 100/100 mm pour légèreté visuelle",
      "Garde-corps minimaliste en profil carré creux 22/22 mm renforçant la transparence et la finesse de l'ensemble"
    ]
  },
  {
    "id": "detail-2009-tokyo-01",
    "title": "Toiture de l'erker-salle de bain en construction légère acier-bois Hinoki",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture légère acier avec parement bois Hinoki et isolation XPS",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "acier",
      "bois hinoki",
      "isolation XPS",
      "bitume",
      "trapezblech",
      "erker",
      "construction legere",
      "porte-a-faux",
      "tokyo",
      "bac acier"
    ],
    "description": "Toiture de l'erker en porte-à-faux constituée d'un parement extérieur en bois Hinoki laqué PU de 15 mm sur profilés acier, bac acier galvanisé trapézoïdal, isolation thermique XPS, étanchéité bitumineuse, panneau de laine de bois de 15 mm sur profilés acier, et sous-face en chevrons tubulaires acier avec parement Hinoki laqué de 15 mm. Structure en acier léger en porte-à-faux fixée uniquement à la façade béton armé du bâtiment principal pour préserver les racines des arbres existants.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Toiture+Erker",
    "source": "Detail Magazine n12/2009 - Bird Park Housing Development Tokyo, Hiroshi Nakamura & NAP Architects",
    "materiaux": [
      "bois Hinoki laqué PU 15 mm",
      "profilés acier",
      "bac acier galvanisé trapézoïdal",
      "isolation XPS",
      "étanchéité bitumineuse",
      "panneau laine de bois 15 mm",
      "chevrons tube acier"
    ],
    "points_cles": [
      "Construction légère en acier en porte-à-faux pour ne pas endommager les racines des arbres existants",
      "Double parement intérieur et extérieur en bois Hinoki laqué assurant une finition naturelle cohérente",
      "Complexe d'étanchéité bitumineux sur isolation XPS avec bac acier trapézoïdal comme support"
    ]
  },
  {
    "id": "detail-2009-tokyo-02",
    "title": "Plancher de l'erker en porte-à-faux avec dallage pierre naturelle sur béton cellulaire",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher acier-béton avec finition pierre naturelle et isolation XPS",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "porte-a-faux",
      "pierre naturelle",
      "beton cellulaire",
      "isolation XPS",
      "bac acier ondulé",
      "beton arme",
      "erker",
      "tokyo",
      "dalle"
    ],
    "description": "Plancher de l'erker-salle de bain en porte-à-faux composé d'un dallage en pierre naturelle de 15 mm sur lit de mortier de 20 mm, béton cellulaire de 150 mm, isolation thermique XPS, étanchéité bitumineuse, dalle béton armé de 70 mm sur tôle ondulée de 50 mm. Contreventement diagonal en acier assurant la stabilité structurelle de la console. Structure entièrement supportée par la façade en béton armé du bâtiment principal.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Plancher+Erker",
    "source": "Detail Magazine n12/2009 - Bird Park Housing Development Tokyo, Hiroshi Nakamura & NAP Architects",
    "materiaux": [
      "pierre naturelle 15 mm",
      "mortier 20 mm",
      "béton cellulaire 150 mm",
      "isolation XPS",
      "étanchéité bitumineuse",
      "béton armé 70 mm",
      "tôle ondulée acier 50 mm",
      "contreventement diagonal acier"
    ],
    "points_cles": [
      "Plancher composite acier-béton avec tôle ondulée collaborante de 50 mm et dalle béton armé de 70 mm",
      "Isolation thermique XPS et étanchéité intégrées entre le béton cellulaire et la structure porteuse",
      "Contreventement diagonal en acier pour la stabilité du porte-à-faux sans appui au sol"
    ]
  },
  {
    "id": "detail-2009-tokyo-03",
    "title": "Paroi de façade de l'erker premier étage en ossature acier avec parement Hinoki",
    "fabricant": "Detail Magazine",
    "systeme": "Façade légère ossature acier avec isolation XPS et bardage bois Hinoki",
    "categorie": "facade",
    "tags": [
      "facade",
      "ossature acier",
      "bois hinoki",
      "isolation XPS",
      "contreplaqué",
      "bardage bois",
      "erker",
      "tokyo",
      "mur exterieur",
      "construction legere"
    ],
    "description": "Paroi verticale de l'erker du premier étage composée d'un parement extérieur en bois Hinoki laqué PU de 15 mm sur lattage de 30 mm, contreplaqué de 15 mm, profilés acier avec isolation XPS entre montants, pare-vapeur/étanchéité, contreplaqué intérieur et poteau acier porteur. Sous-face du plancher supérieur avec suspension en profilés acier, plaque de silicate de calcium de 6 mm, lattage et parement Hinoki laqué de 15 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Facade+Erker",
    "source": "Detail Magazine n12/2009 - Bird Park Housing Development Tokyo, Hiroshi Nakamura & NAP Architects",
    "materiaux": [
      "bois Hinoki laqué PU 15 mm",
      "lattage 30 mm",
      "contreplaqué 15 mm",
      "profilés acier",
      "isolation XPS",
      "étanchéité",
      "plaque silicate de calcium 6 mm",
      "poteau acier"
    ],
    "points_cles": [
      "Ossature en profilés acier avec isolation XPS intégrée entre montants pour minimiser le poids en porte-à-faux",
      "Double peau de contreplaqué de part et d'autre de l'ossature assurant contreventement et support",
      "Sous-face de plancher avec plaque de silicate de calcium de 6 mm pour protection incendie et finition Hinoki"
    ]
  },
  {
    "id": "detail-2009-tokyo-04",
    "title": "Jonction menuiserie vitrage isolant dans l'erker en porte-à-faux",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage isolant en verre feuilleté de sécurité dans structure acier légère",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrage isolant",
      "verre feuillete",
      "VSG",
      "menuiserie",
      "erker",
      "tokyo",
      "double vitrage",
      "securite",
      "lanterneau",
      "fenetre de toit",
      "acier"
    ],
    "description": "Vitrage isolant en verre feuilleté de sécurité (VSG) intégré dans la structure légère en acier de l'erker. Les grandes surfaces vitrées des espaces de vie et les fenêtres de toit des erkers assurent la connexion visuelle avec les arbres existants et renforcent l'impression de se trouver en plein air dans une forêt. Un corridor vitré court relie les deux zones de salles de bain au deuxième étage.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Vitrage+Erker",
    "source": "Detail Magazine n12/2009 - Bird Park Housing Development Tokyo, Hiroshi Nakamura & NAP Architects",
    "materiaux": [
      "vitrage isolant VSG",
      "verre feuilleté de sécurité",
      "profilés acier",
      "bois Hinoki laqué 15 mm"
    ],
    "points_cles": [
      "Vitrage isolant en verre feuilleté de sécurité pour grandes ouvertures dans une structure légère en porte-à-faux",
      "Fenêtres de toit dans les erkers renforçant la connexion visuelle avec la canopée des arbres",
      "Corridor vitré de liaison entre les deux zones de salle de bain au deuxième étage"
    ]
  },
  {
    "id": "detail-2006-otake-01",
    "title": "Toiture végétalisée courbe sur structure bois",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée sur poutres bois cintrées et panneaux contreplaqués",
    "categorie": "toiture",
    "tags": [
      "toiture vegetalisee",
      "gründach",
      "planted roof",
      "bois courbe",
      "poutres cintrees",
      "contreplaque",
      "substrat vegetal",
      "grille metallique",
      "tampon climatique",
      "conductivite thermique",
      "clinique dentaire",
      "japon"
    ],
    "description": "Toiture végétalisée à géométrie courbe composée de poutres bois cintrées supportant des panneaux de contreplaqué (Sperrholz) sur lesquels repose le substrat végétal. Une grille métallique retient le substrat et la végétation contre le glissement sur la surface courbe. Le bois a été choisi pour sa faible conductivité thermique et la végétation agit comme tampon climatique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Otake+Toiture+Vegetalisee",
    "source": "Detail Magazine n12/2006 - Zahnklinik in Otake, Sambuichi Architects",
    "materiaux": [
      "poutres bois cintrees",
      "panneaux contreplaque",
      "substrat vegetal",
      "grille metallique anti-glissement",
      "vegetation extensive"
    ],
    "points_cles": [
      "Poutres bois cintrées comme structure porteuse de la toiture courbe",
      "Grille métallique de retenue du substrat sur pente courbe",
      "Double fonction de la végétalisation : esthétique et tampon climatique"
    ]
  },
  {
    "id": "detail-2006-otake-02",
    "title": "Jonction structure bois courbe sur ossature acier existante",
    "fabricant": "Detail Magazine",
    "systeme": "Charpente bois cintrée sur squelette acier raccordé au bâtiment existant",
    "categorie": "structure",
    "tags": [
      "structure mixte",
      "bois acier",
      "ossature acier",
      "charpente bois",
      "extension",
      "raccordement existant",
      "stahlskelett",
      "timber beams",
      "steel frame",
      "clinique",
      "japon"
    ],
    "description": "Structure mixte associant un squelette acier (Stahlskelett) à des poutres bois cintrées formant la toiture courbe. L'extension au premier étage vient s'accrocher au bâtiment existant en maçonnerie enduite de la clinique municipale, le niveau inférieur abritant un parking. Le système structurel permet de couvrir de grandes portées tout en conservant un habillage intérieur intégralement en bois.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Otake+Structure+Mixte",
    "source": "Detail Magazine n12/2006 - Zahnklinik in Otake, Sambuichi Architects",
    "materiaux": [
      "ossature acier",
      "poutres bois cintrees",
      "maconnerie enduite existante",
      "contreplaque"
    ],
    "points_cles": [
      "Ossature acier comme structure primaire supportant les poutres bois cintrées",
      "Raccordement au premier étage avec la clinique existante en maçonnerie enduite",
      "Système hybride permettant grandes portées et ambiance intérieure bois"
    ]
  },
  {
    "id": "detail-2006-otake-03",
    "title": "Façade vitrée nord pour éclairage naturel uniforme",
    "fabricant": "Detail Magazine",
    "systeme": "Grandes surfaces vitrées orientées nord sous toiture courbe",
    "categorie": "facade",
    "tags": [
      "facade vitree",
      "orientation nord",
      "eclairage naturel",
      "lumiere diffuse",
      "anti-eblouissement",
      "fensterflächen",
      "north-facing windows",
      "clinique dentaire",
      "salle de traitement",
      "salle attente"
    ],
    "description": "Grandes surfaces vitrées orientées au nord assurant un éclairage naturel uniforme et sans éblouissement dans les salles de traitement et d'attente. L'orientation nord garantit une lumière diffuse constante, essentielle pour les soins dentaires. Les fenêtres offrent également des vues apaisantes sur la végétation des toitures adjacentes et la rangée d'arbres intégrée au projet.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Otake+Facade+Nord",
    "source": "Detail Magazine n12/2006 - Zahnklinik in Otake, Sambuichi Architects",
    "materiaux": [
      "vitrage grand format",
      "menuiserie",
      "bois habillage interieur"
    ],
    "points_cles": [
      "Orientation nord pour lumière uniforme et sans éblouissement",
      "Grandes surfaces vitrées adaptées aux exigences d'éclairage médical",
      "Vues cadrées sur la végétation des toitures et les arbres pour effet apaisant"
    ]
  },
  {
    "id": "detail-2006-otake-04",
    "title": "Habillage intérieur bois sous toiture courbe",
    "fabricant": "Detail Magazine",
    "systeme": "Sous-face courbe en bois sur charpente cintrée",
    "categorie": "amenagement_interieur",
    "tags": [
      "habillage bois",
      "sous-face courbe",
      "ambiance chaleureuse",
      "plafond bois",
      "holzkleidung",
      "timber lining",
      "soffit",
      "acoustique",
      "clinique",
      "bien-etre",
      "japon"
    ],
    "description": "La sous-face de la toiture courbe est intégralement habillée de bois, créant une atmosphère chaleureuse qui fait oublier le contexte clinique. Le revêtement bois épouse la courbure des poutres porteuses et contribue au confort thermique grâce à la faible conductivité thermique du matériau. Cette conception favorise le bien-être des patients dans les espaces de traitement et d'attente.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Otake+Habillage+Bois",
    "source": "Detail Magazine n12/2006 - Zahnklinik in Otake, Sambuichi Architects",
    "materiaux": [
      "bois habillage",
      "poutres bois cintrees",
      "contreplaque"
    ],
    "points_cles": [
      "Habillage bois intégral de la sous-face courbe pour ambiance chaleureuse",
      "Faible conductivité thermique du bois contribuant au confort intérieur",
      "Géométrie courbe continue entre structure et finition intérieure"
    ]
  },
  {
    "id": "detail-2002-karuizawa-01",
    "title": "Couverture en bac acier à joints debout sur charpente bois",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture à joints debout avec isolation entre chevrons",
    "categorie": "toiture",
    "tags": [
      "bac acier",
      "joints debout",
      "zinc aluminium",
      "charpente bois",
      "isolation entre chevrons",
      "mineralwolle",
      "plafond plâtre",
      "walmdach",
      "toiture croupe",
      "weekend house",
      "japon",
      "sparren",
      "lauan",
      "sperrholz",
      "bitumenbahn",
      "vapour barrier"
    ],
    "description": "Couverture en tôle d'acier galvanisé revêtue aluminium (0,4 mm) à joints debout plats posée sur lé bitumineux et contreplaqué lauan 9 mm. Isolation en laine minérale 100 mm entre chevrons 90x120 mm, pare-vapeur et finition intérieure en plaque de plâtre 9,5 mm peinte en blanc. La toiture forme un volume croupe tronqué couvrant l'espace principal sans appuis intermédiaires.",
    "thumbnail": "/images/thumb-bow-wow.jpg",
    "source": "Detail Magazine n5/2002 - Weekend House in Karuizawa, Atelier Bow-Wow",
    "materiaux": [
      "tôle acier galvanisé revêtement aluminium 0.4mm",
      "membrane bitumineuse",
      "contreplaqué lauan 9mm",
      "laine minérale 100mm",
      "chevrons bois 90x120mm",
      "pare-vapeur",
      "plaque de plâtre 9.5mm"
    ],
    "points_cles": [
      "Couverture à joints debout plats en tôle galvanisée aluminisée assurant étanchéité sur pente faible",
      "Isolation entre chevrons avec pare-vapeur côté intérieur et étanchéité bitumineuse côté extérieur",
      "Finition intérieure en plâtre blanc contrastant avec l'extérieur brun foncé, toiture autoportante sans appuis intermédiaires"
    ]
  },
  {
    "id": "detail-2002-karuizawa-02",
    "title": "Paroi ossature bois avec bardage clin en cèdre",
    "fabricant": "Detail Magazine",
    "systeme": "Mur à ossature bois avec bardage à clins horizontaux",
    "categorie": "facade",
    "tags": [
      "bardage clin",
      "cèdre",
      "stülpschalung",
      "ossature bois",
      "isolation laine minérale",
      "lauan",
      "bitumenbahn",
      "zedernholz",
      "brun foncé",
      "japon",
      "weekend house",
      "horizontal boarding",
      "cedar lapped"
    ],
    "description": "Paroi extérieure composée d'un bardage horizontal à clins (Stülpschalung) en cèdre 15 mm teinté brun foncé, posé sur membrane bitumineuse d'étanchéité. Isolation en laine minérale 50 mm avec panneau de contreplaqué lauan 9 mm côté intérieur. Les montants d'ossature rapprochés sont laissés apparents à l'intérieur, exprimant le caractère simple de la construction.",
    "thumbnail": "/images/thumb-bow-wow.jpg",
    "source": "Detail Magazine n5/2002 - Weekend House in Karuizawa, Atelier Bow-Wow",
    "materiaux": [
      "bardage cèdre 15mm",
      "membrane bitumineuse",
      "laine minérale 50mm",
      "contreplaqué lauan 9mm",
      "montants bois apparents"
    ],
    "points_cles": [
      "Bardage à clins horizontaux en cèdre teinté brun foncé s'intégrant dans le paysage de chênaie",
      "Membrane bitumineuse comme pare-pluie entre bardage et isolant assurant l'étanchéité à l'eau",
      "Ossature bois à montants rapprochés laissés visibles en finition intérieure pour exprimer la simplicité constructive"
    ]
  },
  {
    "id": "detail-2002-karuizawa-03",
    "title": "Plancher bois surélevé avec isolation polystyrène",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher sur lambourdes avec double contreplaqué et isolation",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "contreplaqué lauan",
      "polystyrène",
      "isolation sol",
      "lambourdes",
      "kantholz",
      "leisten",
      "weekend house",
      "japon",
      "plancher surélevé"
    ],
    "description": "Plancher constitué d'un revêtement en contreplaqué lauan 5,5 mm sur panneau contreplaqué 12 mm, avec isolation en polystyrène 30 mm insérée entre des tasseaux 45x60 mm reposant sur des pièces de bois 150x100 mm. Cette construction légère et surélevée assure l'isolation thermique du sol tout en maintenant la cohérence de la construction bois simple du projet.",
    "thumbnail": "/images/thumb-bow-wow.jpg",
    "source": "Detail Magazine n5/2002 - Weekend House in Karuizawa, Atelier Bow-Wow",
    "materiaux": [
      "contreplaqué lauan 5.5mm",
      "contreplaqué 12mm",
      "polystyrène 30mm",
      "tasseaux bois 45x60mm",
      "pièces de bois 150x100mm"
    ],
    "points_cles": [
      "Double couche de contreplaqué dont finition en lauan offrant une surface lisse et chaleureuse",
      "Isolation polystyrène 30 mm entre tasseaux assurant une coupure thermique avec le sol",
      "Structure de plancher sur pièces de bois 150x100 mm permettant surélévation et ventilation sous plancher"
    ]
  },
  {
    "id": "detail-2002-karuizawa-04",
    "title": "Jonction toiture-façade avec gouttière de condensation et ventilation",
    "fabricant": "Detail Magazine",
    "systeme": "Raccord toiture-paroi avec gestion des eaux de condensation et ventilation naturelle",
    "categorie": "jonction_menuiserie",
    "tags": [
      "jonction toiture façade",
      "gouttière condensation",
      "ventilation",
      "clapet ventilation",
      "moustiquaire",
      "coulissant",
      "fenêtre de toit",
      "skylight",
      "kondenswasserrinne",
      "lüftungsklappe",
      "schiebeelement",
      "fliegennetz",
      "raccord",
      "détail",
      "japon"
    ],
    "description": "Nœud de jonction entre la toiture à joints debout et la paroi bois intégrant une gouttière de récupération des eaux de condensation, un clapet de ventilation naturelle et un élément coulissant équipé d'une moustiquaire. Ce dispositif assure simultanément l'évacuation de la condensation en sous-face de couverture, la ventilation estivale et la protection contre les insectes, typique des maisons japonaises en milieu boisé.",
    "thumbnail": "/images/thumb-bow-wow.jpg",
    "source": "Detail Magazine n5/2002 - Weekend House in Karuizawa, Atelier Bow-Wow",
    "materiaux": [
      "gouttière de condensation",
      "clapet de ventilation",
      "élément coulissant",
      "moustiquaire",
      "tôle acier galvanisé",
      "bardage cèdre"
    ],
    "points_cles": [
      "Gouttière de condensation intégrée au raccord toiture-mur récupérant les eaux de condensation en sous-face de couverture métallique",
      "Clapet de ventilation permettant la régulation de l'air et l'évacuation de l'humidité dans la construction",
      "Élément coulissant avec moustiquaire assurant ventilation naturelle traversante et protection contre les insectes en milieu forestier"
    ]
  },
  {
    "id": "detail-2003-matsunoyama-01",
    "title": "Enveloppe en acier Corten soudé sur structure primaire acier",
    "fabricant": "Detail Magazine",
    "systeme": "Coque soudée en acier Corten sur ossature acier primaire",
    "categorie": "facade",
    "tags": [
      "acier corten",
      "corten",
      "acier patinable",
      "enveloppe soudée",
      "coque acier",
      "sous-marin",
      "tôle 6mm",
      "weathering steel",
      "preoxidized steel",
      "facade métallique",
      "soudure continue",
      "étanchéité",
      "neige extrême",
      "charge neige 2000 tonnes",
      "musée",
      "japon"
    ],
    "description": "Enveloppe continue en acier Corten de 6 mm d'épaisseur, soudée sur une structure primaire en acier pour former une coque étanche inspirée de la construction de sous-marins. L'ensemble totalise 500 tonnes d'acier patinable et doit résister à des charges de neige allant jusqu'à 2000 tonnes. La forme en coque permet une répartition optimale des efforts sous charges extrêmes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Matsunoyama+Facade+Corten",
    "source": "Detail Magazine n10/2003 - Naturwissenschaftliches Museum Matsunoyama, Tezuka Architects",
    "materiaux": [
      "acier Corten 6mm",
      "acier de structure primaire",
      "soudure continue"
    ],
    "points_cles": [
      "Tôle Corten de 6 mm soudée en continu pour former une coque étanche de type sous-marin",
      "500 tonnes d'acier patinable résistant à des surcharges de neige de 2000 tonnes",
      "Patine naturelle de l'acier Corten assurant la protection anticorrosion sans entretien"
    ]
  },
  {
    "id": "detail-2003-matsunoyama-02",
    "title": "Appuis mobiles pour dilatation thermique horizontale",
    "fabricant": "Detail Magazine",
    "systeme": "Fondation à appuis glissants pour compensation de dilatation thermique",
    "categorie": "soubassement",
    "tags": [
      "appui mobile",
      "appui glissant",
      "dilatation thermique",
      "fondation",
      "mouvement horizontal",
      "compensation thermique",
      "bâtiment long",
      "111 mètres",
      "bearing",
      "expansion joint",
      "structure acier",
      "neige",
      "japon"
    ],
    "description": "Système d'appuis mobiles permettant de compenser les variations dimensionnelles horizontales dues aux écarts de température sur un bâtiment de 111 mètres de longueur. Le bâtiment est construit sans fondations fixes rigides afin d'autoriser les mouvements de dilatation et de contraction de la structure en acier. Ce dispositif est essentiel compte tenu de la longueur du bâtiment et des amplitudes thermiques extrêmes du site.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Matsunoyama+Appuis+Mobiles",
    "source": "Detail Magazine n10/2003 - Naturwissenschaftliches Museum Matsunoyama, Tezuka Architects",
    "materiaux": [
      "acier de structure",
      "appuis glissants",
      "fondations béton"
    ],
    "points_cles": [
      "Appuis mobiles autorisant la dilatation horizontale sur 111 mètres de longueur",
      "Absence de fondations fixes rigides pour permettre le mouvement libre de la structure",
      "Adaptation aux écarts de température extrêmes entre hiver enneigé et été"
    ]
  },
  {
    "id": "detail-2003-matsunoyama-03",
    "title": "Fenêtres en acrylique 75 mm aux points de pliage du bâtiment",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage en PMMA épais intégré dans coque acier Corten",
    "categorie": "jonction_menuiserie",
    "tags": [
      "acrylique",
      "PMMA",
      "perspex",
      "plexiglas",
      "75mm",
      "fenêtre épaisse",
      "vitrage résistant neige",
      "jonction acier vitrage",
      "corten menuiserie",
      "grande baie",
      "charge neige",
      "musée",
      "observation nature",
      "japon"
    ],
    "description": "Quatre grandes fenêtres en acrylique (PMMA) de 75 mm d'épaisseur, positionnées aux points d'inflexion du bâtiment méandriforme. L'épaisseur exceptionnelle du vitrage acrylique permet de résister aux charges de neige extrêmes du site tout en offrant des vues panoramiques sur l'environnement naturel. La jonction entre le cadre acrylique et la coque en acier Corten soudé constitue un nœud constructif critique pour l'étanchéité et la résistance structurelle.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Matsunoyama+Fenetre+Acrylique",
    "source": "Detail Magazine n10/2003 - Naturwissenschaftliches Museum Matsunoyama, Tezuka Architects",
    "materiaux": [
      "acrylique PMMA 75mm",
      "acier Corten 6mm",
      "joints d'étanchéité"
    ],
    "points_cles": [
      "Vitrage acrylique de 75 mm d'épaisseur résistant aux charges de neige extrêmes",
      "Positionnement stratégique aux quatre points de pliage du bâtiment méandriforme",
      "Jonction critique entre la coque acier soudée et les panneaux acryliques assurant étanchéité et continuité structurelle"
    ]
  },
  {
    "id": "detail-2003-matsunoyama-04",
    "title": "Tour d'observation de 34 mètres en acier Corten",
    "fabricant": "Detail Magazine",
    "systeme": "Tour verticale en structure acier avec enveloppe Corten soudée",
    "categorie": "structure",
    "tags": [
      "tour",
      "observation",
      "34 mètres",
      "verticalité",
      "structure acier",
      "corten",
      "station météorologique",
      "porte-à-faux",
      "transition horizontal vertical",
      "musée",
      "japon",
      "neige",
      "vent"
    ],
    "description": "Tour d'observation de 34 mètres de hauteur constituant le point culminant du musée, où le bâtiment horizontal se redresse pour s'élever en verticalité. La structure en acier est enveloppée de la même coque en Corten soudé de 6 mm que le reste du bâtiment, assurant une continuité formelle et constructive. La tour abrite une station d'observation météorologique et doit résister aux charges combinées de vent et de neige dans cette zone de climat extrême.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Matsunoyama+Tour+Observation",
    "source": "Detail Magazine n10/2003 - Naturwissenschaftliches Museum Matsunoyama, Tezuka Architects",
    "materiaux": [
      "acier Corten 6mm",
      "acier de structure primaire",
      "soudure continue",
      "équipements météorologiques"
    ],
    "points_cles": [
      "Tour de 34 mètres marquant la transition du bâtiment horizontal vers la verticalité",
      "Continuité constructive de l'enveloppe Corten soudée entre le corps du musée et la tour",
      "Résistance aux charges combinées de vent et de neige extrêmes avec station météorologique intégrée"
    ]
  },
  {
    "id": "detail-2003-takarazuka-01",
    "title": "Toiture béton sur structure acier et bois existante",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton sur trapèze métallique avec isolation polyuréthane",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "béton armé",
      "trapezblech",
      "isolation polyuréthane",
      "acier",
      "rénovation",
      "structure mixte",
      "acrotère",
      "étanchéité",
      "oberlicht",
      "lanterneau",
      "verre feuilleté"
    ],
    "description": "Toiture composée d'une dalle béton armé de 80 mm avec acrotère de 20 mm, peinte avec revêtement étanche, posée sur tôle trapézoïdale avec isolation polyuréthane de 25 mm. Le système intègre un lanterneau en verre feuilleté de sécurité avec couvre-joints en acier inoxydable, ainsi que des plaques alvéolaires plastiques double paroi (2x16 mm) pour l'éclairage zénithal. La toiture repose sur le poutre principale en profilé acier H 294/200/8/12 mm combiné avec des cornières 2x 50/50/6 mm, remplaçant partiellement l'ancienne couverture en bois.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Takarazuka+Toiture",
    "source": "Detail Magazine n10/2003 - Atelierhaus Zenkai Takarazuka, Katsuhiro Miyamoto & Associates",
    "materiaux": [
      "béton armé 80 mm",
      "polyuréthane 25 mm",
      "tôle trapézoïdale",
      "verre feuilleté de sécurité",
      "acier inoxydable",
      "plaques alvéolaires plastique 2x16 mm",
      "profilé acier H 294/200"
    ],
    "points_cles": [
      "Dalle béton étanche peinte sur tôle trapézoïdale avec isolation polyuréthane 25 mm",
      "Lanterneau en VSG avec couvre-joints inox assurant l'éclairage zénithal de l'atrium",
      "Remplacement partiel de la toiture bois existante par des dalles béton faiblement inclinées reposant sur poutres acier"
    ]
  },
  {
    "id": "detail-2003-takarazuka-02",
    "title": "Contreventement spatial acier sur structure bois existante",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature de renforcement en acier tridimensionnel sur construction bois existante",
    "categorie": "structure",
    "tags": [
      "contreventement",
      "fachwerk",
      "treillis spatial",
      "acier",
      "rond plein",
      "tube acier",
      "renforcement sismique",
      "réhabilitation",
      "structure bois",
      "croix de saint-andré",
      "ossature mixte",
      "parasismique"
    ],
    "description": "Système de contreventement tridimensionnel en acier ajouté autour et à travers la structure bois traditionnelle existante pour assurer la stabilité du bâtiment en bout de rang après la perte des constructions adjacentes. Le treillis spatial est composé de ronds pleins Ø25 mm et Ø15 mm, complété par des croix de contreventement en tubes acier Ø89 mm. La poutre principale en profilé H 294/200/8/12 mm avec cornières 2x50/50/6 mm, placée dans le patio intérieur vitré, est reliée aux poutres en façade avant. La structure acier peinte en blanc à l'huile contraste volontairement avec les poutres bois sombres existantes, les assemblages étant délibérément discrets.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Takarazuka+Structure",
    "source": "Detail Magazine n10/2003 - Atelierhaus Zenkai Takarazuka, Katsuhiro Miyamoto & Associates",
    "materiaux": [
      "rond plein acier Ø25 mm",
      "rond plein acier Ø15 mm",
      "tube acier Ø89 mm",
      "profilé acier H 294/200/8/12 mm",
      "cornières acier 50/50/6 mm",
      "peinture huile blanche",
      "poutres bois existantes"
    ],
    "points_cles": [
      "Treillis spatial en ronds pleins Ø25 et Ø15 mm adapté localement selon les besoins structurels",
      "Croix de contreventement en tubes acier Ø89 mm pour la rigidification transversale",
      "Assemblages discrets entre acier neuf peint blanc et charpente bois sombre existante"
    ]
  },
  {
    "id": "detail-2003-takarazuka-03",
    "title": "Façade ouest vitrée sur structure bois existante apparente",
    "fabricant": "Detail Magazine",
    "systeme": "Paroi en verre profilé ondulé armé avec structure bois apparente",
    "categorie": "facade",
    "tags": [
      "façade vitrée",
      "verre profilé",
      "verre armé",
      "ondulé",
      "structure bois apparente",
      "rénovation",
      "transparence",
      "mur ancien visible",
      "profilglas",
      "acrylglas",
      "plaques acrylique"
    ],
    "description": "Façade ouest du bâtiment réhabilitée avec du verre profilé ondulé à armature métallique intégrée, fixé sur la structure bois existante laissée apparente. Ce dispositif permet de rendre visible l'ancienne ossature bois et les fragments de maçonnerie à travers la nouvelle enveloppe vitrée translucide. Le système est complété en partie basse par des plaques en acrylique 30/30/2 mm, assurant une protection tout en maintenant la lecture de la construction historique depuis l'extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Takarazuka+Facade",
    "source": "Detail Magazine n10/2003 - Atelierhaus Zenkai Takarazuka, Katsuhiro Miyamoto & Associates",
    "materiaux": [
      "verre profilé ondulé armé",
      "structure bois existante",
      "plaques acrylique 30/30/2 mm",
      "maçonnerie existante"
    ],
    "points_cles": [
      "Verre profilé ondulé avec armature fil métallique laissant transparaître la structure bois ancienne",
      "Conservation et mise en valeur de la charpente bois et de la maçonnerie existantes derrière la façade vitrée",
      "Plaques acrylique 30x30x2 mm en complément pour les zones de remplissage"
    ]
  },
  {
    "id": "detail-2003-takarazuka-04",
    "title": "Plancher traditionnel tatami et paroi isolée sur ossature bois",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher natte de riz sur solivage bois avec plafond perforé / Paroi isolée avec tôle ondulée galvanisée",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "tatami",
      "natte de riz",
      "solivage",
      "gipskarton",
      "plafond acoustique",
      "paroi isolée",
      "tôle ondulée galvanisée",
      "fibre de verre",
      "contreplaqué",
      "lauan",
      "douglas",
      "rénovation",
      "construction japonaise traditionnelle"
    ],
    "description": "Plancher traditionnel composé d'une natte de paille de riz de 60 mm sur double voligeage 12+15 mm porté par des solives bois 214/95 mm, avec sous-face en plaque de plâtre perforée 9 mm sur lattage 45/45 mm pour absorption acoustique. La paroi extérieure associe un parement en tôle ondulée galvanisée sur ossature bois 50/50 mm avec contreplaqué de Douglas 12 mm, une isolation en fibre de verre 50 mm intégrée dans la charpente bois existante, et une finition intérieure en contreplaqué Lauan 9 mm avec plaque de plâtre perforée 7 mm et enduit minéral.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Takarazuka+Plancher",
    "source": "Detail Magazine n10/2003 - Atelierhaus Zenkai Takarazuka, Katsuhiro Miyamoto & Associates",
    "materiaux": [
      "natte paille de riz 60 mm",
      "voligeage bois 12+15 mm",
      "solives bois 214/95 mm",
      "plaque de plâtre perforée 9 mm",
      "lattage 45/45 mm",
      "tôle ondulée galvanisée",
      "contreplaqué Douglas 12 mm",
      "isolation fibre de verre 50 mm",
      "contreplaqué Lauan 9 mm",
      "plaque de plâtre perforée 7 mm",
      "enduit minéral"
    ],
    "points_cles": [
      "Plancher tatami traditionnel : natte de riz 60 mm sur double voligeage et solives bois 214/95 mm",
      "Sous-face acoustique en plaque de plâtre perforée 9 mm sur lattage 45/45 mm",
      "Paroi multicouche avec tôle ondulée galvanisée extérieure, isolation fibre de verre 50 mm dans charpente existante et finition intérieure enduit minéral sur plaque perforée"
    ]
  },
  {
    "id": "detail-2003-london-01",
    "title": "Coupe sur facade sud - Extension vitree de 26 etages",
    "fabricant": "Detail Magazine",
    "systeme": "Facade rideau aluminium-verre avec protection solaire rapportee",
    "categorie": "facade",
    "tags": [
      "facade rideau",
      "double vitrage",
      "protection solaire",
      "aluminium extrude",
      "lamelles",
      "tirant inox",
      "balcon maintenance",
      "rehabilitation",
      "highrise",
      "extension facade",
      "mur rideau colle",
      "isolation coupe-feu"
    ],
    "description": "Facade rideau vitree de 5,5 m de profondeur ajoutee sur 26 etages de la face sud du Empress State Building. Le systeme comprend un double vitrage colle sur profiles aluminium, des lamelles pare-soleil en aluminium extrude portees par des plats aluminium anodise, des tirants en acier inoxydable pour la stabilite, un balcon de maintenance en caillebotis aluminium et une isolation thermique coupe-feu F120 en jonction avec la structure existante.",
    "thumbnail": "/images/thumb-wilkinson.jpg",
    "source": "Detail Magazine n10/2003 - Hochhaussanierung Empress State Building London, Wilkinson Eyre Architects",
    "materiaux": [
      "double vitrage colle",
      "aluminium extrude",
      "aluminium anodise",
      "acier inoxydable",
      "caillebotis aluminium",
      "isolation thermique coupe-feu F120"
    ],
    "points_cles": [
      "Extension legere en acier rapportee sur structure beton existante sans infrastructure supplementaire",
      "Protection solaire par lamelles aluminium extrude fixees sur supports en plat aluminium anodise",
      "Tirants en acier inoxydable assurant la stabilite structurelle de la facade",
      "Isolation coupe-feu F120 a la jonction avec le batiment existant",
      "Balcon de maintenance integre en caillebotis aluminium"
    ]
  },
  {
    "id": "detail-2003-london-02",
    "title": "Coupe sur terrasse et toiture - Jonction facade sud / terrasse haute",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture-terrasse accessible sur dalle mixte beton arme avec platelage bois",
    "categorie": "toiture",
    "tags": [
      "toiture terrasse",
      "platelage bois",
      "dalle mixte",
      "etancheite monocouche",
      "isolation rigide",
      "pare-vapeur",
      "garde-corps verre feuillete",
      "VSG",
      "laminated safety glass",
      "rehabilitation highrise"
    ],
    "description": "Composition de la terrasse en toiture du Empress State Building : platelage en lames de bois sur sous-construction en tubes acier rectangulaires, membrane d'etancheite monocouche, isolation en mousse rigide, pare-vapeur, le tout sur dalle composite beton arme avec sous-face en plaques de platre de 12,5 mm. Le garde-corps est constitue de panneaux en verre feuillete de securite (VSG).",
    "thumbnail": "/images/thumb-wilkinson.jpg",
    "source": "Detail Magazine n10/2003 - Hochhaussanierung Empress State Building London, Wilkinson Eyre Architects",
    "materiaux": [
      "lames de bois",
      "tubes acier rectangulaires",
      "membrane etancheite monocouche",
      "mousse rigide isolation",
      "pare-vapeur",
      "dalle composite beton arme",
      "plaques de platre 12,5 mm",
      "verre feuillete de securite VSG"
    ],
    "points_cles": [
      "Platelage bois sur sous-construction acier tubulaire pour terrasse accessible",
      "Complexe etancheite monocouche sur isolation rigide et pare-vapeur",
      "Dalle composite beton arme servant de support structurel",
      "Garde-corps en verre feuillete de securite (VSG) pour transparence maximale",
      "Sous-face en placoplatre 12,5 mm pour finition interieure"
    ]
  },
  {
    "id": "detail-2003-london-03",
    "title": "Coupe sur extension en toiture - Dachaufsatz 4 etages avec restaurant tournant",
    "fabricant": "Detail Magazine",
    "systeme": "Superstructure legere acier avec facade verre suspendue et protections solaires multiples",
    "categorie": "structure",
    "tags": [
      "superstructure",
      "extension toiture",
      "structure acier legere",
      "aileron verre",
      "glasschwert",
      "fixation ponctuelle",
      "nacelle nettoyage",
      "filet inox",
      "caillebotis aluminium",
      "protection solaire",
      "restaurant tournant",
      "rehabilitation",
      "highrise",
      "dalle existante beton"
    ],
    "description": "Extension de quatre etages en structure acier legere ajoutee en toiture du Empress State Building, rendue possible par l'allegement du batiment existant (remplacement des chapes par planchers techniques). La facade comprend des profiles aluminium avec ailerons en verre fixes ponctuellement et suspendus, un rail pour nacelle de nettoyage, une protection solaire en maille d'acier inoxydable et en caillebotis aluminium. La toiture reprend le meme complexe terrasse que la facade sud.",
    "thumbnail": "/images/thumb-wilkinson.jpg",
    "source": "Detail Magazine n10/2003 - Hochhaussanierung Empress State Building London, Wilkinson Eyre Architects",
    "materiaux": [
      "structure acier legere",
      "profiles aluminium",
      "ailerons verre point-fixed",
      "maille acier inoxydable",
      "caillebotis aluminium",
      "lamelles aluminium extrude",
      "dalle composite beton arme",
      "dalle beton arme existante"
    ],
    "points_cles": [
      "Quatre etages supplementaires rendus possibles par compensation de poids sur le batiment existant",
      "Ailerons en verre suspendus avec fixations ponctuelles pour rigidification de la facade",
      "Double systeme de protection solaire : maille inox et caillebotis aluminium selon les orientations",
      "Rail integre pour nacelle de nettoyage de facade en partie haute",
      "Appui de la superstructure legere sur la dalle beton arme existante"
    ]
  },
  {
    "id": "detail-2003-london-04",
    "title": "Extensions basses en socle - Structures courbes biaises autour de la base du tour",
    "fabricant": "Detail Magazine",
    "systeme": "Extensions courbes a deux niveaux en structure acier legere au pied de tour",
    "categorie": "structure",
    "tags": [
      "socle",
      "extension basse",
      "structure acier",
      "coupe-vent",
      "confort pietonnier",
      "foyer",
      "cafeteria",
      "locaux techniques",
      "bureaux",
      "arcades",
      "rehabilitation",
      "highrise",
      "vent",
      "urbanisme"
    ],
    "description": "Extensions courbes a deux niveaux disposees autour des faces concaves de la base du Empress State Building. Ces structures legeres en acier accueillent le foyer, la cafeteria, les locaux techniques ainsi que des bureaux et salles de conference supplementaires. Elles jouent egalement un role aerodynamique essentiel en reduisant les vitesses de vent elevees au niveau pietonnier. Un batiment d'entree de trois etages reprend la hauteur du bati riverain et mene par des arcades couvertes vers le parvis du tour.",
    "thumbnail": "/images/thumb-wilkinson.jpg",
    "source": "Detail Magazine n10/2003 - Hochhaussanierung Empress State Building London, Wilkinson Eyre Architects",
    "materiaux": [
      "structure acier legere",
      "beton arme existant",
      "marbre conservation colonnes foyer",
      "pierre naturelle conservation noyaux"
    ],
    "points_cles": [
      "Extensions courbes epousant les faces concaves de la tour pour reduire les effets de vent au sol",
      "Programme mixte : foyer, cafeteria, technique, bureaux et salles de conference",
      "Structure legere en acier contreventee par le batiment existant en beton arme",
      "Batiment d'entree de trois etages assurant la transition d'echelle avec le tissu urbain environnant",
      "Arcades couvertes reliant l'entree au parvis du tour en retrait"
    ]
  },
  {
    "id": "detail-2003-shizuoka-01",
    "title": "Facade pivotante shitomido en panneaux GFK sur ossature acier",
    "fabricant": "Detail Magazine",
    "systeme": "Facade operable a elements pivotants GFK sur cadre aluminium avec mecanisme motorise",
    "categorie": "facade",
    "tags": [
      "facade pivotante",
      "shitomido",
      "GFK",
      "panneaux translucides",
      "stegplatten",
      "fibre de verre",
      "cadre aluminium",
      "motorisation",
      "protection solaire",
      "facade operable",
      "Shigeru Ban",
      "papier",
      "musee",
      "ossature acier",
      "zahnkranz",
      "engrenage"
    ],
    "description": "Facade composee de panneaux GFK-Stegplatten translucides (100/300/40 mm) montes dans des cadres aluminium RHS (100/50/2 mm et 84/32/2 mm), pivotant jusqu'a 90 degres autour d'un point de rotation en tete. Le mecanisme comprend un antriebszahnkranz (couronne dentee), des rouleaux de guidage, des tubes d'extension RHS (100/50/3,2 mm) coulissant dans des rails de guidage, et un moteur avec tige d'entrainement. Un textile en fibre de verre avec revetement PTFE complete le dispositif de protection solaire, reprenant le principe du shitomido de l'architecture traditionnelle japonaise.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Shizuoka+Facade+Pivotante",
    "source": "Detail Magazine n7-8/2003 - Papiermuseum in Shizuoka, Shigeru Ban Architects",
    "materiaux": [
      "panneaux GFK-Stegplatten translucides",
      "profiles aluminium RHS",
      "acier profile IPE 600/400/12/40 mm",
      "tube aluminium SHS 50/50/1,6 mm",
      "tube acier RHS 100/50/3,2 mm",
      "tissu fibre de verre revetement PTFE",
      "moteur electrique"
    ],
    "points_cles": [
      "Elements de facade pivotant a 90 degres servant de brise-soleil selon le principe traditionnel japonais shitomido",
      "Mecanisme motorise avec couronne dentee, rouleaux de guidage et tige d'entrainement permettant l'ouverture automatisee sur toute la hauteur d'etage",
      "Panneaux GFK alveolaires translucides de 40 mm dans cadres aluminium combinant legerte, translucidite et resistance mecanique"
    ]
  },
  {
    "id": "detail-2003-shizuoka-02",
    "title": "Toiture musee avec dalles calcaire sur plots et dalle beton a nervures",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture sur dalle beton nervuree avec etancheite et revetement pierre naturelle sur plots",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "dalle beton nervuree",
      "kalksteinplatten",
      "calcaire",
      "plots",
      "etancheite",
      "beton de pente",
      "Stahlbetonrippendecke",
      "toiture plate",
      "toiture accessible",
      "musee"
    ],
    "description": "Composition de toiture comprenant une dalle beton arme nervuree de 250 mm d'epaisseur, un beton de pente de 100 a 200 mm assurant l'ecoulement des eaux, une membrane d'etancheite bitumineuse, et un revetement final en dalles de calcaire (gres) de 20 mm posees sur plots. Cette toiture plate constitue la couverture du batiment musee a trois niveaux et integre le point de rotation des elements de facade pivotants shitomido.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Shizuoka+Toiture",
    "source": "Detail Magazine n7-8/2003 - Papiermuseum in Shizuoka, Shigeru Ban Architects",
    "materiaux": [
      "dalles calcaire 20 mm",
      "membrane etancheite bitumineuse",
      "beton de pente 100-200 mm",
      "dalle beton arme nervuree 250 mm",
      "plots de surelevement"
    ],
    "points_cles": [
      "Dalle beton arme a nervures de 250 mm offrant une portee structurelle importante pour les espaces d'exposition",
      "Beton de pente variable de 100 a 200 mm assurant le drainage gravitaire vers les descentes d'eaux pluviales",
      "Dalles de pierre naturelle calcaire posees sur plots permettant l'accessibilite de la membrane d'etancheite pour maintenance"
    ]
  },
  {
    "id": "detail-2003-shizuoka-03",
    "title": "Facade coulissante galerie avec panneaux GFK sur rails en porte-a-faux",
    "fabricant": "Detail Magazine",
    "systeme": "Facade coulissante a segments GFK sur rails metalliques en porte-a-faux de 5 metres",
    "categorie": "facade",
    "tags": [
      "facade coulissante",
      "GFK",
      "panneaux translucides",
      "rail en porte-a-faux",
      "galerie",
      "terrasse couverte",
      "ossature acier",
      "contreventement",
      "cable acier",
      "tirant",
      "porte coulissante",
      "transformation",
      "reconversion"
    ],
    "description": "Six segments de facade pleine hauteur composes de panneaux GFK alveolaires de 50 mm montes dans des cadres en corniere acier (L 45/70-180 mm et L 50/50/4 mm), coulissant vers l'exterieur le long de rails de guidage en porte-a-faux de 5 metres. Le systeme repose sur une structure existante renforcee avec des profiles acier IPE (250/125/6/9 mm), des tubes acier (diametre 114,3/6 mm et SHS 150/150/9 mm), un contreventement par tirants acier (diametre 20 mm) et cables (diametre 8 mm). Les panneaux coulissants creent un auvent au-dessus de la terrasse tout en ouvrant l'espace d'exposition sur la nature environnante.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Shizuoka+Facade+Coulissante",
    "source": "Detail Magazine n7-8/2003 - Papiermuseum in Shizuoka, Shigeru Ban Architects",
    "materiaux": [
      "panneaux GFK alveolaires 50 mm",
      "cornieres acier L 45/70-180 mm",
      "profile acier IPE 250/125/6/9 mm",
      "tube acier diametre 114,3/6 mm",
      "tube acier SHS 150/150/9 mm",
      "tirant acier diametre 20 mm",
      "cable acier diametre 8 mm",
      "bobine de verrouillage",
      "cordel de traction"
    ],
    "points_cles": [
      "Six segments de facade coulissant sur des rails en porte-a-faux de 5 metres pour creer simultanement un auvent de terrasse et une ouverture totale de la galerie",
      "Structure de guidage en porte-a-faux contreventee par cables et tirants acier supportant le poids des panneaux GFK en position deployee",
      "Reconversion d'un batiment existant (ancienne werkstatt) avec conservation de la structure acier et de la dalle beton, ajout d'un estrich de 30 mm avec peinture de protection"
    ]
  },
  {
    "id": "detail-2003-shizuoka-04",
    "title": "Jonction sol interieur musee avec parquet cerisier et porte coulissante vitree",
    "fabricant": "Detail Magazine",
    "systeme": "Sol interieur parquet sur dalle beton avec seuil de porte coulissante aluminium et revetement pierre naturelle exterieur",
    "categorie": "jonction_menuiserie",
    "tags": [
      "parquet cerisier",
      "porte coulissante",
      "vitrage simple",
      "cadre aluminium",
      "marbre",
      "seuil",
      "sol interieur",
      "transition interieur exterieur",
      "musee",
      "Shigeru Ban"
    ],
    "description": "Jonction au niveau du sol entre l'espace d'exposition interieur et l'exterieur, comprenant un parquet en cerisier de 20 mm en finition interieure, une porte coulissante a simple vitrage dans un cadre aluminium assurant la fermeture, et des dalles de marbre de 15 mm en revetement de sol exterieur. Cette transition permet une continuite visuelle entre l'interieur du musee et le jardin lorsque les elements de facade shitomido sont ouverts.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Shizuoka+Jonction+Sol",
    "source": "Detail Magazine n7-8/2003 - Papiermuseum in Shizuoka, Shigeru Ban Architects",
    "materiaux": [
      "parquet cerisier 20 mm",
      "porte coulissante aluminium vitrage simple",
      "dalles marbre 15 mm",
      "profile acier IPE 600/400/12/40 mm"
    ],
    "points_cles": [
      "Transition interieur-exterieur par porte coulissante aluminium a simple vitrage offrant une ouverture maximale combinee avec les volets shitomido",
      "Parquet cerisier de 20 mm en finition noble coherente avec la thematique du musee dedie aux arts du papier et aux materiaux naturels",
      "Dalles de marbre de 15 mm en revetement exterieur assurant la durabilite et le drainage au seuil de la facade operable"
    ]
  },
  {
    "id": "detail-2006-azuma-01",
    "title": "Paroi cylindrique autoportante en tôle d'acier préfabriquée",
    "fabricant": "Detail Magazine",
    "systeme": "Cylindres autoportants en éléments de tôle d'acier préfabriqués (technologie silo)",
    "categorie": "structure",
    "tags": [
      "cylindre",
      "acier",
      "tôle",
      "préfabriqué",
      "silo",
      "autoportant",
      "paroi courbe",
      "musée",
      "structure porteuse",
      "éléments préfabriqués",
      "sans poteaux",
      "steel sheet"
    ],
    "description": "Les 33 espaces cylindriques du musée sont constitués d'éléments de tôle d'acier préfabriqués assemblés pour former des volumes autoportants, réalisés par une entreprise spécialisée dans la construction de silos. Cette technique élimine le besoin de poteaux ou de couloirs structurels, chaque cylindre assurant sa propre stabilité. Les perforations ponctuelles dans les parois permettent des vues cadrées vers les cours intérieures plantées.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Azuma+Structure+Cylindre",
    "source": "Detail Magazine n9/2006 - Tomihiro Art Museum Azuma, aat+Makoto Yokomizo architects",
    "materiaux": [
      "tôle d'acier préfabriquée",
      "acier",
      "éléments de silo industriel"
    ],
    "points_cles": [
      "Cylindres autoportants sans structure de poteaux additionnelle",
      "Technologie de construction de silos transférée à l'architecture muséale",
      "Perforations dans les parois courbes pour cadrer les vues sur les cours plantées"
    ]
  },
  {
    "id": "detail-2006-azuma-02",
    "title": "Toiture plane sur volumes cylindriques juxtaposés",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture plane sur plan carré avec découpe cylindrique",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "plane",
      "cylindre",
      "cours intérieures",
      "puits de lumière",
      "ouvert au ciel",
      "plan carré",
      "bâtiment de plain-pied",
      "rez-de-chaussée",
      "lumière zénithale",
      "roof"
    ],
    "description": "La toiture du musée, visible depuis les collines environnantes, révèle le principe constructif sous-jacent de manière quasi abstraite : les sommets des cylindres de diamètres variés sont couverts individuellement et les interstices entre eux forment des cours ouvertes sur le ciel. Le bâtiment est de plain-pied sur un plan carré, les cylindres périphériques étant découpés au droit des façades pour s'inscrire exactement dans le carré.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Azuma+Toiture+Cylindres",
    "source": "Detail Magazine n9/2006 - Tomihiro Art Museum Azuma, aat+Makoto Yokomizo architects",
    "materiaux": [
      "tôle d'acier",
      "couverture métallique",
      "étanchéité"
    ],
    "points_cles": [
      "Toiture lisible depuis les hauteurs comme motif abstrait de cercles",
      "Cours intérieures ouvertes au ciel entre les cylindres servant de puits de lumière naturelle",
      "Découpe des cylindres périphériques pour s'inscrire dans le périmètre carré du bâtiment"
    ]
  },
  {
    "id": "detail-2006-azuma-03",
    "title": "Jonction entre cylindres et parois vitrées ouvrant sur cours et lac",
    "fabricant": "Detail Magazine",
    "systeme": "Paroi vitrée insérée dans enveloppe cylindrique en acier",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrage",
      "paroi vitrée",
      "cylindre",
      "ouverture",
      "cour intérieure",
      "lac",
      "transparence",
      "menuiserie courbe",
      "jonction acier-verre",
      "lumière naturelle",
      "vue"
    ],
    "description": "Certains des cylindres d'exposition s'ouvrent par des parois entièrement vitrées soit vers l'une des cours intérieures plantées, soit vers le lac artificiel adjacent. La jonction entre la structure en tôle d'acier courbe et les menuiseries vitrées crée une alternance entre espaces introvertis et espaces ouverts, modulant l'ambiance de chaque salle. Ce dispositif permet une relation directe entre les œuvres de nature peintes par Tomihiro et la végétation réelle des cours.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Azuma+Jonction+Vitrage",
    "source": "Detail Magazine n9/2006 - Tomihiro Art Museum Azuma, aat+Makoto Yokomizo architects",
    "materiaux": [
      "tôle d'acier",
      "vitrage",
      "menuiserie",
      "profilés acier"
    ],
    "points_cles": [
      "Alternance entre parois opaques en acier et parois vitrées selon les cylindres",
      "Ouvertures vitrées orientées vers les cours plantées ou le lac artificiel",
      "Dialogue entre les représentations de nature de l'artiste et la végétation réelle visible"
    ]
  },
  {
    "id": "detail-2006-azuma-04",
    "title": "Traitement intérieur différencié des cylindres d'exposition",
    "fabricant": "Detail Magazine",
    "systeme": "Revêtements intérieurs variés sur parois cylindriques en acier",
    "categorie": "amenagement_interieur",
    "tags": [
      "revêtement intérieur",
      "cylindre",
      "palette chromatique",
      "matériaux variés",
      "ambiance",
      "musée",
      "surface murale",
      "couleur",
      "paysage",
      "autonomie spatiale",
      "exposition",
      "petit format"
    ],
    "description": "Chaque cylindre d'exposition reçoit un traitement intérieur spécifique avec des matériaux et des couleurs différents, définis conjointement par l'architecte et l'artiste Tomihiro Hoshino à partir d'une palette de tons issus du paysage environnant. L'objectif était de créer des espaces autonomes et non neutres, dont l'atmosphère varie entre ouvert et fermé, chaud et froid. Les œuvres de petit format sont ainsi mises en valeur par des ambiances spatiales singulières.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Azuma+Amenagement+Interieur",
    "source": "Detail Magazine n9/2006 - Tomihiro Art Museum Azuma, aat+Makoto Yokomizo architects",
    "materiaux": [
      "revêtements muraux variés",
      "tôle d'acier (support)",
      "finitions intérieures multiples",
      "peinture"
    ],
    "points_cles": [
      "Palette chromatique unique par cylindre inspirée du paysage local",
      "Materials et finitions différenciés pour créer des ambiances autonomes",
      "Collaboration directe artiste-architecte pour la définition des atmosphères spatiales"
    ]
  },
  {
    "id": "detail-2007-tokyo-01",
    "title": "Façade mixte verre translucide, panneaux métalliques et grilles bois sur ossature acier",
    "fabricant": "Detail Magazine",
    "systeme": "Façade légère multi-matériaux sur structure acier",
    "categorie": "facade",
    "tags": [
      "verre translucide",
      "verre transparent",
      "panneaux métalliques",
      "grille bois",
      "ossature acier",
      "façade mixte",
      "hôtel",
      "Japon",
      "minimaliste",
      "budget",
      "ryokan"
    ],
    "description": "Façade composite enveloppant une structure à ossature acier (Stahlskelettbau), composée de panneaux de verre translucide et transparent, de panneaux métalliques et de grilles en bois. Cette combinaison de matériaux permet de moduler la lumière naturelle et l'intimité des chambres de seulement 7 m², tout en conférant au bâtiment une expression architecturale contemporaine évoquant la lanterne japonaise (andon).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Facade",
    "source": "Detail Magazine n3/2007 - Budget Hotel Andon Ryokan Tokyo, Masayuki Irie",
    "materiaux": [
      "verre translucide",
      "verre transparent",
      "panneaux métalliques",
      "grilles bois",
      "acier de structure"
    ],
    "points_cles": [
      "Enveloppe multi-matériaux sur squelette acier permettant légèreté et économie",
      "Alternance de transparence et translucidité pour moduler intimité et lumière naturelle",
      "Grilles bois rappelant les treillis traditionnels japonais (kōshi) en interprétation contemporaine"
    ]
  },
  {
    "id": "detail-2007-tokyo-02",
    "title": "Habillage plafond de couloirs en panneaux de métal déployé (Streckmetall)",
    "fabricant": "Detail Magazine",
    "systeme": "Faux-plafond en métal déployé",
    "categorie": "amenagement_interieur",
    "tags": [
      "métal déployé",
      "streckmetall",
      "faux-plafond",
      "couloir",
      "éclairage indirect",
      "noir",
      "hôtel",
      "ambiance",
      "Japon"
    ],
    "description": "Les plafonds des couloirs sont revêtus de panneaux en métal déployé (Streckmetallplatten) dans une finition noire intégrale. Ce dispositif dissimule les réseaux techniques tout en laissant filtrer la lumière des luminaires encastrés, créant un effet de profondeur et une atmosphère mystérieuse contrastant avec les chambres blanches et lumineuses.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Plafond",
    "source": "Detail Magazine n3/2007 - Budget Hotel Andon Ryokan Tokyo, Masayuki Irie",
    "materiaux": [
      "métal déployé",
      "luminaires plafonniers",
      "peinture noire"
    ],
    "points_cles": [
      "Métal déployé en sous-face permettant ventilation et passage de lumière",
      "Finition noire intégrale des couloirs créant un contraste dramatique avec les espaces blancs",
      "Solution économique et contemporaine rappelant les cloisons shoji réinterprétées en métal"
    ]
  },
  {
    "id": "detail-2007-tokyo-03",
    "title": "Cloisons coulissantes en métal déployé – réinterprétation des shoji",
    "fabricant": "Detail Magazine",
    "systeme": "Cloisons coulissantes intérieures en métal déployé",
    "categorie": "amenagement_interieur",
    "tags": [
      "cloison coulissante",
      "métal déployé",
      "shoji",
      "partition mobile",
      "espace ouvert",
      "réception",
      "cuisine",
      "polyvalence",
      "japonais",
      "minimaliste"
    ],
    "description": "Les espaces communs du rez-de-chaussée (réception, cuisine, espace petit-déjeuner) forment un volume ouvert subdivisable par des éléments coulissants en métal déployé. Ces panneaux mobiles constituent une réinterprétation contemporaine des shoji traditionnels (cloisons coulissantes en papier), permettant une flexibilité spatiale maximale sur une emprise au sol très réduite (148,58 m²).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Cloison",
    "source": "Detail Magazine n3/2007 - Budget Hotel Andon Ryokan Tokyo, Masayuki Irie",
    "materiaux": [
      "métal déployé",
      "rails coulissants",
      "acier"
    ],
    "points_cles": [
      "Réinterprétation moderne des cloisons shoji japonaises en métal déployé",
      "Flexibilité spatiale maximale dans un plan compact de 148,58 m² au sol",
      "Réception escamotable fermée le soir comme un placard, optimisant chaque centimètre"
    ]
  },
  {
    "id": "detail-2007-tokyo-04",
    "title": "Chambre modulaire minimale 7 m² – module tatami et fenêtres coulissantes toute hauteur",
    "fabricant": "Detail Magazine",
    "systeme": "Cellule hôtelière compacte sur trame tatami",
    "categorie": "amenagement_interieur",
    "tags": [
      "chambre minimale",
      "tatami",
      "futon",
      "fenêtre coulissante toute hauteur",
      "surfaces blanches",
      "micro-espace",
      "hôtel compact",
      "placard intégré",
      "Japon",
      "ryokan",
      "optimisation spatiale"
    ],
    "description": "Chambres de 7 m² conçues sur le module dimensionnel du tatami (environ 90 × 180 cm), conformément à la tradition japonaise. L'aménagement se limite à un placard intégré ; le futon est déroulé au sol le soir. Des fenêtres coulissantes toute hauteur et des surfaces entièrement blanches maximisent la luminosité et la sensation d'espace malgré l'exiguïté, tandis que les sanitaires mutualisés en noyau central libèrent la surface utile des chambres.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Chambre",
    "source": "Detail Magazine n3/2007 - Budget Hotel Andon Ryokan Tokyo, Masayuki Irie",
    "materiaux": [
      "tatami",
      "futon",
      "verre coulissant toute hauteur",
      "surfaces blanches",
      "placard intégré bois"
    ],
    "points_cles": [
      "Module dimensionnel basé sur le tatami (90 × 180 cm) structurant le plan des chambres",
      "Fenêtres coulissantes toute hauteur pour maximiser lumière et ventilation dans 7 m²",
      "Sanitaires mutualisés par étage dans le noyau central, libérant l'intégralité de la surface chambre"
    ]
  },
  {
    "id": "detail-2008-tokio-01",
    "title": "Toiture-terrasse accessible en anneau - Kindergarten Fuji",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture-terrasse praticable ovale servant de cour de récréation",
    "categorie": "toiture",
    "tags": [
      "toiture-terrasse",
      "accessible",
      "aire de jeux",
      "kindergarten",
      "anneau",
      "ovale",
      "garde-corps",
      "grille",
      "enfants",
      "Montessori",
      "Tezuka",
      "Japon",
      "bois",
      "circulation en boucle"
    ],
    "description": "Toiture-terrasse en forme d'anneau ovale continu servant simultanément de cour de récréation et d'espace pédagogique en plein air pour 560 enfants. Le pourtour intérieur donnant sur la cour est équipé d'un garde-corps à barreaux permettant aux enfants de s'asseoir au bord et de laisser pendre leurs jambes à travers la grille. La conception vise à maximiser les surfaces extérieures en compensant l'emprise au sol du bâtiment.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokio+Toiture+Terrasse",
    "source": "Detail Magazine n3/2008 - Fuji Kindergarten, Tezuka Architects (Takaharu + Yui Tezuka)",
    "materiaux": [
      "bois",
      "acier",
      "grille métallique garde-corps",
      "étanchéité toiture-terrasse"
    ],
    "points_cles": [
      "Toiture ovale en anneau continu sans extrémité, créant un parcours de jeu infini pour les enfants",
      "Garde-corps intérieur en grille métallique permettant aux enfants de s'asseoir et d'observer la cour en contrebas",
      "Toiture conçue comme espace multifonctionnel : aire de jeux, salle de classe extérieure, espace de rassemblement"
    ]
  },
  {
    "id": "detail-2008-tokio-02",
    "title": "Espace continu ouvert avec cloisons mobiles - Groupes Kindergarten Fuji",
    "fabricant": "Detail Magazine",
    "systeme": "Continuum spatial ouvert avec zonage par éléments mobiles",
    "categorie": "amenagement_interieur",
    "tags": [
      "cloisons mobiles",
      "open plan",
      "espace continu",
      "flexibilité",
      "kindergarten",
      "Montessori",
      "transparence",
      "modularité",
      "groupes",
      "sécurité visuelle",
      "Tezuka"
    ],
    "description": "Espace intérieur conçu comme un continuum spatial continu sans cloisonnement fixe, zonifié uniquement par des éléments mobiliers amovibles. Cette configuration élimine les angles morts et permet une surveillance constante des enfants, tout en offrant la possibilité de créer un grand espace de rassemblement pour 600 personnes lorsque toutes les cloisons sont retirées.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokio+Cloisons+Mobiles",
    "source": "Detail Magazine n3/2008 - Fuji Kindergarten, Tezuka Architects (Takaharu + Yui Tezuka)",
    "materiaux": [
      "bois",
      "panneaux mobiles",
      "structure poteaux-poutres",
      "sol continu"
    ],
    "points_cles": [
      "Absence de murs fixes entre les groupes : espace continu sans fin réelle, réduisant le harcèlement et améliorant la surveillance",
      "Cloisons entièrement amovibles permettant de passer de salles de groupe à un espace unique de 600 personnes pour les cérémonies",
      "Conception pédagogique Montessori favorisant la visibilité mutuelle et l'apprentissage de la cohabitation entre groupes d'âges mixtes (3-4 ans)"
    ]
  },
  {
    "id": "detail-2008-tokio-03",
    "title": "Façade ouverte transparente avec arbres traversants - Kindergarten Fuji",
    "fabricant": "Detail Magazine",
    "systeme": "Façade vitrée ouverte avec intégration d'arbres existants traversant la structure",
    "categorie": "facade",
    "tags": [
      "façade ouverte",
      "transparence",
      "arbre traversant",
      "perméabilité visuelle",
      "intérieur-extérieur",
      "lumière naturelle",
      "ventilation naturelle",
      "kindergarten",
      "Tezuka",
      "Japon",
      "cour intérieure"
    ],
    "description": "Façade largement vitrée et ouvrable assurant une perméabilité visuelle totale depuis la cour intérieure, la rue et le toit. Des arbres existants traversent la structure du bâtiment, pénétrant à travers le plancher et la toiture-terrasse. Cette transparence permet aux enfants de percevoir les variations lumineuses, le ciel, la pluie et les saisons même depuis l'intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokio+Facade+Ouverte",
    "source": "Detail Magazine n3/2008 - Fuji Kindergarten, Tezuka Architects (Takaharu + Yui Tezuka)",
    "materiaux": [
      "verre",
      "bois",
      "acier",
      "végétation existante intégrée"
    ],
    "points_cles": [
      "Façade entièrement vitrée et ouvrable offrant une visibilité depuis la cour, la rue et le toit pour une philosophie d'acceptation de toutes les formes d'existence",
      "Arbres existants conservés et intégrés à travers la structure, renforçant le lien entre architecture et nature",
      "Conception volontairement non automatisée (pas de capteurs ni de bus domotique) favorisant l'interaction physique directe des enfants avec les éléments du bâtiment"
    ]
  },
  {
    "id": "detail-2008-tokio-04",
    "title": "Structure annulaire poteaux-poutres avec cour intérieure - Kindergarten Fuji",
    "fabricant": "Detail Magazine",
    "systeme": "Structure porteuse annulaire ovale en poteaux-poutres supportant toiture-terrasse praticable",
    "categorie": "structure",
    "tags": [
      "structure annulaire",
      "ovale",
      "poteaux-poutres",
      "toiture accessible",
      "cour intérieure",
      "portée libre",
      "kindergarten",
      "Tezuka",
      "plancher toiture",
      "charge exploitation",
      "aire de jeux en toiture"
    ],
    "description": "Structure porteuse en forme d'anneau ovale organisée autour d'une cour intérieure centrale, supportant une toiture-terrasse praticable conçue pour accueillir simultanément 560 enfants en activité. Le système poteaux-poutres libère de grandes portées au rez-de-chaussée permettant le continuum spatial ouvert des salles de groupe, tout en assurant la résistance structurelle nécessaire aux charges d'exploitation élevées de la terrasse-playground.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokio+Structure+Annulaire",
    "source": "Detail Magazine n3/2008 - Fuji Kindergarten, Tezuka Architects (Takaharu + Yui Tezuka)",
    "materiaux": [
      "acier",
      "bois",
      "béton",
      "fondations"
    ],
    "points_cles": [
      "Forme ovale annulaire créant un parcours continu sans début ni fin, tant en plan qu'en toiture",
      "Structure dimensionnée pour supporter les charges dynamiques de 560 enfants jouant simultanément sur la toiture-terrasse",
      "Système poteaux-poutres à grandes portées libérant le plan intérieur de tout mur porteur pour permettre la flexibilité totale des cloisons mobiles"
    ]
  },
  {
    "id": "detail-2010-ageo-01",
    "title": "Poutre-couronnement béton de l'atrium sans poteaux",
    "fabricant": "Detail Magazine",
    "systeme": "Poutre de rive haute (Überzug) portant la toiture sur cour intérieure",
    "categorie": "structure",
    "tags": [
      "atrium",
      "poutre",
      "béton",
      "sans poteaux",
      "upstand beam",
      "deep beam",
      "toiture",
      "cour intérieure",
      "portée libre",
      "Japon",
      "Tezuka"
    ],
    "description": "Poutre périphérique en béton armé de 1,50 m de hauteur couronnant l'atrium et portant la toiture sans aucun poteau intermédiaire dans la cour intérieure. Cet élément structural massif fonctionne comme un cadre blanc qui encadre le ciel vu depuis le patio, tout en assurant la reprise des charges de couverture sur les murs périphériques. La hauteur importante de la poutre permet de franchir les portées de la cour sans appuis intermédiaires.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ageo+Structure+Atrium",
    "source": "Detail Magazine n3/2010 - Atriumhaus in Ageo, Tezuka Architects",
    "materiaux": [
      "béton armé",
      "enduit blanc"
    ],
    "points_cles": [
      "Poutre-couronnement (Überzug) de 1,50 m de hauteur portant la toiture",
      "Atrium entièrement libre de poteaux grâce à ce dispositif structural périphérique",
      "Cadrage visuel du ciel comme un tableau dans un cadre blanc"
    ]
  },
  {
    "id": "detail-2010-ageo-02",
    "title": "Menuiseries coulissantes bois-verre sur cour intérieure",
    "fabricant": "Detail Magazine",
    "systeme": "Portes coulissantes vitrées à châssis bois ouvrant sur atrium",
    "categorie": "jonction_menuiserie",
    "tags": [
      "porte coulissante",
      "vitrage",
      "bois",
      "châssis bois",
      "atrium",
      "cour intérieure",
      "shoji",
      "transparence",
      "seuil",
      "Japon",
      "Tezuka"
    ],
    "description": "Grandes portes coulissantes vitrées avec encadrement en bois donnant sur la cour intérieure, permettant une ouverture totale des espaces de vie sur le patio. Le système de coulissement permet de libérer entièrement la façade intérieure et de créer une continuité entre les espaces couverts et la cour extérieure protégée. Le seuil en béton légèrement surélevé marque la transition entre intérieur et extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ageo+Menuiserie+Coulissante",
    "source": "Detail Magazine n3/2010 - Atriumhaus in Ageo, Tezuka Architects",
    "materiaux": [
      "bois",
      "vitrage",
      "béton"
    ],
    "points_cles": [
      "Portes coulissantes vitrées de grande dimension à châssis bois",
      "Seuil en béton surélevé séparant visuellement intérieur et cour",
      "Ouverture totale possible vers l'atrium pour fluidité spatiale"
    ]
  },
  {
    "id": "detail-2010-ageo-03",
    "title": "Seuils et transition de matériaux bois-béton-pierre",
    "fabricant": "Detail Magazine",
    "systeme": "Séquence de seuils et de matériaux de sol à la japonaise",
    "categorie": "soubassement",
    "tags": [
      "seuil",
      "béton",
      "bois",
      "pierre",
      "transition",
      "sol",
      "temple japonais",
      "engawa",
      "tatami",
      "matérialité",
      "Tezuka"
    ],
    "description": "Séquence matérielle graduée bois – béton – pierre lors du passage de l'intérieur vers la cour, rappelant les seuils des temples japonais traditionnels. Les seuils en béton sont légèrement surélevés au-dessus du sol, créant une séparation visuelle flottante entre la maison et le patio. Cette stratification de matériaux marque les transitions spatiales et hiérarchise les usages entre espace habitable, galerie et cour.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ageo+Seuil+Materiaux",
    "source": "Detail Magazine n3/2010 - Atriumhaus in Ageo, Tezuka Architects",
    "materiaux": [
      "bois",
      "béton",
      "pierre"
    ],
    "points_cles": [
      "Séquence matérielle bois-béton-pierre inspirée des temples japonais",
      "Seuils béton flottants séparant visuellement maison et cour",
      "Hiérarchisation des espaces par la matérialité et les niveaux de sol"
    ]
  },
  {
    "id": "detail-2010-ageo-04",
    "title": "Façade ouest vitrée avec stores et cloisons coulissantes intérieures",
    "fabricant": "Detail Magazine",
    "systeme": "Façade vitrée avec jalousies et panneaux coulissants bois pour modularité",
    "categorie": "facade",
    "tags": [
      "façade vitrée",
      "jalousie",
      "store",
      "cloison coulissante",
      "bois",
      "modularité",
      "chambre",
      "tatami",
      "intimité",
      "flexibilité",
      "Tezuka"
    ],
    "description": "Grande façade vitrée orientée ouest constituant l'unique ouverture du bâtiment vers l'extérieur, équipée de jalousies pour contrôler les vues et la lumière. À l'intérieur, des cloisons coulissantes en bois permettent de transformer l'espace nuit (tatamis déroulés) en extension du séjour-salle à manger en configuration L durant la journée. Le dispositif prévoit l'insertion future d'une cloison fixe séparant chambre parents et chambre enfants.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ageo+Facade+Vitree",
    "source": "Detail Magazine n3/2010 - Atriumhaus in Ageo, Tezuka Architects",
    "materiaux": [
      "vitrage",
      "bois",
      "aluminium",
      "tatami"
    ],
    "points_cles": [
      "Unique ouverture extérieure du bâtiment orientée ouest avec grande façade vitrée",
      "Jalousies extérieures pour contrôle de l'intimité et de la lumière",
      "Cloisons coulissantes bois intérieures permettant un plan flexible jour/nuit en L"
    ]
  },
  {
    "id": "detail-2010-sapporo-01",
    "title": "Mur extérieur en ossature bois avec bardage zinc à joints debout",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature bois légère avec parement zinc",
    "categorie": "facade",
    "tags": [
      "ossature bois",
      "zinc",
      "joints debout",
      "stehfalz",
      "isolation mince",
      "14cm",
      "mur mince",
      "bardage métallique",
      "timber frame",
      "cold climate",
      "sapporo",
      "résidentiel"
    ],
    "description": "Mur extérieur de seulement 14 cm d'épaisseur totale en ossature bois (Holzständerbauweise) avec isolation thermique de 10 cm. Parement extérieur en bandes de zinc à joints debout (Zinkblechbahnen mit Stehfalzen). Cette épaisseur de paroi, exceptionnellement mince pour un climat nordique avec des chutes de neige allant jusqu'à 2 mètres, résulte d'une optimisation budgétaire radicale.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sapporo+Facade+Zinc",
    "source": "Detail Magazine n3/2010 - Einfamilienhaus in Sapporo, Akasaka Shinichiro Atelier",
    "materiaux": [
      "zinc en bandes à joints debout",
      "ossature bois (montants)",
      "isolation thermique 100mm",
      "PVC blanc intérieur"
    ],
    "points_cles": [
      "Épaisseur totale du mur de seulement 14 cm, inhabituelle pour un climat froid",
      "Bardage zinc à joints debout assurant étanchéité et résistance à la neige abondante",
      "Isolation de 10 cm seulement dans les murs, compensée par 30 cm en toiture"
    ]
  },
  {
    "id": "detail-2010-sapporo-02",
    "title": "Toiture pliée isolée avec finition blanche et forte isolation",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture à géométrie pliée sur ossature bois",
    "categorie": "toiture",
    "tags": [
      "toiture pliée",
      "isolation 30cm",
      "lasure blanche",
      "neige",
      "zinc",
      "cold climate",
      "folded roof",
      "réflexion lumineuse",
      "sapporo",
      "dach"
    ],
    "description": "Toiture à géométrie multiple pliée (mehrfach gefaltet) avec lasure blanche intérieure maximisant la diffusion de lumière naturelle. L'isolation en toiture atteint 30 cm, soit trois fois l'épaisseur des murs, constituant l'essentiel de la performance thermique de l'enveloppe. La surface froide extérieure limite l'accumulation de neige sèche.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sapporo+Toiture+Pliee",
    "source": "Detail Magazine n3/2010 - Einfamilienhaus in Sapporo, Akasaka Shinichiro Atelier",
    "materiaux": [
      "isolation thermique 300mm",
      "ossature bois",
      "zinc extérieur",
      "lasure blanche intérieure"
    ],
    "points_cles": [
      "Isolation de 30 cm en toiture, principal rempart thermique du bâtiment",
      "Surface extérieure froide réduisant l'accumulation de neige sèche",
      "Géométrie pliée créant des hauteurs variables de 2,10 m à 4,82 m et diffusant la lumière"
    ]
  },
  {
    "id": "detail-2010-sapporo-03",
    "title": "Dalle sur sol en gradins suivant la topographie naturelle",
    "fabricant": "Detail Magazine",
    "systeme": "Dallage en gradins avec niveaux décalés",
    "categorie": "soubassement",
    "tags": [
      "dalle sur sol",
      "topographie",
      "gradins",
      "niveaux décalés",
      "split level",
      "fondation économique",
      "bodenplatte",
      "terrassement minimal",
      "sapporo",
      "budget réduit"
    ],
    "description": "Dalle de fondation (Bodenplatte) qui épouse le profil naturel du terrain grâce à une série de niveaux décalés en gradins au rez-de-chaussée et à l'étage. Ce principe de split-level permet de minimiser les travaux de terrassement et les coûts d'excavation, tout en créant une zonation spatiale intérieure sans recours à des portes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sapporo+Dalle+Gradins",
    "source": "Detail Magazine n3/2010 - Einfamilienhaus in Sapporo, Akasaka Shinichiro Atelier",
    "materiaux": [
      "béton (dalle de fondation)",
      "revêtement PVC blanc",
      "ossature bois (structure verticale)"
    ],
    "points_cles": [
      "La dalle suit le terrain naturel pour minimiser les coûts d'excavation",
      "Les niveaux décalés créent un zonage spatial sans portes ni cloisons",
      "Revêtement PVC blanc brillant sur tous les sols pour maximiser la réflexion lumineuse"
    ]
  },
  {
    "id": "detail-2010-sapporo-04",
    "title": "Fenêtres carrées en briques de verre et vitrages variés",
    "fabricant": "Detail Magazine",
    "systeme": "Ouvertures ponctuelles à transmission lumineuse différenciée",
    "categorie": "jonction_menuiserie",
    "tags": [
      "briques de verre",
      "fenêtres carrées",
      "vitrage",
      "transmission lumineuse",
      "glasbaustein",
      "light mood",
      "orientation solaire",
      "façade percée",
      "sapporo",
      "lumière naturelle"
    ],
    "description": "Fenêtres carrées de tailles différentes intégrées dans le mur ossature bois de 14 cm, composées soit de briques de verre (Glasbausteine) soit de vitrages à degrés de transmission lumineuse variés. Leur positionnement, apparemment aléatoire, est calibré selon la course du soleil, la végétation environnante et les réflexions intérieures pour créer des ambiances lumineuses changeantes au fil des saisons.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sapporo+Fenetres+Carrees",
    "source": "Detail Magazine n3/2010 - Einfamilienhaus in Sapporo, Akasaka Shinichiro Atelier",
    "materiaux": [
      "briques de verre",
      "vitrages à transmission variable",
      "ossature bois",
      "zinc (tableau extérieur)"
    ],
    "points_cles": [
      "Fenêtres carrées de dimensions variées positionnées selon la course solaire et l'environnement végétal",
      "Combinaison de briques de verre et de vitrages à différents degrés de transparence",
      "Priorité donnée à la qualité lumineuse intérieure plutôt qu'aux vues vers l'extérieur"
    ]
  },
  {
    "id": "detail-2010-amsterdam-osdorp-01",
    "title": "Façade vitrée sur rue – Reihenhäuser Osdorp",
    "fabricant": "Detail Magazine",
    "systeme": "Façade à grandes surfaces vitrées avec parement blanc",
    "categorie": "facade",
    "tags": [
      "facade",
      "vitrage",
      "grande surface vitrée",
      "enduit blanc",
      "maison en bande",
      "logement collectif",
      "Amsterdam",
      "modernisme",
      "répétition",
      "asymétrie",
      "Kempe Thill"
    ],
    "description": "Façade sur rue des maisons en bande (Reihenhäuser) conçues par Atelier Kempe Thill, caractérisée par de grandes surfaces vitrées et des surfaces blanches. Le traitement architectural contraste volontairement avec les barres de brique environnantes des années 1960, affirmant un langage moderniste contemporain basé sur la répétition et l'asymétrie des ouvertures.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Facade+Rue",
    "source": "Detail Magazine n3/2010 - Reihenhäuser Amsterdam-Osdorp, Atelier Kempe Thill",
    "materiaux": [
      "vitrage grande dimension",
      "enduit blanc",
      "structure béton"
    ],
    "points_cles": [
      "Grandes surfaces vitrées en façade pour maximiser la lumière naturelle",
      "Surfaces blanches contrastant avec le contexte de brique existant",
      "Composition répétitive et asymétrique caractéristique du langage moderniste"
    ]
  },
  {
    "id": "detail-2010-amsterdam-osdorp-02",
    "title": "Intégration du stationnement en rez-de-chaussée – Garage interne avec accès privatif",
    "fabricant": "Detail Magazine",
    "systeme": "Parking intégré au volume bâti avec voie d'accès interne",
    "categorie": "soubassement",
    "tags": [
      "parking intégré",
      "rez-de-chaussée",
      "garage",
      "nappe phréatique",
      "Pays-Bas",
      "accès interne",
      "maison en bande",
      "soubassement",
      "Amsterdam",
      "Kempe Thill",
      "logement économique"
    ],
    "description": "Système d'intégration des places de stationnement directement dans le volume des maisons en bande, avec une voie d'accès interne semi-publique traversant le bâtiment. Cette solution constructive a été déterminante dans le choix du projet car elle évite le recours à un parking souterrain, impossible aux Pays-Bas en raison du niveau élevé de la nappe phréatique et des coûts prohibitifs associés.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Parking+Integre",
    "source": "Detail Magazine n3/2010 - Reihenhäuser Amsterdam-Osdorp, Atelier Kempe Thill",
    "materiaux": [
      "béton",
      "revêtement de sol carrossable",
      "structure porteuse renforcée"
    ],
    "points_cles": [
      "Parking intégré au rez-de-chaussée évitant un sous-sol enterré coûteux",
      "Voie d'accès interne semi-publique desservant les garages individuels",
      "Solution adaptée au contexte néerlandais avec nappe phréatique haute"
    ]
  },
  {
    "id": "detail-2010-amsterdam-osdorp-03",
    "title": "Façade sur cour – Interface logement / espace semi-public",
    "fabricant": "Detail Magazine",
    "systeme": "Façade arrière vitrée ouvrant sur cour communautaire paysagée",
    "categorie": "facade",
    "tags": [
      "facade arrière",
      "cour intérieure",
      "espace semi-public",
      "jardin communautaire",
      "vitrage",
      "logement",
      "Amsterdam",
      "paysage",
      "Kempe Thill",
      "Van Gessel",
      "waterpark"
    ],
    "description": "Façade côté cour des maisons en bande donnant sur les espaces communautaires semi-publics en forme de U. Le traitement architectural assure la transition entre l'espace privé du logement et la cour paysagée connectée au parc aquatique conçu par Michael van Gessel, avec des lacs artificiels prolongeant le canal jusque devant les habitations.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Facade+Cour",
    "source": "Detail Magazine n3/2010 - Reihenhäuser Amsterdam-Osdorp, Atelier Kempe Thill",
    "materiaux": [
      "vitrage",
      "enduit blanc",
      "aménagement paysager",
      "plans d'eau"
    ],
    "points_cles": [
      "Façade arrière ouverte sur cour communautaire semi-publique en U",
      "Continuité paysagère entre le parc aquatique et les espaces résidentiels",
      "Gradation progressive des espaces : public, semi-public, privé"
    ]
  },
  {
    "id": "detail-2010-amsterdam-osdorp-04",
    "title": "Jonction sol-bâtiment – Transition entre jardin privé et espace public",
    "fabricant": "Detail Magazine",
    "systeme": "Socle de maison en bande avec jardin privatif en façade rue",
    "categorie": "jonction_plancher",
    "tags": [
      "socle",
      "jardin privatif",
      "vorgarten",
      "seuil",
      "espace public",
      "transition",
      "rez-de-chaussée",
      "Amsterdam",
      "Kempe Thill",
      "maison en bande"
    ],
    "description": "Traitement du socle et de la jonction entre le niveau du sol extérieur et le rez-de-chaussée des maisons en bande. Côté rue, un jardin privatif (Vorgarten) assure la transition entre l'espace public et le logement, en opposition au modèle des années 1960 où un socle de celliers séparait les logements du jardin, créant une rupture avec l'espace extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Jonction+Sol",
    "source": "Detail Magazine n3/2010 - Reihenhäuser Amsterdam-Osdorp, Atelier Kempe Thill",
    "materiaux": [
      "béton",
      "aménagement paysager",
      "clôture basse",
      "dallage"
    ],
    "points_cles": [
      "Jardin privatif en façade créant un seuil entre espace public et logement",
      "Correction du défaut des barres des années 1960 dont le socle coupait les logements du sol",
      "Connexion directe du rez-de-chaussée avec le niveau du jardin"
    ]
  },
  {
    "id": "detail-2010-kvistgard-01",
    "title": "Façade bois avec bardage - Groupement de maisons en cour",
    "fabricant": "Detail Magazine",
    "systeme": "Construction bois basse densité groupée en cour fermée",
    "categorie": "facade",
    "tags": [
      "facade",
      "bois",
      "bardage",
      "logement collectif",
      "basse hauteur",
      "danemark",
      "cour",
      "ferme traditionnelle",
      "R+2",
      "R+3",
      "densité",
      "vandkunsten",
      "résidentiel"
    ],
    "description": "Façade de maisons groupées en courettes de 9 unités, inspirées de la structure des fermes traditionnelles danoises. La disposition en cour offre une protection au vent tout en préservant les vues sur le paysage. Hauteur limitée à 3-4 niveaux pour favoriser la cohésion sociale entre habitants.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kvistgard+Facade",
    "source": "Detail Magazine n3/2010 - Wohnsiedlung in Kvistgård, Tegnestuen Vandkunsten",
    "materiaux": [
      "bois",
      "bardage bois",
      "verre",
      "isolation"
    ],
    "points_cles": [
      "Groupement de 9 maisons autour d une cour protégée du vent",
      "Hauteur maximale de 3 à 4 niveaux pour maintenir la cohésion sociale",
      "Façade testée en maquette échelle 1:1 avant réalisation"
    ]
  },
  {
    "id": "detail-2010-kvistgard-02",
    "title": "Module salle de bain préfabriquée en fibre de verre",
    "fabricant": "Detail Magazine",
    "systeme": "Salle de bain monobloc préfabriquée en fibre de verre",
    "categorie": "amenagement_interieur",
    "tags": [
      "salle de bain",
      "préfabriqué",
      "fibre de verre",
      "module",
      "léger",
      "étage",
      "logement",
      "industrialisation",
      "économie",
      "italie",
      "vandkunsten",
      "fertigteile"
    ],
    "description": "Modules de salles de bain préfabriqués en fibre de verre, produits en Italie et livrés en éléments complets. Le choix de la fibre de verre plutôt que du béton ou de la brique permet une légèreté suffisante pour l installation flexible en étage courant. Contrôle qualité réalisé directement chez le fabricant par les architectes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kvistgard+SdB+Prefab",
    "source": "Detail Magazine n3/2010 - Wohnsiedlung in Kvistgård, Tegnestuen Vandkunsten",
    "materiaux": [
      "fibre de verre",
      "résine",
      "raccords sanitaires préintégrés"
    ],
    "points_cles": [
      "Module monobloc léger permettant la pose en étage sans structure renforcée",
      "Préfabrication en usine en Italie avec contrôle qualité architecte sur site de production",
      "Compromis entre légèreté pour flexibilité de pose et durabilité recherchée"
    ]
  },
  {
    "id": "detail-2010-kvistgard-03",
    "title": "Plancher intérieur en bambou industriel",
    "fabricant": "Detail Magazine",
    "systeme": "Revêtement de sol bambou densifié usage industriel reconverti en résidentiel",
    "categorie": "amenagement_interieur",
    "tags": [
      "bambou",
      "sol",
      "plancher",
      "revêtement",
      "économique",
      "robuste",
      "industriel",
      "logement",
      "finition",
      "vandkunsten",
      "danemark",
      "résidentiel"
    ],
    "description": "Sol en bambou de qualité industrielle, sélectionné par le maître d ouvrage pour sa robustesse et son coût réduit. Initialement destiné à des bâtiments industriels, le matériau a été mis en œuvre et raffiné par les architectes pour obtenir un rendu résidentiel de qualité. Solution économique contribuant à la maîtrise globale du budget.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kvistgard+Sol+Bambou",
    "source": "Detail Magazine n3/2010 - Wohnsiedlung in Kvistgård, Tegnestuen Vandkunsten",
    "materiaux": [
      "bambou densifié",
      "sous-couche"
    ],
    "points_cles": [
      "Bambou industriel détourné pour usage résidentiel à moindre coût",
      "Robustesse supérieure aux parquets classiques grâce à la densification",
      "Finition et mise en œuvre soignées par les architectes pour un rendu qualitatif"
    ]
  },
  {
    "id": "detail-2010-kvistgard-04",
    "title": "Terrasses étagées - gradation privé/public",
    "fabricant": "Detail Magazine",
    "systeme": "Système de terrasses à gradation de privatisation sur logements groupés",
    "categorie": "jonction_plancher",
    "tags": [
      "terrasse",
      "toiture terrasse",
      "rez-de-chaussée",
      "privé",
      "semi-public",
      "gradation",
      "intimité",
      "cour",
      "logement",
      "vandkunsten",
      "kvistgard",
      "danemark",
      "extérieur"
    ],
    "description": "Dispositif de terrasses assurant une transition progressive entre espaces publics, semi-publics et privés. Terrasses semi-publiques au rez-de-chaussée orientées vers la cour commune, et terrasses privées en toiture à l étage. La cuisine, espace moins intime, donne sur la cour tandis que les chambres sont positionnées en étage pour maximiser l intimité.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kvistgard+Terrasses",
    "source": "Detail Magazine n3/2010 - Wohnsiedlung in Kvistgård, Tegnestuen Vandkunsten",
    "materiaux": [
      "dalle",
      "garde-corps",
      "bois",
      "étanchéité toiture-terrasse"
    ],
    "points_cles": [
      "Gradation en trois niveaux : cour commune, terrasse semi-publique RDC, terrasse privée en toiture",
      "Entrées visibles depuis les logements voisins pour sécurité par contrôle social passif",
      "Organisation intérieure liée à la gradation : cuisine côté cour, chambres en étage"
    ]
  },
  {
    "id": "detail-2010-kyoto-01",
    "title": "Capsule de sommeil en GFK sur structure acier",
    "fabricant": "Detail Magazine",
    "systeme": "Capsule modulaire en plastique renforcé de fibres de verre sur ossature acier",
    "categorie": "amenagement_interieur",
    "tags": [
      "capsule",
      "GFK",
      "fibre de verre",
      "gelcoat",
      "structure acier",
      "hotel",
      "modulaire",
      "prefabrication",
      "Japon",
      "Kyoto",
      "tube acier",
      "LED",
      "panneau de commande",
      "cocoon",
      "kapselhotel"
    ],
    "description": "Capsule de sommeil de 1,20 x 2,34 m en plastique renforcé de fibres de verre (GFK) de 4 mm d'épaisseur avec finition Gelcoat polie. Les capsules sont posées sur une structure porteuse en tubes d'acier carrés de 40x40 mm, disposées en configuration alvéolaire (nid d'abeilles) le long des couloirs. Un éclairage LED dimmable est intégré au plafond avec couvercle en verre acrylique, et un panneau de commande minimaliste noir en GFK de 2,4 mm avec Gelcoat teinté dans la masse est encastré affleurant en tête de capsule.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kyoto+Capsule+GFK",
    "source": "Detail Magazine n4/2010 - Capsule Hotel 9hours Kyoto, Sigma Architectural Design / Shigenori Sugioka",
    "materiaux": [
      "plastique renforcé de fibres de verre GFK 4 mm",
      "gelcoat poli",
      "tube acier carré 40x40 mm",
      "LED dimmable",
      "verre acrylique",
      "matelas polyester"
    ],
    "points_cles": [
      "Capsule GFK 4 mm avec finition Gelcoat polie offrant une surface soyeuse et facile d'entretien",
      "Structure porteuse indépendante en tubes acier carrés 40x40 mm permettant la superposition des capsules en configuration alvéolaire",
      "Panneau de commande en GFK noir teinté dans la masse de 2,4 mm encastré affleurant intégrant éclairage et réveil"
    ]
  },
  {
    "id": "detail-2010-kyoto-02",
    "title": "Plancher technique sur bac acier avec revêtement caoutchouc",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton sur bac acier trapézoïdal avec finition dalles caoutchouc",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "bac acier",
      "trapézoïdal",
      "béton",
      "dalles caoutchouc",
      "LED socle",
      "éclairage intégré",
      "couloir",
      "hotel capsule",
      "sol technique"
    ],
    "description": "Plancher constitué d'une dalle béton coulée sur bac acier trapézoïdal, revêtu de dalles en caoutchouc de 500x500x2,5 mm. Un éclairage LED de socle est intégré en pied des capsules, assurant le balisage des couloirs sombres des zones de sommeil. Ce système supporte la structure porteuse en acier des capsules superposées.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kyoto+Plancher+Bac+Acier",
    "source": "Detail Magazine n4/2010 - Capsule Hotel 9hours Kyoto, Sigma Architectural Design / Shigenori Sugioka",
    "materiaux": [
      "bac acier trapézoïdal",
      "béton",
      "dalles caoutchouc 500x500x2,5 mm",
      "LED de socle"
    ],
    "points_cles": [
      "Dalle béton sur bac acier trapézoïdal assurant la portance des capsules superposées sur structure acier",
      "Dalles caoutchouc 500x500x2,5 mm comme revêtement de sol pour absorption acoustique et confort",
      "Éclairage LED intégré en socle pour balisage discret des couloirs noirs des zones de sommeil"
    ]
  },
  {
    "id": "detail-2010-kyoto-03",
    "title": "Façade et front de capsule en tôle acier laquée noire",
    "fabricant": "Detail Magazine",
    "systeme": "Habillage frontal en tôle acier avec marche aluminium et rideau polyester",
    "categorie": "amenagement_interieur",
    "tags": [
      "front capsule",
      "tôle acier",
      "résine mélamine",
      "noir",
      "aluminium moulé",
      "marche",
      "rideau polyester",
      "occultation",
      "intimité",
      "poignée",
      "tube acier",
      "habillage"
    ],
    "description": "Le front visible des capsules dans le couloir est constitué d'une tôle d'acier de 3,2 mm revêtue de résine mélamine noire, formant un encadrement sobre et graphique. Une marche en aluminium moulé laqué noir permet l'accès aux capsules supérieures, avec une poignée en tube acier Ø 25,4 mm également revêtue de résine mélamine noire. L'occultation est assurée par un store en tissu polyester qui offre une intimité visuelle sans isolation acoustique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kyoto+Front+Capsule",
    "source": "Detail Magazine n4/2010 - Capsule Hotel 9hours Kyoto, Sigma Architectural Design / Shigenori Sugioka",
    "materiaux": [
      "tôle acier 3,2 mm revêtement résine mélamine noire",
      "aluminium moulé laqué noir",
      "tube acier Ø 25,4 mm résine mélamine noire",
      "tissu polyester store"
    ],
    "points_cles": [
      "Front en tôle acier 3,2 mm avec résine mélamine noire créant l'aspect alvéolaire caractéristique dans les couloirs",
      "Marche d'accès en aluminium moulé et poignée tube acier Ø 25,4 mm avec finition mélamine noire coordonnée",
      "Store en tissu polyester sans porte offrant une intimité visuelle tout en permettant la ventilation et la détection incendie"
    ]
  },
  {
    "id": "detail-2010-kyoto-04",
    "title": "Plafond suspendu et cloisonnement léger acier-plâtre",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier légère avec habillage plaque de plâtre",
    "categorie": "structure",
    "tags": [
      "plafond suspendu",
      "plaque de plâtre",
      "gipskarton",
      "ossature légère acier",
      "cloison sèche",
      "revêtement blanc",
      "séparation",
      "hôtel",
      "détecteur fumée",
      "parcelle étroite",
      "6 mètres"
    ],
    "description": "Le système de cloisonnement et de plafond suspendu est constitué d'une ossature en acier léger habillée de plaques de plâtre (Gipskarton) de 12,5 mm avec revêtement blanc. Ce système enveloppe les espaces de circulation et sépare les zones fonctionnelles (couloirs, locaux techniques, gaines). Le plafond suspendu en plaque de plâtre 12,5 mm avec revêtement blanc intègre les détecteurs de fumée et masque les réseaux techniques dans un bâtiment de seulement 6 m de largeur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kyoto+Cloison+Plafond",
    "source": "Detail Magazine n4/2010 - Capsule Hotel 9hours Kyoto, Sigma Architectural Design / Shigenori Sugioka",
    "materiaux": [
      "plaque de plâtre 12,5 mm",
      "ossature acier léger",
      "revêtement blanc",
      "détecteur de fumée"
    ],
    "points_cles": [
      "Construction sèche en ossature acier légère et plaques de plâtre 12,5 mm adaptée à une parcelle très étroite de 6 m",
      "Plafond suspendu en plaque de plâtre revêtue blanc intégrant détection incendie et masquant les réseaux",
      "Différenciation chromatique des espaces : blanc pour entrée et lounge, gris pour sanitaires, noir pour zones de sommeil"
    ]
  },
  {
    "id": "detail-2010-linz-01",
    "title": "Toiture végétalisée sur dalle béton avec charpente acier et kragträger",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée sur structure acier avec poutres en porte-à-faux (Kragträger)",
    "categorie": "toiture",
    "tags": [
      "toiture vegetalisee",
      "structure acier",
      "dalle beton",
      "isolation EPS",
      "etancheite bitume",
      "poutre porte-a-faux",
      "kragtrager",
      "profil acier",
      "voestalpine",
      "immeuble bureaux",
      "linz"
    ],
    "description": "Toiture végétalisée composée d'une couche de végétation de 100 à 220 mm sur filtre, couche de stockage d'eau en polyéthylène 20 mm, mat en granulat de caoutchouc 10 mm, étanchéité bitumineuse bicouche, isolation EPS 100-220 mm en pente à 2%, pare-vapeur, sur dalle béton armé de 300 mm. La structure porteuse est constituée de poutres en acier en porte-à-faux (Kragträger) de section variable Å 700-190/300-197/30 mm, réduisant le moment de flexion en milieu de travée et permettant des façades et bureaux sans poteaux.",
    "thumbnail": "/images/thumb-feichtinger.jpg",
    "source": "Detail Magazine n6/2010 - Verwaltungsgebäude in Linz, Dietmar Feichtinger Architectes",
    "materiaux": [
      "végétalisation extensive",
      "filtre géotextile",
      "polyéthylène stockage eau",
      "granulat caoutchouc",
      "étanchéité bitumineuse bicouche",
      "isolation EPS",
      "pare-vapeur",
      "dalle béton armé 300 mm",
      "poutres acier Å section variable"
    ],
    "points_cles": [
      "Poutres en porte-à-faux (Kragträger) à section variable optimisant la hauteur structurelle et libérant la façade de tout poteau",
      "Pente de 2% intégrée dans l'épaisseur d'isolation EPS variable (100-220 mm) pour drainage naturel",
      "Couche de stockage d'eau en polyéthylène et mat en granulat caoutchouc assurant rétention et protection de l'étanchéité"
    ]
  },
  {
    "id": "detail-2010-linz-02",
    "title": "Structure acier en porte-à-faux de 34 m avec treillis tubulaire et revêtement en métal déployé",
    "fabricant": "Detail Magazine",
    "systeme": "Auskragung - Structure en porte-à-faux avec poutres treillis et diagonales tubulaires acier",
    "categorie": "structure",
    "tags": [
      "porte-a-faux",
      "auskragung",
      "treillis acier",
      "poutre treillis",
      "tube acier diagonal",
      "metal deploye",
      "verre trempe",
      "protection incendie",
      "sprinkler",
      "acier apparent",
      "voestalpine",
      "linz",
      "34 metres"
    ],
    "description": "Pointe en porte-à-faux de 34 mètres formée par deux poutres treillis dont les charges sont reprises par le noyau de circulation et quatre poteaux cruciformes en acier. Les diagonales sont des tubes acier Ø 298,5/32 mm, les montants des profils en T à gousset (265/140/15/20 à 170/70/15/20 mm) avec revêtement coupe-feu. La sous-face est habillée de métal déployé galvanisé et peint par poudrage, conférant un aspect textile. Le vitrage en verre trempé partiellement (TVG 3×10 mm) ferme la terrasse sur toit protégée derrière cette structure.",
    "thumbnail": "/images/thumb-feichtinger.jpg",
    "source": "Detail Magazine n6/2010 - Verwaltungsgebäude in Linz, Dietmar Feichtinger Architectes",
    "materiaux": [
      "tubes acier Ø 298,5/32 mm diagonales",
      "profils acier en T à gousset",
      "peinture coupe-feu intumescente",
      "métal déployé galvanisé 16/8/1,5/1 mm",
      "verre TVG 3×10 mm",
      "plat acier suspentes 2×60/15 mm",
      "tôle acier galvanisée 2 mm",
      "caillebotis acier galvanisé à chaud 40 mm",
      "peinture fer micacé"
    ],
    "points_cles": [
      "Porte-à-faux spectaculaire de 34 m porté par deux poutres treillis avec diagonales tubulaires Ø 298,5/32 mm et montants à section variable",
      "Protection incendie assurée par peinture intumescente sur la structure de la pointe et système sprinkler pour l'ensemble du bâtiment",
      "Sous-face en métal déployé galvanisé et peint par poudrage créant un effet textile et filtrant la lumière"
    ]
  },
  {
    "id": "detail-2010-linz-03",
    "title": "Façade bureaux avec brise-soleil coulissant en métal déployé et menuiserie aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Façade double-peau avec panneaux coulissants en métal déployé et vitrages fixes aluminium",
    "categorie": "facade",
    "tags": [
      "facade",
      "brise-soleil",
      "metal deploye",
      "streckmetall",
      "panneau coulissant",
      "protection solaire",
      "vitrage fixe",
      "aluminium",
      "sandwich panel",
      "garde-corps",
      "acier galvanise",
      "bureaux",
      "voestalpine",
      "linz",
      "peau textile"
    ],
    "description": "Façade de bureaux composée d'un vitrage fixe (float 8 mm + SZR 20 mm + VSG 11 mm) en cadre aluminium, doublé de panneaux coulissants de protection solaire en métal déployé galvanisé et laqué or-jaune (25/13,5/5/1,52 mm) sur ossature secondaire en plat acier galvanisé laqué (27-60/10 mm). Des panneaux sandwich aluminium de 107 mm complètent le dispositif en éléments basculants/coulissants. Un garde-corps en plat acier galvanisé laqué (40/5 mm) assure la sécurité anti-chute.",
    "thumbnail": "/images/thumb-feichtinger.jpg",
    "source": "Detail Magazine n6/2010 - Verwaltungsgebäude in Linz, Dietmar Feichtinger Architectes",
    "materiaux": [
      "métal déployé galvanisé laqué 25/13,5/5/1,52 mm",
      "plat acier galvanisé laqué 27-60/10 mm",
      "vitrage fixe float 8 + SZR 20 + VSG 11 mm",
      "cadre aluminium",
      "panneau sandwich aluminium 107 mm",
      "tôle aluminium laquée 3 mm",
      "garde-corps plat acier galvanisé 40/5 mm"
    ],
    "points_cles": [
      "Panneaux coulissants en métal déployé galvanisé revêtu or-jaune assurant la protection solaire avec un effet textile caractéristique",
      "Double dispositif mobile : éléments en métal déployé coulissants et panneaux sandwich aluminium basculants/coulissants de 107 mm",
      "Poteaux tubulaires acier de diamètre décroissant selon les étages (Ø 323,9/50 mm en bas, Ø 244,5/20 mm en haut) libérant la façade"
    ]
  },
  {
    "id": "detail-2010-linz-04",
    "title": "Terrasse sur toit avec plancher bois sur isolation et dalle béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Terrasse accessible sur dalle béton avec platelage mélèze, isolation XPS drainante et étanchéité bitumineuse",
    "categorie": "jonction_plancher",
    "tags": [
      "terrasse",
      "dachterrasse",
      "plancher bois",
      "meleze",
      "isolation XPS",
      "drainage",
      "etancheite bitume",
      "dalle beton",
      "garde-corps verre",
      "VSG",
      "ESG",
      "porte-a-faux",
      "voestalpine",
      "linz"
    ],
    "description": "Terrasse sur toit située à la pointe en porte-à-faux, composée d'un platelage en mélèze raboté 25 mm sur lattage variable 50-110 mm, isolation XPS 100 mm avec rainures de drainage, étanchéité bitumineuse bicouche, isolation EPS 20-80 mm en pente à 2%, pare-vapeur, sur dalle béton armé de 260 mm. La balustrade est en verre feuilleté de sécurité (VSG 2×10 mm ESG). Le sol intérieur adjacent est un parquet frêne collé 10 mm sur plancher technique creux (dalles 600×600×30 mm) posé sur dalle béton armé 300 mm.",
    "thumbnail": "/images/thumb-meck.jpg",
    "source": "Detail Magazine n6/2010 - Verwaltungsgebäude in Linz, Dietmar Feichtinger Architectes",
    "materiaux": [
      "mélèze raboté 25 mm",
      "lattage bois 50-110 mm",
      "isolation XPS 100 mm à rainures drainage",
      "étanchéité bitumineuse bicouche",
      "isolation EPS 20-80 mm",
      "pare-vapeur",
      "dalle béton armé 260 mm",
      "garde-corps VSG 2×10 mm ESG",
      "parquet frêne collé 10 mm",
      "plancher technique creux 600×600×30 mm"
    ],
    "points_cles": [
      "Double couche d'isolation : XPS 100 mm avec rainures de drainage en partie haute et EPS 20-80 mm en pente à 2% en partie basse pour écoulement des eaux",
      "Garde-corps en verre feuilleté de sécurité (VSG 2×10 mm trempé) offrant une vue dégagée sur les hauts-fourneaux et gazomètres du site industriel",
      "Transition intérieur/extérieur avec plancher technique creux (parquet frêne) côté bureau et platelage mélèze sur lattage ventilé côté terrasse"
    ]
  },
  {
    "id": "detail-2014-munich-01",
    "title": "Toiture à joint debout en acier inoxydable étamé avec isolation entre chevrons",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture à joint debout sur charpente bois isolée ventilée",
    "categorie": "toiture",
    "tags": [
      "joint debout",
      "acier inoxydable",
      "étamé",
      "stehfalz",
      "laine minérale",
      "chevrons",
      "ventilation",
      "pare-vapeur",
      "plaque de plâtre",
      "voligeage",
      "fenêtre de toit",
      "toiture inclinée",
      "rénovation"
    ],
    "description": "Toiture inclinée avec couverture en acier inoxydable étamé 0,5 mm à joint debout handgefalzt (pliée à la main), posée sur voligeage brut de sciage 24 mm et lattage ventilé. L'isolation thermique de 180 mm en laine minérale est placée entre chevrons 80/220 mm, complétée par un pare-vapeur et une couche d'isolation supplémentaire entre lattage 40/40 mm, avec finition intérieure en double plaque de plâtre 2×12,5 mm. Des fenêtres de toit rectangulaires sont réparties sur la surface pour apporter un éclairage naturel ciblé dans un contexte urbain dense orienté nord.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Munich+Toiture",
    "source": "Detail Magazine n5/2014 - Wohnhaus in München, leonardhautum (Kristin Leonard und Lisa Hautum)",
    "materiaux": [
      "acier inoxydable étamé 0,5 mm",
      "voligeage sapin brut de sciage 24 mm",
      "lattage pin 30/50 mm",
      "chevrons 80/220 mm",
      "laine minérale 180 mm",
      "pare-vapeur",
      "lattage 40/40 mm",
      "plaque de plâtre 2×12,5 mm"
    ],
    "points_cles": [
      "Couverture à joint debout pliée à la main reproduisant la toiture historique d'origine",
      "Double couche d'isolation (entre chevrons 180 mm + entre lattage intérieur) avec lame d'air ventilée",
      "Fenêtres de toit stratégiquement dispersées pour compenser l'orientation nord et la densité urbaine"
    ]
  },
  {
    "id": "detail-2014-munich-02",
    "title": "Plancher bas sur granulat de verre expansé avec plancher chêne et béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé sur isolation en granulat de verre cellulaire avec revêtement bois",
    "categorie": "soubassement",
    "tags": [
      "plancher bas",
      "dalle béton armé",
      "granulat verre expansé",
      "Glasschaumgranulat",
      "chêne",
      "dielen",
      "bitume",
      "étanchéité épaisse",
      "couche de séparation",
      "rez-de-chaussée",
      "rénovation",
      "surbaissement"
    ],
    "description": "Plancher bas constitué d'une couche de granulat de verre cellulaire (Glasschaumgranulat) de 350 mm comme isolation et drainage, sur couches de séparation, supportant une dalle béton armé de 250 mm protégée par une étanchéité bitumineuse épaisse de 5 mm. Le revêtement de sol est en lames de chêne massif 30 mm sur lattage 30/50 mm. La dalle a été abaissée par rapport au niveau d'origine pour gagner en hauteur sous plafond dans le bâtiment existant.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Munich+Plancher+Bas",
    "source": "Detail Magazine n5/2014 - Wohnhaus in München, leonardhautum (Kristin Leonard und Lisa Hautum)",
    "materiaux": [
      "granulat de verre cellulaire 350 mm",
      "couche de séparation",
      "étanchéité bitumineuse épaisse 5 mm",
      "dalle béton armé 250 mm",
      "lattage 30/50 mm",
      "lames de chêne massif 30 mm"
    ],
    "points_cles": [
      "Isolation du plancher bas par 350 mm de granulat de verre cellulaire (matériau recyclé léger et drainant)",
      "Abaissement du niveau de sol pour récupérer de la hauteur sous plafond dans le volume existant",
      "Étanchéité bitumineuse épaisse entre dalle et isolation pour protection contre l'humidité du sol"
    ]
  },
  {
    "id": "detail-2014-munich-03",
    "title": "Mur de soutènement en béton projeté sur maçonnerie existante avec erdnägel titane",
    "fabricant": "Detail Magazine",
    "systeme": "Confortement de paroi enterrée par clous de sol titane et béton projeté sur maçonnerie existante",
    "categorie": "structure",
    "tags": [
      "béton projeté",
      "Spritzbeton",
      "shotcrete",
      "erdnägel",
      "clous de sol",
      "titane",
      "mur de soutènement",
      "maçonnerie brique",
      "bestand",
      "existant",
      "étanchéité",
      "talus",
      "confortement",
      "rénovation",
      "paroi enterrée"
    ],
    "description": "Confortement de la paroi arrière enterrée dans le talus, composé de la maçonnerie en brique existante renforcée par une couche de béton projeté (Spritzbeton) de 200 mm avec enduit de finition 5 mm côté intérieur et une étanchéité côté terre. Le talus est stabilisé par des clous de sol en titane de Ø 32 mm et 8 m de longueur. Cette solution a permis de reprendre les poussées du terrain et de créer l'extension creusée à la main dans la pente, les contraintes d'accès du chantier interdisant l'usage d'engins lourds.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Munich+Soutenement",
    "source": "Detail Magazine n5/2014 - Wohnhaus in München, leonardhautum (Kristin Leonard und Lisa Hautum)",
    "materiaux": [
      "maçonnerie brique existante",
      "béton projeté (Spritzbeton) 200 mm",
      "enduit 5 mm",
      "étanchéité",
      "clous de sol titane Ø 32 mm L 8000 mm"
    ],
    "points_cles": [
      "Clous de sol en titane de 8 m de longueur pour ancrage dans le talus sans engins lourds",
      "Béton projeté de 200 mm en renforcement de la maçonnerie existante conservée",
      "Terrassement entièrement réalisé à la main avec évacuation par seaux en raison de l'inaccessibilité du site"
    ]
  },
  {
    "id": "detail-2014-munich-04",
    "title": "Façade en béton isolant avec enduit trass-ciment sur mur brique existant",
    "fabricant": "Detail Magazine",
    "systeme": "Enveloppe mixte béton isolant et enduit isolant sur maçonnerie existante",
    "categorie": "facade",
    "tags": [
      "béton isolant",
      "Dämmbeton",
      "granulat verre recyclé",
      "enduit isolant",
      "trass",
      "ciment",
      "structure main",
      "Dämmputz",
      "maçonnerie brique",
      "existant",
      "fenêtre à caisson",
      "Kastenfenster",
      "rénovation",
      "Munich",
      "conservation"
    ],
    "description": "Système d'enveloppe dual : les extensions sont réalisées en béton isolant (Dämmbeton) de 500 mm intégrant du granulat de verre recyclé, formant à la fois la structure porteuse, l'isolation thermique et le parement intérieur apparent. Les murs en brique existants conservés reçoivent un enduit isolant trass-ciment de 60 à 80 mm avec texture tirée à la main et fascia lisse de 100 mm, préservant les fenêtres à caisson (Kastenfenster) d'origine. Le béton isolant intègre l'ensemble des réseaux techniques du bâtiment.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Munich+Facade",
    "source": "Detail Magazine n5/2014 - Wohnhaus in München, leonardhautum (Kristin Leonard und Lisa Hautum)",
    "materiaux": [
      "béton isolant (Dämmbeton) 500 mm",
      "granulat de verre recyclé",
      "enduit isolant trass-ciment 60-80 mm",
      "maçonnerie brique existante",
      "fenêtre à caisson bois existante"
    ],
    "points_cles": [
      "Béton isolant de 500 mm avec granulat de verre recyclé assurant simultanément structure, isolation et finition intérieure",
      "Enduit isolant trass-ciment 60-80 mm avec texture artisanale tirée à la main sur maçonnerie existante",
      "Distinction architecturale lisible entre parties existantes (brique enduite + Kastenfenster) et extensions (béton isolant apparent)"
    ]
  },
  {
    "id": "detail-2015-vaduz-01",
    "title": "Façade en béton coulé en place à surface polie - Marbre et gravier de rivière",
    "fabricant": "Detail Magazine",
    "systeme": "Façade monolithique en béton apparent poli avec agrégats de marbre et galets de rivière",
    "categorie": "facade",
    "tags": [
      "béton apparent",
      "béton poli",
      "marbre",
      "gravier rivière",
      "façade monolithique",
      "white cube",
      "musée",
      "Liechtenstein",
      "Vaduz",
      "béton coulé en place",
      "surface polie",
      "agrégats apparents",
      "ortbeton",
      "finition miroir",
      "béton blanc"
    ],
    "description": "Façade en béton coulé en place (Ortbeton) avec une surface hautement polie composée de marbre, ciment et galets de rivière provenant de la vallée du Rhin voisine. Cette technique de polissage manuel, déjà utilisée pour le bâtiment existant du Kunstmuseum (en version noire avec basalte), est ici déclinée en version blanche pour le cube de l'extension, créant un effet de surface brillante rappelant un objet de Minimal Art. Le contraste entre le White Cube de l'extension et la Black Box du musée existant repose sur la même technique constructive avec des agrégats différents.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Vaduz+Facade+Beton+Poli",
    "source": "Detail Magazine n7-8/2015 - Extension Kunstmuseum Liechtenstein, Morger + Dettli Architekten",
    "materiaux": [
      "béton coulé en place",
      "ciment blanc",
      "agrégats de marbre",
      "galets de rivière du Rhin",
      "basalte (bâtiment existant)"
    ],
    "points_cles": [
      "Surface polie à la main pour obtenir un fini brillant révélant les agrégats",
      "Même technique constructive que le musée existant (2000) mais avec des agrégats clairs au lieu de sombres",
      "Effet monolithique de cube abstrait blanc positionné au plus près de la rue"
    ]
  },
  {
    "id": "detail-2015-vaduz-02",
    "title": "Plafond à lumière naturelle zénithale - Salle d'exposition 3e étage",
    "fabricant": "Detail Magazine",
    "systeme": "Plafond diffuseur de lumière naturelle (Tageslichtdecke) pour espace muséal",
    "categorie": "toiture",
    "tags": [
      "éclairage zénithal",
      "lumière naturelle",
      "plafond lumineux",
      "Tageslichtdecke",
      "musée",
      "salle exposition",
      "lumière diffuse",
      "toiture musée",
      "éclairage muséal",
      "white cube"
    ],
    "description": "Plafond à lumière naturelle (Tageslichtdecke) au troisième étage de l'extension du Kunstmuseum Liechtenstein, offrant un éclairage zénithal diffus pour la salle d'exposition supérieure. Ce niveau se distingue des étages inférieurs éclairés artificiellement par son apport de lumière du jour, accompagné de murs blancs marquant la rupture thématique entre art moderne classique et art d'après-guerre. Le système de plafond lumineux assure une diffusion homogène adaptée à la présentation d'œuvres d'art.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Vaduz+Toiture+Eclairage+Zenithal",
    "source": "Detail Magazine n7-8/2015 - Extension Kunstmuseum Liechtenstein, Morger + Dettli Architekten",
    "materiaux": [
      "verre diffusant",
      "structure porteuse toiture",
      "béton",
      "système de régulation lumineuse"
    ],
    "points_cles": [
      "Plafond à lumière naturelle réservé au 3e étage pour différencier les ambiances muséales",
      "Contraste programmatique: murs blancs et lumière naturelle pour l'art d'après-guerre vs murs gris-vert et gris-bleu éclairés artificiellement aux niveaux inférieurs",
      "Intégration dans un empilement alterné de niveaux vitrés (joaillier) et aveugles (musée)"
    ]
  },
  {
    "id": "detail-2015-vaduz-03",
    "title": "Liaison souterraine en entonnoir entre musée existant et extension",
    "fabricant": "Detail Magazine",
    "systeme": "Passage souterrain à géométrie évasée reliant deux bâtiments muséaux indépendants",
    "categorie": "jonction_plancher",
    "tags": [
      "passage souterrain",
      "liaison souterraine",
      "entonnoir",
      "trichterförmig",
      "connexion bâtiments",
      "musée",
      "infrastructure souterraine",
      "transition spatiale",
      "sous-sol",
      "galerie de liaison",
      "extension musée"
    ],
    "description": "Passage souterrain reliant le foyer du Kunstmuseum Liechtenstein existant à l'extension de la Hilti Art Foundation, conçu en forme d'entonnoir (trichterförmig) qui s'évase progressivement pour devenir un espace d'exposition à part entière. Cette liaison en sous-sol permet de connecter les deux bâtiments indépendants tout en maintenant leur autonomie en surface, l'accès au musée se faisant exclusivement par le foyer de l'ancien bâtiment tandis que l'entrée côté rue mène au commerce de joaillerie.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Vaduz+Jonction+Souterraine",
    "source": "Detail Magazine n7-8/2015 - Extension Kunstmuseum Liechtenstein, Morger + Dettli Architekten",
    "materiaux": [
      "béton armé",
      "béton coulé en place",
      "infrastructure souterraine",
      "parois d'exposition"
    ],
    "points_cles": [
      "Forme en entonnoir s'élargissant depuis le foyer existant vers un espace d'exposition du sous-sol de l'extension",
      "Séparation stricte des flux: visiteurs du musée par le sous-sol, clients du joaillier par le rez-de-chaussée côté rue",
      "Solution permettant l'extension muséale sur un terrain contraint avec maintien d'une activité commerciale indépendante"
    ]
  },
  {
    "id": "detail-2015-vaduz-04",
    "title": "Cage d'escalier monumentale à volées droites sans palier sur 20 m de hauteur",
    "fabricant": "Detail Magazine",
    "systeme": "Circulation verticale muséale à escalier monumental traversant deux niveaux sans interruption",
    "categorie": "structure",
    "tags": [
      "escalier monumental",
      "Himmelsleiter",
      "cage escalier",
      "circulation verticale",
      "double hauteur",
      "20 mètres",
      "sans palier",
      "escalier musée",
      "desserte alternée",
      "structure verticale",
      "séparation programmatique"
    ],
    "description": "Cage d'escalier monumentale de 20 mètres de hauteur, dite Himmelsleiter (échelle céleste), dont les volées relient directement le sous-sol au premier étage puis au troisième étage sans palier intermédiaire, permettant de desservir exclusivement les niveaux d'exposition en sautant les étages occupés par le joaillier. Ce système de circulations verticales séparées est la clé de la coexistence programmatique entre espaces muséaux et commerciaux dans un même volume, organisés en alternance comme un double cheeseburger selon les architectes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Vaduz+Escalier+Monumental",
    "source": "Detail Magazine n7-8/2015 - Extension Kunstmuseum Liechtenstein, Morger + Dettli Architekten",
    "materiaux": [
      "béton armé",
      "structure porteuse verticale",
      "garde-corps",
      "éclairage intégré"
    ],
    "points_cles": [
      "Volées d'escalier franchissant deux niveaux d'un seul tenant sans palier intermédiaire dans un vide de 20 m",
      "Desserte sélective permettant la séparation complète entre niveaux muséaux (sous-sol, 1er, 3e étage) et niveaux commerciaux (RDC, 2e étage, sous-sol)",
      "Circulations verticales dédoublées comme principe structurant la cohabitation de deux programmes indépendants dans un même volume"
    ]
  },
  {
    "id": "detail-1998-sendagaya-01",
    "title": "Escalier en treillis tridimensionnel - Structure acier",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier en treillis 3D avec marches en tôle pliée soudées sur ronds pleins",
    "categorie": "structure",
    "tags": [
      "escalier",
      "treillis",
      "acier",
      "tôle pliée",
      "rond plein",
      "soudure",
      "structure tridimensionnelle",
      "légèreté",
      "transparence",
      "fachwerk",
      "steel stair",
      "three-dimensional truss"
    ],
    "description": "Escalier conçu comme un treillis tridimensionnel avec des épaisseurs de matériaux minimales. Les marches en tôle d'acier pliée de 4,5 mm sont soudées en partie haute à deux ronds pleins de Ø16 mm faisant office de membrures supérieures, et en partie basse à un seul rond plein Ø16 mm central faisant office de membrure inférieure. Des plats d'acier entaillés de 3 mm assurent la rigidification entre les membrures et les marches.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sendagaya+Escalier+Treillis",
    "source": "Detail Magazine n°2/1998 - Atelier und Bürohaus in Sendagaya, Hisao Kohyama",
    "materiaux": [
      "rond plein acier Ø16 mm",
      "tôle acier pliée 4,5 mm",
      "plat acier entaillé 3 mm",
      "plat acier 9x50x700 mm",
      "plat acier 4,5x50x880 mm",
      "profilé acier carré 10x10 mm"
    ],
    "points_cles": [
      "Construction en treillis tridimensionnel avec épaisseurs minimales pour exprimer légèreté et mouvement",
      "Deux membrures supérieures (ronds Ø16) et une membrure inférieure centrale (rond Ø16) reliées par marches soudées",
      "Plats d'acier entaillés de 3 mm assurant le contreventement transversal du treillis"
    ]
  },
  {
    "id": "detail-1998-sendagaya-02",
    "title": "Détail de marche - Tôle acier pliée sur ronds porteurs",
    "fabricant": "Detail Magazine",
    "systeme": "Marche individuelle en tôle d'acier kantée soudée sur membrures rondes",
    "categorie": "amenagement_interieur",
    "tags": [
      "marche",
      "tôle pliée",
      "acier",
      "kantage",
      "soudure",
      "revêtement teppich",
      "bande antidérapante",
      "nez de marche",
      "détail 1:10",
      "steel step"
    ],
    "description": "Chaque marche est réalisée en tôle d'acier pliée (kantée) de 4,5 mm d'épaisseur, soudée aux membrures rondes supérieures et inférieure. Le nez de marche est protégé par un plat acier soudé de 6 mm et une bande plastique antidérapante. La surface de la marche reçoit un revêtement textile (teppich/moquette) collé.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sendagaya+Marche+Acier",
    "source": "Detail Magazine n°2/1998 - Atelier und Bürohaus in Sendagaya, Hisao Kohyama",
    "materiaux": [
      "tôle acier pliée 4,5 mm",
      "plat acier soudé 6 mm",
      "bande plastique antidérapante",
      "moquette",
      "rond plein acier Ø16 mm"
    ],
    "points_cles": [
      "Marche en tôle pliée 4,5 mm offrant résistance structurelle avec épaisseur minimale",
      "Protection de nez de marche par plat acier 6 mm soudé et bande plastique antidérapante",
      "Revêtement moquette directement collé sur la tôle d'acier pour confort acoustique et visuel"
    ]
  },
  {
    "id": "detail-1998-sendagaya-03",
    "title": "Jonction escalier - plancher béton sur bac acier",
    "fabricant": "Detail Magazine",
    "systeme": "Raccord entre escalier acier léger et dalle béton sur coffrage en bac acier trapézoïdal",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction",
      "plancher",
      "dalle béton",
      "bac acier",
      "trapézblech",
      "coffrage collaborant",
      "chape ciment",
      "escalier",
      "HEB 100",
      "raccord structure"
    ],
    "description": "Le palier d'arrivée de l'escalier se raccorde à un plancher composé d'une dalle béton armé coulée sur coffrage en bac acier trapézoïdal, recevant une chape ciment et un revêtement moquette. Un profilé HEB 100 assure la reprise des efforts au droit de la jonction entre l'escalier léger en treillis et la structure porteuse principale en ossature acier. Le plafond du niveau inférieur est constitué de plaques de plâtre suspendues.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sendagaya+Jonction+Plancher",
    "source": "Detail Magazine n°2/1998 - Atelier und Bürohaus in Sendagaya, Hisao Kohyama",
    "materiaux": [
      "dalle béton armé",
      "bac acier trapézoïdal",
      "chape ciment",
      "moquette",
      "profilé HEB 100",
      "plaque de plâtre suspendue"
    ],
    "points_cles": [
      "Plancher mixte béton armé sur coffrage bac acier trapézoïdal avec chape et revêtement textile",
      "Profilé HEB 100 assurant la transition structurelle entre escalier treillis et ossature porteuse",
      "Plafond en plaques de plâtre suspendues au premier étage permettant passage de réseaux"
    ]
  },
  {
    "id": "detail-1998-sendagaya-04",
    "title": "Façade rideau vitrée sur ossature acier - zone escalier",
    "fabricant": "Detail Magazine",
    "systeme": "Façade rideau vitrée suspendue devant ossature porteuse acier avec escalier visible",
    "categorie": "facade",
    "tags": [
      "façade rideau",
      "vitrage",
      "ossature acier",
      "transparence",
      "mur rideau",
      "curtain wall",
      "squelette acier",
      "remplissage",
      "lumière naturelle",
      "Sendagaya",
      "éclairage naturel"
    ],
    "description": "La façade sur rue est conçue comme un mur rideau vitré suspendu devant l'ossature porteuse en acier, créant un espace intermédiaire où se situe l'escalier. Cette disposition en double peau permet d'inonder le volume de circulation de lumière naturelle tout en rendant les mouvements des usagers visibles depuis l'extérieur. Les panneaux de remplissage de la façade alternent entre parties vitrées transparentes et panneaux opaques massifs selon les fonctions intérieures.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sendagaya+Facade+Rideau",
    "source": "Detail Magazine n°2/1998 - Atelier und Bürohaus in Sendagaya, Hisao Kohyama",
    "materiaux": [
      "ossature acier",
      "vitrage",
      "panneaux de remplissage opaques",
      "profilés acier",
      "garde-corps acier rond Ø13 mm",
      "main courante tube acier Ø27,2 mm"
    ],
    "points_cles": [
      "Façade rideau vitrée suspendue devant la structure porteuse créant un espace tampon pour l'escalier",
      "Alternance de remplissages transparents et opaques selon les fonctions (exposition, bureaux, expérimentation lumière)",
      "Transparence de la zone escalier permettant une animation visuelle de la façade par les circulations des usagers"
    ]
  },
  {
    "id": "detail-2014-helsingor-01",
    "title": "Paroi du dock existant avec doublage intérieur isolé - Zone administrative",
    "fabricant": "Detail Magazine",
    "systeme": "Doublage intérieur sur mur béton massif existant avec ossature métallique",
    "categorie": "facade",
    "tags": [
      "doublage",
      "isolation intérieure",
      "mur béton existant",
      "dock",
      "réhabilitation",
      "ossature métallique",
      "noppenbahn",
      "pare-vapeur",
      "gipsfaserplatte",
      "musée souterrain",
      "patrimoine",
      "BIG"
    ],
    "description": "Doublage intérieur d'un mur en béton armé existant de 140 cm d'épaisseur (paroi du dock sec). L'isolation thermique est intégrée dans une ossature métallique (Metallständerkonstruktion), protégée côté intérieur par un pare-vapeur et un parement en plaques de fibres de gypse peintes, et côté extérieur par une membrane à plots en plastique (Noppenbahn) drainante contre le mur béton existant. Ce système permet de conserver intégralement la structure historique du dock tout en assurant le confort thermique des espaces muséaux enterrés.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Helsingor+Facade+Doublage",
    "source": "Detail Magazine n°4/2014 - Dänisches Seefahrtsmuseum Helsingør, BIG Bjarke Ingels Group",
    "materiaux": [
      "béton armé existant 140 cm",
      "membrane à plots plastique (Noppenbahn)",
      "isolation thermique",
      "ossature métallique (Metallständerkonstruktion)",
      "pare-vapeur",
      "plaques de fibres de gypse peintes"
    ],
    "points_cles": [
      "Conservation intégrale du mur béton existant du dock sec de 140 cm d'épaisseur",
      "Membrane à plots (Noppenbahn) assurant le drainage entre le mur existant et l'isolation",
      "Ossature métallique légère permettant l'intégration de l'isolation sans intervention sur la structure historique"
    ]
  },
  {
    "id": "detail-2014-helsingor-02",
    "title": "Couronnement du dock - Jonction dalle béton, garde-corps vitré et espace public",
    "fabricant": "Detail Magazine",
    "systeme": "Acrotère de dock avec garde-corps en verre feuilleté et revêtement granit",
    "categorie": "soubassement",
    "tags": [
      "couronnement",
      "garde-corps verre",
      "VSG",
      "verre feuilleté",
      "encastrement acier galvanisé",
      "granit",
      "acrotère",
      "dock",
      "espace public",
      "main courante inox",
      "étanchéité",
      "pente",
      "évacuation eaux pluviales",
      "BIG",
      "Helsingør"
    ],
    "description": "Détail du couronnement de la paroi existante du dock sec, formant la jonction entre le niveau de l'espace public extérieur et le vide intérieur du dock. Un béton de forme en pente (min. 10‰) assure l'évacuation des eaux pluviales, recouvert d'un revêtement en granit à surface bouchardée (genoppt). Le garde-corps est constitué de panneaux en verre feuilleté de sécurité (VSG) encastrés dans un sabot en acier galvanisé, surmonté d'une main courante en profil plat inox. Une rigole de drainage et un trop-plein de secours complètent le dispositif.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Helsingor+Couronnement+Dock",
    "source": "Detail Magazine n°4/2014 - Dänisches Seefahrtsmuseum Helsingør, BIG Bjarke Ingels Group",
    "materiaux": [
      "béton armé existant 140 cm (mur dock)",
      "béton de pente min. 10‰",
      "granit bouchardé (genoppt)",
      "profil de rive acier galvanisé",
      "verre feuilleté de sécurité VSG",
      "encastrement acier galvanisé",
      "main courante profil plat inox"
    ],
    "points_cles": [
      "Garde-corps en verre feuilleté VSG encastré dans sabot acier galvanisé pour transparence maximale vers le dock",
      "Béton de forme en pente minimale de 10‰ avec rigole de drainage et trop-plein de secours",
      "Revêtement granit bouchardé antidérapant pour l'espace public au-dessus du dock"
    ]
  },
  {
    "id": "detail-2014-helsingor-03",
    "title": "Plancher des passerelles - Structure acier préfabriquée avec vitrage sans cadre",
    "fabricant": "Detail Magazine",
    "systeme": "Planchers inclinés en acier préfabriqué avec vitrage isolant sans cadre en façade",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher acier",
      "préfabrication",
      "chantier naval",
      "passerelle",
      "vitrage sans cadre",
      "isolierverglasung",
      "plancher incliné",
      "appui élastique",
      "dilatation différentielle",
      "acier",
      "béton",
      "HEB 400",
      "dock",
      "BIG",
      "structure mixte"
    ],
    "description": "Les planchers inclinés des passerelles traversant le dock sont des éléments en acier préfabriqués dans un chantier naval en Chine, transportés par bateau et posés par grue dans le dock. Ils reposent sur des poutres HEB 400 et des colonnes rondes en acier Ø180 mm. Des appuis élastiques compensent les dilatations différentielles entre la dalle béton armé (220 mm) et les éléments de plancher en acier, protégeant ainsi les vitrages isolants sans cadre qui ferment les extrémités effilées des passerelles. Le revêtement intérieur est en lames de chêne.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Helsingor+Plancher+Passerelle",
    "source": "Detail Magazine n°4/2014 - Dänisches Seefahrtsmuseum Helsingør, BIG Bjarke Ingels Group",
    "materiaux": [
      "éléments de plancher acier préfabriqués",
      "poutres acier HEB 400",
      "colonnes rondes acier Ø180 mm",
      "dalle béton armé 220 mm",
      "appuis élastiques",
      "vitrage isolant sans cadre",
      "lames de chêne",
      "habillage plaque de fibres de gypse peinte",
      "plaque acoustique plâtre perforé"
    ],
    "points_cles": [
      "Éléments de plancher acier préfabriqués en chantier naval en Chine puis acheminés par voie maritime",
      "Appuis élastiques absorbant les dilatations différentielles acier/béton pour protéger les vitrages sans cadre",
      "Planchers inclinés en sens opposé créant des espaces à géométrie variable (auditorium, tribunes)"
    ]
  },
  {
    "id": "detail-2014-helsingor-04",
    "title": "Rampe d'accès suspendue par chaînes acier au-dessus du dock",
    "fabricant": "Detail Magazine",
    "systeme": "Rampe préfabriquée acier suspendue par chaînes sur structure acier supérieure",
    "categorie": "structure",
    "tags": [
      "rampe",
      "suspension",
      "chaînes acier",
      "Stahlketten",
      "préfabrication acier",
      "accessibilité",
      "PMR",
      "dock",
      "accès musée",
      "structure suspendue",
      "BIG",
      "sémantique maritime",
      "passerelle inclinée",
      "rampe hélicoïdale"
    ],
    "description": "La rampe d'accès principale descend en diagonale à travers le vide du dock pour rejoindre l'entrée du musée en contrebas. Les deux niveaux (plancher et plafond) sont préfabriqués en acier et suspendus par des chaînes en acier de couleur rouille, évoquant l'univers maritime. Cette rampe assure un accès sans barrière (PMR) depuis le niveau de la rue jusqu'à l'entrée principale du musée située au fond du dock, tout en offrant des vues spectaculaires sur les parois brutes en béton du bassin.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Helsingor+Rampe+Suspendue",
    "source": "Detail Magazine n°4/2014 - Dänisches Seefahrtsmuseum Helsingør, BIG Bjarke Ingels Group",
    "materiaux": [
      "éléments de plancher acier préfabriqués",
      "chaînes acier couleur rouille",
      "habillage tôle acier",
      "béton armé existant (parois dock)",
      "colonnes béton armé rondes"
    ],
    "points_cles": [
      "Double niveau de rampe entièrement préfabriqué en acier et suspendu par chaînes, référence sémantique à la navigation",
      "Accessibilité PMR intégrale depuis la rue jusqu'au fond du dock par un parcours en rampe continue",
      "Fondations sur pieux forés ancrés à plus de 30 m de profondeur pour contrer la poussée hydrostatique sur le bassin vide"
    ]
  },
  {
    "id": "detail-2013-amsterdam-01",
    "title": "Structure porteuse en cadres acier de containers hospitaliers réemployés",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier de réemploi - containers hospitaliers empilés",
    "categorie": "structure",
    "tags": [
      "acier",
      "réemploi",
      "container",
      "ossature",
      "structure",
      "upcycling",
      "squelette acier",
      "modules empilés",
      "pavillon",
      "Amsterdam",
      "bottom-up",
      "seconde main"
    ],
    "description": "La structure porteuse du pavillon est constituée de trois cadres squelettes en acier provenant d'anciens containers hospitaliers. Deux modules sont empilés l'un sur l'autre pour encadrer la terrasse, tandis qu'un troisième module reçoit la façade vitrée et la toiture. Ce système de réemploi structurel permet une construction rapide et économique à partir d'éléments standardisés récupérés.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Structure",
    "source": "Detail Magazine n10/2013 - Noorderparkbar Amsterdam, Bureau SLA / Peter van Assche + Overtreders W / Reinder Bakker",
    "materiaux": [
      "cadres acier de containers hospitaliers",
      "acier de réemploi",
      "assemblages boulonnés"
    ],
    "points_cles": [
      "Réemploi de trois squelettes acier de containers hospitaliers comme structure principale",
      "Empilage de deux modules acier pour créer le cadre de la terrasse couverte",
      "Approche bottom-up : conception et exécution simultanées selon les matériaux disponibles"
    ]
  },
  {
    "id": "detail-2013-amsterdam-02",
    "title": "Façade patchwork de fenêtres récupérées de dimensions variées",
    "fabricant": "Detail Magazine",
    "systeme": "Façade composite en menuiseries de réemploi hétérogènes",
    "categorie": "facade",
    "tags": [
      "façade",
      "fenêtre",
      "réemploi",
      "patchwork",
      "vitrage",
      "menuiserie",
      "récupération",
      "seconde main",
      "Marktplaats",
      "pavillon",
      "Amsterdam",
      "upcycling"
    ],
    "description": "La façade principale est composée d'un assemblage patchwork de fenêtres de dimensions et typologies différentes, toutes acquises d'occasion via la plateforme en ligne Marktplaats. L'hétérogénéité des menuiseries crée une esthétique singulière qualifiée de minimalisme avec patine. Les fenêtres sont intégrées dans le cadre structurel en acier des containers réemployés.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Facade",
    "source": "Detail Magazine n10/2013 - Noorderparkbar Amsterdam, Bureau SLA / Peter van Assche + Overtreders W / Reinder Bakker",
    "materiaux": [
      "menuiseries de réemploi dimensions variées",
      "vitrages récupérés",
      "cadre acier de container"
    ],
    "points_cles": [
      "Composition patchwork de fenêtres de tailles et provenances différentes",
      "Intégration des menuiseries hétérogènes dans la trame du squelette acier",
      "Esthétique du réemploi assumée : chaque élément porte sa propre histoire et patine"
    ]
  },
  {
    "id": "detail-2013-amsterdam-03",
    "title": "Portes pliantes anti-vandalisme en lattis bois brûlé technique Shou Sugi Ban",
    "fabricant": "Detail Magazine",
    "systeme": "Fermeture pivotante en lattes de bois de coffrage récupérées, traitement Shou Sugi Ban",
    "categorie": "jonction_menuiserie",
    "tags": [
      "porte pliante",
      "bois brûlé",
      "shou sugi ban",
      "anti-vandalisme",
      "lattis diagonal",
      "bois de coffrage",
      "réemploi",
      "fermeture",
      "sécurité",
      "pavillon",
      "Amsterdam",
      "yakisugi",
      "protection"
    ],
    "description": "Le pavillon est intégralement protégé par des portes pliantes toute hauteur constituées de lattes de bois montées en diagonal, récupérées auprès d'un fabricant de coffrages en faillite. Le bois a été traité selon la technique japonaise traditionnelle Shou Sugi Ban (flambage superficiel) qui lui confère une teinte noire uniforme et une résistance accrue aux intempéries. Ce dispositif assure une fermeture anti-vandalisme complète du pavillon en soirée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Menuiserie",
    "source": "Detail Magazine n10/2013 - Noorderparkbar Amsterdam, Bureau SLA / Peter van Assche + Overtreders W / Reinder Bakker",
    "materiaux": [
      "lattes de bois de coffrage de réemploi",
      "traitement Shou Sugi Ban carbonisation",
      "ferrures de portes pliantes"
    ],
    "points_cles": [
      "Lattes de bois récupérées d'un fabricant de coffrages en faillite, montées en diagonale",
      "Traitement Shou Sugi Ban : carbonisation superficielle pour uniformité chromatique noire et résistance aux intempéries",
      "Système de portes pliantes toute hauteur permettant la fermeture anti-vandalisme complète du pavillon"
    ]
  },
  {
    "id": "detail-2013-amsterdam-04",
    "title": "Toiture composée d'un assemblage de lanterneaux récupérés",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture en lanterneaux et éléments zénithaux de réemploi",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "lanterneau",
      "oberlichter",
      "éclairage zénithal",
      "réemploi",
      "skylight",
      "lumière naturelle",
      "seconde main",
      "pavillon",
      "Amsterdam",
      "upcycling",
      "couverture"
    ],
    "description": "La toiture du volume principal est constituée d'un assemblage hétérogène de lanterneaux (Oberlichter) de récupération, de formes et dimensions variées, posés sur la structure acier des containers réemployés. Cette composition offre un éclairage zénithal généreux à l'intérieur du bar tout en poursuivant la logique de patchwork de matériaux de seconde main qui caractérise l'ensemble du projet.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Amsterdam+Toiture",
    "source": "Detail Magazine n10/2013 - Noorderparkbar Amsterdam, Bureau SLA / Peter van Assche + Overtreders W / Reinder Bakker",
    "materiaux": [
      "lanterneaux de réemploi dimensions variées",
      "cadre acier de container",
      "étanchéité de raccord"
    ],
    "points_cles": [
      "Assemblage composite de lanterneaux récupérés de dimensions et formes hétérogènes",
      "Éclairage zénithal naturel abondant pour l'espace intérieur du bar",
      "Raccordement étanche des éléments zénithaux sur la structure acier existante des containers"
    ]
  },
  {
    "id": "detail-2011-copenhague-01",
    "title": "Double facade vitrée - Protection acoustique nord/ouest",
    "fabricant": "Detail Magazine",
    "systeme": "Double peau vitrée ventilée sur ossature béton armé",
    "categorie": "facade",
    "tags": [
      "double facade",
      "double peau",
      "vitrage",
      "acoustique",
      "protection solaire",
      "transparence",
      "facade rideau",
      "bureaux",
      "daylighting",
      "Copenhague",
      "Orestad",
      "isolation phonique",
      "mur rideau vitré"
    ],
    "description": "Facade entièrement vitrée en double peau conçue pour maximiser l'apport de lumière naturelle tout en assurant une isolation acoustique vis-à-vis des axes routiers au nord et à l'ouest. La double facade permet une ventilation dans la lame d'air intermédiaire et reflète les images du ciel, conférant au bâtiment son apparence de solitaire brillant.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Double+Facade",
    "source": "Detail Magazine n9/2011 - Ingenieurbüro Rambøll Kopenhagen, Dissing+Weitling architecture",
    "materiaux": [
      "vitrage double peau",
      "acier",
      "béton armé",
      "aluminium"
    ],
    "points_cles": [
      "Double facade vitrée pour isolation acoustique contre le bruit routier",
      "Transparence maximale pour optimiser l'éclairage naturel en hiver nordique",
      "Effet miroir reflétant le ciel - identité architecturale du bâtiment en solitaire"
    ]
  },
  {
    "id": "detail-2011-copenhague-02",
    "title": "Facade sud/est à tôle perforée et profil brisé",
    "fabricant": "Detail Magazine",
    "systeme": "Facade à géométrie pliée avec panneaux en tôle perforée en allège",
    "categorie": "facade",
    "tags": [
      "tôle perforée",
      "Lochblech",
      "allège",
      "facade pliée",
      "brise-soleil",
      "protection solaire",
      "sud",
      "est",
      "profil brisé",
      "brüstung",
      "ventilation naturelle",
      "bureaux"
    ],
    "description": "Sur les faces sud et est du bâtiment angulaire, la peau extérieure présente une géométrie à plis multiples avec des panneaux en tôle perforée dans les zones d'allège. Ce traitement crée une modulation de la lumière et une protection solaire passive tout en différenciant clairement cette facade des parois entièrement vitrées au nord et à l'ouest.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Tole+Perforee",
    "source": "Detail Magazine n9/2011 - Ingenieurbüro Rambøll Kopenhagen, Dissing+Weitling architecture",
    "materiaux": [
      "tôle perforée métallique",
      "vitrage",
      "acier",
      "béton armé"
    ],
    "points_cles": [
      "Tôle perforée en allège pour filtrage lumineux et protection solaire sud/est",
      "Géométrie à plis multiples de la facade créant un jeu d'ombres et de reflets",
      "Différenciation architecturale entre facades exposées au bruit et facades exposées au soleil"
    ]
  },
  {
    "id": "detail-2011-copenhague-03",
    "title": "Atrium longitudinal de 80 m avec escaliers en cascade et passerelles",
    "fabricant": "Detail Magazine",
    "systeme": "Atrium central sur 8 niveaux avec circulations suspendues et balcons périphériques",
    "categorie": "structure",
    "tags": [
      "atrium",
      "escalier cascade",
      "passerelle",
      "balcon",
      "vide central",
      "circulation verticale",
      "squelette béton",
      "bureaux ouverts",
      "lumière naturelle",
      "spatial",
      "steg",
      "treppe"
    ],
    "description": "Atrium de 80 m de longueur traversant les 8 étages du bâtiment en structure squelette béton armé. Il est équipé d'un escalier en cascade monumental, de balcons périphériques continus et de passerelles transversales qui relient les deux ailes. Cet espace central assure la distribution verticale et horizontale tout en créant des relations visuelles multiples entre les niveaux.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Atrium",
    "source": "Detail Magazine n9/2011 - Ingenieurbüro Rambøll Kopenhagen, Dissing+Weitling architecture",
    "materiaux": [
      "béton armé",
      "acier",
      "garde-corps métallique",
      "verre"
    ],
    "points_cles": [
      "Atrium de 80 m de long sur 8 niveaux comme colonne vertébrale spatiale du bâtiment",
      "Escalier monumental en cascade favorisant la circulation libre et informelle",
      "Passerelles transversales et balcons périphériques créant des connexions visuelles entre étages"
    ]
  },
  {
    "id": "detail-2011-copenhague-04",
    "title": "Organisation spatiale type - Plateau de bureaux combinés avec noyaux de service",
    "fabricant": "Detail Magazine",
    "systeme": "Kombibüro - Bureaux combinés ouverts en périphérie avec noyaux fonctionnels centraux",
    "categorie": "amenagement_interieur",
    "tags": [
      "bureau combiné",
      "Kombibüro",
      "open space",
      "noyau de service",
      "trame 1.50m",
      "aménagement tertiaire",
      "flexibilité",
      "acoustique",
      "teeküche",
      "Druckerstation",
      "lounge",
      "hauteur libre 2.60m",
      "poste de travail"
    ],
    "description": "Plateaux de bureaux organisés sur une trame de 1,50 m avec une hauteur libre de 2,60 m. Les espaces de travail ouverts sont disposés le long des facades pour maximiser la lumière naturelle, tandis que les noyaux fonctionnels (salles de réunion, kitchenettes, stations d'impression) sont regroupés en position centrale et séparent les zones animées des zones calmes. La superposition verticale des fonctions identiques facilite l'orientation avec 10,6 m² de surface utile par poste de travail.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Bureaux",
    "source": "Detail Magazine n9/2011 - Ingenieurbüro Rambøll Kopenhagen, Dissing+Weitling architecture",
    "materiaux": [
      "béton armé",
      "cloisons légères",
      "mobilier de bureau",
      "revêtements de sol"
    ],
    "points_cles": [
      "Trame de 1,50 m et ratio de 10,6 m² NF par poste pour 1800 collaborateurs",
      "Noyaux fonctionnels centraux séparant zones animées et zones calmes",
      "Superposition verticale des fonctions identiques pour simplifier l'orientation dans 40 000 m² de surface"
    ]
  },
  {
    "id": "detail-1997-osaka-01",
    "title": "Coupe verticale façade - Jonction toiture/mur avec bandeau vitré",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier avec façade vitrée et toiture légère",
    "categorie": "jonction_menuiserie",
    "tags": [
      "façade",
      "acier",
      "verre",
      "bandeau vitré",
      "fenêtre horizontale",
      "jonction toiture mur",
      "profil acier",
      "polycarbonate",
      "Japon",
      "résidentiel",
      "maison individuelle",
      "structure métallique",
      "transparence"
    ],
    "description": "Coupe verticale sur la façade montrant la jonction entre la toiture plate légère et le mur, séparés par un bandeau vitré horizontal continu. La structure est composée de poteaux acier IPE 150/150/7.5/10 peints en rouge, supportant des poutres IPE 250/100/125/6 et 250/125/6. Le toit est constitué de chevrons acier de 75 mm de hauteur, voligeage de 25 mm et couverture en feuille plastique, avec sous-face en plaques de plâtre de 9 mm. Un lanterneau en verre armé de 6,8 mm complète le dispositif de lumière zénithale.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Facade+Toiture",
    "source": "Detail Magazine n°2/1997 - Wohnhaus in Osaka, Kishi + K. Associates",
    "materiaux": [
      "acier peint blanc",
      "acier peint rouge",
      "verre armé 6.8 mm",
      "polycarbonate alvéolaire",
      "plaque de plâtre 9 mm",
      "feuille plastique étanchéité",
      "voligeage bois 25 mm"
    ],
    "points_cles": [
      "Séparation visuelle toiture/mur par bandeau vitré horizontal continu créant un effet de flottement du toit",
      "Couverture en polycarbonate alvéolaire pour apport de lumière diffuse en toiture",
      "Lanterneau en verre armé 6.8 mm avec fixation par baguettes de maintien"
    ]
  },
  {
    "id": "detail-1997-osaka-02",
    "title": "Détail de toiture plate légère sur ossature acier",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate légère acier-bois avec étanchéité plastique",
    "categorie": "toiture",
    "tags": [
      "toiture plate",
      "acier",
      "chevrons acier",
      "voligeage",
      "étanchéité",
      "plaque de plâtre",
      "sous-face",
      "polycarbonate",
      "lanterneau",
      "verre armé",
      "toiture légère",
      "Osaka"
    ],
    "description": "Toiture plate légère composée de chevrons en profil acier de 75 mm de hauteur, voligeage bois de 25 mm, et couverture en feuille plastique d'étanchéité. La sous-face est habillée de plaques de plâtre de 9 mm. Des parties de toiture sont rendues transparentes grâce à des panneaux en polycarbonate alvéolaire et des lanterneaux en verre armé de 6,8 mm, assurant la continuité spatiale entre intérieur et extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Toiture",
    "source": "Detail Magazine n°2/1997 - Wohnhaus in Osaka, Kishi + K. Associates",
    "materiaux": [
      "profil acier chevrons 75 mm",
      "voligeage bois 25 mm",
      "feuille plastique étanchéité",
      "plaque de plâtre 9 mm",
      "polycarbonate alvéolaire",
      "verre armé 6.8 mm",
      "profilé acier UPN 150/75/9"
    ],
    "points_cles": [
      "Toiture partiellement transparente en polycarbonate pour lumière diffuse et verre armé pour lanterneaux",
      "Structure hybride acier-bois : chevrons acier de 75 mm avec voligeage bois de 25 mm",
      "Sous-face en plaques de plâtre 9 mm pour finition intérieure légère"
    ]
  },
  {
    "id": "detail-1997-osaka-03",
    "title": "Jonction plancher - Terrasse extérieure bois et sol intérieur marbre",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher avec revêtement marbre intérieur et platelage bois extérieur",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "marbre",
      "platelage bois",
      "terrasse",
      "transition intérieur extérieur",
      "seuil",
      "sol",
      "continuité spatiale",
      "Osaka",
      "résidentiel"
    ],
    "description": "Jonction entre le sol intérieur en revêtement marbre de 15 mm et la terrasse extérieure en platelage bois massif de 30 mm d'épaisseur. Cette transition matérialise le concept de gradation progressive entre intérieur et extérieur, les terrasses formant une couche intermédiaire protégée au sein de l'enceinte des murs périphériques du patio.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Plancher",
    "source": "Detail Magazine n°2/1997 - Wohnhaus in Osaka, Kishi + K. Associates",
    "materiaux": [
      "marbre 15 mm",
      "platelage bois massif 30 mm",
      "acier peint"
    ],
    "points_cles": [
      "Revêtement intérieur en marbre de 15 mm de qualité résidentielle japonaise",
      "Terrasse en lames bois massif de 30 mm assurant la transition dedans/dehors",
      "Concept de maison à patio avec gradation spatiale progressive entre public et privé"
    ]
  },
  {
    "id": "detail-1997-osaka-04",
    "title": "Meuble buffet bas encastré en contreplaqué de hêtre et aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiserie intégrée en contreplaqué hêtre avec habillage aluminium",
    "categorie": "amenagement_interieur",
    "tags": [
      "meuble intégré",
      "buffet",
      "sideboard",
      "contreplaqué",
      "hêtre",
      "aluminium",
      "tiroir",
      "tourillon",
      "ébénisterie",
      "détail mobilier",
      "aménagement intérieur",
      "Japon",
      "menuiserie",
      "meuble bas"
    ],
    "description": "Détail au 1:5 d'un meuble buffet bas (sideboard) encastré, dont le corps est entièrement réalisé en contreplaqué de hêtre verni clair sur cadre bois massif de 25 mm d'épaisseur avec chants plaqués. Les portes de 20 mm d'épaisseur totale sont constituées de contreplaqué sur cadre bois avec parement frontal en tôle d'aluminium revêtue de 3 mm. Les tiroirs sont en contreplaqué avec fond en bois massif collé, coulissant sur glissières en bois massif. L'assemblage utilise des tourillons bois espacés de 50 mm et repose sur des tasseaux de 50x20 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Mobilier",
    "source": "Detail Magazine n°2/1997 - Wohnhaus in Osaka, Kishi + K. Associates",
    "materiaux": [
      "contreplaqué de hêtre verni",
      "bois massif de hêtre",
      "tôle aluminium 3 mm revêtue",
      "tourillons bois",
      "tasseaux bois 50x20 mm"
    ],
    "points_cles": [
      "Portes à parement aluminium de 3 mm sur cadre bois, épaisseur totale 20 mm, pour une esthétique contemporaine",
      "Tiroirs sur glissières bois massif avec assemblage par collage, tradition artisanale japonaise",
      "Mobilier fixe intégré définissant l'orientation des espaces de vie vers la vue sur la vallée"
    ]
  },
  {
    "id": "detail-1988-oyodo-01",
    "title": "Cube intérieur en bois - Structure poteaux-poutres du pavillon de thé",
    "fabricant": "Detail Magazine",
    "systeme": "Structure bois poteaux-poutres avec parement en placage de tilleul japonais",
    "categorie": "structure",
    "tags": [
      "structure bois",
      "poteaux-poutres",
      "pavillon de thé",
      "cube",
      "tilleul japonais",
      "chashitsu",
      "Tadao Ando",
      "Japon",
      "espace minimal",
      "architecture japonaise",
      "bois massif",
      "placage"
    ],
    "description": "Structure en poteaux et poutres bois définissant un espace cubique de 2390 mm de côté. Les poutres sont dimensionnées 100 mm plus basses que celles du Myoki-an (1582), référence historique du projet. L'ensemble des surfaces intérieures (sol, murs, plafond) est revêtu d'un placage de tilleul japonais (Tilia japonica) pour créer une atmosphère monomatériau chaleureuse.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Oyodo+Structure",
    "source": "Detail Magazine n05/1988 - Teehaus in Oyodo, Tadao Ando",
    "materiaux": [
      "bois massif structure",
      "placage de tilleul japonais (Tilia japonica)",
      "poteaux bois",
      "poutres bois"
    ],
    "points_cles": [
      "Cube intérieur de 2390 mm de côté défini par poteaux et poutres",
      "Poutres dimensionnées en référence au Myoki-an avec 100 mm de moins en hauteur",
      "Revêtement monomatériau en placage de tilleul japonais sur les six faces du volume"
    ]
  },
  {
    "id": "detail-1988-oyodo-02",
    "title": "Plafond suspendu voûté en arc de cercle au sixième",
    "fabricant": "Detail Magazine",
    "systeme": "Plafond suspendu courbe en placage bois sur structure légère",
    "categorie": "amenagement_interieur",
    "tags": [
      "plafond suspendu",
      "voûte",
      "arc de cercle",
      "sixième de cercle",
      "tilleul japonais",
      "plafond courbe",
      "pavillon de thé",
      "Tadao Ando",
      "acoustique",
      "bois courbe",
      "intérieur"
    ],
    "description": "Plafond suspendu formant un arc correspondant au sixième d'un cercle complet (Sechstelkreis-Tonne), créant une voûte légère au-dessus du volume cubique. Ce plafond est revêtu du même placage de tilleul japonais que les murs et le sol, assurant la continuité matérielle. La courbure modifie subtilement la perception de l'espace minimal en lui conférant une profondeur infinie.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Oyodo+Plafond+Voute",
    "source": "Detail Magazine n05/1988 - Teehaus in Oyodo, Tadao Ando",
    "materiaux": [
      "placage de tilleul japonais",
      "structure de suspension",
      "ossature courbe",
      "bois cintré"
    ],
    "points_cles": [
      "Voûte au sixième de cercle suspendue au-dessus du cube de 2390 mm",
      "Continuité du placage de tilleul japonais entre murs, sol et plafond courbe",
      "Courbure conçue pour amplifier la perception spatiale d'un volume minimal"
    ]
  },
  {
    "id": "detail-1988-oyodo-03",
    "title": "Jonction pavillon de thé - maison en bande existante",
    "fabricant": "Detail Magazine",
    "systeme": "Greffe architecturale bois sur construction existante en bois avec escalier intérieur",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction",
      "extension",
      "maison en bande",
      "escalier intérieur",
      "transition",
      "roji",
      "seuil",
      "Tadao Ando",
      "greffe architecturale",
      "bois sur bois",
      "niveau décalé",
      "nijiri-guchi"
    ],
    "description": "Jonction entre la maison en bande existante en bois et le pavillon de thé ajouté, réalisée par un escalier intérieur raide. L'entrée dans le pavillon se fait à un niveau inférieur à celui du plancher fini, en référence au nijiri-guchi traditionnel (ouverture de 650 x 600 mm) mais réinterprété par un décalage vertical. Le bâtiment existant fait office de roji (jardin de transition) et assure le parcours initiatique vers l'espace de thé.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Oyodo+Jonction",
    "source": "Detail Magazine n05/1988 - Teehaus in Oyodo, Tadao Ando",
    "materiaux": [
      "bois massif structure existante",
      "bois structure neuve",
      "placage tilleul japonais",
      "escalier bois"
    ],
    "points_cles": [
      "Accès par escalier intérieur raide depuis la maison existante en bois",
      "Entrée dans le pavillon à un niveau inférieur au plancher fini, réinterprétation du nijiri-guchi",
      "Bâtiment existant servant de parcours transitionnel (fonction de roji) sans modification extérieure visible"
    ]
  },
  {
    "id": "detail-1988-oyodo-04",
    "title": "Paroi à store lumineux - contrôle de la lumière diffuse",
    "fabricant": "Detail Magazine",
    "systeme": "Store intérieur filtrant la lumière naturelle dans un espace monomatériau bois",
    "categorie": "amenagement_interieur",
    "tags": [
      "lumière diffuse",
      "store",
      "blende",
      "ombre",
      "clair-obscur",
      "paroi filtrante",
      "tilleul japonais",
      "Tadao Ando",
      "pavillon de thé",
      "ambiance lumineuse",
      "pénombre",
      "contrôle solaire intérieur"
    ],
    "description": "Une des faces du cube est équipée d'un store (Lichtblende) créant dans la pénombre des ombres diffuses et complexes. Ce dispositif de contrôle lumineux travaille en association avec le ton chaud du placage de tilleul japonais pour définir le caractère atmosphérique propre au pavillon. La composition tridimensionnelle de la lumière et de l'obscurité est au cœur de la réinterprétation contemporaine de l'esprit du chashitsu.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Oyodo+Lumiere",
    "source": "Detail Magazine n05/1988 - Teehaus in Oyodo, Tadao Ando",
    "materiaux": [
      "store filtrant",
      "placage de tilleul japonais",
      "cadre bois"
    ],
    "points_cles": [
      "Store (Lichtblende) sur une paroi du cube générant des ombres diffuses en pénombre",
      "Interaction entre lumière filtrée et tonalité chaude du tilleul japonais pour l'atmosphère",
      "Composition tridimensionnelle lumière/obscurité comme principe de conception spatiale"
    ]
  },
  {
    "id": "detail-1996-olot-01",
    "title": "Toiture plate avec lanterneau circulaire en acrylique",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate béton avec étanchéité bitumineuse et lanterneau Perspex",
    "categorie": "toiture",
    "tags": [
      "toiture plate",
      "lanterneau",
      "acrylique",
      "perspex",
      "étanchéité bitumineuse",
      "isolation thermique",
      "lest gravier",
      "béton armé",
      "école",
      "Espagne",
      "dalle céramique creuse",
      "habillage conique",
      "plâtre"
    ],
    "description": "Complexe de toiture plate sur dalles céramiques creuses emboîtées, avec étanchéité bitumineuse à âme aluminium, isolation thermique de 50 mm, couche de séparation et lest gravier. Des lanterneaux circulaires de 600 mm en acrylique Perspex sont montés sur un panneau isolé à revêtement en plastique renforcé de fibres de verre, avec habillage intérieur conique en plaques de plâtre.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Olot+Toiture+Lanterneau",
    "source": "Detail Magazine n7/1996 - School in Olot, José Antonio Martínez Lapeña & Elías Torres Tur",
    "materiaux": [
      "béton armé",
      "dalles céramiques creuses emboîtées",
      "étanchéité bitumineuse à âme aluminium",
      "isolation thermique 50 mm",
      "gravier",
      "acrylique Perspex 600 mm",
      "plaques de plâtre",
      "plastique renforcé fibre de verre",
      "chape de pente"
    ],
    "points_cles": [
      "Lanterneau circulaire Perspex de 600 mm sur rehausse isolée avec revêtement PRV",
      "Habillage intérieur conique en plaques de plâtre pour diffusion de la lumière naturelle",
      "Étanchéité bitumineuse avec âme aluminium sous lest gravier sur chape de pente"
    ]
  },
  {
    "id": "detail-1996-olot-02",
    "title": "Façade en maçonnerie de briques avec menuiserie aluminium et volets fixes",
    "fabricant": "Detail Magazine",
    "systeme": "Mur béton armé avec parement brique apparente et menuiserie aluminium anodisé",
    "categorie": "jonction_menuiserie",
    "tags": [
      "façade",
      "brique",
      "appareil en panneresse",
      "menuiserie aluminium",
      "volet",
      "lamelles fixes",
      "aluminium anodisé",
      "béton armé",
      "joint de dilatation",
      "école",
      "Olot"
    ],
    "description": "Façade composée d'une structure porteuse en béton armé peinte en blanc côté intérieur, doublée d'un parement en briques de 240x120x70 mm posées en appareil de panneresse. Les ouvertures sont équipées de profilés en aluminium anodisé avec volets à lamelles fixes. Un joint de dilatation est intégré dans le parement de façade.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Olot+Facade+Brique",
    "source": "Detail Magazine n7/1996 - School in Olot, José Antonio Martínez Lapeña & Elías Torres Tur",
    "materiaux": [
      "béton armé peint blanc",
      "briques 240x120x70 mm",
      "aluminium anodisé",
      "volets à lamelles fixes",
      "pierre naturelle"
    ],
    "points_cles": [
      "Parement brique en appareil de panneresse sur structure béton armé",
      "Menuiseries ouvrant en aluminium anodisé avec volets à lamelles fixes intégrés",
      "Joint de dilatation traité dans l'épaisseur de la façade"
    ]
  },
  {
    "id": "detail-1996-olot-03",
    "title": "Acrotère avec couvertine zinc sur support bois",
    "fabricant": "Detail Magazine",
    "systeme": "Acrotère béton-brique avec couvertine en tôle de zinc sur volige bois",
    "categorie": "toiture",
    "tags": [
      "acrotère",
      "couvertine",
      "zinc",
      "bois",
      "étanchéité",
      "toiture plate",
      "relevé d'étanchéité",
      "brique",
      "béton armé",
      "détail de rive"
    ],
    "description": "Détail d'acrotère formé par la continuité du mur en béton armé avec parement brique, couronné par une couvertine en tôle de zinc posée sur un support en bois de 20 mm d'épaisseur. Le relevé d'étanchéité bitumineux à âme aluminium assure la continuité de l'étanchéité de la toiture plate jusqu'à l'acrotère.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Olot+Acrotere+Zinc",
    "source": "Detail Magazine n7/1996 - School in Olot, José Antonio Martínez Lapeña & Elías Torres Tur",
    "materiaux": [
      "tôle de zinc",
      "volige bois 20 mm",
      "béton armé",
      "briques 240x120x70 mm",
      "étanchéité bitumineuse à âme aluminium",
      "panneaux laine de bois"
    ],
    "points_cles": [
      "Couvertine zinc sur support bois de 20 mm en tête d'acrotère",
      "Continuité du parement brique en panneresse jusqu'à l'acrotère",
      "Panneau laine de bois léger en sous-face de toiture côté intérieur"
    ]
  },
  {
    "id": "detail-1996-olot-04",
    "title": "Verrière triangulaire avec vitrage de sécurité et fixation galvanisée",
    "fabricant": "Detail Magazine",
    "systeme": "Lanterneau triangulaire vitré avec structure acier galvanisé et étanchéité bitumineuse",
    "categorie": "toiture",
    "tags": [
      "verrière",
      "lanterneau triangulaire",
      "vitrage sécurité",
      "verre feuilleté",
      "acier galvanisé",
      "néoprène",
      "étanchéité",
      "marbre blanc",
      "école",
      "éclairage zénithal",
      "baguettes pin"
    ],
    "description": "Lanterneau triangulaire en toiture composé d'un vitrage de protection thermique double (2x10 mm) et d'un verre de sécurité de 6 mm, fixé par des pattes galvanisées de 3 mm d'épaisseur avec joints néoprène. La structure est en tôle pliée galvanisée de 4 mm et profilé en tôle d'acier de 10 mm. L'habillage intérieur est en plaques de marbre blanc de 20 mm sur lit de mortier et baguettes de pin peintes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Olot+Verriere+Triangulaire",
    "source": "Detail Magazine n7/1996 - School in Olot, José Antonio Martínez Lapeña & Elías Torres Tur",
    "materiaux": [
      "verre de protection thermique 2x10 mm",
      "verre de sécurité 6 mm",
      "tôle galvanisée 4 mm",
      "pattes galvanisées 3 mm",
      "joint néoprène",
      "profilé acier 10 mm",
      "marbre blanc 20 mm",
      "mortier",
      "baguettes pin peintes",
      "étanchéité bitumineuse à âme aluminium",
      "dalles 40x300x300 mm",
      "dalle béton armé",
      "dalles céramiques creuses"
    ],
    "points_cles": [
      "Double vitrage thermique 2x10 mm avec couche intérieure en verre de sécurité 6 mm",
      "Fixation par pattes galvanisées de 3 mm avec joints néoprène assurant l'étanchéité à l'eau",
      "Habillage intérieur en plaques de marbre blanc 20 mm sur mortier avec baguettes de pin peintes"
    ]
  },
  {
    "id": "detail-1964-tottori-01",
    "title": "Mégastructure béton à stützen principales et poutres longitudinales avec suspension par câbles précontraints",
    "fabricant": "Detail Magazine",
    "systeme": "Structure porteuse en béton armé avec étages suspendus par câbles en acier précontraint",
    "categorie": "structure",
    "tags": [
      "megastructure",
      "beton",
      "cables precontraints",
      "suspension",
      "etages suspendus",
      "stutzen",
      "poutres longitudinales",
      "acier precontraint",
      "hotel",
      "japon",
      "kikutake",
      "metabolisme"
    ],
    "description": "Mégastructure composée de six colonnes principales en béton et de deux poutres longitudinales auxquelles les étages hôteliers sont suspendus au moyen de câbles en acier précontraint. Ce système permet de libérer les niveaux inférieurs de la charge des planchers supérieurs et de concentrer l'effort porteur sur un nombre réduit d'appuis massifs. La structure exprime une verticalité affirmée et reste entièrement visible en façade.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tottori+Megastructure",
    "source": "Detail Magazine - Hotel Tokoen bei Tottori, Kiyonori Kikutake",
    "materiaux": [
      "beton arme",
      "acier precontraint",
      "cables de suspension"
    ],
    "points_cles": [
      "Six colonnes principales en béton portant deux poutres longitudinales sommitales",
      "Planchers des étages hôteliers suspendus par câbles en acier précontraint",
      "Structure porteuse entièrement visible depuis l'extérieur comme expression architecturale"
    ]
  },
  {
    "id": "detail-1964-tottori-02",
    "title": "Contreventement par treillis cruciformes et colonnes secondaires en béton contre séismes et typhons",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature béton contreventée par diagonales croisées en treillis sur quatre niveaux inférieurs",
    "categorie": "structure",
    "tags": [
      "contreventement",
      "treillis",
      "croix",
      "diagonales",
      "antisismique",
      "typhon",
      "beton",
      "rigidite",
      "stabilite",
      "colonnes secondaires",
      "quatre niveaux",
      "japon"
    ],
    "description": "Les quatre étages inférieurs sont rigidifiés par des contreventements en treillis disposés en croix entre les colonnes principales, complétés par des colonnes secondaires en béton. Ce dispositif confère la rigidité nécessaire pour résister aux sollicitations dynamiques des séismes et des typhons fréquents sur la côte japonaise. Le réseau de diagonales forme un motif de grille visible qui participe à l'expression plastique de la façade.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tottori+Contreventement",
    "source": "Detail Magazine - Hotel Tokoen bei Tottori, Kiyonori Kikutake",
    "materiaux": [
      "beton arme",
      "acier",
      "entretoises diagonales"
    ],
    "points_cles": [
      "Diagonales croisées en forme de treillis reliant les colonnes principales sur quatre niveaux",
      "Colonnes secondaires en béton assurant une redondance structurelle",
      "Conception parasismique et anti-typhon adaptée au littoral de la mer du Japon"
    ]
  },
  {
    "id": "detail-1964-tottori-03",
    "title": "Parois de chambres en panneaux légers à ossature acier et bois insérés dans la mégastructure",
    "fabricant": "Detail Magazine",
    "systeme": "Remplissage non porteur par unités murales légères en ossature acier ou ossature bois",
    "categorie": "facade",
    "tags": [
      "remplissage",
      "parois legeres",
      "ossature acier",
      "ossature bois",
      "panneaux",
      "cloisons",
      "hotel",
      "chambre",
      "unites murales",
      "mur rideau",
      "separation",
      "enveloppe"
    ],
    "description": "Les murs extérieurs et les cloisons intérieures des chambres d'hôtel sont réalisés sous forme d'unités modulaires légères à ossature acier ou bois, indépendantes de la structure porteuse en béton. Ces panneaux sont simplement insérés entre les planchers suspendus et assurent les fonctions de clôture, d'isolation et de séparation entre chambres. La dissociation entre structure et enveloppe permet une flexibilité d'aménagement et une facilité de remplacement caractéristiques de l'architecture métaboliste.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tottori+Parois+Legeres",
    "source": "Detail Magazine - Hotel Tokoen bei Tottori, Kiyonori Kikutake",
    "materiaux": [
      "profiles acier legers",
      "ossature bois",
      "panneaux de remplissage"
    ],
    "points_cles": [
      "Unités murales non porteuses indépendantes de la mégastructure béton",
      "Double système constructif: ossature acier pour certaines parois, ossature bois pour d'autres",
      "Principe métaboliste de séparation entre structure permanente et éléments remplaçables"
    ]
  },
  {
    "id": "detail-1964-tottori-04",
    "title": "Couverture du restaurant en toiture par coques hyperboliques-paraboloïdes en béton",
    "fabricant": "Detail Magazine",
    "systeme": "Coques minces en béton de forme hyperbolique-paraboloïde en couronnement du bâtiment",
    "categorie": "toiture",
    "tags": [
      "coque",
      "hypar",
      "hyperbolique paraboloide",
      "beton",
      "toiture",
      "restaurant",
      "couverture",
      "forme libre",
      "shell structure",
      "couronnement",
      "contraste"
    ],
    "description": "Le restaurant panoramique situé en toiture est couvert par des coques de forme hyperbolique-paraboloïde en béton, créant un accent plastique de contraste au sommet du bâtiment. Cette géométrie à double courbure inverse permet de couvrir de grandes portées avec une épaisseur de coque minimale tout en assurant une excellente stabilité de forme. Les coques constituent le couronnement expressif de l'édifice et dialoguent avec la verticalité rigoureuse de la mégastructure sous-jacente.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tottori+Coque+Hypar",
    "source": "Detail Magazine - Hotel Tokoen bei Tottori, Kiyonori Kikutake",
    "materiaux": [
      "beton arme",
      "coque mince",
      "armatures"
    ],
    "points_cles": [
      "Coques hyperboliques-paraboloïdes coiffant le restaurant panoramique en toiture",
      "Double courbure inverse assurant rigidité et portée avec une épaisseur minimale de matière",
      "Effet de contraste formel volontaire entre la géométrie curviligne des coques et la verticalité de la structure"
    ]
  },
  {
    "id": "detail-2015-pachacamac-01",
    "title": "Toiture végétalisée enterrée sur dalle béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture végétalisée extensive sur structure enterrée",
    "categorie": "toiture",
    "tags": [
      "toiture vegetalisee",
      "enterree",
      "beton arme",
      "membrane etancheite",
      "substrat inorganique",
      "recyclage",
      "integration paysagere",
      "wurzelschutz",
      "root barrier",
      "dalle beton"
    ],
    "description": "Complexe de toiture végétalisée conçu pour fusionner avec le paysage collinaire existant. La composition comprend une couche de végétation sur membrane anti-racines, un substrat inorganique à base de bouteilles plastiques recyclées et de terre, une membrane d'étanchéité posée sur une dalle en béton armé de 200 mm enduite de 10 mm de plâtre en sous-face. Ce système permet à la maison de disparaître progressivement dans le site naturel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Pachacamac+Toiture+Vegetalisee",
    "source": "Detail Magazine n7-8/2015 - Casa Pachacámac, Longhi Architects",
    "materiaux": [
      "béton armé 200 mm",
      "membrane d'étanchéité",
      "membrane anti-racines",
      "substrat inorganique recyclé",
      "enduit plâtre 10 mm",
      "couche de végétation"
    ],
    "points_cles": [
      "Substrat inorganique composé de bouteilles plastiques recyclées et de terre pour alléger la charge et favoriser le drainage",
      "Membrane anti-racines (Wurzelschutzbahn) protégeant l'étanchéité de la pénétration racinaire",
      "Intégration paysagère totale : la toiture plantée fusionne avec la colline environnante au fil du temps"
    ]
  },
  {
    "id": "detail-2015-pachacamac-02",
    "title": "Façade en maçonnerie de pierre naturelle sur voile béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Mur composite pierre brute et béton armé",
    "categorie": "facade",
    "tags": [
      "bruchstein",
      "pierre naturelle",
      "maconnerie",
      "beton arme",
      "mur massif",
      "facade enterree",
      "ventilation croisee",
      "ashlar",
      "mur composite"
    ],
    "description": "Mur composite associant un parement extérieur en maçonnerie de pierre brute locale de 150 mm, hourdé au mortier, et un voile porteur en béton armé de 200 mm. De petites ouvertures sont ménagées dans cette paroi massive côté est pour assurer la ventilation croisée et l'éclairage naturel des espaces enterrés. La pierre de taille locale (Bruchstein) ancre visuellement le bâtiment dans son contexte géologique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Pachacamac+Facade+Pierre",
    "source": "Detail Magazine n7-8/2015 - Casa Pachacámac, Longhi Architects",
    "materiaux": [
      "pierre brute locale 150 mm",
      "mortier",
      "béton armé 200 mm",
      "enduit ciment peint 10 mm"
    ],
    "points_cles": [
      "Double paroi massive : 150 mm de maçonnerie de pierre brute locale + 200 mm de béton armé structurel",
      "Petites ouvertures percées dans la masse pour ventilation croisée et éclairage naturel des espaces semi-enterrés",
      "Utilisation de matériaux locaux (bruchstein) en cohérence avec la tradition constructive inca"
    ]
  },
  {
    "id": "detail-2015-pachacamac-03",
    "title": "Jonction menuiserie - vitrage isolant en cadre acajou avec linteau béton poli",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiserie bois massif avec double vitrage et linteau béton",
    "categorie": "jonction_menuiserie",
    "tags": [
      "menuiserie bois",
      "acajou",
      "mahagoni",
      "double vitrage",
      "isolierverglasung",
      "linteau beton poli",
      "gesims",
      "cube verre",
      "salon vitré",
      "cadre bois"
    ],
    "description": "Système de menuiserie en acajou (mahagoni) recevant un double vitrage isolant, formant le cube vitré du séjour émergeant de la colline. Le linteau est réalisé en béton poli de 120 mm faisant office de gesims (corniche). En partie basse, la porte vitrée simple en cadre acajou est intégrée dans un dormant en béton armé de 100 mm d'épaisseur, assurant la transition entre l'intérieur en béton brut et l'extérieur paysager.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Pachacamac+Menuiserie+Acajou",
    "source": "Detail Magazine n7-8/2015 - Casa Pachacámac, Longhi Architects",
    "materiaux": [
      "acajou (mahagoni)",
      "double vitrage isolant",
      "simple vitrage",
      "béton poli 120 mm",
      "béton armé 100 mm"
    ],
    "points_cles": [
      "Linteau-corniche en béton poli de 120 mm assurant la finition supérieure et la protection du vitrage",
      "Cadres en acajou massif recevant un double vitrage isolant pour le volume principal du séjour",
      "Dormant de porte en béton armé de 100 mm intégrant la menuiserie dans la continuité structurelle des murs"
    ]
  },
  {
    "id": "detail-2015-pachacamac-04",
    "title": "Plancher intérieur en béton armé avec tapis de pierre et revêtement laminé",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton avec finitions mixtes pierre et laminé",
    "categorie": "jonction_plancher",
    "tags": [
      "dalle beton",
      "plancher",
      "gravier riviere",
      "flusskies",
      "tapis pierre",
      "bruchstein",
      "laminat",
      "sol stratifie",
      "beton poli",
      "amenagement sol",
      "stone carpet"
    ],
    "description": "Dalle structurelle en béton armé de 200 mm recevant différentes finitions de sol selon les espaces : revêtement stratifié (laminé) dans les zones de vie, et tapis de pierre composés de gravier fin de rivière (Flusskies) et de pierres brutes de granulométries variées (fine et grossière) dans les circulations et espaces de transition. Le béton armé poli de 200 mm est également utilisé comme finition apparente dans certaines zones, créant une continuité avec les murs et le mobilier intégré sculptés dans le béton.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Pachacamac+Plancher+Pierre",
    "source": "Detail Magazine n7-8/2015 - Casa Pachacámac, Longhi Architects",
    "materiaux": [
      "béton armé 200 mm",
      "béton armé poli 200 mm",
      "revêtement stratifié (laminé)",
      "pierre brute fine",
      "pierre brute grossière",
      "gravier de rivière"
    ],
    "points_cles": [
      "Dalle structurelle de 200 mm en béton armé servant de support à des finitions multiples adaptées aux usages",
      "Tapis de pierre naturelle (fine et grossière) incrustés dans le sol créant des motifs et textures variés",
      "Continuité matérielle entre sol, murs et mobilier intégré grâce au béton poli apparent et aux pierres locales"
    ]
  },
  {
    "id": "detail-2001-nasu-01",
    "title": "Façade vitrée suspendue avec protection solaire en paille et plâtre",
    "fabricant": "Detail Magazine",
    "systeme": "Façade rideau vitrée suspendue avec écrans translucides coulissants",
    "categorie": "facade",
    "tags": [
      "facade vitree",
      "verre suspendu",
      "suspended glazing",
      "protection solaire",
      "ecrans coulissants",
      "paille",
      "platre",
      "aluminium",
      "transparence",
      "musee",
      "reflet",
      "japon",
      "kengo kuma",
      "translucide",
      "filtre lumiere"
    ],
    "description": "Façade entièrement vitrée en construction suspendue (vitrage accroché) avec profilés aluminium porteurs. Les panneaux de verre forment une surface lisse sans profilés structurants visibles, créant un miroir reflétant la végétation environnante. Des éléments de protection solaire coulissants en fibres de paille collées avec du plâtre dans des cadres aluminium minces filtrent la lumière et projettent des motifs irréguliers au sol.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nasu+Facade",
    "source": "Detail Magazine n7/2001 - Historisches Museum in Nasu, Kengo Kuma & Associates",
    "materiaux": [
      "verre suspendu",
      "profilés aluminium",
      "fibres de paille",
      "plâtre",
      "cadres aluminium minces"
    ],
    "points_cles": [
      "Vitrage suspendu formant une surface lisse sans profilés apparents pour maximiser la réflexion du paysage",
      "Éléments de protection solaire coulissants en paille et plâtre créant des filtres translucides à motifs irréguliers",
      "Poteaux acier de façade très fins rendus possibles par le noyau central en béton armé parasismique"
    ]
  },
  {
    "id": "detail-2001-nasu-02",
    "title": "Toiture à double pente avec lanterneaux vitrés et écrans solaires",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture saddleback avec zones vitrées et protection solaire intégrée",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "saddleback",
      "toit a deux pentes",
      "lanterneau",
      "eclairage zenithal",
      "oberlichter",
      "skylight",
      "protection solaire",
      "paille",
      "platre",
      "lumiere naturelle",
      "musee",
      "japon"
    ],
    "description": "Toiture simple à deux pentes (Satteldach) interrompue par des champs vitrés permettant un éclairage zénithal de l'espace intérieur. Devant les lanterneaux sont disposés des éléments coulissants de protection solaire identiques à ceux de la façade, composés de fibres de paille et de plâtre dans des cadres aluminium, créant un jeu de lumière et d'ombre subtil dans l'espace d'exposition.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nasu+Toiture",
    "source": "Detail Magazine n7/2001 - Historisches Museum in Nasu, Kengo Kuma & Associates",
    "materiaux": [
      "verre de lanterneau",
      "cadres aluminium",
      "fibres de paille",
      "plâtre",
      "structure de toiture"
    ],
    "points_cles": [
      "Champs vitrés insérés dans la toiture pour un éclairage zénithal complémentaire à la façade vitrée",
      "Écrans solaires coulissants en paille et plâtre positionnés devant les lanterneaux pour filtrer la lumière",
      "Combinaison éclairage latéral par façade et zénithal par toiture pour une lumière naturelle homogène dans le musée"
    ]
  },
  {
    "id": "detail-2001-nasu-03",
    "title": "Structure mixte : noyau béton parasismique et ossature acier périphérique",
    "fabricant": "Detail Magazine",
    "systeme": "Système structurel mixte béton armé et acier pour zone sismique",
    "categorie": "structure",
    "tags": [
      "structure mixte",
      "beton arme",
      "acier",
      "parasismique",
      "sismique",
      "noyau central",
      "poteaux acier",
      "colonnes fines",
      "japon",
      "musee",
      "plan libre",
      "kengo kuma"
    ],
    "description": "Le bâtiment de plain-pied repose sur un système structurel mixte : un noyau central en béton armé abritant les locaux de service (bureaux, stockage, sanitaires) assure la stabilité parasismique du bâtiment. Cette conception permet de réduire les poteaux acier périphériques à des sections très fines, quasi invisibles depuis l'extérieur, libérant ainsi le plan et maximisant la transparence des façades vitrées.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nasu+Structure",
    "source": "Detail Magazine n7/2001 - Historisches Museum in Nasu, Kengo Kuma & Associates",
    "materiaux": [
      "béton armé",
      "acier",
      "verre"
    ],
    "points_cles": [
      "Noyau central en béton armé reprenant les efforts sismiques et libérant la périphérie du bâtiment",
      "Poteaux acier périphériques de section minimale grâce au report des charges sismiques sur le noyau",
      "Plan libre rectangulaire avec espace d'exposition continu le long des quatre façades vitrées"
    ]
  },
  {
    "id": "detail-2001-nasu-04",
    "title": "Panneaux coulissants translucides en paille et plâtre sur cadre aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Écrans mobiles translucides en matériaux naturels",
    "categorie": "amenagement_interieur",
    "tags": [
      "panneau coulissant",
      "paille",
      "platre",
      "gips",
      "stroh",
      "aluminium",
      "protection solaire",
      "filtre lumiere",
      "translucide",
      "motifs ombre",
      "artisanal",
      "materiau naturel",
      "kengo kuma",
      "shoji",
      "ecran mobile"
    ],
    "description": "Éléments de protection solaire coulissants composés de fibres de paille collées avec un enduit de plâtre (Gipsmörtel) et tendus dans des cadres aluminium minces. Ce procédé transforme les panneaux en filtres lumineux translucides dont la structure irrégulière des fibres de paille génère des motifs d'ombre et de lumière changeants au sol, articulant subtilement l'espace d'exposition intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nasu+Ecrans",
    "source": "Detail Magazine n7/2001 - Historisches Museum in Nasu, Kengo Kuma & Associates",
    "materiaux": [
      "fibres de paille",
      "enduit de plâtre",
      "profilés aluminium minces"
    ],
    "points_cles": [
      "Fibres de paille noyées dans un enduit de plâtre créant un composite translucide léger",
      "Cadres aluminium minces permettant le coulissement devant façades et lanterneaux",
      "Structure irrégulière naturelle des fibres générant des motifs d'ombre dynamiques modulant l'ambiance intérieure"
    ]
  },
  {
    "id": "detail-2009-salzburg-01",
    "title": "Revêtement de sol stratifié pour showroom commercial",
    "fabricant": "Detail Magazine",
    "systeme": "Kaindl TWO H30201 - Sol stratifié avec impression logo personnalisée",
    "categorie": "amenagement_interieur",
    "tags": [
      "sol stratifié",
      "showroom",
      "revêtement de sol",
      "Kaindl",
      "impression personnalisée",
      "logo",
      "espace commercial",
      "Salzburg",
      "plancher flottant",
      "aménagement intérieur",
      "espace d'exposition"
    ],
    "description": "Mise en œuvre d'un revêtement de sol stratifié Kaindl TWO référence H30201 dans un showroom commercial à Salzburg (Kwintet Austria). Le sol intègre une impression de logo individuelle directement sur les lames, démontrant les capacités de personnalisation graphique des sols stratifiés pour des espaces de présentation et d'accueil.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Salzburg+Sol+Showroom",
    "source": "Detail Magazine - Kwintet Austria Showroom, Salzburg, Kaindl Flooring GmbH",
    "materiaux": [
      "sol stratifié Kaindl TWO H30201",
      "impression numérique sur stratifié",
      "sous-couche de pose"
    ],
    "points_cles": [
      "Sol stratifié avec personnalisation graphique par impression de logo intégrée dans la couche décorative",
      "Application en espace commercial de type showroom nécessitant une résistance adaptée au trafic intense",
      "Système Kaindl TWO permettant l'intégration d'éléments visuels personnalisés dans le revêtement de sol"
    ]
  },
  {
    "id": "detail-2009-salzburg-02",
    "title": "Jonction sol stratifié personnalisé et parois de showroom",
    "fabricant": "Detail Magazine",
    "systeme": "Jonction périphérique sol stratifié Kaindl en espace d'exposition",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction sol",
      "plinthe",
      "stratifié",
      "showroom",
      "finition périphérique",
      "raccord sol-mur",
      "dilatation",
      "Kaindl",
      "espace commercial"
    ],
    "description": "Détail de jonction périphérique entre le revêtement de sol stratifié Kaindl TWO H30201 et les parois verticales du showroom Kwintet Austria. La mise en œuvre requiert un joint de dilatation périphérique adapté aux contraintes dimensionnelles du stratifié flottant dans un espace commercial de grande surface.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Salzburg+Jonction+Sol",
    "source": "Detail Magazine - Kwintet Austria Showroom, Salzburg, Kaindl Flooring GmbH",
    "materiaux": [
      "sol stratifié Kaindl TWO H30201",
      "profilé de finition périphérique",
      "joint de dilatation"
    ],
    "points_cles": [
      "Joint de dilatation périphérique indispensable pour un sol flottant stratifié en grande surface commerciale",
      "Traitement soigné des raccords sol-mur pour maintenir la qualité visuelle de l'espace d'exposition",
      "Compatibilité des profilés de finition avec le décor personnalisé du revêtement"
    ]
  },
  {
    "id": "detail-2010-nantes-01",
    "title": "Dalle béton massive sur structure acier légère - Plancher intermédiaire",
    "fabricant": "Detail Magazine",
    "systeme": "Dalles béton armé portées sur structure acier avec espaces double hauteur",
    "categorie": "jonction_plancher",
    "tags": [
      "dalle béton",
      "structure acier",
      "plancher mixte",
      "double hauteur",
      "flexibilité",
      "école architecture",
      "Lacaton Vassal",
      "Nantes",
      "plancher intermédiaire",
      "structure hybride"
    ],
    "description": "Système de trois dalles massives en béton armé situées à 9, 16 et 22 mètres de hauteur, constituant les plateaux principaux du bâtiment. Les espaces intermédiaires entre ces dalles sont subdivisés verticalement par une structure légère en acier créant des niveaux supplémentaires, permettant une grande flexibilité programmatique et des espaces à double hauteur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nantes+Plancher",
    "source": "Detail Magazine n9/2010 - Faculté d'Architecture de Nantes, Lacaton & Vassal",
    "materiaux": [
      "béton armé",
      "acier",
      "structure métallique légère"
    ],
    "points_cles": [
      "Trois dalles béton massives portant à grande échelle à 9m, 16m et 22m",
      "Subdivision verticale intermédiaire par structure acier légère indépendante",
      "Espaces double hauteur intégrés pour flexibilité et évolutivité du programme"
    ]
  },
  {
    "id": "detail-2010-nantes-02",
    "title": "Façade transparente polyvalente - Enveloppe légère",
    "fabricant": "Detail Magazine",
    "systeme": "Façade transparente sur structure acier avec espaces indéterminés",
    "categorie": "facade",
    "tags": [
      "façade transparente",
      "polycarbonate",
      "façade légère",
      "double hauteur",
      "école architecture",
      "Lacaton Vassal",
      "Nantes",
      "enveloppe",
      "flexibilité",
      "ventilation naturelle"
    ],
    "description": "Façades transparentes enveloppant les espaces à double hauteur à fonction indéterminée. Ces parois légères assurent la continuité visuelle entre intérieur et extérieur et permettent une appropriation libre des espaces par les usagers. Le système de façade participe à la stratégie bioclimatique du bâtiment en créant des espaces tampons.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nantes+Facade",
    "source": "Detail Magazine n9/2010 - Faculté d'Architecture de Nantes, Lacaton & Vassal",
    "materiaux": [
      "acier",
      "verre",
      "polycarbonate",
      "profilés métalliques"
    ],
    "points_cles": [
      "Façades transparentes sur les espaces double hauteur à usage indéterminé",
      "Légèreté constructive contrastant avec les dalles béton massives",
      "Perméabilité visuelle créant des relations spatiales entre niveaux et extérieur"
    ]
  },
  {
    "id": "detail-2010-nantes-03",
    "title": "Rampe extérieure d'accès - Circulation verticale",
    "fabricant": "Detail Magazine",
    "systeme": "Rampe béton extérieure en pente douce desservant les plateaux principaux",
    "categorie": "structure",
    "tags": [
      "rampe extérieure",
      "circulation verticale",
      "accès",
      "béton armé",
      "Lacaton Vassal",
      "Nantes",
      "école architecture",
      "parcours architectural",
      "accessibilité"
    ],
    "description": "Rampe extérieure à pente douce constituant le principal dispositif de circulation verticale du bâtiment, desservant les trois plateaux béton à 9, 16 et 22 mètres. Cet élément structurel et fonctionnel crée un parcours architectural continu le long de la façade, offrant des vues changeantes sur la ville et l'intérieur du bâtiment.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nantes+Rampe",
    "source": "Detail Magazine n9/2010 - Faculté d'Architecture de Nantes, Lacaton & Vassal",
    "materiaux": [
      "béton armé",
      "acier",
      "garde-corps métallique"
    ],
    "points_cles": [
      "Rampe extérieure à pente douce comme alternative aux circulations verticales classiques",
      "Desserte directe des trois niveaux principaux à 9m, 16m et 22m",
      "Élément structurel autonome créant un parcours architectural et des vues multiples"
    ]
  },
  {
    "id": "detail-2010-nantes-04",
    "title": "Toiture-terrasse accessible - Dernier niveau",
    "fabricant": "Detail Magazine",
    "systeme": "Terrasse accessible sur dalle béton armé à 22 mètres",
    "categorie": "toiture",
    "tags": [
      "toiture terrasse",
      "terrasse accessible",
      "dalle béton",
      "dernier niveau",
      "Lacaton Vassal",
      "Nantes",
      "école architecture",
      "étanchéité",
      "espace extérieur"
    ],
    "description": "Terrasses accessibles au niveau supérieur du bâtiment, aménagées sur la dalle béton armé culminant à 22 mètres. Ces espaces extérieurs en toiture prolongent le programme pédagogique et offrent des vues panoramiques sur Nantes. La dalle béton massive assure la portance nécessaire tout en recevant le complexe d'étanchéité de toiture.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Nantes+Toiture",
    "source": "Detail Magazine n9/2010 - Faculté d'Architecture de Nantes, Lacaton & Vassal",
    "materiaux": [
      "béton armé",
      "membrane d'étanchéité",
      "isolant thermique",
      "revêtement de terrasse"
    ],
    "points_cles": [
      "Terrasses accessibles intégrées au programme en toiture à 22 mètres",
      "Dalle béton massive servant de support structurel et de base d'étanchéité",
      "Espaces extérieurs prolongeant la logique de flexibilité et d'appropriation du bâtiment"
    ]
  },
  {
    "id": "detail-1994-osaka-01",
    "title": "Escalier suspendu en acier habillé bois - Structure principale",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier acier suspendu avec appui intermédiaire et suspension depuis allège",
    "categorie": "structure",
    "tags": [
      "escalier",
      "acier",
      "suspension",
      "flachstahl",
      "plat acier",
      "structure légère",
      "halle centrale",
      "double hauteur",
      "japon",
      "résidentiel",
      "escalier flottant",
      "articulation"
    ],
    "description": "Escalier en structure acier conçu pour paraître léger et flottant dans une halle centrale double hauteur. La structure est appuyée au niveau de la 6ème marche et suspendue au niveau de la 10ème marche depuis l'allège de l'étage supérieur. Les points de suspension sont articulés (rotulés) pour absorber les mouvements de l'escalier.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Escalier+Structure",
    "source": "Detail Magazine n2/1994 - Wohnhaus in Japan, Chitoshi Kihara and Associates",
    "materiaux": [
      "acier plat 9mm",
      "acier plat 6mm",
      "acier plat 9x25mm",
      "acier plat 6x75mm",
      "acier plat 9x75mm",
      "tube acier diamètre 45mm",
      "chêne"
    ],
    "points_cles": [
      "Structure porteuse en plats d'acier (Flachstahl) de différentes sections assemblés par soudure",
      "Double système porteur : appui sous la 6ème marche et suspension depuis allège au niveau de la 10ème marche",
      "Points de suspension articulés (gelenk) pour absorber les déformations et mouvements de la structure"
    ]
  },
  {
    "id": "detail-1994-osaka-02",
    "title": "Escalier suspendu - Habillage bois et marches en chêne",
    "fabricant": "Detail Magazine",
    "systeme": "Habillage chêne sur structure acier avec revêtement de marche rapporté",
    "categorie": "amenagement_interieur",
    "tags": [
      "escalier",
      "habillage bois",
      "chêne",
      "marche",
      "revêtement",
      "coffrages bois",
      "quittenholz",
      "cognassier",
      "japon",
      "résidentiel",
      "finition intérieure"
    ],
    "description": "Habillage en chêne de 25mm sur la structure acier de l'escalier pour s'intégrer à l'atmosphère naturelle de la maison. Les marches reçoivent un revêtement en chêne de 25mm. La structure acier est partiellement recouverte d'un plaquage en chêne de 6mm et en bois de cognassier (Quittenholz). Le poteau tubulaire acier de 45mm est également habillé en chêne.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Habillage+Bois",
    "source": "Detail Magazine n2/1994 - Wohnhaus in Japan, Chitoshi Kihara and Associates",
    "materiaux": [
      "chêne massif 25mm",
      "placage chêne 6mm",
      "bois de cognassier (Quittenholz)",
      "acier"
    ],
    "points_cles": [
      "Revêtement de marche en chêne massif de 25mm rapporté sur structure acier plat",
      "Habillage en placage chêne 6mm et bois de cognassier sur les éléments structurels acier visibles",
      "Poteau tubulaire acier diamètre 45mm habillé en chêne pour continuité de l'aspect naturel"
    ]
  },
  {
    "id": "detail-1994-osaka-03",
    "title": "Escalier suspendu - Garde-corps et main courante",
    "fabricant": "Detail Magazine",
    "systeme": "Garde-corps en tube acier et laiton avec main courante chêne",
    "categorie": "amenagement_interieur",
    "tags": [
      "garde-corps",
      "main courante",
      "chêne",
      "laiton",
      "tube acier",
      "tube laiton",
      "escalier",
      "balustrade",
      "poteaux",
      "japon",
      "résidentiel",
      "détail 1:5"
    ],
    "description": "Garde-corps composé de poteaux en tube acier de 25mm de diamètre supportant une main courante en chêne massif. Un tube en laiton de 21mm de diamètre est utilisé comme élément de remplissage ou fixation. Les détails sont dessinés à l'échelle 1:5, montrant les assemblages entre plats acier, tubes et habillage bois.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Garde-Corps",
    "source": "Detail Magazine n2/1994 - Wohnhaus in Japan, Chitoshi Kihara and Associates",
    "materiaux": [
      "tube laiton diamètre 21mm",
      "tube acier diamètre 25mm",
      "chêne massif",
      "acier plat"
    ],
    "points_cles": [
      "Poteaux de garde-corps en tube acier de 25mm de diamètre pour finesse maximale",
      "Main courante en chêne massif en cohérence avec l'habillage général de l'escalier",
      "Utilisation de tube laiton diamètre 21mm comme élément de détail apportant une finition soignée"
    ]
  },
  {
    "id": "detail-1994-osaka-04",
    "title": "Halle centrale double hauteur avec portes coulissantes et lanterneau faîtier",
    "fabricant": "Detail Magazine",
    "systeme": "Halle traversante avec ventilation naturelle et éclairage zénithal",
    "categorie": "jonction_menuiserie",
    "tags": [
      "halle",
      "double hauteur",
      "porte coulissante",
      "lanterneau",
      "faîtier",
      "ventilation naturelle",
      "lumière zénithale",
      "shoji",
      "japon",
      "résidentiel",
      "tatami",
      "séparation spatiale",
      "bioclimatique"
    ],
    "description": "Halle centrale double hauteur servant d'espace tampon entre les pièces de style occidental à l'est et les pièces japonaises traditionnelles (tatami) à l'ouest. Des portes coulissantes toute hauteur sur les façades nord et sud permettent une ventilation traversante naturelle. Un lanterneau en faîtage apporte un éclairage zénithal continu tout au long de la journée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Osaka+Halle+Centrale",
    "source": "Detail Magazine n2/1994 - Wohnhaus in Japan, Chitoshi Kihara and Associates",
    "materiaux": [
      "bois",
      "verre",
      "acier"
    ],
    "points_cles": [
      "Portes coulissantes toute hauteur sur façades nord et sud permettant ventilation traversante naturelle",
      "Lanterneau faîtier (Firstoberlicht) assurant un apport de lumière naturelle zénithale toute la journée",
      "Espace tampon bioclimatique séparant les zones de vie occidentales et les pièces japonaises traditionnelles"
    ]
  },
  {
    "id": "detail-2002-yamanaka-01",
    "title": "Toiture ventilée sur charpente bois - ossature poteaux-poutres pin japonais",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture légère ventilée avec étanchéité synthétique sur ossature bois",
    "categorie": "toiture",
    "tags": [
      "toiture ventilée",
      "charpente bois",
      "pin japonais",
      "étanchéité synthétique",
      "isolation polystyrène",
      "sparren",
      "lattage",
      "sperrholz",
      "polycarbonat",
      "maison bois",
      "weekend house",
      "Japon",
      "sismique",
      "ventilation sous-toiture",
      "plafond suspendu",
      "laine minérale"
    ],
    "description": "Toiture ventilée composée de chevrons en pin japonais 90x90 mm avec isolation polystyrène 50 mm entre lattage 45x45 mm, panneau de contreplaqué 12 mm et membrane d'étanchéité synthétique 1,5 mm. Le plafond côté intérieur est constitué d'un matelas de laine minérale 75 mm sur lattage 30x30 mm et d'un contreplaqué plaqué tilleul japonais 9 mm, avec un vide ventilé entre la structure de toiture et le plafond suspendu.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Yamanaka+Toiture",
    "source": "Detail Magazine n°5/2002 - Weekend House on Lake Yamanaka, Kazunari Sakamoto",
    "materiaux": [
      "membrane étanchéité synthétique 1.5 mm",
      "contreplaqué 12 mm",
      "lattage bois 45x45 mm",
      "polystyrène 50 mm",
      "chevrons pin japonais 90x90 mm",
      "laine minérale 75 mm",
      "lattage 30x30 mm",
      "contreplaqué plaqué tilleul japonais 9 mm"
    ],
    "points_cles": [
      "Ventilation du comble entre la structure de toiture et le plafond suspendu isolé",
      "Double couche d'isolation : polystyrène 50 mm en toiture et laine minérale 75 mm en plafond",
      "Chevrons pin japonais 90x90 mm dimensionnés pour la résistance sismique avec portée réduite à 3 m grâce au mur-étagère central"
    ]
  },
  {
    "id": "detail-2002-yamanaka-02",
    "title": "Mur extérieur à ossature bois avec bardage cèdre et pare-pluie diffusant",
    "fabricant": "Detail Magazine",
    "systeme": "Paroi à ossature bois avec isolation laine minérale et bardage ventilé en cèdre",
    "categorie": "facade",
    "tags": [
      "ossature bois",
      "bardage cèdre",
      "pare-vent diffusant",
      "isolation laine minérale",
      "laine de verre",
      "montants bois",
      "105x105",
      "contreplaqué lauan",
      "tilleul japonais",
      "finition cire",
      "paroi respirante",
      "Japon",
      "maison week-end",
      "timber frame",
      "cedar cladding"
    ],
    "description": "Paroi extérieure à ossature bois composée de montants en pin japonais 105x105 mm avec isolation en laine minérale 100 mm, pare-vent diffusant ouvert à la vapeur, contreplaqué lauan 5,5 mm et bardage en cèdre japonais 15 mm côté extérieur. Côté intérieur, un lattage 24x45 mm et un contreplaqué plaqué tilleul japonais ciré 5,5 mm assurent la finition. La variante en coupe horizontale mentionne une isolation en laine de verre 100 mm et un frein-vapeur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Yamanaka+Facade",
    "source": "Detail Magazine n°5/2002 - Weekend House on Lake Yamanaka, Kazunari Sakamoto",
    "materiaux": [
      "bardage cèdre japonais 15 mm",
      "contreplaqué lauan 5,5 mm",
      "lattage 24x45 mm",
      "membrane pare-vent diffusante",
      "laine minérale 100 mm",
      "montants pin japonais 105x105 mm",
      "contreplaqué plaqué tilleul japonais ciré 5,5 mm"
    ],
    "points_cles": [
      "Paroi respirante avec pare-vent ouvert à la diffusion de vapeur côté extérieur et frein-vapeur côté intérieur",
      "Montants 105x105 mm surdimensionnés pour la résistance sismique latérale, doublés par des contreventements en tige acier Ø9 mm",
      "Double lattage 24x45 mm de part et d'autre de l'isolation pour passage de réseaux et lame d'air"
    ]
  },
  {
    "id": "detail-2002-yamanaka-03",
    "title": "Plancher sur solivage bois avec isolation et finition contreplaqué bouleau ciré",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher bois isolé avec double contreplaqué et finition cirée",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bois",
      "solivage",
      "contreplaqué bouleau",
      "contreplaqué lauan",
      "finition cirée",
      "isolation polystyrène",
      "frein-vapeur",
      "solives",
      "plancher sur vide sanitaire",
      "plancher intermédiaire",
      "tilleul japonais",
      "Japon"
    ],
    "description": "Deux types de planchers sont détaillés. Le plancher intermédiaire (niveau 1) est composé de solives 75x150 mm avec contreplaqué plaqué bouleau ciré 15 mm et contreplaqué lauan 5,5 mm en face supérieure, et contreplaqué plaqué tilleul japonais 9 mm en sous-face. Le plancher sur sol (niveau 0) comprend des solives 90x90 mm avec isolation polystyrène 50 mm entre lattage 45x45 mm, un frein-vapeur, et la même finition en contreplaqué bouleau ciré 15 mm sur contreplaqué lauan 5,5 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Yamanaka+Plancher",
    "source": "Detail Magazine n°5/2002 - Weekend House on Lake Yamanaka, Kazunari Sakamoto",
    "materiaux": [
      "contreplaqué plaqué bouleau ciré 15 mm",
      "contreplaqué lauan 5,5 mm",
      "solives 75x150 mm",
      "solives 90x90 mm",
      "polystyrène 50 mm",
      "lattage 45x45 mm",
      "frein-vapeur",
      "contreplaqué plaqué tilleul japonais 9 mm"
    ],
    "points_cles": [
      "Finition intérieure en contreplaqué bouleau ciré 15 mm rappelant les surfaces lisses et chaleureuses de l'habitat japonais traditionnel",
      "Plancher sur sol isolé en polystyrène 50 mm avec frein-vapeur pour contrôle de l'humidité du sol",
      "Plancher intermédiaire non isolé mais avec sous-face en contreplaqué tilleul pour unité visuelle des plafonds"
    ]
  },
  {
    "id": "detail-2002-yamanaka-04",
    "title": "Mur-étagère structurel de contreventement avec remplissages polycarbonat et verre",
    "fabricant": "Detail Magazine",
    "systeme": "Système de contreventement intérieur par mur ouvert en ossature bois avec remplissages translucides",
    "categorie": "structure",
    "tags": [
      "contreventement",
      "mur étagère",
      "parasismique",
      "polycarbonat",
      "double paroi alvéolaire",
      "verre armé",
      "verre flotté",
      "tige acier",
      "contreventement diagonal",
      "pin japonais",
      "ossature bois",
      "structure intérieure",
      "cloison structurelle",
      "translucide",
      "Japon",
      "séisme",
      "kantholz",
      "105x105",
      "38x235"
    ],
    "description": "Système structurel central de type mur-étagère ouvert, composé de montants et traverses en pin japonais 105x105 mm et de lames horizontales en bois massif 38x235 mm. Les remplissages alternent entre panneaux de polycarbonat alvéolaire 10 mm, verre flotté 10 mm et verre armé 6,8 mm, créant une paroi translucide. Des tiges d'acier Ø9 mm en diagonale assurent le contreventement parasismique. Ce mur divise la portée de 6 m en deux et sépare visuellement le séjour des zones secondaires.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Yamanaka+Structure",
    "source": "Detail Magazine n°5/2002 - Weekend House on Lake Yamanaka, Kazunari Sakamoto",
    "materiaux": [
      "montants pin japonais 105x105 mm",
      "lames bois pin japonais 38x235 mm",
      "polycarbonat alvéolaire 10 mm",
      "verre flotté 10 mm",
      "verre armé 6.8 mm",
      "tige acier Ø9 mm",
      "cadre aluminium 20x40 mm"
    ],
    "points_cles": [
      "Double fonction structurelle et spatiale : contreventement parasismique et séparation visuelle translucide entre séjour et zones annexes",
      "Contreventement par tirants diagonaux en acier Ø9 mm intégrés dans l'épaisseur du mur-étagère",
      "Remplissages mixtes polycarbonat alvéolaire, verre flotté et verre armé dans cadres aluminium 20x40 mm évoquant les shoji traditionnels japonais"
    ]
  },
  {
    "id": "detail-1993-japan-01",
    "title": "Détail de façade vitrée avec stores motorisés et lamelles aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Façade vitrée coulissante avec protection solaire intégrée",
    "categorie": "facade",
    "tags": [
      "facade",
      "vitrage",
      "isolierverglasung",
      "store motorisé",
      "lamelles aluminium",
      "porte coulissante",
      "moustiquaire",
      "protection solaire",
      "aluminium",
      "acier",
      "japon",
      "foster",
      "résidentiel"
    ],
    "description": "Façade vitrée composée de vitrages isolants fixes en imposte et de portes coulissantes en aluminium avec double vitrage (8+12+8 mm). Le système intègre des stores à enroulement motorisés pour la protection visuelle et contre l'éblouissement, ainsi que des éléments coulissants en cadre aluminium avec grille en acier inoxydable servant de moustiquaire, amovibles en hiver. Des lamelles en aluminium extrudé, fixes et orientables, complètent le dispositif de contrôle de la lumière naturelle.",
    "thumbnail": "/images/thumb-foster.jpg",
    "source": "Detail Magazine n03/1993 - Wohnhaus in Japan, Norman Foster & Partners",
    "materiaux": [
      "vitrage isolant 8+12+8 mm",
      "vitrage isolant 5+12+5 mm",
      "cadre aluminium",
      "store à enroulement motorisé",
      "grille acier inoxydable",
      "lamelles aluminium extrudé"
    ],
    "points_cles": [
      "Porte coulissante aluminium avec vitrage isolant triple couche 8+12+8 mm",
      "Moustiquaire intégrée en cadre aluminium avec grille inox, amovible en hiver",
      "Stores à enroulement motorisés pour protection visuelle et contre l'éblouissement"
    ]
  },
  {
    "id": "detail-1993-japan-02",
    "title": "Toiture-cinquième façade avec lanterneaux, stores extérieurs et lamelles",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate avec lanterneaux vitrés et protection solaire motorisée",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "cinquième façade",
      "lanterneau",
      "verre armé",
      "drahtglas",
      "lamelles aluminium",
      "store motorisé",
      "panneau aluminium",
      "isolation",
      "foster",
      "japon",
      "résidentiel",
      "éclairage zénithal"
    ],
    "description": "Toiture conçue comme cinquième façade, composée de panneaux en tôle aluminium 3 mm sur couche d'isolation expansée, de lanterneaux en verre armé 12 mm avec stores à enroulement motorisés extérieurs, et de vitrages isolants (6+6+6,8 mm) avec lamelles aluminium fixes en sous-face. Des lamelles orientables en aluminium extrudé permettent un contrôle précis de la lumière zénithale pour exploiter les taux élevés d'ensoleillement hivernal.",
    "thumbnail": "/images/thumb-foster.jpg",
    "source": "Detail Magazine n03/1993 - Wohnhaus in Japan, Norman Foster & Partners",
    "materiaux": [
      "tôle aluminium 3 mm",
      "isolation expansée",
      "verre armé 12 mm",
      "vitrage isolant 6+6+6,8 mm",
      "lamelles aluminium fixes",
      "lamelles aluminium orientables",
      "store à enroulement motorisé"
    ],
    "points_cles": [
      "Toiture traitée comme cinquième façade avec trois composants distincts : panneaux alu, verre armé et vitrage isolant",
      "Stores à enroulement extérieurs motorisés sur les lanterneaux pour occultation optimale",
      "Double système de lamelles aluminium, fixes et orientables, pour contrôle fin de la lumière naturelle"
    ]
  },
  {
    "id": "detail-1993-japan-03",
    "title": "Structure acier avec plancher surélevé sur deck bois",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature acier avec plancher technique surélevé en bois",
    "categorie": "structure",
    "tags": [
      "structure",
      "acier",
      "poteau tubulaire",
      "profilé IPE",
      "plancher surélevé",
      "deck bois",
      "platelage",
      "réseaux techniques",
      "japon",
      "foster",
      "résidentiel",
      "flexibilité"
    ],
    "description": "Structure portante en acier composée de poteaux tubulaires circulaires de 267,4 mm de diamètre et de profilés en I (396/199/7/11 et 200/200/8/12) avec cornières d'assemblage. Le plancher surélevé d'environ 1 m de hauteur est constitué d'un platelage bois de 25x145 mm, créant un vide technique sous le niveau habitable pour le passage de toutes les canalisations et réseaux. Cette disposition permet une flexibilité totale de l'espace intérieur grâce aux cloisons coulissantes.",
    "thumbnail": "/images/thumb-foster.jpg",
    "source": "Detail Magazine n03/1993 - Wohnhaus in Japan, Norman Foster & Partners",
    "materiaux": [
      "poteau acier tubulaire Ø 267,4 mm",
      "profilé I 396/199/7/11",
      "profilé I 200/200/8/12",
      "cornière 150/100/15 mm",
      "profilé U 250/90/9/13",
      "platelage bois 25x145 mm"
    ],
    "points_cles": [
      "Poteaux tubulaires acier Ø 267,4 mm assurant une transparence structurelle maximale",
      "Plancher surélevé de 1 m créant un plénum technique complet pour tous les réseaux",
      "Platelage bois 25x145 mm sur structure acier, référence au deck traditionnel japonais"
    ]
  },
  {
    "id": "detail-1993-japan-04",
    "title": "Cellules de service en ossature acier avec habillage aluminium sous débord de toiture",
    "fabricant": "Detail Magazine",
    "systeme": "Modules utilitaires à ossature acier et bardage aluminium",
    "categorie": "jonction_plancher",
    "tags": [
      "cellule",
      "module",
      "ossature acier",
      "bardage aluminium",
      "panneau alu",
      "cuisine",
      "salle de bain",
      "local technique",
      "débord toiture",
      "porte-à-faux",
      "japon",
      "foster",
      "résidentiel",
      "zonage"
    ],
    "description": "Les locaux de service (cuisine, salle de bain, rangements, local technique) sont regroupés en cellules modulaires alignées le long des murs extérieurs, sous le débord en porte-à-faux de la toiture. Chaque cellule possède une ossature en cadre acier habillée de panneaux aluminium 3 mm sur isolation expansée, formant une enveloppe opaque distincte de la façade vitrée du volume principal. Cette disposition sépare clairement les espaces servants des espaces servis, dans la tradition spatiale japonaise.",
    "thumbnail": "/images/thumb-foster.jpg",
    "source": "Detail Magazine n03/1993 - Wohnhaus in Japan, Norman Foster & Partners",
    "materiaux": [
      "ossature acier",
      "panneau aluminium 3 mm",
      "isolation expansée",
      "tôle aluminium"
    ],
    "points_cles": [
      "Locaux de service regroupés en cellules modulaires indépendantes du volume principal",
      "Ossature acier avec habillage en panneaux aluminium sur isolation expansée",
      "Positionnement sous le débord de toiture en porte-à-faux, en périphérie du noyau habitable"
    ]
  },
  {
    "id": "detail-2014-fukuoka-01",
    "title": "Toiture zinc sur charpente bois avec isolation",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture ventilée en zinc sur structure bois avec parement intérieur en meranti",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "zinc",
      "charpente bois",
      "isolation thermique",
      "sperrholz",
      "meranti",
      "sparren",
      "couverture métallique",
      "étanchéité",
      "Japon",
      "résidentiel"
    ],
    "description": "Couverture en tôle de zinc de 0,35 mm sur membrane d'étanchéité, posée sur un support en contreplaqué 18 mm. L'isolation thermique de 50 mm est insérée entre les chevrons de 120x180 mm, avec un contreplaqué de 9 mm côté intérieur et un parement en contreplaqué de meranti de 5 mm en finition visible. Structure compacte adaptée au climat subtropical de Fukuoka.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Toiture",
    "source": "Detail Magazine n10/2014 - Wohnhaus in Fukuoka, Movedesign (Mikio Sakamoto)",
    "materiaux": [
      "tôle de zinc 0,35 mm",
      "membrane d'étanchéité",
      "contreplaqué 18 mm",
      "isolation thermique 50 mm",
      "contreplaqué 9 mm",
      "contreplaqué meranti 5 mm",
      "chevrons 120x180 mm"
    ],
    "points_cles": [
      "Couverture zinc très fine (0,35 mm) sur membrane d'étanchéité continue",
      "Double couche de contreplaqué assurant support et contreventement",
      "Parement intérieur en meranti visible depuis l'espace habitable"
    ]
  },
  {
    "id": "detail-2014-fukuoka-02",
    "title": "Façade ossature bois avec enduit sur fibre-ciment",
    "fabricant": "Detail Magazine",
    "systeme": "Mur à ossature bois avec pare-pluie ventilé, parement enduit sur fibre-ciment et doublage intérieur en meranti",
    "categorie": "facade",
    "tags": [
      "facade",
      "ossature bois",
      "enduit",
      "fibre-ciment",
      "isolation 120mm",
      "pare-pluie",
      "lame d'air ventilée",
      "lattage",
      "contrelattage",
      "meranti",
      "diffusion vapeur",
      "résidentiel",
      "Japon"
    ],
    "description": "Paroi à ossature bois avec isolation de 120 mm intégrée entre les montants structurels. Le parement extérieur est constitué d'un enduit de 15 mm sur panneau de fibre-ciment de 12,5 mm, ventilé par un double lattage de 20x35 mm et protégé par un écran pare-pluie diffusant à la vapeur. Le doublage intérieur comprend un lattage, un contreplaqué de 9 mm et une finition en contreplaqué de meranti de 5 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Facade",
    "source": "Detail Magazine n10/2014 - Wohnhaus in Fukuoka, Movedesign (Mikio Sakamoto)",
    "materiaux": [
      "enduit 15 mm",
      "panneau fibre-ciment 12,5 mm",
      "lattage/contrelattage 20x35 mm",
      "écran pare-pluie diffusant",
      "bois de construction massif",
      "isolation thermique 120 mm",
      "contreplaqué 9 mm",
      "contreplaqué meranti 5 mm"
    ],
    "points_cles": [
      "Lame d'air ventilée par double lattage entre pare-pluie et parement extérieur",
      "Membrane pare-pluie ouverte à la diffusion de vapeur pour éviter la condensation",
      "Symétrie du montage intérieur avec lattage et contreplaqué pour gestion hygrothermique"
    ]
  },
  {
    "id": "detail-2014-fukuoka-03",
    "title": "Escalier acier et bois de cerisier sur mur béton",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier à limon en acier plat avec marches en cerisier et main courante tubulaire",
    "categorie": "amenagement_interieur",
    "tags": [
      "escalier",
      "acier",
      "cerisier",
      "main courante",
      "limon acier",
      "marches bois",
      "tube acier",
      "flachstahl",
      "kirsche",
      "résidentiel",
      "Japon",
      "espace vertical",
      "béton armé"
    ],
    "description": "Escalier ouvert reliant les trois niveaux de la maison, composé de limons en acier plat de 6 mm et de marches en bois de cerisier de 30 mm d'épaisseur. La main courante est un tube en acier de diamètre 25 mm. L'ensemble est ancré sur un mur en béton armé de 200 mm, créant un espace de circulation vertical continu flanqué d'une bibliothèque murale.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Escalier",
    "source": "Detail Magazine n10/2014 - Wohnhaus in Fukuoka, Movedesign (Mikio Sakamoto)",
    "materiaux": [
      "acier plat 6 mm",
      "bois de cerisier 30 mm",
      "tube acier Ø 25 mm",
      "béton armé 200 mm"
    ],
    "points_cles": [
      "Limons en acier plat de 6 mm pour une apparence légère et minimale",
      "Marches en cerisier massif de 30 mm en continuité avec le parquet",
      "Escalier ouvert servant d'espace de vie vertical sur trois niveaux"
    ]
  },
  {
    "id": "detail-2014-fukuoka-04",
    "title": "Jonction soubassement béton et plancher bois sur socle enterré",
    "fabricant": "Detail Magazine",
    "systeme": "Soubassement en béton armé avec parquet cerisier et transition vers structure bois en superstructure",
    "categorie": "soubassement",
    "tags": [
      "soubassement",
      "béton armé",
      "socle",
      "parquet cerisier",
      "meranti",
      "niveau enterré",
      "plancher",
      "patio",
      "lichthof",
      "éclairage indirect",
      "résidentiel",
      "Japon"
    ],
    "description": "Le niveau de socle semi-enterré est réalisé en murs de béton armé de 200 mm, recevant un parquet en cerisier de 15 mm en finition de sol. Les murs en béton assurent la transition structurelle entre la fondation et la superstructure en ossature bois. Des patios (Lichthöfe) généreusement dimensionnés apportent un éclairage naturel indirect à ce niveau, avec des habillages intérieurs en contreplaqué de meranti de 24 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Fukuoka+Soubassement",
    "source": "Detail Magazine n10/2014 - Wohnhaus in Fukuoka, Movedesign (Mikio Sakamoto)",
    "materiaux": [
      "béton armé 200 mm",
      "parquet cerisier 15 mm",
      "contreplaqué meranti 24 mm"
    ],
    "points_cles": [
      "Socle en béton armé semi-enterré rendant la lecture des niveaux impossible depuis l'extérieur",
      "Patios en creux apportant lumière indirecte douce au niveau inférieur",
      "Habillage intérieur en meranti 24 mm unifiant l'atmosphère avec les étages supérieurs en bois"
    ]
  },
  {
    "id": "detail-1995-tokyo-01",
    "title": "Toiture sur structure acier avec lamelles aluminium perforées",
    "fabricant": "Detail Magazine",
    "systeme": "Couverture étanchée sur charpente acier profilés I avec faux-plafond aluminium perforé",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "acier",
      "profilé I",
      "étanchéité synthétique",
      "isolation thermique",
      "tôle acier",
      "faux-plafond",
      "aluminium perforé",
      "éclairage intégré",
      "police",
      "Tokyo",
      "Nikken Sekkei"
    ],
    "description": "Complexe de toiture composé d'un cadre structurel en profilés I 150/150 mm recouvert d'une tôle acier, d'une isolation thermique et d'une membrane d'étanchéité synthétique. Le plafond intérieur est constitué de panneaux d'aluminium perforés intégrant un éclairage par downlights et des luminaires rouges en toiture. Un système de fixation à pivot (18° de débattement) permet la suspension de lamelles aluminium perforées mobiles.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Toiture",
    "source": "Detail Magazine n1/1995 - Polizeistation in Tokio, Nikken Sekkei",
    "materiaux": [
      "profilés I acier 150/150 mm",
      "tôle acier",
      "isolation thermique",
      "membrane étanchéité synthétique",
      "panneaux aluminium perforés",
      "luminaires"
    ],
    "points_cles": [
      "Structure porteuse en profilés I 150/150 mm formant le cadre de toiture",
      "Complexe toiture multicouche : tôle acier + isolation + membrane plastique d'étanchéité",
      "Faux-plafond en panneaux aluminium perforés intégrant éclairage downlights et luminaires rouges"
    ]
  },
  {
    "id": "detail-1995-tokyo-02",
    "title": "Façade à lamelles aluminium perforées mobiles sur vitrage fixe",
    "fabricant": "Detail Magazine",
    "systeme": "Brise-soleil en lamelles aluminium perforées pivotantes devant vitrage feuilleté fixe",
    "categorie": "facade",
    "tags": [
      "façade",
      "brise-soleil",
      "lamelles",
      "aluminium perforé",
      "pivotant",
      "vitrage feuilleté",
      "VSG",
      "contrôle lumineux",
      "protection solaire",
      "lochkarten",
      "informatique",
      "Tokyo",
      "Nikken Sekkei"
    ],
    "description": "Façade composée d'un vitrage fixe en verre feuilleté de sécurité (VSG 2x8 mm) doublé de lamelles aluminium perforées mobiles pivotant sur 18°. Le motif de perforation des lamelles varie selon les zones fonctionnelles du bâtiment (bureau, sanitaires, salle de repos) afin de moduler progressivement l'apport lumineux naturel, créant un gradient de luminosité décroissant du bureau vers la salle de repos.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Facade+Lamelles",
    "source": "Detail Magazine n1/1995 - Polizeistation in Tokio, Nikken Sekkei",
    "materiaux": [
      "lamelles aluminium perforées",
      "verre feuilleté de sécurité VSG 2x8 mm",
      "fixation pivot acier",
      "profilés acier"
    ],
    "points_cles": [
      "Lamelles aluminium perforées pivotantes avec débattement de 18° via fixation articulée",
      "Vitrage fixe en verre feuilleté de sécurité VSG 2x8 mm en arrière-plan",
      "Perforation variable des lamelles selon la fonction des espaces pour gradation lumineuse progressive"
    ]
  },
  {
    "id": "detail-1995-tokyo-03",
    "title": "Brüstung en verre empilé avec isolation intégrée - garde-corps côté douves",
    "fabricant": "Detail Magazine",
    "systeme": "Allège en plaques de verre empilées à arêtes chanfreinées avec double vitrage isolant intercalé",
    "categorie": "soubassement",
    "tags": [
      "brüstung",
      "allège",
      "verre empilé",
      "verre feuilleté",
      "chanfrein",
      "double vitrage",
      "isolation",
      "barrière humidité",
      "néoprène",
      "canal inox",
      "réflexion eau",
      "douves",
      "Tokyo",
      "Nikken Sekkei"
    ],
    "description": "Allège côté douves constituée de plaques de verre plat empilées avec arêtes chanfreinées, entre lesquelles est intercalé un double vitrage isolant scellé assurant la protection thermique et l'étanchéité à l'humidité. Chaque empilement repose sur des appuis ponctuels en néoprène absorbant les vibrations. Un caniveau en acier inoxydable collecte les eaux en pied de brüstung. Ce dispositif permet aux reflets de l'eau des douves de pénétrer dans l'intérieur de manière diffractée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Brustung+Verre",
    "source": "Detail Magazine n1/1995 - Polizeistation in Tokio, Nikken Sekkei",
    "materiaux": [
      "plaques de verre plat empilées à arêtes chanfreinées",
      "double vitrage isolant scellé",
      "appuis ponctuels néoprène",
      "caniveau acier inoxydable",
      "carreaux céramique"
    ],
    "points_cles": [
      "Empilement de plaques de verre à arêtes chanfreinées créant un effet de diffraction lumineuse des reflets de l'eau",
      "Double vitrage isolant intercalé entre les empilements pour protection thermique et barrière à l'humidité",
      "Appuis ponctuels en néoprène et caniveau inox en pied pour drainage et amortissement"
    ]
  },
  {
    "id": "detail-1995-tokyo-04",
    "title": "Jonction façade basse - ventilation par lamelles de verre et grille anti-insectes",
    "fabricant": "Detail Magazine",
    "systeme": "Ventilation naturelle par lamelles de verre orientables avec grille anti-insectes et baguette aluminium de finition",
    "categorie": "jonction_menuiserie",
    "tags": [
      "ventilation",
      "lamelles verre",
      "jalousie",
      "grille insectes",
      "aluminium",
      "baguette couvre-joint",
      "panzerglas",
      "verre blindé",
      "sécurité",
      "sortie secours",
      "poteaux acier",
      "Tokyo",
      "Nikken Sekkei"
    ],
    "description": "Jonction en partie basse de façade intégrant des lamelles de verre orientables pour la ventilation naturelle, protégées par une grille anti-insectes et finies par une baguette de recouvrement en aluminium. Le vitrage blindé (Panzerglas) assure la sécurité requise pour un poste de police, tandis que des poteaux acier forment la structure porteuse verticale. Une sortie de secours et des unités de ventilation mécanique complètent le dispositif en partie basse.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Jonction+Ventilation",
    "source": "Detail Magazine n1/1995 - Polizeistation in Tokio, Nikken Sekkei",
    "materiaux": [
      "lamelles de verre orientables",
      "grille anti-insectes",
      "baguette aluminium couvre-joint",
      "verre blindé Panzerglas",
      "poteaux acier",
      "unités ventilation mécanique"
    ],
    "points_cles": [
      "Lamelles de verre orientables assurant la ventilation naturelle en partie basse de façade",
      "Grille anti-insectes et baguette aluminium de finition pour protection et esthétique",
      "Vitrage blindé (Panzerglas) et poteaux acier répondant aux exigences de sécurité d'un poste de police"
    ]
  },
  {
    "id": "detail-2006-tosu-01",
    "title": "Toiture modulaire en profilés aluminium extrudés",
    "fabricant": "Detail Magazine",
    "systeme": "Ecoms House - Système modulaire aluminium",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "aluminium",
      "profilés extrudés",
      "modulaire",
      "étanchéité synthétique",
      "polystyrène",
      "isolation",
      "panneaux préfabriqués",
      "trame 1200",
      "construction légère",
      "Japon"
    ],
    "description": "Complexe de toiture composé d'éléments de plafond préfabriqués en profilés aluminium extrudés (20/200 mm sur 150/200 mm) de dimension 1200x3600 mm, isolés par 50 mm de polystyrène et étanchéifiés par une membrane synthétique. Un panneau de fibres de bois de 15 mm et un contreplaqué de 10 mm complètent le support, avec un cornière aluminium 50/50/3 mm assurant la fixation et un système de drainage périphérique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tosu+Toiture",
    "source": "Detail Magazine n7-8/2006 - Musterhaus in Tosu-City, Riken Yamamoto & Field Shop",
    "materiaux": [
      "profilés aluminium extrudés 20/200 mm",
      "profilés aluminium extrudés 150/200 mm",
      "polystyrène 50 mm",
      "membrane étanchéité synthétique",
      "panneau fibres de bois 15 mm",
      "contreplaqué 10 mm",
      "cornière aluminium 50/50/3 mm"
    ],
    "points_cles": [
      "Éléments de plafond préfabriqués de 1200x3600 mm en aluminium extrudé permettant un montage rapide sur trame modulaire",
      "Isolation thermique par polystyrène 50 mm avec étanchéité par membrane synthétique en surface",
      "Cornière aluminium L 50/50/3 mm servant d'interface entre isolation et structure porteuse, avec système de drainage intégré en rive"
    ]
  },
  {
    "id": "detail-2006-tosu-02",
    "title": "Plancher modulaire aluminium sur dalle béton armé",
    "fabricant": "Detail Magazine",
    "systeme": "Ecoms House - Système modulaire aluminium",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "aluminium",
      "profilés extrudés",
      "modulaire",
      "béton armé",
      "plancher surélevé",
      "dalles moquette",
      "isolation",
      "mousse rigide",
      "trame 1200",
      "construction légère",
      "Japon"
    ],
    "description": "Plancher composé d'une dalle béton armé de 250 mm avec isolation en mousse rigide de 50 mm sur couche de propreté et gravier compacté, surmonté d'un plancher surélevé recevant un contreplaqué de 12 mm, un feutre de 6 mm et des dalles moquette de 9 mm. L'étage courant utilise des éléments de plancher préfabriqués en profilés aluminium extrudés (20/200 mm sur 150/200 mm) de dimension 1200x3600 mm avec la même finition en surface.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tosu+Plancher",
    "source": "Detail Magazine n7-8/2006 - Musterhaus in Tosu-City, Riken Yamamoto & Field Shop",
    "materiaux": [
      "béton armé 250 mm",
      "mousse rigide isolante 50 mm",
      "couche de propreté 50 mm",
      "gravier compacté 60 mm",
      "plancher surélevé",
      "contreplaqué 12 mm",
      "feutre 6 mm",
      "dalles moquette 9 mm",
      "profilés aluminium extrudés 20/200 mm",
      "profilés aluminium extrudés 150/200 mm"
    ],
    "points_cles": [
      "Double système de plancher : dalle béton armé 250 mm au RDC et éléments préfabriqués aluminium 1200x3600 mm à l'étage, assurant flexibilité des hauteurs",
      "Plancher surélevé permettant le passage de réseaux et l'adaptation modulaire aux configurations spatiales variables",
      "Isolation du plancher bas par mousse rigide 50 mm sur couche de propreté et gravier compacté, avec couche de séparation"
    ]
  },
  {
    "id": "detail-2006-tosu-03",
    "title": "Façade modulaire : panneaux aluminium brossé et vitrage isolant",
    "fabricant": "Detail Magazine",
    "systeme": "Ecoms House - Système modulaire aluminium",
    "categorie": "facade",
    "tags": [
      "facade",
      "aluminium brossé",
      "vitrage isolant",
      "modulaire",
      "panneau isolé",
      "profilés extrudés",
      "trame 1200",
      "grille aluminium",
      "panneaux ouvrants",
      "construction légère",
      "Japon"
    ],
    "description": "Enveloppe de façade modulaire calée sur la trame de 1200 mm, composée de panneaux aluminium brossé isolés de 20 mm, de vitrages isolants (float 3 + lame d'air 6 + float 3 mm) et d'éléments de grille en profilés extrudés de 5 mm à maille de 205 mm. Les éléments de façade incluent des panneaux ouvrants, des fenêtres et des portes, tous dimensionnés sur le module de base et fixés aux cadres structurels en aluminium de 1200x1200 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tosu+Facade",
    "source": "Detail Magazine n7-8/2006 - Musterhaus in Tosu-City, Riken Yamamoto & Field Shop",
    "materiaux": [
      "panneau aluminium brossé isolé 20 mm",
      "vitrage isolant float 3 + SZR 6 + float 3 mm",
      "grille profilés aluminium extrudés 5 mm",
      "cadre aluminium 8/120/1200 mm",
      "boulons M12"
    ],
    "points_cles": [
      "Trois types d'éléments de façade interchangeables sur trame 1200 mm : panneaux opaques isolés, vitrages isolants et grilles ventilées en profilés extrudés",
      "Panneaux aluminium brossé de 20 mm avec isolation intégrée offrant une identité esthétique propre au matériau aluminium",
      "Éléments ouvrants (portes, fenêtres, panneaux) intégrés au système modulaire permettant une reconfiguration flexible de l'enveloppe"
    ]
  },
  {
    "id": "detail-2006-tosu-04",
    "title": "Nœud de jonction structurelle : croix de connexion aluminium",
    "fabricant": "Detail Magazine",
    "systeme": "Ecoms House - Système modulaire aluminium",
    "categorie": "structure",
    "tags": [
      "structure",
      "aluminium",
      "jonction",
      "croix de connexion",
      "modulaire",
      "assemblage boulonné",
      "profilés extrudés",
      "noeud structurel",
      "préfabrication",
      "trame 1200",
      "pont thermique",
      "amélioration thermique",
      "Japon"
    ],
    "description": "Nœud structurel central du système modulaire constitué d'une croix de connexion en aluminium de 10 mm reliant les cadres de 1200x1200 mm (profilés aluminium 8/120 mm) par boulonnage M12. Les profilés cruciformes des cadres s'emboîtent par des extrémités en forme de rail assurant un assemblage par friction. Une version thermiquement améliorée du nœud a été développée pour réduire les ponts thermiques aux jonctions entre modules.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tosu+Noeud+Structure",
    "source": "Detail Magazine n7-8/2006 - Musterhaus in Tosu-City, Riken Yamamoto & Field Shop",
    "materiaux": [
      "croix de connexion aluminium 10 mm",
      "profilé aluminium cadre 8/120 mm",
      "boulons M12",
      "profilés extrudés aluminium 5 mm"
    ],
    "points_cles": [
      "Croix de connexion aluminium 10 mm permettant l'assemblage sur site des modules préfabriqués 1200x1200 mm par simple boulonnage M12",
      "Profilés cruciformes avec extrémités en rail assurant un emboîtement par friction et une liaison mécanique entre cadres adjacents",
      "Développement d'une version thermiquement améliorée du nœud de jonction, validée par thermographie, pour rompre les ponts thermiques aux interfaces entre modules"
    ]
  },
  {
    "id": "detail-2008-kakamigahara-01",
    "title": "Toiture mince en béton armé à formes concaves et convexes",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé courbe 200mm avec étanchéité polyuréthane",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "beton arme",
      "dalle mince",
      "200mm",
      "polyurethane",
      "etancheite",
      "forme organique",
      "courbe",
      "concave",
      "convexe",
      "crematorium",
      "toyo ito",
      "coffrage prefabrique",
      "mortier isolant"
    ],
    "description": "Toiture en dalle béton armé de seulement 200 mm d'épaisseur, composée de formes concaves et convexes optimisées par calcul numérique. Le complexe d'étanchéité comprend un enduit d'étanchéité polyuréthane de 3 mm, une couche de nivellement en mortier de 10 mm, la dalle béton armé de 200 mm, un mortier isolant de 20 mm et un revêtement de 3 mm en sous-face. La forme a été obtenue par des centaines de cycles de calcul itératifs entre architecte et ingénieur structure.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kakamigahara+Toiture",
    "source": "Detail Magazine n7-8/2008 - Krematorium Kakamigahara, Toyo Ito & Associates",
    "materiaux": [
      "beton arme",
      "polyurethane",
      "mortier",
      "mortier isolant"
    ],
    "points_cles": [
      "Dalle béton armé de seulement 200 mm d'épaisseur pour une toiture de grande portée à géométrie complexe",
      "Étanchéité par enduit polyuréthane de 3 mm avec couche de nivellement en mortier",
      "Forme optimisée numériquement pour minimiser les efforts internes et assurer le drainage vers les têtes de poteaux",
      "Coffrages courbes préfabriqués en atelier à partir des données numériques"
    ]
  },
  {
    "id": "detail-2008-kakamigahara-02",
    "title": "Jonction toiture-poteau conique avec drainage intégré",
    "fabricant": "Detail Magazine",
    "systeme": "Poteau conique béton armé avec tube acier de drainage intégré",
    "categorie": "structure",
    "tags": [
      "poteau",
      "conique",
      "drainage integre",
      "tube acier",
      "beton arme",
      "toiture",
      "jonction",
      "entwasserung",
      "descente eau pluviale",
      "tete de poteau",
      "crematorium",
      "toyo ito"
    ],
    "description": "Jonction entre la toiture mince en béton armé et les douze poteaux coniques qui la supportent. Le drainage de la toiture est intégré directement dans les têtes de poteaux via un tube acier de diamètre 216 mm, éliminant ainsi les descentes d'eau pluviale extérieures. Le système exploite la pente naturelle de la toiture courbe vers les points bas situés aux têtes de poteaux.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kakamigahara+Poteau+Drainage",
    "source": "Detail Magazine n7-8/2008 - Krematorium Kakamigahara, Toyo Ito & Associates",
    "materiaux": [
      "beton arme",
      "tube acier Ø216mm",
      "acier inoxydable"
    ],
    "points_cles": [
      "Drainage intégré dans les poteaux via tube acier Ø 216 mm supprimant les descentes extérieures visibles",
      "Douze poteaux coniques assurant la transition organique entre toiture et sol",
      "Rigole de condensation en acier inoxydable au pied du vitrage",
      "Forme conique des poteaux préfabriquée en atelier à partir des coordonnées numériques"
    ]
  },
  {
    "id": "detail-2008-kakamigahara-03",
    "title": "Jonction vitrage-toiture béton avec profilés acier plat",
    "fabricant": "Detail Magazine",
    "systeme": "Vitrage trempé 19mm fixé par profilés acier plat sur dalle béton courbe",
    "categorie": "jonction_menuiserie",
    "tags": [
      "vitrage",
      "verre trempe",
      "ESG",
      "19mm",
      "acier plat",
      "fixation",
      "facade vitree",
      "jonction",
      "toiture",
      "beton",
      "acier inoxydable",
      "condensation",
      "crematorium",
      "toyo ito",
      "tole inox"
    ],
    "description": "Détail de jonction entre la toiture courbe en béton armé et le vitrage périphérique en verre trempé ESG de 19 mm d'épaisseur. La fixation est assurée par des profilés en acier plat de 165x12 mm et 165x9 mm. Un habillage en tôle d'acier inoxydable de 5 mm assure la finition au nez de dalle, tandis qu'une rigole en acier inoxydable récupère la condensation en partie basse du vitrage.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kakamigahara+Vitrage",
    "source": "Detail Magazine n7-8/2008 - Krematorium Kakamigahara, Toyo Ito & Associates",
    "materiaux": [
      "verre trempe ESG 19mm",
      "acier plat 165x12mm",
      "acier plat 165x9mm",
      "tole acier inoxydable 5mm",
      "acier inoxydable"
    ],
    "points_cles": [
      "Vitrage en verre trempé ESG de 19 mm d'épaisseur pour grande hauteur libre",
      "Fixation par profilés acier plat de 165x12 mm et 165x9 mm assurant un détail minimal et élégant",
      "Habillage du nez de dalle en tôle inox de 5 mm pour une finition nette à la jonction toiture-vitrage",
      "Rigole de récupération de condensation en acier inoxydable intégrée en pied de vitrage"
    ]
  },
  {
    "id": "detail-2008-kakamigahara-04",
    "title": "Plancher sur terre-plein avec revêtement marbre et isolation thermique",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé 200mm sur béton de propreté avec isolation et revêtement marbre",
    "categorie": "soubassement",
    "tags": [
      "plancher",
      "dalle",
      "terre-plein",
      "beton arme",
      "marbre",
      "isolation thermique",
      "beton de proprete",
      "soubassement",
      "mortier",
      "crematorium",
      "toyo ito",
      "revetement sol"
    ],
    "description": "Complexe de plancher sur terre-plein composé d'une couche de béton de propreté de 80 mm, d'une dalle en béton armé de 200 mm, d'une double couche d'isolation thermique (100 mm + 20 mm), d'un lit de mortier de 10 mm et d'un revêtement en marbre de 20 mm. Ce système assure à la fois l'isolation thermique du sol et une finition noble en marbre cohérente avec l'habillage des volumes intérieurs cubiques.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Kakamigahara+Plancher",
    "source": "Detail Magazine n7-8/2008 - Krematorium Kakamigahara, Toyo Ito & Associates",
    "materiaux": [
      "marbre 20mm",
      "mortier",
      "isolation thermique 120mm",
      "beton arme 200mm",
      "beton de proprete 80mm"
    ],
    "points_cles": [
      "Revêtement en marbre de 20 mm posé sur lit de mortier de 10 mm pour une finition noble",
      "Double couche d'isolation thermique totalisant 120 mm (100 mm + 20 mm) pour performance thermique",
      "Dalle béton armé de 200 mm sur couche de béton de propreté de 80 mm",
      "Cohérence avec le revêtement marbre des volumes cubiques intérieurs abritant les salles cérémonielles"
    ]
  },
  {
    "id": "detail-1960s-mondsee-01",
    "title": "Toiture en pente - Détail de faîtage et ventilation en Leca-Béton",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture ventilée en béton Leca coulé avec isolation Telwolle et couverture tuiles",
    "categorie": "toiture",
    "tags": [
      "faîtage",
      "toiture ventilée",
      "béton Leca",
      "Telwolle",
      "isolation thermique",
      "chevrons bois",
      "lattage",
      "tuiles",
      "ventilation toiture",
      "Schüttbau",
      "papier bitumé",
      "voligeage",
      "détail faîtière"
    ],
    "description": "Détail de faîtage et de couverture pour l'atelier Roppolt au bord du Mondsee. La construction en béton Leca coulé (Schüttbau) avec surfaces brutes de décoffrage assure l'isolation thermique sans matériau complémentaire. La toiture ventilée comprend des chevrons 12/24 cm, une isolation en laine Telwolle de 5 cm, un voligeage, un papier bitumé non sablé, un lattage en lattes de tuile 2,5/5 cm espacées d'environ 90 cm, des éléments Eternit 40/20 gris foncé et un couronnement de faîtière en tôle avec ventilation haute (évacuation) et basse (admission d'air).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Mondsee+Toiture",
    "source": "Detail Magazine - Atelierhaus Roppolt, Wangauer Ache/Mondsee, Architectes Karl Mang et Eva Mang-Krimmel, Vienne",
    "materiaux": [
      "béton Leca (Leca-Beton)",
      "laine Telwolle 5 cm",
      "chevrons bois 12/24 cm",
      "voligeage bois (Schalung)",
      "papier bitumé non sablé",
      "lattes tuiles 2,5/5 cm",
      "panneaux Eternit 40/20 gris foncé",
      "Heraklith 1,5 cm",
      "tôle de faîtière",
      "fer d'ancrage"
    ],
    "points_cles": [
      "Ventilation de toiture assurée par entrée d'air basse (Zuluft) et sortie d'air haute (Abluft) au faîtage",
      "Construction monomatériau en béton Leca coulé offrant isolation thermique intégrée avec surfaces brutes apparentes",
      "Isolation complémentaire en laine Telwolle de 5 cm entre chevrons avec sous-face en voligeage apparent et Heraklith 1,5 cm en complément"
    ]
  },
  {
    "id": "detail-1960s-muenchen-solln-02",
    "title": "Jonction balcon - Mur de façade avec coupure thermique sur consoles porteuses",
    "fabricant": "Detail Magazine",
    "systeme": "Façade en panneaux préfabriqués béton lavé avec isolation intercalaire et balcons sur consoles avec coupure thermique",
    "categorie": "jonction_plancher",
    "tags": [
      "balcon",
      "pont thermique",
      "console porteuse",
      "coupure thermique",
      "béton préfabriqué",
      "dalle balcon",
      "façade béton lavé",
      "Thiokol",
      "joint étanche",
      "isolation intercalaire",
      "semi-préfabrication",
      "Allbeton",
      "laine de verre",
      "laine de roche",
      "München"
    ],
    "description": "Détail de jonction entre la dalle de balcon et le plancher des tours d'habitation Max et Moritz à Munich-Solln. Les dalles de balcon sont posées sur des consoles porteuses et des parois latérales porteuses avec interposition d'une couche isolante pour éviter les ponts thermiques et les transmissions de contraintes. Les dalles de balcon sont des éléments préfabriqués en béton apparent lisse, les joints étant étanchés au Thiokol.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Muenchen+Balcon",
    "source": "Detail Magazine - Wohnhochhäuser Max und Moritz, München-Solln, Architectes v. Gagern, Ludwig v. d. Mühlen, München",
    "materiaux": [
      "béton coulé en semi-préfabrication (système Allbeton)",
      "panneaux de façade préfabriqués en béton lavé (Waschbeton)",
      "panneaux isolants laine de verre ou laine de roche",
      "mastic d'étanchéité Thiokol",
      "consoles porteuses béton",
      "dalle balcon béton apparent préfabriqué",
      "coffrage acier à surface lisse"
    ],
    "points_cles": [
      "Coupure thermique systématique entre dalle de balcon et dalle de plancher par interposition d'un isolant, supprimant le pont thermique",
      "Dalles de balcon préfabriquées en béton apparent lisse posées sur consoles porteuses et parois latérales porteuses indépendantes de la structure principale",
      "Joints entre éléments préfabriqués étanchés au Thiokol assurant l'imperméabilité et la souplesse de la jonction"
    ]
  },
  {
    "id": "detail-1960s-muenchen-solln-03",
    "title": "Façade en panneaux préfabriqués béton lavé avec isolation intercalaire - Coupe horizontale et verticale",
    "fabricant": "Detail Magazine",
    "systeme": "Mur extérieur en béton coulé doublé de panneaux de façade préfabriqués béton lavé hauteur d'étage avec isolation thermique intercalaire",
    "categorie": "facade",
    "tags": [
      "façade préfabriquée",
      "béton lavé",
      "Waschbeton",
      "panneau hauteur d'étage",
      "isolation intercalaire",
      "laine minérale",
      "Thiokol",
      "joint de façade",
      "coffrage spécial",
      "Allbeton",
      "semi-préfabrication",
      "enduit projeté",
      "mur rideau béton",
      "München",
      "immeuble tour"
    ],
    "description": "Système de façade des tours Max et Moritz composé de voiles porteurs en béton coulé en semi-préfabrication (système Allbeton avec coffrage à squelette acier et planches, surface lisse) doublés côté extérieur de panneaux de façade préfabriqués en béton lavé de la hauteur d'un étage. L'isolation thermique est assurée par des panneaux de laine de verre ou de roche intercalés entre le voile porteur et le panneau de parement. À l'intérieur, les surfaces lisses du coffrage permettent un simple enduit projeté spécial sans plâtre traditionnel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Muenchen+Facade",
    "source": "Detail Magazine - Wohnhochhäuser Max und Moritz, München-Solln, Architectes v. Gagern, Ludwig v. d. Mühlen, München",
    "materiaux": [
      "béton coulé semi-préfabriqué (système Allbeton)",
      "panneaux préfabriqués béton lavé (Waschbeton) hauteur d'étage",
      "panneaux isolants laine de verre ou laine de roche",
      "mastic Thiokol pour joints",
      "coffrage squelette acier avec planches",
      "enduit projeté intérieur (Spezialspritztechnik)"
    ],
    "points_cles": [
      "Panneaux de façade préfabriqués en béton lavé de la hauteur d'un étage venant doubler les voiles porteurs en béton coulé",
      "Isolation thermique intercalaire en panneaux de laine minérale entre voile porteur et panneau de parement, supprimant les ponts thermiques courants",
      "Intégration complète des réseaux électriques (tubes vides PVC, prises, interrupteurs) et des gaines de ventilation en tôle galvanisée directement dans les coffrages avant coulage du béton"
    ]
  },
  {
    "id": "detail-1960s-muenchen-solln-04",
    "title": "Toiture-terrasse avec étanchéité aluminium et acrotère en élément préfabriqué béton avec jardinière",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture-terrasse avec étanchéité multicouche aluminium Villodrit et acrotère préfabriqué béton avec paroi végétalisée",
    "categorie": "toiture",
    "tags": [
      "toiture-terrasse",
      "étanchéité aluminium",
      "Villodrit",
      "acrotère béton préfabriqué",
      "gravier",
      "protection lourde",
      "lestage",
      "bitume chaud",
      "bitume froid",
      "aluminium soudé",
      "jardinière béton",
      "Pflanzwand",
      "élément préfabriqué",
      "garde-corps",
      "München"
    ],
    "description": "Détail de toiture-terrasse et d'acrotère des tours Max et Moritz à Munich-Solln. L'étanchéité est un complexe multicouche composé d'une couche inférieure Alu-Villodrit soudée pleine surface sur la dalle d'acrotère, d'une feuille d'aluminium soudée, d'une couche supérieure Alu-Villodrit pleine surface, le tout protégé par un gravier 3/7 mm en bitume chaud et un gravier 7/15 mm en bitume froid. L'acrotère est un élément préfabriqué en béton formant garde-corps et jardinière (Pflanzwand).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Muenchen+Toiture-Terrasse",
    "source": "Detail Magazine - Wohnhochhäuser Max und Moritz, München-Solln, Architectes v. Gagern, Ludwig v. d. Mühlen, München",
    "materiaux": [
      "dalle béton armé",
      "étanchéité Alu-Villodrit multicouche",
      "feuille aluminium soudée",
      "aluminium avec Alcofol",
      "gravier 3/7 mm en bitume chaud (Heißriesel)",
      "gravier 7/15 mm en bitume froid (Kaltriesel)",
      "élément préfabriqué béton d'acrotère-jardinière (Pflanzwand)"
    ],
    "points_cles": [
      "Système d'étanchéité multicouche à base d'aluminium Villodrit soudé pleine surface garantissant une imperméabilité durable en toiture-terrasse",
      "Protection lourde en double couche de gravier (3/7 et 7/15 mm) appliqué en bitume chaud puis froid assurant le lestage et la protection mécanique de l'étanchéité",
      "Acrotère en élément préfabriqué béton intégrant la fonction de garde-corps et de jardinière (Pflanzwand) avec relevé d'étanchéité complet sur la dalle d'acrotère"
    ]
  },
  {
    "id": "detail-2006-tokyo-01",
    "title": "Façade translucide en polyester renforcé fibres de verre avec isolation translucide",
    "fabricant": "Detail Magazine",
    "systeme": "Enveloppe translucide légère sur ossature acier",
    "categorie": "facade",
    "tags": [
      "polyester",
      "fibre de verre",
      "translucide",
      "isolation translucide",
      "ossature acier",
      "tube acier",
      "façade légère",
      "lumière naturelle",
      "polycarbonate",
      "enveloppe translucide",
      "maison étroite",
      "tokyo"
    ],
    "description": "Paroi de façade composée d'un panneau de polyester renforcé de fibres de verre de 3 mm revêtu, fixé sur une ossature de tubes acier 25x25 mm avec une isolation thermique translucide de 30 mm intercalée. La face intérieure est constituée d'un tissu polyéthylène ignifugé de 1 mm tendu sur des plats acier revêtus de 100x36 mm, permettant une diffusion homogène de la lumière naturelle dans l'ensemble de l'habitation.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Facade+Translucide",
    "source": "Detail Magazine n7-8/2006 - Lucky Drop House Tokyo, Atelier Tekuto / Yasuhiro Yamashita",
    "materiaux": [
      "polyester renforcé fibres de verre 3 mm",
      "tube acier 25x25 mm",
      "isolation thermique translucide 30 mm",
      "plat acier revêtu 100x36 mm",
      "tissu polyéthylène ignifugé 1 mm"
    ],
    "points_cles": [
      "Isolation translucide de 30 mm assurant à la fois performance thermique et transmission lumineuse",
      "Double peau avec polyester extérieur et tissu PE intérieur pour diffusion de la lumière",
      "Ossature légère en tubes acier 25x25 mm minimisant les ponts thermiques et l'encombrement"
    ]
  },
  {
    "id": "detail-2006-tokyo-02",
    "title": "Plancher intermédiaire en streckmetall (métal déployé) sur structure acier",
    "fabricant": "Detail Magazine",
    "systeme": "Mezzanine transparente en métal déployé sur profilés acier",
    "categorie": "jonction_plancher",
    "tags": [
      "métal déployé",
      "streckmetall",
      "mezzanine",
      "plancher transparent",
      "expanded metal",
      "plat acier",
      "transparence",
      "plancher acier",
      "dalle intermédiaire",
      "légèreté"
    ],
    "description": "Plancher de mezzanine constitué de métal déployé (streckmetall) de 24 mm d'épaisseur posé sur des plats acier de 19x60 mm. Ce dispositif constructif permet la continuité visuelle et lumineuse entre les niveaux, évitant que la dalle intermédiaire ne constitue un élément de séparation dans cet espace habitable très étroit.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Plancher+Metal+Deploye",
    "source": "Detail Magazine n7-8/2006 - Lucky Drop House Tokyo, Atelier Tekuto / Yasuhiro Yamashita",
    "materiaux": [
      "métal déployé 24 mm",
      "plat acier 19x60 mm"
    ],
    "points_cles": [
      "Métal déployé de 24 mm assurant transparence visuelle et passage de la lumière entre niveaux",
      "Fixation sur plats acier 19x60 mm pour une structure minimale",
      "Solution constructive adaptée aux espaces très étroits nécessitant continuité spatiale"
    ]
  },
  {
    "id": "detail-2006-tokyo-03",
    "title": "Soubassement enterré avec plancher chauffant sur structure acier et isolation polystyrène",
    "fabricant": "Detail Magazine",
    "systeme": "Radier acier isolé avec chape chauffante sur fondation drainée",
    "categorie": "soubassement",
    "tags": [
      "soubassement",
      "plancher chauffant électrique",
      "radier acier",
      "polystyrène",
      "isolation sol",
      "profilé IPE",
      "plaque acier",
      "chape ciment",
      "carrelage céramique",
      "drainage",
      "gravier",
      "sable",
      "enterré",
      "fondation"
    ],
    "description": "Plancher bas enterré composé d'une couche drainante de gravier 60 mm et sable 30 mm, d'une isolation polystyrène 25 mm, d'une plaque acier 12 mm avec membrane d'étanchéité, puis de profilés acier IPE 200 avec isolation polystyrène 200 mm intercalée, surmonté d'une chape ciment de 70 mm intégrant un chauffage électrique par le sol et d'un carrelage céramique de 5 mm en finition. La structure porteuse en profilés IPE 200 assure à la fois le rôle structurel et celui de support d'isolation.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Soubassement",
    "source": "Detail Magazine n7-8/2006 - Lucky Drop House Tokyo, Atelier Tekuto / Yasuhiro Yamashita",
    "materiaux": [
      "carrelage céramique 5 mm",
      "chape ciment 70 mm avec chauffage électrique",
      "profilé acier IPE 200",
      "isolation polystyrène 200 mm",
      "plaque acier 12 mm",
      "membrane d'étanchéité",
      "isolation polystyrène 25 mm",
      "sable 30 mm",
      "gravier 60 mm"
    ],
    "points_cles": [
      "Double couche d'isolation polystyrène (200 mm entre profilés + 25 mm sous plaque acier) pour un sol enterré performant",
      "Chauffage électrique intégré dans la chape ciment de 70 mm",
      "Couche drainante gravier/sable sous la plaque acier avec membrane d'étanchéité pour protéger contre l'humidité du sol"
    ]
  },
  {
    "id": "detail-2006-tokyo-04",
    "title": "Jonction structure-fondation avec profilé acier IPE et plaque d'assise",
    "fabricant": "Detail Magazine",
    "systeme": "Assemblage acier boulonné avec cornières et plaque de liaison",
    "categorie": "structure",
    "tags": [
      "assemblage acier",
      "cornière",
      "plaque acier",
      "profilé IPE",
      "jonction",
      "fixation",
      "membrane minérale",
      "étanchéité",
      "structure acier",
      "pied de poteau",
      "connexion",
      "bois"
    ],
    "description": "Jonction structurelle entre les profilés acier IPE 200 porteurs et la plaque d'assise en acier de 12,5 mm, réalisée par deux cornières acier de 60x60 mm boulonnées. Une membrane d'étanchéité minérale est interposée sur la plaque acier, et des éléments en bois de 24 mm sont intercalés entre les plats acier pour assurer la continuité de l'isolation et la désolidarisation thermique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Jonction+Structure",
    "source": "Detail Magazine n7-8/2006 - Lucky Drop House Tokyo, Atelier Tekuto / Yasuhiro Yamashita",
    "materiaux": [
      "profilé acier IPE 200",
      "cornière acier 60x60 mm",
      "plaque acier 12,5 mm",
      "membrane d'étanchéité minérale",
      "plat acier",
      "bois 24 mm"
    ],
    "points_cles": [
      "Assemblage par double cornière acier 60x60 mm boulonnée sur profilé IPE 200",
      "Membrane d'étanchéité minérale interposée entre plaque acier et structure pour protection contre les remontées d'humidité",
      "Intercalaires bois de 24 mm entre plats acier pour rupture de pont thermique"
    ]
  },
  {
    "id": "detail-2012-geldrop-01",
    "title": "Façade sud en acier-verre toute hauteur",
    "fabricant": "Detail Magazine",
    "systeme": "Façade rideau acier-verre Metaglas",
    "categorie": "facade",
    "tags": [
      "facade",
      "acier",
      "verre",
      "vitrage",
      "toute hauteur",
      "facade rideau",
      "transparence",
      "sud",
      "villa",
      "pays-bas",
      "metaglas",
      "profil acier"
    ],
    "description": "Façade sud entièrement vitrée en structure acier-verre réalisée par Metaglas B.V. La façade rideau s'étend sur toute la longueur du bâtiment côté sud ainsi que sur les pignons, créant une transparence totale entre l'espace de vie intérieur et le paysage verdoyant environnant. La réduction aux matériaux essentiels — béton, acier, verre — confère au détail une grande pureté de lignes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Geldrop+Facade+Verre",
    "source": "Detail Magazine n5/2012 - Villa in Geldrop, Hofman Dujardin Architects",
    "materiaux": [
      "acier",
      "verre",
      "profilés acier"
    ],
    "points_cles": [
      "Façade rideau acier-verre sur toute la longueur sud et les pignons",
      "Détaillage soigné assurant la continuité matérielle entre façade et toiture",
      "Transparence maximale orientée sud pour apport solaire tout au long de la journée"
    ]
  },
  {
    "id": "detail-2012-geldrop-02",
    "title": "Toiture à deux pans en briques — continuité façade-toiture",
    "fabricant": "Detail Magazine",
    "systeme": "Revêtement unifié façade-toiture en briques Wienerberger",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "brique",
      "wienerberger",
      "pente",
      "deux pans",
      "satteldach",
      "materialite homogene",
      "facade toiture",
      "villa",
      "pays-bas",
      "archetype"
    ],
    "description": "Toiture à deux pans dont le revêtement en briques Wienerberger est identique à celui de la façade nord, assurant une matérialité homogène et unitaire de l'enveloppe du bâtiment. Cette uniformité de traitement entre façade et toiture simplifie la volumétrie archétypale de la maison à toit en selle et renforce la présence sobre du bâtiment dans le paysage plat. Le volume intérieur s'ouvre jusqu'au faîtage grâce à une galerie en double hauteur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Geldrop+Toiture+Brique",
    "source": "Detail Magazine n5/2012 - Villa in Geldrop, Hofman Dujardin Architects",
    "materiaux": [
      "brique Wienerberger",
      "structure porteuse",
      "isolation"
    ],
    "points_cles": [
      "Matérialité uniforme brique en façade et en toiture pour une lecture monolithique",
      "Volume intérieur ouvert jusqu'au faîtage via une galerie en mezzanine",
      "Archétype simplifié de la maison à deux pans réinterprété avec des détails épurés"
    ]
  },
  {
    "id": "detail-2012-geldrop-03",
    "title": "Sous-sol enterré avec tranchée en béton armé et patios lumineux",
    "fabricant": "Detail Magazine",
    "systeme": "Infrastructure béton armé enterrée avec patios et rampe",
    "categorie": "soubassement",
    "tags": [
      "sous-sol",
      "enterre",
      "beton arme",
      "patio",
      "tranchee",
      "lumiere naturelle",
      "rampe",
      "escalier exterieur",
      "villa",
      "pays-bas",
      "soubassement"
    ],
    "description": "Le sous-sol est entièrement enterré et desservi par une tranchée longitudinale en béton armé traversant l'axe principal du bâtiment. Cette tranchée fait office à la fois de voie d'accès principale (escalier monumental côté nord) et de capteur de lumière naturelle pour les pièces du niveau inférieur — chambres et salles de bains. Deux patios intégrés au plan permettent un éclairage zénithal et latéral, assurant un ensoleillement quasi continu des espaces enterrés.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Geldrop+Soussol+Beton",
    "source": "Detail Magazine n5/2012 - Villa in Geldrop, Hofman Dujardin Architects",
    "materiaux": [
      "béton armé",
      "verre",
      "acier"
    ],
    "points_cles": [
      "Tranchée en béton armé traversant le bâtiment servant d'accès et de puits de lumière",
      "Deux patios intégrés au plan inspirés des typologies Renaissance italienne",
      "Positionnement stratégique du bâtiment sur la parcelle pour maximiser l'ensoleillement du sous-sol"
    ]
  },
  {
    "id": "detail-2012-geldrop-04",
    "title": "Jonction plancher RDC — façade vitrée sud et sous-sol béton",
    "fabricant": "Detail Magazine",
    "systeme": "Jonction dalle béton / façade rideau acier-verre / infrastructure enterrée",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction",
      "plancher",
      "dalle beton",
      "facade verre",
      "sous-sol",
      "rez-de-chaussee",
      "plain-pied",
      "transition",
      "acier",
      "verre",
      "villa",
      "pays-bas"
    ],
    "description": "Jonction technique entre la dalle du rez-de-chaussée posée de plain-pied sur le terrain naturel, la façade rideau acier-verre côté sud et la structure béton armé du sous-sol enterré. Ce nœud constructif concentre les enjeux d'étanchéité, d'isolation thermique et de continuité structurelle entre l'infrastructure lourde en béton et l'enveloppe légère vitrée. La réduction à trois matériaux essentiels — béton, acier, verre — exige une détaillage exemplaire à cette interface critique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Geldrop+Jonction+Plancher",
    "source": "Detail Magazine n5/2012 - Villa in Geldrop, Hofman Dujardin Architects",
    "materiaux": [
      "béton armé",
      "acier",
      "verre",
      "isolant"
    ],
    "points_cles": [
      "Interface critique entre infrastructure béton enterrée et façade légère acier-verre",
      "Bâtiment posé de plain-pied sur le terrain avec sous-sol complètement enterré",
      "Détaillage épuré nécessitant une coordination étanchéité-isolation-structure exemplaire"
    ]
  },
  {
    "id": "detail-2016-hamburg-001",
    "title": "Intégration de luminaires LED en plafonnier pour éclairage général de bureaux",
    "fabricant": "Detail Magazine",
    "systeme": "Éclairage LED intégré en faux-plafond - Bâtiment administratif",
    "categorie": "amenagement_interieur",
    "tags": [
      "LED",
      "éclairage",
      "bureau",
      "faux-plafond",
      "luminaire",
      "efficacité énergétique",
      "éclairage général",
      "plafonnier",
      "administration",
      "140 lm/W",
      "200 lm/W"
    ],
    "description": "Système d'éclairage LED intégré pour grands bâtiments administratifs, remplaçant les technologies conventionnelles (fluorescent T5, halogène). Les luminaires LED atteignent des efficacités de 140 à 200 lm/W, soit le double d'un tube fluorescent T5 et 20 fois celle d'une lampe à incandescence, avec une durée de vie pouvant atteindre 25 ans sans remplacement.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Hamburg+LED+Plafond",
    "source": "Detail Magazine n5/2016 - LED Technology, Uwe Slabke / Unilever HQ Hamburg, Behnisch Architekten",
    "materiaux": [
      "semi-conducteur inorganique LED",
      "lentilles de distribution lumineuse",
      "dissipateur thermique",
      "faux-plafond"
    ],
    "points_cles": [
      "Efficacité lumineuse de 140 à 200 lm/W contre 10 lm/W pour l'incandescence",
      "Durée de vie jusqu'à 25 ans éliminant les coûts de remplacement",
      "Source semi-directionnelle (demi-espace) rendant les réflecteurs coûteux superflus"
    ]
  },
  {
    "id": "detail-2016-hamburg-002",
    "title": "Luminaire LED sur pied flexible pour éclairage de poste de travail",
    "fabricant": "Detail Magazine",
    "systeme": "Luminaire LED autonome flexible - Éclairage direct/indirect de bureau",
    "categorie": "amenagement_interieur",
    "tags": [
      "LED",
      "luminaire sur pied",
      "éclairage de bureau",
      "poste de travail",
      "flexible",
      "direct-indirect",
      "Nimbus",
      "Unilever",
      "Behnisch",
      "dimmable"
    ],
    "description": "Lampadaire LED flexible conçu pour combiner éclairage de poste de travail et éclairage général dans le siège Unilever à Hambourg (Behnisch Architekten, 2009). Premier projet de grande envergure intégrant des luminaires LED, ces lampadaires autonomes permettent un positionnement libre et une adaptation individuelle de l'éclairage.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Hamburg+LED+Stehleuchte",
    "source": "Detail Magazine n5/2016 - Unilever Hauptzentrale Hamburg 2009, Behnisch Architekten",
    "materiaux": [
      "LED semi-conducteur inorganique",
      "structure aluminium",
      "diffuseur optique",
      "socle lesté"
    ],
    "points_cles": [
      "Première application LED à grande échelle dans un projet d'architecture majeur (2009)",
      "Double fonction : éclairage direct du poste de travail et contribution à l'éclairage ambiant",
      "Flexibilité de positionnement sans intervention sur le faux-plafond existant"
    ]
  },
  {
    "id": "detail-2016-hamburg-003",
    "title": "Luminaires LED spéciaux pour hall d'accueil et foyer",
    "fabricant": "Detail Magazine",
    "systeme": "Luminaires LED sur mesure - Éclairage scénographique de foyer",
    "categorie": "amenagement_interieur",
    "tags": [
      "LED",
      "luminaire spécial",
      "foyer",
      "hall",
      "éclairage scénographique",
      "sur mesure",
      "Unilever",
      "Behnisch",
      "accueil",
      "effet lumineux",
      "température de couleur"
    ],
    "description": "Luminaires LED spécialement conçus pour le foyer du siège Unilever à Hambourg, exploitant les possibilités de la technologie LED en matière de compacité et de contrôle de la distribution lumineuse. La technologie permet des températures de couleur de 2700 K à 4000 K (blanc chaud à blanc neutre) et un rendu des couleurs adapté aux ambiances architecturales.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Hamburg+LED+Foyer",
    "source": "Detail Magazine n5/2016 - Unilever Hauptzentrale Hamburg 2009, Behnisch Architekten",
    "materiaux": [
      "LED semi-conducteur inorganique",
      "optiques et lentilles de distribution",
      "boîtier sur mesure",
      "câblage intégré"
    ],
    "points_cles": [
      "Conception sur mesure exploitant la compacité des sources LED",
      "Choix de température de couleur entre 2700 K (blanc chaud) et 4000 K (blanc neutre)",
      "Suppression des réflecteurs coûteux grâce à l'émission directionnelle naturelle des LED"
    ]
  },
  {
    "id": "detail-2016-hamburg-004",
    "title": "Stratégie de retrofit LED pour luminaires à douilles conventionnelles",
    "fabricant": "Detail Magazine",
    "systeme": "Lampes LED retrofit sur socles E27/E14/GU10/GU5.3/G9",
    "categorie": "amenagement_interieur",
    "tags": [
      "LED",
      "retrofit",
      "E27",
      "E14",
      "GU10",
      "GU5.3",
      "G9",
      "rénovation",
      "substitution",
      "halogène",
      "incandescence",
      "dimmable",
      "patrimoine",
      "historique"
    ],
    "description": "Solution transitoire de lampes LED retrofit équipées de culots conventionnels (E27, E14, GU10, GU5.3, G9) permettant la substitution directe de lampes à incandescence, halogènes ou fluocompactes dans des luminaires existants. Des versions dimmables sont disponibles, mais les caractéristiques lumineuses diffèrent de l'original, nécessitant une réévaluation de l'ambiance lumineuse, notamment dans le contexte patrimonial.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+LED+Retrofit",
    "source": "Detail Magazine n5/2016 - LED Technology From Indicator Lamp to Intelligent Lighting, Uwe Slabke",
    "materiaux": [
      "LED semi-conducteur",
      "culot E27/E14/GU10/GU5.3/G9",
      "dissipateur thermique intégré",
      "diffuseur plastique ou verre"
    ],
    "points_cles": [
      "Compatibilité avec les douilles existantes pour rénovation sans changement de luminaire",
      "Flux lumineux de 1000 lm d'un halogène GU5.3 MR16 difficilement atteignable en retrofit LED",
      "Nécessité de réévaluer l'ambiance lumineuse dans le contexte historique lors de la substitution"
    ]
  },
  {
    "id": "detail-2010-wien-01",
    "title": "Facade opaque en panneaux sandwich aluminium avec relief",
    "fabricant": "Detail Magazine",
    "systeme": "Facade ventilee en panneaux sandwich aluminium plies et laqués blanc",
    "categorie": "facade",
    "tags": [
      "aluminium",
      "sandwich",
      "panneau",
      "plie",
      "cante",
      "relief",
      "facade opaque",
      "blanc",
      "laque",
      "horizontalite",
      "fachhochschule",
      "wien",
      "delugan meissl",
      "bardage metallique",
      "facade ventilee"
    ],
    "description": "Les surfaces opaques de la facade sont constituees de panneaux sandwich en aluminium cantes et revetus en blanc. Le relief genere par les pliages confere de la plasticite au batiment et cree un jeu de tension entre horizontalite calme et vivacite, accentue par les effets de lumiere et d'ombre au fil de la journee.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Wien+Facade+Alu",
    "source": "Detail Magazine n9/2010 - Fachhochschule Wien, Delugan Meissl",
    "materiaux": [
      "panneaux sandwich aluminium",
      "revetement blanc laque",
      "sous-structure metallique"
    ],
    "points_cles": [
      "Panneaux sandwich aluminium cantes formant un relief en facade",
      "Revetement blanc avec jeu de nuances et degres de brillance",
      "Horizontalite marquee par la composition des bandes opaques et des fenetres en bandeau"
    ]
  },
  {
    "id": "detail-2010-wien-02",
    "title": "Bandeau vitré horizontal encastre avec sauts de hauteur rythmiques",
    "fabricant": "Detail Magazine",
    "systeme": "Fenetres en bandeau horizontal profondement encastrees dans la facade",
    "categorie": "jonction_menuiserie",
    "tags": [
      "fenetre bandeau",
      "horizontal",
      "encastre",
      "profond",
      "rythme",
      "sauts de hauteur",
      "menuiserie",
      "vitrage",
      "facade",
      "embrasure",
      "wien",
      "delugan meissl"
    ],
    "description": "Les bandeaux vitres horizontaux sont profondement encastres dans la facade opaque, avec des sauts de hauteur distribues de maniere rythmique. Cette mise en retrait cree des embrasures profondes qui accentuent le jeu d'ombres et renforcent l'expression plastique de la facade tout en assurant une protection solaire passive.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Wien+Bandeau+Vitre",
    "source": "Detail Magazine n9/2010 - Fachhochschule Wien, Delugan Meissl",
    "materiaux": [
      "vitrage",
      "cadre menuiserie",
      "panneaux sandwich aluminium",
      "isolant"
    ],
    "points_cles": [
      "Fenetres en bandeau horizontal profondement encastrees dans l'epaisseur de facade",
      "Distribution rythmique des sauts de hauteur entre les bandeaux",
      "Effet de profondeur et d'ombre renforce par l'encastrement des vitrages"
    ]
  },
  {
    "id": "detail-2010-wien-03",
    "title": "Soubassement en socle a deux niveaux avec terrasse en gradins",
    "fabricant": "Detail Magazine",
    "systeme": "Structure de socle beton a deux niveaux avec terrasses exterieures etagees",
    "categorie": "soubassement",
    "tags": [
      "socle",
      "deux niveaux",
      "terrasse",
      "gradins",
      "escalier exterieur",
      "paysage",
      "pente",
      "beton",
      "mensa",
      "cafeteria",
      "transition interieur exterieur",
      "wien",
      "delugan meissl"
    ],
    "description": "Le socle a deux niveaux accueille les fonctions communes (aula, bibliotheque, amphitheatres, cafeteria) et s'inscrit dans la pente naturelle du terrain orientee au sud. La cafeteria ouvre directement sur une generereuse terrasse en gradins, tandis que des escaliers exterieurs et chemins lient le batiment au paysage, assurant une transition sans seuil entre interieur et exterieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Wien+Soubassement",
    "source": "Detail Magazine n9/2010 - Fachhochschule Wien, Delugan Meissl",
    "materiaux": [
      "beton arme",
      "revetement de sol exterieur",
      "structure porteuse beton"
    ],
    "points_cles": [
      "Socle a deux niveaux integre dans la topographie en pente douce vers le sud",
      "Terrasse en gradins en prolongement direct de la cafeteria",
      "Escaliers exterieurs et chemins assurant la continuite batiment-paysage"
    ]
  },
  {
    "id": "detail-2010-wien-04",
    "title": "Amenagement interieur monochrome blanc avec split-levels et galeries",
    "fabricant": "Detail Magazine",
    "systeme": "Espaces interieurs en split-level avec galeries, ponts et vides sur hall d'entree",
    "categorie": "amenagement_interieur",
    "tags": [
      "split-level",
      "galerie",
      "pont",
      "vide",
      "gradins",
      "hall",
      "monochrome",
      "blanc",
      "nuances",
      "brillance",
      "lumiere naturelle",
      "elargissement couloir",
      "circulation",
      "wien",
      "delugan meissl"
    ],
    "description": "Le hall d'entree au nord est concu comme un espace fluide a hauteur variable en split-level, anime par des galeries, des ponts et des vides qui multiplient les relations visuelles entre niveaux. Les surfaces murales et les plafonds en blanc monochrome jouent sur de fines nuances de teinte et de degres de brillance, vivifiees par les variations de lumiere naturelle. Les elargissements de couloirs cote facade servent de zones de sejour et ameliorent l'eclairage naturel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Wien+Interieur",
    "source": "Detail Magazine n9/2010 - Fachhochschule Wien, Delugan Meissl",
    "materiaux": [
      "platre peint blanc",
      "beton",
      "garde-corps metallique",
      "revetements varies en blanc"
    ],
    "points_cles": [
      "Espace d'entree en split-level avec hauteurs variables et multiples relations visuelles",
      "Surfaces blanches monochromes avec variations subtiles de teinte et de brillance",
      "Elargissements de couloirs en facade creant des zones de rencontre et optimisant la lumiere naturelle"
    ]
  },
  {
    "id": "detail-1960s-tokyo-01",
    "title": "Nœud de faîtage – Structure en parapluie avec connecteur acier central",
    "fabricant": "Detail Magazine",
    "systeme": "Charpente bois en éventail avec assemblage acier central",
    "categorie": "toiture",
    "tags": [
      "faîtage",
      "charpente bois",
      "chevrons radiaux",
      "connecteur acier",
      "structure parapluie",
      "plat acier",
      "boulons",
      "épicéa",
      "toiture pyramidale",
      "Shinohara",
      "Japon"
    ],
    "description": "Nœud de faîtage d'une toiture pyramidale en structure parapluie où les chevrons en épicéa (180x60 mm) convergent vers un cadre central en fer plat. Les chevrons sont reliés au centre par un cadre en acier plat (150x9 mm) avec des cornières (50x5 mm) et des boulons de 16 mm. Les chevrons diagonaux d'angle sont doublés pour empêcher les déplacements et boulonnés sur les poutres du cadre structurel.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Faitage+Parapluie",
    "source": "Detail Magazine – Wohnhäuser in Japan, Wohnhaus in Tokio, Kazuo Shinohara",
    "materiaux": [
      "chevrons épicéa 180x60 mm",
      "plat acier 150x9 mm",
      "cornières acier 50x5 mm",
      "boulons diamètre 16 mm",
      "contreplaqué hydrofuge"
    ],
    "points_cles": [
      "Structure en parapluie : chevrons rayonnant depuis le centre avec charge uniformément répartie",
      "Assemblage central par cadre en fer plat et cornières acier boulonnés",
      "Chevrons d'angle doublés pour rigidifier la structure contre les déplacements latéraux"
    ]
  },
  {
    "id": "detail-1960s-tokyo-02",
    "title": "Coupe horizontale – Paroi extérieure et cloison intérieure en ossature bois",
    "fabricant": "Detail Magazine",
    "systeme": "Mur à ossature bois avec isolation laine de roche et parement cyprès",
    "categorie": "facade",
    "tags": [
      "mur extérieur",
      "ossature bois",
      "cyprès",
      "isolation laine de roche",
      "amiante-ciment",
      "sperrholz",
      "contreplaqué",
      "cloison coulissante",
      "fusuma",
      "Japon",
      "section horizontale",
      "Shinohara"
    ],
    "description": "Paroi extérieure composée de montants en cyprès (150x150 mm), isolation en laine de roche, panneaux d'amiante-ciment de 6 mm peints en blanc côté extérieur et bardage en cyprès. Côté intérieur, contreplaqué de 6 mm tapissé de soie. La cloison intérieure entre séjour et chambre intègre des panneaux coulissants (fusuma), un cadre à papier huilé sur plaques de plâtre et un poteau rond poli de diamètre 190 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Tokyo+Facade+Bois",
    "source": "Detail Magazine – Wohnhäuser in Japan, Wohnhaus in Tokio, Kazuo Shinohara",
    "materiaux": [
      "cyprès 150x150 mm",
      "laine de roche",
      "panneaux amiante-ciment 6 mm",
      "contreplaqué 6 mm",
      "tapisserie soie",
      "poteau rond poli diamètre 190 mm",
      "papier huilé sur plaques de plâtre",
      "poutres cyprès 75x40 mm"
    ],
    "points_cles": [
      "Tous les éléments bois visibles en extérieur sont en cyprès japonais",
      "Double fonction de la cloison intérieure : paroi coulissante fusuma permettant l'ouverture totale entre séjour et chambre",
      "Superposition de couches traditionnelles japonaises (papier huilé, soie) sur supports modernes (contreplaqué, plaques de plâtre)"
    ]
  },
  {
    "id": "detail-1960s-chigasaki-03",
    "title": "Coupe transversale – Maison béton armé avec jardin intérieur et verrière",
    "fabricant": "Detail Magazine",
    "systeme": "Structure béton armé avec plancher décaissé et lanterneau vitré",
    "categorie": "jonction_plancher",
    "tags": [
      "béton armé",
      "jardin intérieur",
      "niwa",
      "plancher décaissé",
      "lanterneau",
      "verre armé",
      "carrelage terre cuite",
      "dallage céramique",
      "Chigasaki",
      "Shinohara",
      "Japon",
      "niveau décalé"
    ],
    "description": "Section transversale d'une maison en béton armé à Chigasaki montrant le décaissement d'environ 22 m² du plancher par rapport au niveau principal, revêtu de carreaux en terre cuite pour créer un jardin intérieur (niwa) surmonté d'un lanterneau en verre armé. Les fondations, éléments porteurs et dalle sont en béton armé. Le sol décaissé repose sur des pierres en béton avec étanchéité asphalte, tandis que le plafond est habillé de voligeage en épicéa.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chigasaki+Plancher+Niwa",
    "source": "Detail Magazine – Wohnhäuser in Japan, Land-Wohnhaus in Chigasaki, Kazuo Shinohara",
    "materiaux": [
      "béton armé",
      "carreaux terre cuite",
      "verre armé",
      "asphalte étanche",
      "pierres béton",
      "voligeage épicéa",
      "isolation"
    ],
    "points_cles": [
      "Plancher décaissé d'une marche créant une zone de jardin intérieur (niwa) de 22 m² en continuité avec l'espace de vie",
      "Lanterneau en verre armé apportant un éclairage zénithal naturel au jardin intérieur",
      "Étanchéité assurée par couche d'asphalte imperméable sous le dallage céramique sur pierres béton"
    ]
  },
  {
    "id": "detail-1960s-chigasaki-04",
    "title": "Façade vitrée coulissante – Baies vers jardin avec moustiquaire intégrée",
    "fabricant": "Detail Magazine",
    "systeme": "Menuiserie bois avec vitrage fixe haut et panneaux coulissants bas",
    "categorie": "jonction_menuiserie",
    "tags": [
      "baie vitrée",
      "coulissant",
      "menuiserie bois",
      "moustiquaire",
      "vitrage fixe",
      "cyprès",
      "porte coulissante",
      "volet coulissant",
      "façade jardin",
      "ventilation naturelle",
      "Chigasaki",
      "Shinohara",
      "Japon"
    ],
    "description": "Façade vitrée vers le jardin composée d'une partie haute en vitrage fixe et d'une partie basse en panneaux coulissants vitrés sur cadre bois en cyprès (12x12 cm). Lorsque les panneaux vitrés coulissants sont ouverts, des cadres moustiquaires peuvent être insérés dans les mêmes rails. Le système inclut également des volets coulissants extérieurs et une porte d'entrée en acier peint. Le bardage extérieur est en cyprès avec finition laque japonaise.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chigasaki+Menuiserie+Coulissante",
    "source": "Detail Magazine – Wohnhäuser in Japan, Land-Wohnhaus in Chigasaki, Kazuo Shinohara",
    "materiaux": [
      "cyprès 12x12 cm",
      "vitrage",
      "cadre moustiquaire",
      "acier peint",
      "laque japonaise",
      "habillage cyprès",
      "contreplaqué 6 mm tapissé soie"
    ],
    "points_cles": [
      "Système à triple rail permettant l'interchangeabilité entre panneaux vitrés coulissants et cadres moustiquaires",
      "Partie haute en vitrage fixe assurant un apport lumineux permanent, partie basse ouvrable pour la ventilation",
      "Volets coulissants extérieurs (Schiebeladen) offrant une protection solaire et une occultation complémentaires"
    ]
  },
  {
    "id": "detail-1980-holte-01",
    "title": "Mur extérieur en maçonnerie double paroi avec isolation intermédiaire",
    "fabricant": "Detail Magazine",
    "systeme": "Maçonnerie double paroi en briques artisanales avec isolation intercalée",
    "categorie": "facade",
    "tags": [
      "maçonnerie double paroi",
      "zweischaliges Mauerwerk",
      "briques artisanales",
      "handgestrichene Ziegel",
      "isolation intermédiaire",
      "jointoiement spécial",
      "abgedichtete Verfugung",
      "façade brique",
      "mur porteur",
      "Danemark"
    ],
    "description": "Mur extérieur en maçonnerie double paroi (zweischaliges Ziegelmauerwerk) avec isolation thermique intercalée. Les briques artisanales cuites à haute température présentent des tonalités variées (rouge clair à brun foncé) et des formats irréguliers, nécessitant un jointoiement spécial dit « abgedichtete Verfugung » où les briques sont posées dans un excès de mortier qui remplit les joints et les angles. Les joints volontairement larges confèrent à la surface murale une tonalité grise d'ensemble et une texture fortement marquée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Holte+Facade",
    "source": "Detail Magazine - Baustrukturen/Baukonstruktionen: Einfamilienhäuser - Maison d'architecte à Holte/Danemark, Max et Tulla Gudiksen",
    "materiaux": [
      "briques artisanales cuites dur (handgestrichene Ziegel)",
      "mortier de jointoiement",
      "isolant thermique intercalé"
    ],
    "points_cles": [
      "Double paroi de briques avec isolation dans la lame d'air pour performance thermique",
      "Jointoiement spécial (abgedichtete Verfugung) adapté aux formats irréguliers des briques artisanales",
      "Maçonnerie non nettoyée après pose pour conserver l'aspect brut et la texture grise des joints larges"
    ]
  },
  {
    "id": "detail-1980-holte-02",
    "title": "Toiture en voûte-coque béton armé avec couverture végétalisée",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle en voûte béton armé (Stahlbetontonne) avec étanchéité bitumineuse, isolation polystyrène et toiture végétalisée",
    "categorie": "toiture",
    "tags": [
      "voûte béton armé",
      "Stahlbetontonne",
      "Schalenkonstruktion",
      "toiture végétalisée",
      "Grasnarbe",
      "polystyrène",
      "bitume",
      "feutre bitumé",
      "Dachpappe",
      "toiture coque",
      "toiture courbe",
      "Danemark"
    ],
    "description": "Toiture en structure coque (Schalenkonstruktion) constituée d'une voûte en béton armé (Stahlbetontonne) reposant sur les murs extérieurs porteurs. La couverture se compose, de l'intérieur vers l'extérieur, d'une couche de bitume sur la coque béton, d'une couche d'isolation en polystyrène, de trois couches de feutre bitumé (Dachpappe) assurant l'étanchéité, et d'une couche de terre engazonnée (Grasnarbe) en finition. Cette composition assure à la fois l'isolation thermique, l'étanchéité et l'intégration paysagère de la toiture dans le site lacustre.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Holte+Toiture",
    "source": "Detail Magazine - Baustrukturen/Baukonstruktionen: Einfamilienhäuser - Maison d'architecte à Holte/Danemark, Max et Tulla Gudiksen",
    "materiaux": [
      "béton armé (voûte coque)",
      "bitume",
      "polystyrène (isolation)",
      "feutre bitumé (Dachpappe) 3 couches",
      "terre végétalisée (Grasnarbe)"
    ],
    "points_cles": [
      "Structure en coque béton armé (Stahlbetontonne) permettant de franchir la portée sans appuis intermédiaires",
      "Isolation en polystyrène posée sur l'extrados de la coque avec triple couche de feutre bitumé pour étanchéité",
      "Finition en toiture végétalisée (gazon) assurant l'intégration paysagère au bord du lac et la protection de l'étanchéité"
    ]
  },
  {
    "id": "detail-1980-holte-03",
    "title": "Plancher sur dalle béton avec chauffage au sol et dallage en briques",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton armé avec canalisations de chauffage par le sol, chape mortier et revêtement en briques",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher chauffant",
      "Fußbodenheizung",
      "dalle béton",
      "Stahlbetonplatte",
      "dallage brique",
      "Ziegelpflaster",
      "chape mortier",
      "isolation hydrofuge",
      "wasserdichte Isolierung",
      "sol intérieur",
      "Danemark"
    ],
    "description": "Plancher constitué d'une dalle en béton armé intégrant les canalisations du chauffage par le sol (Fußbodenheizung), surmontée d'une isolation hydrofuge (wasserdichte Isolierung). Le revêtement de sol est un dallage en briques (Ziegelpflaster) posé sur un lit de mortier de 3 cm d'épaisseur. Cette composition assure la diffusion homogène de la chaleur tout en offrant un revêtement en cohérence avec la matérialité de la façade en briques.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Holte+Plancher",
    "source": "Detail Magazine - Baustrukturen/Baukonstruktionen: Einfamilienhäuser - Maison d'architecte à Holte/Danemark, Max et Tulla Gudiksen",
    "materiaux": [
      "béton armé (dalle)",
      "canalisations de chauffage au sol",
      "isolation hydrofuge (wasserdichte Isolierung)",
      "mortier (lit de pose 3 cm)",
      "briques de sol (Ziegelpflaster)"
    ],
    "points_cles": [
      "Dalle béton armé intégrant les canalisations du chauffage par le sol pour une diffusion thermique par inertie",
      "Isolation hydrofuge (wasserdichte Isolierung) protégeant contre les remontées d'humidité du sol",
      "Revêtement en dallage brique sur lit de mortier de 3 cm assurant la continuité matérielle avec les murs extérieurs"
    ]
  },
  {
    "id": "detail-1980-holte-04",
    "title": "Jonction mur porteur double paroi / voûte béton armé en toiture",
    "fabricant": "Detail Magazine",
    "systeme": "Appui de voûte-coque béton armé sur mur en maçonnerie double paroi isolée",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction mur-toiture",
      "appui voûte",
      "Stahlbetontonne",
      "zweischaliges Mauerwerk",
      "coque béton",
      "naissance de voûte",
      "continuité isolation",
      "détail constructif",
      "Danemark",
      "structure"
    ],
    "description": "Détail de jonction entre le mur extérieur porteur en maçonnerie double paroi avec isolation intermédiaire et la voûte en coque de béton armé (Stahlbetontonne). La coque repose directement sur les murs extérieurs, assurant la transmission des charges de la toiture vers les fondations. Les cloisons intérieures sont des parois légères non porteuses, ce qui confirme que seuls les murs de façade reprennent les efforts de la voûte, permettant une flexibilité totale du plan intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Holte+Jonction",
    "source": "Detail Magazine - Baustrukturen/Baukonstruktionen: Einfamilienhäuser - Maison d'architecte à Holte/Danemark, Max et Tulla Gudiksen",
    "materiaux": [
      "béton armé (voûte coque)",
      "maçonnerie double paroi en briques",
      "isolant thermique intercalé",
      "cloisons légères non porteuses"
    ],
    "points_cles": [
      "Appui direct de la voûte-coque béton armé sur les murs extérieurs porteurs en maçonnerie double paroi",
      "Cloisons intérieures non porteuses (flexible Trennwände) permettant un plan libre sous la voûte",
      "Nécessité de continuité de l'isolation entre le complexe de toiture et l'isolation intercalée du mur double paroi"
    ]
  },
  {
    "id": "detail-2005-utrecht-01",
    "title": "Façade Structural Glazing sur ossature acier avec relief béton",
    "fabricant": "Detail Magazine",
    "systeme": "Façade rideau Structural Glazing sur grille de profilés creux acier soudés avec panneaux béton relief",
    "categorie": "facade",
    "tags": [
      "structural glazing",
      "façade rideau",
      "acier",
      "aluminium",
      "verre feuilleté",
      "béton relief",
      "profilés creux",
      "façade collée",
      "bibliothèque",
      "dilatation thermique",
      "points de fixation ponctuels",
      "sérigraphie verre",
      "fertigteil",
      "préfabriqué"
    ],
    "description": "Façade Structural Glazing composée de vitrages de protection solaire sérigraphiés (ESG 8 + SZR 16 + Float 10 mm) collés sur profilés aluminium sans fixation mécanique, dimensions 1,60 x 3,45 m. Ces éléments aluminium sont vissés sur une grille de profilés creux acier soudés (120/330 mm) au pas de 6,45 x 3,45 m. La structure acier de 30 m de haut n'est fixée que ponctuellement à la construction béton, avec des connexions permettant d'absorber les dilatations thermiques horizontales et les déformations verticales des porte-à-faux jusqu'à 15 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utrecht+Facade+Structural+Glazing",
    "source": "Detail Magazine n3/2005 - Universitätsbibliothek Utrecht, Wiel Arets Architects",
    "materiaux": [
      "verre trempé sérigraphié ESG 8 mm",
      "verre float 10 mm",
      "profilés aluminium façade",
      "profilés creux acier soudés 120x330 mm",
      "mastic structural glazing",
      "panneau béton préfabriqué relief 125 mm",
      "béton coulé en place relief 425 mm"
    ],
    "points_cles": [
      "Vitrage collé sans fixation mécanique sur profil aluminium démontable pour remplacement facile des verres",
      "Structure acier fixée ponctuellement au béton avec joints de connexion absorbant jusqu'à 15 mm de déformation verticale et dilatations thermiques horizontales",
      "Double registre de façade : peau de verre sérigraphiée enveloppant le bâtiment comme une peau libre devant les murs béton en relief"
    ]
  },
  {
    "id": "detail-2005-utrecht-02",
    "title": "Mur béton à surface en relief – coffrage à matrice caoutchouc",
    "fabricant": "Detail Magazine",
    "systeme": "Béton architectonique à relief matricé – préfabriqué et coulé en place",
    "categorie": "facade",
    "tags": [
      "béton relief",
      "matrice caoutchouc",
      "coffrage spécial",
      "béton architectonique",
      "préfabriqué",
      "ortbeton",
      "béton coulé en place",
      "polyuréthane",
      "CNC",
      "motif photographique",
      "béton noir",
      "peinture béton",
      "fertigteil",
      "relief 25 mm"
    ],
    "description": "Parois de magasins traitées avec une surface en relief de 25 mm de profondeur maximum, reproduisant un motif photographique de branches de saule (Kim Zwarts) abstrait en 4 niveaux de gris. Le relief a été découpé manuellement dans une plaque de polyuréthane (4 plans correspondant aux niveaux de gris), puis une matrice caoutchouc a été coulée comme moule-mère, avec chanfreins aux arêtes pour faciliter le décoffrage. Un moulage en plâtre de ce prototype a fourni la forme négative servant à couler les inserts de coffrage en caoutchouc définitifs.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utrecht+Beton+Relief",
    "source": "Detail Magazine n3/2005 - Universitätsbibliothek Utrecht, Wiel Arets Architects",
    "materiaux": [
      "béton préfabriqué B35 125 mm",
      "béton coulé en place B45/B65 425 mm",
      "matrice caoutchouc de coffrage",
      "polyuréthane pour prototype",
      "plâtre pour moule négatif",
      "peinture noire de finition"
    ],
    "points_cles": [
      "Matrice caoutchouc réutilisable ~100 fois en préfabrication mais seulement ~2 fois en coffrage de béton coulé en place en raison des percements de tirants et des dimensions variables",
      "Éléments préfabriqués de façade max 1,60 x 3,45 m en B35 portant uniquement leur poids propre, tandis que les murs porteurs intérieurs sont en béton coulé B45 à B65",
      "Le béton teinté dans la masse a été abandonné au profit d'une peinture noire appliquée après durcissement pour garantir l'homogénéité de teinte sur la durée du chantier et les grandes quantités de béton"
    ]
  },
  {
    "id": "detail-2005-utrecht-03",
    "title": "Structure porteuse en refends béton avec dalles alvéolaires précontraintes",
    "fabricant": "Detail Magazine",
    "systeme": "Refends béton armé porteurs avec dalles alvéolaires précontraintes et chape collaborante",
    "categorie": "structure",
    "tags": [
      "refend béton",
      "dalle alvéolaire précontrainte",
      "hohldielen",
      "béton précontraint",
      "chape collaborante",
      "forte charge",
      "bibliothèque",
      "magasin livres",
      "noyaux rigides",
      "contreventement",
      "joint de dilatation",
      "porte-à-faux",
      "suspension barres rondes",
      "B45",
      "B65"
    ],
    "description": "Tragwerk principal composé de refends béton armé de 400 mm d'épaisseur espacés de 12,90 m avec grandes ouvertures, supportant des dalles alvéolaires précontraintes de 320 à 400 mm d'épaisseur avec une chape collaborante de 80 mm. Le système permet des charges d'exploitation de 800 kg/m² en salle de lecture et 1300 kg/m² dans les magasins. Quatre noyaux assurent le contreventement longitudinal tandis que les refends assurent le contreventement transversal, avec un joint de dilatation au centre du bâtiment de 100 m de long.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utrecht+Structure+Beton",
    "source": "Detail Magazine n3/2005 - Universitätsbibliothek Utrecht, ABT ingénieurs / Wiel Arets Architects",
    "materiaux": [
      "béton armé B45 coulé en place",
      "béton haute performance B65",
      "dalles alvéolaires précontraintes 320-400 mm",
      "chape béton collaborante 80 mm",
      "barres rondes acier Ø60-80 mm pour suspentes",
      "profilés acier intégrés dans dalles béton"
    ],
    "points_cles": [
      "Charges exceptionnelles de 1300 kg/m² dans les magasins obtenues par dalles alvéolaires précontraintes de 400 mm avec chape collaborante de 80 mm",
      "Refends en béton B45 à B65 à section mince permettant de reprendre les efforts normaux élevés et les concentrations de contraintes malgré les grandes ouvertures",
      "Joint de dilatation central sur un bâtiment de 100 m de long, avec le grand vide du hall central absorbant les variations dimensionnelles"
    ]
  },
  {
    "id": "detail-2005-utrecht-04",
    "title": "Plateformes en porte-à-faux et suspensions par tirants acier aux magasins",
    "fabricant": "Detail Magazine",
    "systeme": "Porte-à-faux béton avec contreflèche et plateformes suspendues par tirants acier boulonnés",
    "categorie": "jonction_plancher",
    "tags": [
      "porte-à-faux",
      "auskragung",
      "contreflèche",
      "étaiement provisoire",
      "suspension",
      "tirant acier",
      "barre ronde",
      "plateforme suspendue",
      "pont",
      "salle lecture",
      "magasin suspendu",
      "béton armé",
      "profilé acier noyé",
      "assemblage boulonné"
    ],
    "description": "Les magasins-cubes flottants répartis dans les étages supérieurs sont équilibrés par des porte-à-faux béton atteignant 13 m, coulés avec une contreflèche de 50 mm et soutenus par des étais provisoires durant la construction. Après retrait des étais, la structure s'abaisse en position horizontale sous charges permanentes et d'exploitation. Les plateformes de lecture de type pont sont suspendues aux magasins par des tirants en barres rondes acier de Ø60 à 80 mm, boulonnés sur des profilés acier noyés dans les dalles béton.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Utrecht+Porte-a-faux+Suspension",
    "source": "Detail Magazine n3/2005 - Universitätsbibliothek Utrecht, ABT ingénieurs / Wiel Arets Architects",
    "materiaux": [
      "béton armé B45-B65",
      "barres rondes acier Ø60 mm",
      "barres rondes acier Ø80 mm",
      "profilés acier noyés dans dalles béton",
      "boulons haute résistance",
      "étais provisoires de chantier"
    ],
    "points_cles": [
      "Porte-à-faux jusqu'à 13 m de portée bétonés avec contreflèche de 50 mm, se mettant à niveau horizontal après retrait des étais sous l'effet des charges permanentes et d'exploitation",
      "Plateformes de lecture suspendues aux cubes-magasins par tirants en barres rondes acier Ø60-80 mm boulonnés sur profilés acier intégrés aux dalles, supprimant tout poteau",
      "Conception structurelle complexe avec magasins lourds positionnés en hauteur nécessitant un équilibre soigné des forces malgré la position défavorable des charges par rapport aux fondations"
    ]
  },
  {
    "id": "detail-1993-awaji-01",
    "title": "Section longitudinale de l'escalier enterré sous bassin lotus",
    "fabricant": "Detail Magazine",
    "systeme": "Escalier en béton apparent traversant un bassin d'eau avec étanchéité uréthane",
    "categorie": "structure",
    "tags": [
      "escalier",
      "béton apparent",
      "sichtbeton",
      "bassin",
      "enterré",
      "étanchéité",
      "uréthane",
      "temple",
      "souterrain",
      "Tadao Ando",
      "eau"
    ],
    "description": "Coupe longitudinale de l'escalier monumental qui traverse axialement le bassin ovale de lotus pour descendre vers la salle souterraine du temple. La structure en béton apparent (Sichtbeton) reçoit une étanchéité en résine uréthane pour assurer l'imperméabilité vis-à-vis du plan d'eau supérieur. Le sol de la salle inférieure est en plancher bois de cyprès japonais.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Awaji+Escalier+Enterré",
    "source": "Detail Magazine n05/1993 - Der Wassertempel, Tadao Ando",
    "materiaux": [
      "béton apparent (Sichtbeton)",
      "résine uréthane (étanchéité)",
      "cyprès japonais (plancher)",
      "béton lavé (Waschbeton)"
    ],
    "points_cles": [
      "Escalier en béton apparent traversant axialement le bassin ovale",
      "Étanchéité par revêtement uréthane entre la structure béton et le plan d'eau",
      "Transition entre espace extérieur aquatique et salle souterraine"
    ]
  },
  {
    "id": "detail-1993-awaji-02",
    "title": "Jonction escalier - bord de bassin (coupe transversale)",
    "fabricant": "Detail Magazine",
    "systeme": "Raccord étanche entre paroi d'escalier béton et rive de bassin en béton lavé",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction",
      "bassin",
      "escalier",
      "béton lavé",
      "waschbeton",
      "étanchéité",
      "uréthane",
      "rive",
      "bord de bassin",
      "Tadao Ando"
    ],
    "description": "Coupe transversale au droit de la jonction entre la trémie de l'escalier descendant et le bord du bassin à lotus. Le béton lavé (Waschbeton) constitue la finition du pourtour du bassin, tandis que le béton apparent forme la structure porteuse de l'escalier. L'étanchéité uréthane assure la continuité de l'imperméabilisation à cette jonction critique.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Awaji+Jonction+Bassin",
    "source": "Detail Magazine n05/1993 - Der Wassertempel, Tadao Ando",
    "materiaux": [
      "béton apparent (Sichtbeton)",
      "béton lavé (Waschbeton)",
      "résine uréthane (étanchéité)"
    ],
    "points_cles": [
      "Jonction étanche entre trémie d'escalier et bassin d'eau en toiture",
      "Différenciation des parements : béton apparent structurel et béton lavé en finition de rive",
      "Point critique d'étanchéité traité par revêtement uréthane continu"
    ]
  },
  {
    "id": "detail-1993-awaji-03",
    "title": "Aménagement intérieur de la salle souterraine du temple",
    "fabricant": "Detail Magazine",
    "systeme": "Salle à colonnes en béton avec habillage bois de cèdre et plancher en cyprès japonais",
    "categorie": "amenagement_interieur",
    "tags": [
      "aménagement intérieur",
      "temple",
      "souterrain",
      "cèdre",
      "cyprès japonais",
      "béton",
      "colonnes",
      "habillage bois",
      "lumière naturelle",
      "Tadao Ando"
    ],
    "description": "La salle principale du temple est un espace souterrain à colonnes en béton, dont les murs sont habillés de panneaux de cèdre (Wandschalung Zedernholz) et le sol revêtu de plancher en cyprès japonais. Une ouverture étroite à l'ouest permet l'entrée de lumière naturelle, créant des jeux d'ombre portée sur les colonnes lors du coucher de soleil.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Awaji+Salle+Temple",
    "source": "Detail Magazine n05/1993 - Der Wassertempel, Tadao Ando",
    "materiaux": [
      "béton apparent (Sichtbeton)",
      "cèdre (habillage mural)",
      "cyprès japonais (plancher)"
    ],
    "points_cles": [
      "Habillage mural en panneaux de cèdre sur structure béton souterraine",
      "Plancher en bois de cyprès japonais dans un espace enterré sous un bassin",
      "Ouverture unique à l'ouest pour éclairage naturel dramatique"
    ]
  },
  {
    "id": "detail-1993-awaji-04",
    "title": "Toiture-bassin : étanchéité du bassin à lotus sur salle enterrée",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton étanchée par résine uréthane supportant un bassin d'eau planté",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "bassin",
      "étanchéité",
      "uréthane",
      "béton",
      "toiture végétalisée",
      "lotus",
      "plan d'eau",
      "dalle",
      "enterré",
      "Tadao Ando"
    ],
    "description": "La couverture de la salle souterraine est constituée d'une dalle en béton apparent formant le fond d'un vaste bassin ovale planté de lotus. L'étanchéité est assurée par un revêtement en résine uréthane appliqué sur la face supérieure de la structure béton. Le pourtour du bassin est traité en béton lavé (Waschbeton) pour une finition texturée distincte.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Awaji+Toiture+Bassin",
    "source": "Detail Magazine n05/1993 - Der Wassertempel, Tadao Ando",
    "materiaux": [
      "béton apparent (Sichtbeton)",
      "béton lavé (Waschbeton)",
      "résine uréthane (étanchéité)"
    ],
    "points_cles": [
      "Dalle béton servant simultanément de structure porteuse et de fond de bassin",
      "Étanchéité par revêtement uréthane supportant une charge d'eau permanente",
      "Bassin ovale de lotus fonctionnant comme toiture paysagère au-dessus du temple"
    ]
  },
  {
    "id": "detail-2015-sweden-01",
    "title": "Toiture végétalisée sur dalle béton préfabriquée avec isolation mousse de verre",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate végétalisée sur structure béton préfabriqué avec isolation Schaumglas",
    "categorie": "toiture",
    "tags": [
      "toiture végétalisée",
      "mousse de verre",
      "Schaumglas",
      "béton préfabriqué",
      "drainage",
      "protection racines",
      "toiture plate",
      "isolation thermique",
      "pente intégrée",
      "acrotère brique",
      "couvertine acier",
      "brique Elbmarsch",
      "toit vert extensif"
    ],
    "description": "Toiture plate végétalisée composée d'une végétation de 30 mm sur natte drainante de 25 mm, membrane anti-racines, isolation thermique en mousse de verre (2×100 mm) formant la pente, posée sur dalle béton armé préfabriquée de 200 mm. L'acrotère est couronné d'une couvertine en tôle d'acier laquée de 3 mm, avec le parement extérieur en brique pleine Elbmarsch armée (240/115/65 mm) assurant la continuité de la façade jusqu'en tête de mur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sweden+Toiture+Vegetalisee",
    "source": "Detail Magazine n7-8/2015 - Creek House, Tham & Videgård Arkitekter",
    "materiaux": [
      "végétalisation extensive",
      "natte drainante",
      "membrane anti-racines",
      "mousse de verre Schaumglas 2×100 mm",
      "dalle béton armé préfabriquée 200 mm",
      "couvertine tôle acier laquée 3 mm",
      "brique pleine Elbmarsch armée"
    ],
    "points_cles": [
      "Isolation en mousse de verre (Schaumglas) formant la pente d'écoulement, imputrescible et résistante à la compression",
      "Dalle béton armé préfabriquée de 200 mm servant de support structurel à l'ensemble du complexe de toiture",
      "Couvertine en tôle d'acier laquée 3 mm coiffant l'acrotère en brique armée pour assurer l'étanchéité en tête de mur"
    ]
  },
  {
    "id": "detail-2015-sweden-02",
    "title": "Façade double-paroi brique Elbmarsch sur maçonnerie portante en blocs de béton d'argile expansée (LECA)",
    "fabricant": "Detail Magazine",
    "systeme": "Mur double-paroi avec parement brique pleine et maçonnerie portante Blähton (LECA)",
    "categorie": "facade",
    "tags": [
      "double paroi",
      "brique pleine",
      "Elbmarsch",
      "Blähton",
      "LECA",
      "argile expansée",
      "laine minérale",
      "lame d'air",
      "maçonnerie portante",
      "joint large 30 mm",
      "enduit intérieur",
      "façade ventilée",
      "brique retournée",
      "texture rugueuse",
      "mortier gris naturel"
    ],
    "description": "Façade double-paroi constituée d'un parement extérieur en brique pleine Elbmarsch (240/115/65 mm) posée face arrière visible avec joints larges de 30 mm en mortier gris naturel débordant, d'une lame d'air ventilée de 20 mm, d'une isolation en laine minérale de 100 mm, d'une maçonnerie portante en blocs d'argile expansée (Blähton/LECA) de 250 mm et d'un enduit intérieur de 15 mm. Le concept de brique retournée offre une texture rugueuse et un aspect chromatique varié renforcé par le mortier largement appliqué.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sweden+Facade+Brique+LECA",
    "source": "Detail Magazine n7-8/2015 - Creek House, Tham & Videgård Arkitekter",
    "materiaux": [
      "brique pleine Elbmarsch 240/115/65 mm",
      "mortier gris naturel joints 30 mm",
      "lame d'air 20 mm",
      "laine minérale 100 mm",
      "blocs argile expansée LECA 250 mm",
      "enduit intérieur 15 mm"
    ],
    "points_cles": [
      "Briques posées face arrière vers l'extérieur pour révéler la texture rugueuse et la variation chromatique naturelle du tesson",
      "Joints extra-larges de 30 mm avec mortier gris naturel appliqué généreusement, débordant partiellement sur les briques",
      "Mur porteur en blocs d'argile expansée (LECA) de 250 mm combinant fonction structurelle et contribution à l'isolation thermique"
    ]
  },
  {
    "id": "detail-2015-sweden-03",
    "title": "Plancher bas sur terre-plein avec parquet frêne massif et triple couche d'isolation EPS",
    "fabricant": "Detail Magazine",
    "systeme": "Dallage sur terre-plein isolé EPS avec finition parquet frêne massif",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher bas",
      "terre-plein",
      "dallage",
      "EPS",
      "isolation sol",
      "frêne massif",
      "pare-vapeur",
      "contreplaqué",
      "béton armé",
      "étanchéité plastique",
      "soubassement",
      "radier",
      "triple isolation"
    ],
    "description": "Plancher bas sur terre-plein composé de trois couches d'isolation EPS (3×100 mm = 300 mm) sous membrane d'étanchéité plastique, dalle béton armé de 135 mm, pare-vapeur, panneau contreplaqué de séparation de 18 mm et parquet en frêne massif de 20 mm en finition. L'épaisseur d'isolation importante de 300 mm en polystyrène expansé répond aux exigences thermiques du climat suédois méridional.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sweden+Plancher+Terre-plein",
    "source": "Detail Magazine n7-8/2015 - Creek House, Tham & Videgård Arkitekter",
    "materiaux": [
      "parquet frêne massif 20 mm",
      "couche de séparation",
      "contreplaqué 18 mm",
      "pare-vapeur",
      "béton armé 135 mm",
      "membrane étanchéité plastique",
      "isolant EPS 3×100 mm"
    ],
    "points_cles": [
      "Triple couche d'isolation EPS totalisant 300 mm sous la dalle, adaptée aux exigences thermiques scandinaves",
      "Membrane d'étanchéité plastique positionnée entre l'isolation EPS et la dalle béton armé pour assurer la protection contre l'humidité du sol",
      "Finition intérieure en frêne massif 20 mm sur contreplaqué de répartition 18 mm avec pare-vapeur intermédiaire"
    ]
  },
  {
    "id": "detail-2015-sweden-04",
    "title": "Jonction menuiserie – niche de fenêtre avec volet de ventilation et linteau brique armée",
    "fabricant": "Detail Magazine",
    "systeme": "Fenêtre aluminium en tableau de mur double-paroi brique avec volet ventilation bois de mélèze",
    "categorie": "jonction_menuiserie",
    "tags": [
      "linteau brique armée",
      "niche fenêtre",
      "volet ventilation",
      "mélèze",
      "cornière acier",
      "double vitrage trempé",
      "châssis aluminium",
      "Elbmarsch",
      "grille insectes",
      "joint ouvert",
      "larmier",
      "tableau profond",
      "mobilier intégré",
      "cadre bois dur"
    ],
    "description": "Détail de jonction fenêtre en tableau profond de mur double-paroi : linteau en brique pleine Elbmarsch armée (240/230/65 mm) porté par cornière acier L 50/270 mm, double vitrage trempé (ESG 6 + SZR 12 + ESG 6 mm) en châssis aluminium, avec volet de ventilation en panneau de mélèze massif 12 mm isolé 40 mm sur contreplaqué 12 mm dans cadre bois dur de mélèze. Un joint ouvert entre parement brique et cadre de fenêtre assure la ventilation de la lame d'air, protégé par grille anti-insectes et larmier en tôle pliée.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Sweden+Jonction+Fenetre+Brique",
    "source": "Detail Magazine n7-8/2015 - Creek House, Tham & Videgård Arkitekter",
    "materiaux": [
      "brique pleine Elbmarsch armée 240/230/65 mm linteau",
      "cornière acier L 50/270 mm",
      "double vitrage ESG 6+12+6 mm",
      "châssis aluminium",
      "panneau mélèze massif 12 mm",
      "isolation 40 mm",
      "contreplaqué 12 mm",
      "cadre mélèze bois dur",
      "grille anti-insectes",
      "larmier tôle pliée",
      "tôle inox évacuation eau"
    ],
    "points_cles": [
      "Linteau en brique pleine Elbmarsch armée de double hauteur (240/230/65 mm) supporté par cornière acier L 50/270 mm, assurant la continuité visuelle du parement",
      "Volet de ventilation isolé en mélèze (12 mm panneau + 40 mm isolation + 12 mm contreplaqué) avec joint ouvert et grille anti-insectes permettant la ventilation contrôlée de la lame d'air",
      "Tôle inox de récupération des eaux d'infiltration (wasserführend) intégrée en appui de fenêtre pour évacuer l'humidité éventuelle de la lame d'air ventilée"
    ]
  },
  {
    "id": "detail-2002-ise-01",
    "title": "Structure poteaux sur fondation directe en terre - Schrein de Ise",
    "fabricant": "Detail Magazine",
    "systeme": "Construction traditionnelle japonaise à poteaux fichés en terre (hottate-bashira)",
    "categorie": "structure",
    "tags": [
      "poteaux bois",
      "fondation directe",
      "cyprès japonais",
      "hinoki",
      "structure traditionnelle",
      "hottate",
      "shinto",
      "Ise",
      "plancher surélevé",
      "bois massif",
      "poteau fiché en terre",
      "construction sacrée"
    ],
    "description": "Structure à poteaux en bois de cyprès (hinoki) directement fichés dans le sol sans semelle de fondation, supportant un plancher surélevé. Les poteaux principaux portant la panne faîtière du sanctuaire central atteignent 76 cm de diamètre pour 11 m de longueur, taillés dans un seul tronc. Les panneaux de remplissage entre les poteaux sont constitués de planches rainurées insérées dans des rainures pratiquées dans la structure.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ise+Structure",
    "source": "Detail Magazine n10/2002 - Die Werkstätten am Großschrein von Ise, Christoph Henrichsen",
    "materiaux": [
      "bois de cyprès japonais (hinoki)",
      "planches rainurées en cyprès"
    ],
    "points_cles": [
      "Poteaux fichés directement en terre limitant la durabilité et justifiant le renouvellement périodique tous les 20 ans",
      "Poteaux principaux de faîtage de 76 cm de diamètre sur 11 m de longueur taillés dans un seul tronc",
      "Remplissage des travées par planches de bois insérées dans des rainures (eingenutete Bretter)",
      "Le bois de cyprès non traité prend une patine gris argenté avec le temps"
    ]
  },
  {
    "id": "detail-2002-ise-02",
    "title": "Couverture en chaume (reet) sur charpente à pente 45° - Sanctuaire principal",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture traditionnelle kayabuki en chaume avec sous-couche cuivre",
    "categorie": "toiture",
    "tags": [
      "toiture chaume",
      "kayabuki",
      "reet",
      "toit à 45 degrés",
      "satteldach",
      "couverture cuivre",
      "katsuogi",
      "chigi",
      "faîtage décoratif",
      "Ise",
      "toiture traditionnelle japonaise",
      "pente raide"
    ],
    "description": "Toiture à deux pentes (Satteldach) inclinée à 45 degrés, orientée côté gouttière (traufständig), couverte de chaume (kayabuki) sur les sanctuaires principaux. Une sous-couche de tôle de cuivre a été ajoutée sous le chaume lors des restaurations modernes pour protéger les trésors intérieurs. Le faîtage est orné de billes de bois cylindriques en forme de tonneaux (katsuogi) et de planches de rive prolongées en croix (chigi/shigi).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ise+Toiture+Chaume",
    "source": "Detail Magazine n10/2002 - Die Werkstätten am Großschrein von Ise, Christoph Henrichsen",
    "materiaux": [
      "chaume (reet/kayabuki)",
      "tôle de cuivre (sous-couche)",
      "bois de cyprès pour éléments de faîtage (katsuogi et chigi)"
    ],
    "points_cles": [
      "Pente de toiture à 45 degrés assurant un écoulement rapide des eaux sur le chaume",
      "Ajout moderne d'une sous-couche en cuivre sous le chaume pour protéger les objets sacrés",
      "Éléments décoratifs de faîtage katsuogi (billes en forme de tonneau) et chigi (planches de rive croisées prolongées) issus de l'architecture aristocratique du VIIe siècle",
      "Atelier dédié à la préparation des bottes de chaume directement sur le site du sanctuaire"
    ]
  },
  {
    "id": "detail-2002-ise-03",
    "title": "Couverture en planches de bois (itabuki) - Sanctuaires secondaires",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture traditionnelle itabuki en planches de cyprès",
    "categorie": "toiture",
    "tags": [
      "toiture bois",
      "itabuki",
      "planches",
      "bardeaux bois",
      "cyprès",
      "sanctuaire secondaire",
      "Ise",
      "couverture planches",
      "hinoki",
      "toiture sèche"
    ],
    "description": "Toiture à deux pentes à 45 degrés couverte de planches de bois de cyprès (itabuki) utilisée sur les 125 sanctuaires secondaires (bekku, sessha, massha, sokansha). Ce système de couverture en planches constitue une variante plus simple que le chaume des sanctuaires principaux, tout en conservant la même géométrie de charpente et la même inclinaison. Le bois de cyprès non traité se patine rapidement en gris argenté.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ise+Toiture+Planches",
    "source": "Detail Magazine n10/2002 - Die Werkstätten am Großschrein von Ise, Christoph Henrichsen",
    "materiaux": [
      "planches de cyprès japonais (hinoki)"
    ],
    "points_cles": [
      "Couverture en planches de cyprès comme alternative économique au chaume pour les sanctuaires secondaires",
      "Même géométrie de toiture que les sanctuaires principaux (pente 45°, orientation gouttière)",
      "Durabilité limitée du bois non traité compensée par le cycle de renouvellement de 20 ans",
      "Patine gris argenté naturelle du cyprès non traité"
    ]
  },
  {
    "id": "detail-2002-ise-04",
    "title": "Enceinte en clôtures de bois à rangs multiples - Sanctuaire de Ise",
    "fabricant": "Detail Magazine",
    "systeme": "Système d'enceintes concentriques en palissades de bois de cyprès",
    "categorie": "facade",
    "tags": [
      "clôture bois",
      "palissade",
      "enceinte",
      "cyprès",
      "Ise",
      "zaun",
      "holzzaun",
      "quatre rangs",
      "enceinte concentrique",
      "sanctuaire shinto",
      "protection sacrée"
    ],
    "description": "Système d'enceintes concentriques composé de quatre rangs de clôtures en bois de cyprès (Holzzäune) échelonnées autour des sanctuaires principaux intérieur et extérieur. Ces palissades en bois non traité délimitent l'espace sacré inaccessible et créent une hiérarchie spatiale progressive. Le bois de cyprès se patine naturellement en gris argenté, et l'ensemble est renouvelé intégralement tous les 20 ans selon le rituel du shikinen sengu.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Ise+Enceinte+Bois",
    "source": "Detail Magazine n10/2002 - Die Werkstätten am Großschrein von Ise, Christoph Henrichsen",
    "materiaux": [
      "bois de cyprès japonais (hinoki) non traité"
    ],
    "points_cles": [
      "Quatre rangs de clôtures concentriques échelonnées autour des sanctuaires principaux",
      "Hiérarchie spatiale progressive créant des niveaux de sacralité croissants",
      "Bois de cyprès non traité se patinant en gris argenté",
      "Renouvellement intégral tous les 20 ans dans le cadre du shikinen sengu avec environ 11 000 m³ de bois nécessaires pour l'ensemble"
    ]
  },
  {
    "id": "detail-1997-mirasaka-01",
    "title": "Composition de toiture en acier sur charpente bois",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture acier sur ossature bois avec isolation entre chevrons",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "acier",
      "tôle",
      "bois",
      "chevrons",
      "isolation",
      "laine de verre",
      "contreplaqué",
      "bitume",
      "cabane",
      "japon",
      "ossature bois"
    ],
    "description": "Toiture composée d'une couverture en tôle d'acier de 0,4 mm sur feuille bitumineuse et contreplaqué de 12 mm. L'isolation en laine de verre de 100 mm est placée entre des chevrons de 45x210 mm. Le parement intérieur est en contreplaqué plaqué chêne de 5,5 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Mirasaka+Toiture",
    "source": "Detail Magazine n1/1997 - Ferienhäuser in Mirasaka, The Architecture Factory (Tom Heneghan, Kazuhiro Ando, Naoki Kaji)",
    "materiaux": [
      "tôle acier 0,4 mm",
      "feuille bitumineuse",
      "contreplaqué 12 mm",
      "laine de verre 100 mm",
      "chevrons bois 45x210 mm",
      "contreplaqué plaqué chêne 5,5 mm"
    ],
    "points_cles": [
      "Couverture légère en tôle acier grise adaptée aux cabanes en milieu boisé",
      "Isolation entre chevrons de forte section permettant 100 mm de laine de verre",
      "Finition intérieure en contreplaqué plaqué chêne pour un rendu soigné"
    ]
  },
  {
    "id": "detail-1997-mirasaka-02",
    "title": "Composition de mur à ossature bois avec bardage cèdre",
    "fabricant": "Detail Magazine",
    "systeme": "Mur ossature bois avec bardage cèdre japonais teinté vert",
    "categorie": "facade",
    "tags": [
      "facade",
      "bardage",
      "cèdre",
      "bois",
      "ossature bois",
      "isolation",
      "laine de verre",
      "contreplaqué",
      "rainure languette",
      "japon",
      "cabane",
      "teinture verte"
    ],
    "description": "Paroi extérieure constituée d'un bardage en cèdre japonais rainuré-bouveté de 15 mm teinté vert, posé sur feuille bitumineuse et contreplaqué hydrofuge de 12 mm. L'isolation en laine de verre de 100 mm est insérée entre des montants bois de 105x105 mm. Le parement intérieur est en contreplaqué plaqué chêne de 5,5 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Mirasaka+Facade",
    "source": "Detail Magazine n1/1997 - Ferienhäuser in Mirasaka, The Architecture Factory (Tom Heneghan, Kazuhiro Ando, Naoki Kaji)",
    "materiaux": [
      "bardage cèdre japonais rainuré-bouveté 15 mm",
      "feuille bitumineuse",
      "contreplaqué hydrofuge 12 mm",
      "laine de verre 100 mm",
      "montants bois 105x105 mm",
      "contreplaqué plaqué chêne 5,5 mm"
    ],
    "points_cles": [
      "Bardage cèdre teinté vert pour camouflage dans l'environnement forestier",
      "Montants de forte section 105x105 mm assurant structure et logement de l'isolant",
      "Étanchéité assurée par feuille bitumineuse et contreplaqué hydrofuge en second plan"
    ]
  },
  {
    "id": "detail-1997-mirasaka-03",
    "title": "Composition de plancher bois sur lambourdes isolées",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher bois avec isolation thermique entre lambourdes",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "bois",
      "chêne",
      "isolation",
      "lambourdes",
      "panneau aggloméré",
      "rainure languette",
      "cabane",
      "japon"
    ],
    "description": "Plancher composé de lames de chêne rainurées-bouvetées de 15 mm posées sur des panneaux isolants thermiques de 42 mm insérés entre lambourdes de 45x45 mm. Le support est constitué d'un panneau aggloméré de 12 mm.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Mirasaka+Plancher",
    "source": "Detail Magazine n1/1997 - Ferienhäuser in Mirasaka, The Architecture Factory (Tom Heneghan, Kazuhiro Ando, Naoki Kaji)",
    "materiaux": [
      "lames chêne rainurées-bouvetées 15 mm",
      "panneaux isolants thermiques 42 mm",
      "lambourdes bois 45x45 mm",
      "panneau aggloméré 12 mm"
    ],
    "points_cles": [
      "Revêtement de sol en chêne massif pour durabilité et confort",
      "Isolation thermique de 42 mm entre lambourdes pour limiter les déperditions par le sol",
      "Structure légère adaptée à une construction de type cabane sur terrain en pente boisé"
    ]
  },
  {
    "id": "detail-1997-mirasaka-04",
    "title": "Garde-corps et accès toiture avec pergola sur poteaux bois",
    "fabricant": "Detail Magazine",
    "systeme": "Échelle d'accès, banc en toiture et pergola bois avec câble inox",
    "categorie": "amenagement_interieur",
    "tags": [
      "garde-corps",
      "échelle",
      "pergola",
      "toiture terrasse",
      "banc",
      "câble inox",
      "tube acier",
      "pin",
      "cèdre",
      "belvédère",
      "plantes grimpantes",
      "japon",
      "cabane"
    ],
    "description": "Dispositif d'accès au toit comprenant une échelle en montants de pin 90x45 mm avec barreaux de 50x50 mm, menant à un banc en lattes de pin 30x50 mm. Le garde-corps est constitué de poteaux et main courante en pin 100x100 mm avec câbles inox de 4 mm sur tubes acier de 48,6 mm. Trois poutres en pin 90x180 mm forment une pergola destinée à recevoir des plantes grimpantes.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Mirasaka+Pergola",
    "source": "Detail Magazine n1/1997 - Ferienhäuser in Mirasaka, The Architecture Factory (Tom Heneghan, Kazuhiro Ando, Naoki Kaji)",
    "materiaux": [
      "pin 100x100 mm",
      "pin 90x180 mm",
      "pin 90x45 mm",
      "pin 30x50 mm",
      "cèdre 90x90 mm",
      "tube acier diamètre 48,6 mm",
      "câble inox diamètre 4 mm"
    ],
    "points_cles": [
      "Belvédère en toiture à hauteur de cime des arbres offrant une vue sur la vallée",
      "Pergola en poutres bois destinée à supporter des plantes grimpantes pour ombrage estival et intégration paysagère",
      "Garde-corps mixte bois et câble inox alliant sécurité et légèreté visuelle"
    ]
  },
  {
    "id": "detail-2010-rotterdam-01",
    "title": "Module de rangement préfabriqué en laminé polyester suspendu en façade de coursive",
    "fabricant": "Detail Magazine",
    "systeme": "Boîte préfabriquée en composite polyester-PUR avec cadre acier intégré, suspendue par consoles sur dalles béton",
    "categorie": "facade",
    "tags": [
      "module préfabriqué",
      "polyester",
      "résine",
      "PUR",
      "cadre acier laminé",
      "console acier soudée",
      "coursive",
      "laubengang",
      "box suspendu",
      "stockage",
      "façade industrielle",
      "composite",
      "Rotterdam",
      "haute densité",
      "démontable",
      "recyclable"
    ],
    "description": "Module de rangement préfabriqué en composite polyester-résine (laminat 4 mm + mousse PUR rigide 41 mm + laminat 4 mm) avec cadre en tube acier 60/60/6 mm intégré par lamination. La boîte intègre porte, fenêtre en double vitrage aluminium et grille de ventilation. Elle est suspendue devant les dalles béton préfabriquées par quatre consoles en acier soudé (cornière 200/160/25 mm), formant un rythme libre le long de la coursive extérieure.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Module+Prefab",
    "source": "Detail Magazine n7-8/2010 - Wohn- und Bürogebäude Schiecentrale Rotterdam, Mei Architekten",
    "materiaux": [
      "laminé résine polyester 4 mm",
      "mousse PUR rigide 41 mm",
      "tube acier carré 60/60/6 mm",
      "plat acier 25 mm soudé",
      "cornière acier 200/160/25 mm",
      "console acier soudée",
      "aluminium (cadre vitrage)",
      "ESG 4 mm + SZR 12 mm + ESG 6 mm",
      "tôle striée aluminium 5 mm",
      "bois équarri 38/38 mm",
      "revêtement UV"
    ],
    "points_cles": [
      "Cadre acier intégré par lamination dans le composite polyester, assurant rigidité structurelle et fixation aux consoles",
      "Porte, fenêtre double vitrage et grille ventilation intégrées en usine dans le module pour montage rapide sur site",
      "Suspension par 4 consoles acier soudées fixées aux dalles préfabriquées, permettant démontage et recyclage individualisé",
      "Revêtement UV-résistant sur composite brun foncé créant un contraste signalétique avec le filet inox argenté"
    ]
  },
  {
    "id": "detail-2010-rotterdam-02",
    "title": "Protection intempéries de coursive par filet en acier inoxydable tendu sur ressorts",
    "fabricant": "Detail Magazine",
    "systeme": "Maille inox à 35% d'ouverture tendue par ressorts acier avec câbles de sécurité anti-déformation au vent",
    "categorie": "facade",
    "tags": [
      "filet inox",
      "maille acier inoxydable",
      "edelstahlgewebe",
      "protection intempéries",
      "coursive",
      "ressort acier",
      "câble sécurité",
      "câble inox",
      "façade textile",
      "façade perméable",
      "wind load",
      "Rotterdam",
      "industriel",
      "laubengang",
      "ventilation naturelle"
    ],
    "description": "Le système de protection climatique de la coursive extérieure (Laubengang) est constitué d'un tissu/filet en acier inoxydable avec 35% de surface ouverte, tendu en lés sur un maximum de trois étages. La tension est assurée par des ressorts en acier, alternés avec des câbles de sécurité en acier Ø 5 mm qui limitent l'élongation excessive sous charges de vent. Des câbles inox Ø 8 mm en double assurent le guidage vertical et la fixation aux éléments de structure en béton préfabriqué.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Filet+Inox",
    "source": "Detail Magazine n7-8/2010 - Wohn- und Bürogebäude Schiecentrale Rotterdam, Mei Architekten",
    "materiaux": [
      "filet acier inoxydable (35% ouverture)",
      "ressorts acier",
      "câble acier sécurité Ø 5 mm",
      "câble acier inoxydable Ø 8 mm double",
      "guidage câble acier soudé",
      "béton préfabriqué (support)"
    ],
    "points_cles": [
      "Maille inox à 35% d'ouverture assurant protection pluie/vent tout en maintenant ventilation et transparence visuelle",
      "Lés de filet couvrant maximum 3 étages, limitant les efforts de tension et facilitant le remplacement partiel",
      "Système alternant ressorts de tension et câbles de sécurité Ø 5 mm pour contrôler la déformation sous charge de vent",
      "Câbles inox Ø 8 mm doublés comme structure primaire de suspension et de guidage vertical du filet"
    ]
  },
  {
    "id": "detail-2010-rotterdam-03",
    "title": "Complexe de toiture sur dalles alvéolées précontraintes avec étanchéité PVC",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate sur hourdis béton précontraint 260 mm avec isolation 160 mm, forme de pente en béton maigre et membrane PVC bicouche",
    "categorie": "toiture",
    "tags": [
      "toiture plate",
      "dalle alvéolée",
      "précontraint",
      "béton maigre",
      "forme de pente",
      "isolation thermique",
      "pare-vapeur",
      "membrane PVC",
      "étanchéité bicouche",
      "acrotère",
      "dallage béton",
      "Rotterdam",
      "immeuble grande hauteur"
    ],
    "description": "Complexe de toiture plate composé de dalles alvéolées en béton précontraint de 260 mm, d'une forme de pente en béton maigre (120 à 40 mm), d'un pare-vapeur, de 160 mm d'isolation thermique et d'une membrane PVC bicouche. L'acrotère est traité avec un dallage béton de 40 mm en finition. Ce système s'inscrit dans la logique de préfabrication et de séparation des composants structurels, d'enveloppe et de finition du projet.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Toiture",
    "source": "Detail Magazine n7-8/2010 - Wohn- und Bürogebäude Schiecentrale Rotterdam, Mei Architekten",
    "materiaux": [
      "dalle alvéolée béton précontraint 260 mm",
      "béton maigre forme de pente 120-40 mm",
      "pare-vapeur",
      "isolation thermique 160 mm",
      "membrane PVC bicouche",
      "dallage béton 40 mm (acrotère)",
      "contreplaqué plaqué 15 mm",
      "isolation thermique 50 mm (acrotère)",
      "étanchéité (acrotère)"
    ],
    "points_cles": [
      "Dalles alvéolées précontraintes 260 mm permettant grandes portées et rapidité de mise en œuvre par préfabrication",
      "Forme de pente en béton maigre (120 à 40 mm) intégrée sur les hourdis pour évacuation des eaux pluviales",
      "Double membrane PVC assurant la redondance d'étanchéité sur l'isolation de 160 mm",
      "Acrotère isolé avec contreplaqué plaqué 15 mm + 50 mm d'isolation + étanchéité et finition dallage béton 40 mm"
    ]
  },
  {
    "id": "detail-2010-rotterdam-04",
    "title": "Plancher courant sur dalles alvéolées précontraintes avec chape anhydrite et isolation acoustique",
    "fabricant": "Detail Magazine",
    "systeme": "Plancher séparatif sur hourdis béton précontraint 260 mm avec béton maigre de remplissage, isolation aux bruits d'impact et chape anhydrite flottante",
    "categorie": "jonction_plancher",
    "tags": [
      "plancher",
      "dalle alvéolée",
      "précontraint",
      "hourdis",
      "béton maigre",
      "isolation acoustique",
      "bruits d'impact",
      "chape anhydrite",
      "chape flottante",
      "couche de désolidarisation",
      "béton préfabriqué",
      "Rotterdam",
      "logement",
      "bureau",
      "mixité programmatique",
      "démontable"
    ],
    "description": "Plancher courant composé de dalles alvéolées en béton précontraint de 260 mm recouvertes de 80 mm de béton maigre de remplissage/nivellement, d'une isolation aux bruits d'impact de 20 mm, d'une couche de désolidarisation et d'une chape anhydrite flottante de 50 mm. Ce complexe assure les performances acoustiques requises entre unités de logement et de bureau dans un système entièrement basé sur des éléments préfabriqués standardisés et la séparation structure/façade/aménagement.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Rotterdam+Plancher",
    "source": "Detail Magazine n7-8/2010 - Wohn- und Bürogebäude Schiecentrale Rotterdam, Mei Architekten",
    "materiaux": [
      "dalle alvéolée béton précontraint 260 mm",
      "béton maigre 80 mm",
      "isolation bruits d'impact 20 mm",
      "couche de désolidarisation",
      "chape anhydrite 50 mm"
    ],
    "points_cles": [
      "Dalle alvéolée précontrainte 260 mm standardisée permettant flexibilité programmatique logement/bureau sans modification structurelle",
      "Béton maigre de 80 mm assurant le nivellement et la masse acoustique complémentaire sur les hourdis",
      "Chape flottante anhydrite 50 mm sur isolation acoustique 20 mm et couche séparatrice pour performances aux bruits d'impact",
      "Système conçu pour démontage et recyclage facilité par séparation rigoureuse des composants secs et humides"
    ]
  },
  {
    "id": "detail-2013-chiba-01",
    "title": "Toiture plate avec lanterneaux zénithaux pour corridors-solarium",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture plate bungalow avec oberlichts intégrés",
    "categorie": "toiture",
    "tags": [
      "toiture plate",
      "lanterneau",
      "oberlicht",
      "lumière zénithale",
      "bungalow",
      "corridor",
      "solarium",
      "Japon",
      "résidentiel",
      "plain-pied"
    ],
    "description": "Toiture plate de plain-pied intégrant des lanterneaux (Oberlichter) au-dessus des corridors-solariums qui relient les unités d'habitation. Ces ouvertures zénithales inondent de lumière naturelle les espaces intermédiaires hybrides, créant des zones baignées de soleil entre intérieur et extérieur. La conception de la toiture doit assurer l'étanchéité aux jonctions entre surface opaque et vitrage zénithal tout en permettant une ventilation naturelle transversale.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Toiture+Lanterneau",
    "source": "Detail Magazine - M-apartment, Chiba, Shinichiro Iwata, 2013",
    "materiaux": [
      "membrane d'étanchéité",
      "vitrage lanterneau",
      "structure légère bois ou acier",
      "isolation thermique"
    ],
    "points_cles": [
      "Lanterneaux intégrés en toiture plate pour éclairer les corridors-solariums",
      "Étanchéité soignée aux jonctions vitrage-toiture opaque",
      "Conception plain-pied favorisant une architecture horizontale de type bungalow"
    ]
  },
  {
    "id": "detail-2013-chiba-02",
    "title": "Jonction menuiserie - Parois vitrées coulissantes entre solarium et pièces de vie",
    "fabricant": "Detail Magazine",
    "systeme": "Grandes portes vitrées de séparation intérieur/extérieur",
    "categorie": "jonction_menuiserie",
    "tags": [
      "porte vitrée",
      "grande baie",
      "coulissant",
      "solarium",
      "corridor vitré",
      "transparence",
      "seuil",
      "hybride intérieur-extérieur",
      "Japon",
      "ventilation traversante"
    ],
    "description": "Portes vitrées de grande dimension (großflächige Glastüren) assurant la séparation entre les corridors-solariums et les pièces de vie. Ces menuiseries permettent une ouverture totale pour créer une ventilation traversante agréable entre jardin et solarium, tout en maintenant une transparence visuelle. Le détail de jonction au sol et en partie haute doit gérer le seuil, l'étanchéité à l'air et la transition entre espace semi-extérieur et espace privé.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Menuiserie+Vitree",
    "source": "Detail Magazine - M-apartment, Chiba, Shinichiro Iwata, 2013",
    "materiaux": [
      "vitrage clair grande dimension",
      "profilés aluminium ou acier fin",
      "seuil encastré",
      "joint d'étanchéité"
    ],
    "points_cles": [
      "Grandes surfaces vitrées coulissantes ou pivotantes pour ouvrir totalement le solarium",
      "Ventilation naturelle traversante entre jardin privatif et corridor-solarium",
      "Gestion de la transparence et de l'intimité entre espace semi-public et espace privé"
    ]
  },
  {
    "id": "detail-2013-chiba-03",
    "title": "Jonction plancher - Transition entre corridors solariums et jardins privatifs",
    "fabricant": "Detail Magazine",
    "systeme": "Seuil et transition plancher intérieur / sol extérieur jardin",
    "categorie": "jonction_plancher",
    "tags": [
      "seuil",
      "transition intérieur-extérieur",
      "jardin privatif",
      "corridor",
      "plancher",
      "plain-pied",
      "accessibilité",
      "niveau zéro",
      "Japon"
    ],
    "description": "Détail de jonction au niveau du sol entre les corridors intérieurs (solariums) et les petits jardins privatifs attenants à chaque unité. La conception plain-pied implique une gestion soignée du niveau fini entre sol intérieur et sol extérieur, avec traitement de l'étanchéité, du drainage périphérique et de l'accessibilité de plain-pied. Le seuil doit permettre une continuité spatiale tout en protégeant contre les infiltrations d'eau.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Jonction+Plancher",
    "source": "Detail Magazine - M-apartment, Chiba, Shinichiro Iwata, 2013",
    "materiaux": [
      "dalle béton",
      "revêtement de sol intérieur",
      "gravier ou plantation jardin",
      "drainage périphérique",
      "membrane d'étanchéité soubassement"
    ],
    "points_cles": [
      "Continuité de plain-pied entre espace intérieur solarium et jardin privatif",
      "Drainage et étanchéité au seuil pour éviter les infiltrations",
      "Transition douce renforçant le caractère hybride intérieur-extérieur du projet"
    ]
  },
  {
    "id": "detail-2013-chiba-04",
    "title": "Façade opaque et trame structurelle du réseau de corridors",
    "fabricant": "Detail Magazine",
    "systeme": "Murs porteurs et cloisons formant la trame en grille des unités",
    "categorie": "facade",
    "tags": [
      "façade",
      "mur porteur",
      "trame",
      "grille",
      "structure",
      "corridor",
      "partition",
      "intimité",
      "bungalow",
      "résidentiel collectif",
      "Japon"
    ],
    "description": "Système de parois porteuses et de cloisons formant la trame orthogonale caractéristique du complexe M-apartment. Ce réseau de murs délimite les unités d'habitation, les corridors de circulation et les solariums, créant un jeu complexe de formes et d'espaces variés. Les murs opaques assurent l'intimité des pièces de vie principales tout en contrastant avec la transparence des zones intermédiaires vitrées.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Facade+Trame",
    "source": "Detail Magazine - M-apartment, Chiba, Shinichiro Iwata, 2013",
    "materiaux": [
      "murs porteurs béton ou ossature bois",
      "isolation thermique",
      "revêtement de façade",
      "enduit ou bardage"
    ],
    "points_cles": [
      "Trame structurelle en grille définissant corridors, solariums et unités privatives",
      "Alternance de parois opaques (intimité) et de parois vitrées (transparence)",
      "Formes complexes et variées des unités au sein d'un système orthogonal régulier"
    ]
  },
  {
    "id": "detail-2002-grenoble-01",
    "title": "Façade wintergarten en polycarbonate ondulé - Coupe horizontale",
    "fabricant": "Detail Magazine",
    "systeme": "Façade légère en polycarbonate sur ossature acier galvanisé",
    "categorie": "facade",
    "tags": [
      "polycarbonate",
      "ondulé",
      "wellplatten",
      "facade transparente",
      "wintergarten",
      "serre",
      "acier galvanisé",
      "HEA100",
      "UV protection",
      "conservatory",
      "lacaton vassal",
      "grenoble",
      "campus universitaire",
      "facade légère",
      "tube acier rectangulaire"
    ],
    "description": "Coupe horizontale de la façade de serre (wintergarten) composée de plaques de polycarbonate ondulé transparent 177/51/3 mm avec protection UV, fixées sur une sous-construction en tubes d'acier galvanisé rectangulaires 70/50/4 mm. Les poteaux sont des profilés acier galvanisé HEA 100, et les angles sont résolus par des profilés de rive en polycarbonate transparent thermoformé. L'ensemble forme l'enveloppe extérieure des jardins d'hiver qui filtrent la lumière grâce aux plantations de bougainvilliers et bambous.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Facade+Horizontale",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "polycarbonate ondulé transparent 177/51/3 mm avec UV",
      "profilé de rive polycarbonate thermoformé",
      "tube acier galvanisé rectangulaire 70/50/4 mm",
      "profilé acier galvanisé HEA 100",
      "béton armé (squelette structurel)"
    ],
    "points_cles": [
      "Façade économique en polycarbonate ondulé avec protection UV pour enveloppe de serre",
      "Sous-construction simple en tubes acier galvanisé rectangulaires portant les plaques ondulées",
      "Profilés de rive thermoformés en polycarbonate assurant la continuité transparente en angle",
      "Poteaux HEA 100 galvanisés assurant la structure primaire de la façade wintergarten"
    ]
  },
  {
    "id": "detail-2002-grenoble-02",
    "title": "Toiture et acrotère du wintergarten - Coupe verticale haute",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture isolée sur bac acier avec acrotère et ventilation par clapet motorisé",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "bac acier",
      "trapezblech",
      "isolation rigide",
      "pare-vapeur",
      "étanchéité",
      "clapet ventilation",
      "moteur électrique",
      "polycarbonate",
      "acier galvanisé",
      "HEA120",
      "caillebotis",
      "lacaton vassal",
      "grenoble",
      "toiture plate"
    ],
    "description": "Coupe verticale sur la partie haute du wintergarten montrant la toiture composée d'un bac acier nervuré 70 mm, pare-vapeur, isolation en panneaux de mousse rigide 80 mm et membrane d'étanchéité. La ventilation haute de la serre est assurée par des clapets ouvrants en polycarbonate ondulé sur cadre en cornière acier 50/50/5 mm avec contreventement en tube carré 20/2,3 mm, motorisés par moteur électrique. Un caillebotis acier pressé de 40 mm sert de passerelle technique en partie haute.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Toiture+Wintergarten",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "membrane d'étanchéité",
      "panneau isolant mousse rigide 80 mm",
      "pare-vapeur",
      "bac acier nervuré 70 mm",
      "polycarbonate ondulé 177/51/3 mm",
      "cornière acier 50/50/5 mm",
      "tube acier carré 20/2,3 mm",
      "profilé acier galvanisé HEA 120",
      "caillebotis acier pressé 40 mm",
      "tôle acier galvanisé pliée",
      "moteur électrique"
    ],
    "points_cles": [
      "Complexe de toiture simple : bac acier + pare-vapeur + isolation 80 mm + étanchéité",
      "Ventilation naturelle de la serre par clapets motorisés en polycarbonate ondulé sur cadre acier",
      "Caillebotis acier pressé en passerelle de maintenance en partie haute",
      "Profilés HEA 120 galvanisés comme poutres de rive en tête de façade wintergarten"
    ]
  },
  {
    "id": "detail-2002-grenoble-03",
    "title": "Jonction plancher-façade wintergarten - Interface béton/serre",
    "fabricant": "Detail Magazine",
    "systeme": "Jonction entre squelette béton armé et façade serre avec menuiserie coulissante aluminium",
    "categorie": "jonction_plancher",
    "tags": [
      "jonction",
      "plancher",
      "béton armé",
      "squelette",
      "fenêtre coulissante",
      "aluminium",
      "double vitrage",
      "isolant",
      "wintergarten",
      "serre",
      "chauffage",
      "bac à plantes",
      "IPE140",
      "HEA120",
      "lacaton vassal",
      "grenoble",
      "interface intérieur extérieur"
    ],
    "description": "Détail de la jonction entre le plancher en béton armé du squelette structurel et la façade wintergarten, montrant l'interface entre l'espace intérieur chauffé et la serre tempérée. Des fenêtres coulissantes en aluminium avec double vitrage isolant sont installées en façade du bâtiment principal. La serre est équipée de tuyaux de chauffage et de bacs à plantes posés au sol. Les poutres IPE 140 et HEA 120 galvanisées assurent la liaison structurelle entre la dalle béton et l'ossature acier de la serre.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Jonction+Plancher",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "béton armé (squelette structurel)",
      "profilé acier galvanisé IPE 140",
      "profilé acier galvanisé HEA 120",
      "menuiserie coulissante aluminium",
      "double vitrage isolant",
      "tuyaux de chauffage",
      "bac à plantes",
      "tube acier galvanisé rectangulaire 70/50/4 mm",
      "profilé acier galvanisé HEA 100"
    ],
    "points_cles": [
      "Double enveloppe : menuiserie aluminium isolante côté intérieur + polycarbonate côté extérieur",
      "Espace tampon climatique de la serre avec chauffage intégré par tubes",
      "Poutres acier galvanisé IPE 140 et HEA 120 assurant la transition structurelle béton-acier",
      "Bacs à plantes créant un filtre végétal entre espace de travail et extérieur"
    ]
  },
  {
    "id": "detail-2002-grenoble-04",
    "title": "Principe structurel global - Squelette béton préfabriqué et double peau",
    "fabricant": "Detail Magazine",
    "systeme": "Structure squelette béton armé préfabriqué avec double peau wintergarten",
    "categorie": "structure",
    "tags": [
      "structure",
      "béton armé",
      "préfabriqué",
      "squelette",
      "double peau",
      "wintergarten",
      "passerelle",
      "steg",
      "cour intérieure",
      "deux phases",
      "campus",
      "économique",
      "lacaton vassal",
      "grenoble",
      "polycarbonate",
      "serre bioclimatique"
    ],
    "description": "Le bâtiment universitaire est constitué de deux corps de bâtiment en squelette béton armé préfabriqué séparés de 13 m, reliés par trois passerelles fermées aux étages supérieurs. Des serres étroites (wintergärten) sont ajoutées en façades nord et sud des étages, unifiant l'ensemble en un volume unique sous enveloppe de polycarbonate. La structure préfabriquée économique a permis de dégager des espaces généreux : halls, circulations larges, salles supplémentaires. Les plantes (bougainvilliers au sud, bambous au nord) sont entretenues automatiquement (arrosage, ventilation, chauffage).",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Structure+Globale",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "béton armé préfabriqué",
      "polycarbonate ondulé transparent avec UV",
      "acier galvanisé (HEA, IPE, tubes rectangulaires)",
      "menuiserie aluminium coulissante",
      "double vitrage isolant",
      "isolation mousse rigide 80 mm",
      "bac acier nervuré",
      "tôle acier galvanisé"
    ],
    "points_cles": [
      "Deux bâtiments en squelette béton préfabriqué reliés par passerelles fermées sur cour intérieure",
      "Serres bioclimatiques en polycarbonate formant double peau végétalisée sur façades nord et sud",
      "Stratégie économique : structure simple et détails réduits au profit de la générosité spatiale",
      "Entretien automatisé des serres (arrosage, ventilation, chauffage) selon techniques horticoles professionnelles"
    ]
  },
  {
    "id": "detail-2002-grenoble-01",
    "title": "Façade wintergarten en polycarbonate ondulé - Coupe horizontale",
    "fabricant": "Detail Magazine",
    "systeme": "Façade serre en polycarbonate sur ossature acier galvanisé",
    "categorie": "facade",
    "tags": [
      "polycarbonate",
      "ondulé",
      "serre",
      "wintergarten",
      "façade transparente",
      "acier galvanisé",
      "HEA",
      "UV protection",
      "profil de rive",
      "thermoformé",
      "campus universitaire",
      "Lacaton Vassal",
      "béton préfabriqué",
      "structure poteau-poutre"
    ],
    "description": "Coupe horizontale de la façade wintergarten composée de plaques ondulées en polycarbonate transparent (177/51/3 mm) avec protection UV, fixées sur une sous-construction en tubes d'acier galvanisé rectangulaires (70/50/4 mm). Les angles sont résolus par des profilés de rive en polycarbonate transparent thermoformé. La structure porteuse principale est constituée de poteaux en profilé acier galvanisé HEA 100, positionnés en avant du squelette en béton armé du bâtiment.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Facade+Horizontale",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "polycarbonate ondulé transparent avec UV",
      "profilé de rive polycarbonate thermoformé",
      "tube acier galvanisé RHS 70/50/4 mm",
      "poteau acier galvanisé HEA 100",
      "béton armé préfabriqué"
    ],
    "points_cles": [
      "Plaques ondulées polycarbonate 177/51/3 mm avec couche de protection UV",
      "Profilés de rive en polycarbonate thermoformé assurant l'étanchéité et la continuité visuelle aux angles",
      "Sous-construction légère en tubes acier galvanisé permettant une façade économique et transparente"
    ]
  },
  {
    "id": "detail-2002-grenoble-02",
    "title": "Toiture wintergarten avec clapet d'ouverture motorisé",
    "fabricant": "Detail Magazine",
    "systeme": "Toiture légère isolée avec ventilation motorisée intégrée",
    "categorie": "toiture",
    "tags": [
      "toiture",
      "clapet ventilation",
      "moteur électrique",
      "bac acier",
      "isolation rigide",
      "pare-vapeur",
      "étanchéité",
      "polycarbonate",
      "HEA 120",
      "serre",
      "ventilation automatique",
      "Lacaton Vassal"
    ],
    "description": "Coupe verticale de la toiture du wintergarten associant une couverture isolée classique (bac acier trapézoïdal 70 mm, pare-vapeur, isolation mousse rigide 80 mm, membrane d'étanchéité) et un système de clapet d'ouverture en polycarbonate ondulé monté sur cadre en cornière acier 50/50/5 mm avec contreventement en tube carré 20/2,3 mm. Le clapet est actionné par moteur électrique pour la ventilation automatique de la serre. La structure porteuse est en poutre acier galvanisé HEA 120.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Toiture+Serre",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "membrane d'étanchéité",
      "mousse rigide isolante 80 mm",
      "pare-vapeur",
      "bac acier trapézoïdal 70 mm",
      "polycarbonate ondulé 177/51/3 mm",
      "cornière acier 50/50/5 mm",
      "tube acier carré 20/2,3 mm",
      "poutre acier galvanisé HEA 120",
      "moteur électrique"
    ],
    "points_cles": [
      "Complexe de toiture isolée avec bac acier 70 mm, pare-vapeur, 80 mm d'isolation rigide et étanchéité",
      "Clapet d'ouverture motorisé en polycarbonate ondulé sur cadre acier contreventé pour ventilation automatique de la serre",
      "Gestion climatique automatisée (arrosage, chauffage, ventilation) comparable aux serres professionnelles"
    ]
  },
  {
    "id": "detail-2002-grenoble-03",
    "title": "Jonction plancher béton - façade wintergarten avec menuiserie coulissante",
    "fabricant": "Detail Magazine",
    "systeme": "Jonction entre structure béton préfabriqué et serre avec menuiserie aluminium coulissante",
    "categorie": "jonction_menuiserie",
    "tags": [
      "jonction",
      "plancher béton",
      "menuiserie coulissante",
      "aluminium",
      "double vitrage",
      "isolant",
      "serre",
      "wintergarten",
      "bac jardinière",
      "chauffage",
      "caillebotis acier",
      "IPE 140",
      "Lacaton Vassal",
      "passerelle"
    ],
    "description": "Détail de la jonction entre le plancher en béton armé préfabriqué et l'espace serre en façade. Le raccord est assuré par une fenêtre coulissante en aluminium avec double vitrage isolant, formant la séparation climatique entre l'intérieur chauffé et le wintergarten. Côté serre, un caillebotis en acier pressé (40 mm) sur poutre IPE 140 galvanisé forme le plancher, avec des tôles d'acier galvanisé pliées en habillage. Des jardinières et des tubes de chauffage sont intégrés dans l'espace serre.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Jonction+Menuiserie",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "béton armé préfabriqué",
      "menuiserie aluminium coulissante",
      "double vitrage isolant",
      "caillebotis acier pressé 40 mm",
      "poutre acier galvanisé IPE 140",
      "poutre acier galvanisé HEA 120",
      "tôle acier galvanisé pliée",
      "tubes de chauffage",
      "bac à plantes"
    ],
    "points_cles": [
      "Menuiserie coulissante aluminium avec double vitrage isolant assurant la frontière thermique entre intérieur et serre",
      "Plancher de la serre en caillebotis acier pressé 40 mm sur poutres IPE 140 galvanisé, léger et drainant",
      "Intégration de jardinières et de tubes de chauffage dans l'espace wintergarten pour le maintien des plantes"
    ]
  },
  {
    "id": "detail-2002-grenoble-04",
    "title": "Structure principale - Squelette béton préfabriqué avec façade serre rapportée",
    "fabricant": "Detail Magazine",
    "systeme": "Structure poteau-poutre béton préfabriqué avec enveloppe serre indépendante",
    "categorie": "structure",
    "tags": [
      "béton préfabriqué",
      "squelette",
      "poteau-poutre",
      "structure indépendante",
      "serre rapportée",
      "acier galvanisé",
      "HEA 100",
      "économie",
      "campus",
      "passerelle",
      "cour intérieure",
      "Lacaton Vassal",
      "Grenoble",
      "université"
    ],
    "description": "Le système structurel principal du bâtiment universitaire est un squelette en béton armé préfabriqué simple et économique, composé de poteaux et poutres. Devant ce squelette, sur les façades nord et sud des étages supérieurs, une ossature secondaire indépendante en acier galvanisé (poteaux HEA 100, tubes RHS et poutres HEA 120) porte l'enveloppe des serres en polycarbonate. Deux bâtiments similaires sont reliés par trois passerelles fermées traversant la cour intérieure de 13 m de large.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Grenoble+Structure+Beton",
    "source": "Detail Magazine n12/2002 - Institutsgebäude in Grenoble, Lacaton & Vassal",
    "materiaux": [
      "béton armé préfabriqué",
      "poteau acier galvanisé HEA 100",
      "poutre acier galvanisé HEA 120",
      "tube acier galvanisé RHS 70/50/4 mm",
      "tube acier galvanisé RHS 100/50 mm",
      "polycarbonate ondulé transparent"
    ],
    "points_cles": [
      "Squelette béton préfabriqué simple permettant une économie de construction réinvestie en générosité spatiale",
      "Ossature secondaire acier galvanisé indépendante portant les serres en façade nord et sud",
      "Deux corps de bâtiment reliés par trois passerelles fermées au-dessus d'une cour intérieure de 13 m"
    ]
  },
  {
    "id": "detail-2012-chiba-01",
    "title": "Revêtement mural intérieur/extérieur en cèdre carbonisé (Yakisugi) traité au Bengara",
    "fabricant": "Detail Magazine",
    "systeme": "Bardage bois brûlé Shou Sugi Ban avec traitement aux tanins de kaki et oxyde de fer rouge",
    "categorie": "facade",
    "tags": [
      "yakisugi",
      "cèdre carbonisé",
      "shou sugi ban",
      "bengara",
      "oxyde de fer rouge",
      "persimmon",
      "tanins de kaki",
      "bardage bois brûlé",
      "continuité intérieur extérieur",
      "bois poncé",
      "cedar charred",
      "revêtement mural",
      "japon",
      "traitement naturel bois"
    ],
    "description": "Revêtement mural identique en intérieur et extérieur constitué de cèdre carbonisé puis poncé, traité avec des tanins de kaki (persimmon) contenant du Bengara (oxyde de fer rouge). Ce traitement traditionnel japonais assure une protection naturelle contre les intempéries, les insectes et la pourriture tout en conférant une teinte rouge-brun profonde. L'application uniforme sur les deux faces du mur efface la frontière entre espace intérieur et extérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Facade+Yakisugi",
    "source": "Detail Magazine - Boundary House, Chiba Prefecture, Yasuhiro Yamashita / Atelier Tekuto, 2012",
    "materiaux": [
      "cèdre japonais carbonisé (yakisugi)",
      "tanins de kaki (persimmon)",
      "Bengara (oxyde de fer rouge)",
      "bois poncé"
    ],
    "points_cles": [
      "Technique traditionnelle japonaise de carbonisation superficielle du cèdre suivie d'un ponçage pour révéler la texture du bois",
      "Traitement de surface aux tanins naturels de kaki enrichis en Bengara (oxyde de fer rouge) pour protection et coloration",
      "Continuité totale du parement entre intérieur et extérieur pour effacer la limite architecturale"
    ]
  },
  {
    "id": "detail-2012-chiba-02",
    "title": "Sol en terrazzo poli continu intérieur/extérieur",
    "fabricant": "Detail Magazine",
    "systeme": "Dallage terrazzo poli en continuité intérieur-extérieur",
    "categorie": "jonction_plancher",
    "tags": [
      "terrazzo",
      "terrazzo poli",
      "sol continu",
      "continuité intérieur extérieur",
      "plancher",
      "dallage",
      "transition intérieur extérieur",
      "seuil",
      "sol sans rupture",
      "japon",
      "ground floor"
    ],
    "description": "Sol en terrazzo poli sans rupture entre les espaces intérieurs et extérieurs, assurant une continuité visuelle et matérielle totale au niveau du plan horizontal. Ce traitement uniforme du sol participe à l'effacement de la frontière entre dedans et dehors, caractéristique centrale du projet. Le terrazzo poli offre une résistance aux intempéries en extérieur tout en conservant un aspect raffiné en intérieur.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Sol+Terrazzo",
    "source": "Detail Magazine - Boundary House, Chiba Prefecture, Yasuhiro Yamashita / Atelier Tekuto, 2012",
    "materiaux": [
      "terrazzo poli",
      "granulats de pierre",
      "liant cimentaire"
    ],
    "points_cles": [
      "Continuité absolue du sol terrazzo poli entre intérieur et extérieur sans seuil ni changement de matériau",
      "Ponçage et polissage du terrazzo pour obtenir une surface lisse et homogène sur l'ensemble du projet",
      "Résistance aux conditions extérieures (gel, pluie, UV) tout en maintenant une qualité de finition intérieure"
    ]
  },
  {
    "id": "detail-2012-chiba-03",
    "title": "Lanterneaux zénithaux vitrés et ouverts sur le ciel",
    "fabricant": "Detail Magazine",
    "systeme": "Système de 16 lanterneaux mixtes - vitrés et ouverts aux éléments",
    "categorie": "toiture",
    "tags": [
      "lanterneau",
      "oberlichter",
      "skylight",
      "puits de lumière",
      "toiture ouverte",
      "zénithal",
      "ouverture toiture",
      "lumière naturelle",
      "ventilation naturelle",
      "patio",
      "labyrinthe",
      "japon",
      "éléments naturels",
      "pluie intérieure"
    ],
    "description": "Système de 16 ouvertures zénithales réparties dans la toiture selon une organisation labyrinthique, dont certaines sont vitrées pour l'apport de lumière naturelle et d'autres volontairement laissées ouvertes aux éléments (pluie, vent, lumière directe). Ce dispositif radical brouille la perception traditionnelle de l'abri en introduisant les phénomènes météorologiques à l'intérieur de l'habitat, renforçant la fusion entre architecture et nature.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Toiture+Lanterneaux",
    "source": "Detail Magazine - Boundary House, Chiba Prefecture, Yasuhiro Yamashita / Atelier Tekuto, 2012",
    "materiaux": [
      "vitrage pour lanterneaux fermés",
      "cadre structurel de lanterneau",
      "étanchéité de toiture",
      "évacuation des eaux pluviales intérieures"
    ],
    "points_cles": [
      "16 lanterneaux répartis dans le plan labyrinthique dont certains vitrés et d'autres ouverts aux intempéries",
      "Les ouvertures non vitrées laissent pénétrer la pluie et le vent, nécessitant un système de drainage au sol en terrazzo poli",
      "Conception inspirée de structures de type tente permettant une immersion dans la nature depuis l'intérieur"
    ]
  },
  {
    "id": "detail-2012-chiba-04",
    "title": "Organisation spatiale labyrinthique - jonction mur/sol à la limite intérieur-extérieur",
    "fabricant": "Detail Magazine",
    "systeme": "Système de parois labyrinthiques avec continuité matérielle au seuil intérieur-extérieur",
    "categorie": "jonction_menuiserie",
    "tags": [
      "seuil",
      "transition intérieur extérieur",
      "labyrinthe",
      "paroi continue",
      "limite architecturale",
      "boundary",
      "frontière",
      "jonction mur sol",
      "ouverture sans cadre",
      "cadre minimal",
      "japon",
      "fluidité spatiale",
      "tente"
    ],
    "description": "Système de jonctions entre parois et ouvertures conçu pour minimiser toute démarcation entre intérieur et extérieur dans un plan labyrinthique. Les murs revêtus de cèdre carbonisé et les sols en terrazzo poli se prolongent sans interruption à travers les seuils, tandis que les ouvertures sont traitées avec un cadre minimal ou absent pour permettre une circulation fluide entre les espaces couverts et découverts.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Chiba+Jonction+Seuil",
    "source": "Detail Magazine - Boundary House, Chiba Prefecture, Yasuhiro Yamashita / Atelier Tekuto, 2012",
    "materiaux": [
      "cèdre carbonisé traité au Bengara",
      "terrazzo poli",
      "profilés de seuil minimalistes",
      "vitrage"
    ],
    "points_cles": [
      "Jonctions mur-sol traitées en continuité matérielle totale pour effacer la notion de seuil entre intérieur et extérieur",
      "Plan labyrinthique permettant une interpénétration progressive des espaces couverts, semi-couverts et ouverts",
      "Cinq éléments de conception combinés (plan labyrinthique, lanterneaux, plantes identiques, bardage continu, sol continu) pour dissoudre la frontière architecturale"
    ]
  },
  {
    "id": "detail-2000-copenhague-01",
    "title": "Facade en cuivre pre-patine sur structure de bureaux",
    "fabricant": "Detail Magazine",
    "systeme": "Bardage cuivre pre-patine sur ossature",
    "categorie": "facade",
    "tags": [
      "cuivre",
      "pre-patine",
      "bardage metallique",
      "facade bureaux",
      "Copenhague",
      "immeuble de bureaux",
      "facade opaque",
      "contraste verre cuivre"
    ],
    "description": "Facade de bureaux habillée de panneaux de cuivre pre-patine, creant un contraste saisissant avec les surfaces vitrees adjacentes. Le cuivre pre-patine assure une esthetique uniforme des la livraison et une durabilite face au climat maritime de Copenhague. Le jeu entre les parties opaques en cuivre et les parties transparentes en verre offre une alternance de lumiere chaude et froide, particulierement visible de nuit.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Facade+Cuivre",
    "source": "Detail Magazine n8/2000 - Verwaltungsbau Kopenhagen, Henning Larsens Tegnestue",
    "materiaux": [
      "cuivre pre-patine",
      "verre",
      "ossature metallique"
    ],
    "points_cles": [
      "Cuivre pre-patine pour eviter l'evolution chromatique apres pose",
      "Contraste materiaux opaques et transparents en facade",
      "Adaptation au climat maritime danois"
    ]
  },
  {
    "id": "detail-2000-copenhague-02",
    "title": "Facade de lamelles de verre fixes - orientation ouest",
    "fabricant": "Detail Magazine",
    "systeme": "Brise-soleil en lamelles de verre fixes",
    "categorie": "facade",
    "tags": [
      "lamelles verre",
      "brise-soleil",
      "protection solaire",
      "facade ouest",
      "verre fixe",
      "lamelles fixes",
      "double peau",
      "bureaux"
    ],
    "description": "Sur la facade ouest du complexe, des lamelles de verre fixes sont disposees devant le vitrage principal, creant une enveloppe finement articulee. Ce dispositif assure une protection solaire passive contre le rayonnement de l'apres-midi tout en preservant la transparence et la legerete de la facade. La superposition des couches de verre genere un effet de profondeur et de finesse dans le traitement architectural.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Lamelles+Verre",
    "source": "Detail Magazine n8/2000 - Verwaltungsbau Kopenhagen, Henning Larsens Tegnestue",
    "materiaux": [
      "lamelles de verre",
      "fixations metalliques",
      "vitrage"
    ],
    "points_cles": [
      "Lamelles de verre fixes en protection solaire ouest",
      "Articulation fine de la facade par superposition de couches",
      "Maintien de la transparence malgre la protection solaire"
    ]
  },
  {
    "id": "detail-2000-copenhague-03",
    "title": "Facade en pierre naturelle - front urbain residentiel",
    "fabricant": "Detail Magazine",
    "systeme": "Revetement en pierre naturelle sur facade residentielle",
    "categorie": "facade",
    "tags": [
      "pierre naturelle",
      "facade residentielle",
      "front urbain",
      "alignement rue",
      "logements",
      "Copenhague",
      "parement pierre"
    ],
    "description": "Les facades des logements situes cote ville sont revetues de pierre naturelle, assurant la continuite du front bati urbain tout en menageant des percees visuelles vers le port et l'eau. Ce traitement en pierre confere une massivite et une noblesse appropriees au contexte urbain existant, en contraste avec les facades en cuivre et verre des corps de bureaux orientes vers l'eau.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Facade+Pierre",
    "source": "Detail Magazine n8/2000 - Verwaltungsbau Kopenhagen, Henning Larsens Tegnestue",
    "materiaux": [
      "pierre naturelle",
      "structure beton",
      "isolant"
    ],
    "points_cles": [
      "Parement en pierre naturelle pour integration au contexte urbain",
      "Maintien de l'alignement de rue avec percees visuelles vers le port",
      "Differenciation materielle entre programme bureaux et logements"
    ]
  },
  {
    "id": "detail-2000-copenhague-04",
    "title": "Passerelles en bois sur bassins d'eau entre batiments",
    "fabricant": "Detail Magazine",
    "systeme": "Passerelles bois sur miroirs d'eau",
    "categorie": "amenagement_interieur",
    "tags": [
      "passerelle bois",
      "bassin eau",
      "amenagement exterieur",
      "espace public",
      "platelage bois",
      "miroir eau",
      "entre batiments",
      "cheminement pieton"
    ],
    "description": "Entre les corps de batiments en peigne, des bassins d'eau alternent avec des voies d'acces carrossables, relies par des passerelles en bois formant des cheminements pietons. Ces steg en bois enjambent les plans d'eau et creent des espaces de promenade accessibles y compris le week-end, contribuant a la qualite de l'espace public du quartier portuaire reconverti.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Copenhague+Passerelle+Bois",
    "source": "Detail Magazine n8/2000 - Verwaltungsbau Kopenhagen, Henning Larsens Tegnestue",
    "materiaux": [
      "bois",
      "acier",
      "eau"
    ],
    "points_cles": [
      "Passerelles bois enjambant des bassins entre les batiments en peigne",
      "Alternance de voies carrossables et de plans d'eau dans les entre-corps",
      "Creation d'espaces publics de promenade dans un site portuaire reconverti"
    ]
  },
  {
    "id": "detail-2011-frankfurt-01",
    "title": "Double façade ventilée par pression de vent avec structure en écailles de verre",
    "fabricant": "Detail Magazine",
    "systeme": "Double façade ventilée naturellement par effet aérodynamique (pression/succion du vent)",
    "categorie": "facade",
    "tags": [
      "double facade",
      "ventilation naturelle",
      "pression vent",
      "écailles verre",
      "clapets ventilation",
      "aérodynamique",
      "tour keilform",
      "verre coloré",
      "façade transparente",
      "leeseite",
      "winddruck",
      "hochhaus",
      "bureaux",
      "KfW",
      "Sauerbruch Hutton",
      "Transsolar",
      "Werner Sobek",
      "Frankfurt"
    ],
    "description": "Double façade innovante dont le cavity est ventilé non pas par effet cheminée ascendant classique mais par la pression et la dépression du vent exploitant la forme en coin (Keilform) du bâtiment orienté face au vent d'ouest dominant. La peau extérieure est constituée d'écailles de verre transparent et de clapets de ventilation étroits ouvrants, avec un code couleur contextuel (rouge côté ville, vert côté Palmengarten, bleu-gris côté bâtiment principal KfW). Selon l'angle de vue, la façade apparaît soit comme un mur polychrome quasi fermé, soit totalement transparente.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Frankfurt+DoubleFacade",
    "source": "Detail Magazine (Detail Green) n1/2011 - Westarkade KfW Frankfurt, Sauerbruch Hutton",
    "materiaux": [
      "verre transparent écailles",
      "clapets ventilation ouvrants",
      "verre coloré rouge vert bleu gris",
      "structure acier façade",
      "profilés aluminium"
    ],
    "points_cles": [
      "Ventilation de la cavité par pression et dépression du vent latéral et non par effet cheminée vertical",
      "Forme aérodynamique en coin du bâtiment exploitée pour créer les différentiels de pression nécessaires",
      "Structure en écailles (Schuppenstruktur) alternant panneaux de verre fixes et clapets ouvrants commandés",
      "Codage chromatique contextuel de la façade selon l'orientation vers la ville, le jardin ou le bâtiment voisin"
    ]
  },
  {
    "id": "detail-2011-frankfurt-02",
    "title": "Plancher technique sur dalle béton activée thermiquement avec double plancher",
    "fabricant": "Detail Magazine",
    "systeme": "Dalle béton à activation thermique (Bauteilaktivierung) combinée à un plancher surélevé technique",
    "categorie": "jonction_plancher",
    "tags": [
      "bauteilaktivierung",
      "activation thermique",
      "dalle béton",
      "plancher surélevé",
      "double plancher",
      "Doppelboden",
      "convecteur sol",
      "chauffage",
      "refroidissement",
      "masse thermique",
      "ringleitung",
      "béton apparent",
      "acoustique",
      "moquette",
      "bureaux tour",
      "Frankfurt",
      "KfW"
    ],
    "description": "Dalles plates en béton armé laissées brutes en sous-face pour servir de masse thermique et intégrant un système d'activation thermique (tubes d'eau dans la dalle) assurant chauffage et rafraîchissement dans toutes les zones y compris les circulations. Un plancher surélevé (Doppelboden) distribue les réseaux annulaires chaud et froid ainsi que l'air neuf jusqu'à des convecteurs intégrés au sol en périphérie de façade, qui assurent à la fois la diffusion d'air et un appoint thermique individualisé par bureau.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Frankfurt+PlancherActive",
    "source": "Detail Magazine (Detail Green) n1/2011 - Westarkade KfW Frankfurt, Sauerbruch Hutton",
    "materiaux": [
      "béton armé dalle plate",
      "tubes activation thermique dans dalle",
      "plancher surélevé modulaire",
      "convecteurs encastrés sol",
      "moquette acoustique orange-rouge",
      "réseaux annulaires chaud-froid"
    ],
    "points_cles": [
      "Dalle béton brute en sous-face exploitée comme masse thermique de stockage et surface de rayonnement",
      "Activation thermique intégrée dans les dalles béton pour chauffage et rafraîchissement radiant de tous les espaces",
      "Double plancher technique distribuant air neuf, réseaux chaud et froid vers convecteurs de sol en façade",
      "Absorption acoustique assurée par la moquette seule dans les bureaux, dalles béton apparentes non habillées"
    ]
  },
  {
    "id": "detail-2011-frankfurt-03",
    "title": "Ventilation hybride naturelle et mécanique avec registre géothermique",
    "fabricant": "Detail Magazine",
    "systeme": "Ventilation hybride combinant ventilation naturelle traversante et CTA avec puits canadien (Erdregister)",
    "categorie": "amenagement_interieur",
    "tags": [
      "ventilation hybride",
      "ventilation naturelle",
      "puits canadien",
      "Erdregister",
      "géothermie",
      "préchauffage air",
      "tirage naturel",
      "conduits verticaux",
      "extraction toiture",
      "transfert acoustique",
      "cloisons bureau",
      "brandschutzabschnitt",
      "triple secteur coupe-feu",
      "désenfumage",
      "KfW",
      "Frankfurt",
      "Transsolar"
    ],
    "description": "Système de ventilation hybride à double mode. En mode naturel, l'air frais entre par les fenêtres ouvrantes de la double façade, traverse les bureaux puis passe par des éléments de transfert acoustique intégrés aux cloisons vers les circulations et le noyau central, où il est évacué par tirage naturel dans des conduits verticaux débouchant en toiture. En mode mécanique, un registre géothermique (puits canadien) implanté dans la cour intérieure pré-tempère l'air neuf qui est ensuite distribué par des gaines montantes séparées (une par secteur coupe-feu) vers le plancher surélevé des bureaux.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Frankfurt+VentilationHybride",
    "source": "Detail Magazine (Detail Green) n1/2011 - Westarkade KfW Frankfurt, Sauerbruch Hutton",
    "materiaux": [
      "registre géothermique enterré",
      "conduits verticaux béton tirage naturel",
      "gaines montantes acier séparées par secteur",
      "éléments de transfert acoustique en cloisons",
      "grilles de soufflage plancher surélevé"
    ],
    "points_cles": [
      "Double mode ventilation naturelle par fenêtres et mécanique par CTA avec puits canadien pour pré-tempérer l'air",
      "Extraction naturelle par tirage thermique dans des conduits verticaux du noyau central débouchant en toiture",
      "Trois secteurs coupe-feu indépendants par étage, chacun alimenté par sa propre gaine montante de ventilation",
      "Registre géothermique (Erdregister) dans la cour intérieure assurant le pré-conditionnement thermique de l'air neuf"
    ]
  },
  {
    "id": "detail-2011-frankfurt-04",
    "title": "Structure béton armé avec noyau triangulaire de contreventement et dalles plates",
    "fabricant": "Detail Magazine",
    "systeme": "Ossature poteaux-dalles béton armé avec noyau central triangulaire de contreventement",
    "categorie": "structure",
    "tags": [
      "structure béton armé",
      "squelette béton",
      "Stahlbeton-Skelettbauweise",
      "noyau triangulaire",
      "contreventement",
      "dalle plate",
      "Flachdecke",
      "tour 14 étages",
      "56 mètres",
      "socle 4 étages",
      "infrastructure parking",
      "datacenter",
      "fondations profondes",
      "plan triangulaire",
      "Frankfurt",
      "KfW",
      "Sauerbruch Hutton"
    ],
    "description": "Construction en ossature squelette béton armé (Stahlbeton-Skelettbauweise) avec dalles plates (Flachdecken) permettant à la fois l'intégration de l'activation thermique et l'exploitation de la masse structurelle comme stockage thermique. La tour de 14 étages et 56 m de hauteur est contreventée par son noyau central de plan triangulaire abritant ascenseurs, escaliers de secours et locaux annexes. L'ensemble repose sur une infrastructure de 4 niveaux enterrés servant de parking (200 places accessibles au public le soir et le week-end) et de centre de données.",
    "thumbnail": "https://placehold.co/400x300/1a1a1a/666666?text=Detail+Frankfurt+StructureBeton",
    "source": "Detail Magazine (Detail Green) n1/2011 - Westarkade KfW Frankfurt, Sauerbruch Hutton",
    "materiaux": [
      "béton armé poteaux",
      "béton armé dalles plates",
      "béton armé noyau voiles triangulaire",
      "béton armé infrastructure 4 niveaux",
      "pierre naturelle sol RDC"
    ],
    "points_cles": [
      "Ossature squelette béton armé avec dalles plates optimisées pour l'activation thermique intégrée",
      "Noyau de contreventement de géométrie triangulaire concentrant circulations verticales et locaux techniques",
      "Infrastructure de 4 niveaux enterrés mutualisée entre tour et socle pour parking public et datacenter",
      "Plan triangulaire permettant 630 à 720 m² de bureaux par étage avec bureaux en périphérie et vues aux angles"
    ]
  }
];

// ─── Appel Claude Vision ─────────────────────────────────────────────────────
async function analyzeSketchWithClaude(imagesData, contextText, mode = "trouver") {

  // ── Prompt TROUVER ────────────────────────────────────────────────────────
  // Adapter le prompt selon l'échelle
  const isEarlyStage = contextText && (contextText.includes("1/500") || contextText.includes("1/200"));
  const isMidStage = contextText && (contextText.includes("1/100") || contextText.includes("1/50"));

  const systemFind = isEarlyStage
    ? `Tu es un expert en architecture et conception. Tu analyses des esquisses à grande échelle (1/500, 1/200).
Si l'image n'est pas un dessin ou document architectural, réponds UNIQUEMENT avec ce JSON : {"not_architecture": true, "message": "une réponse courte et drôle"}.
Si l'architecte demande un schéma ou dessin de principe (dessine, schéma, principe, draw, diagram), ajoute "request_diagram": true et décris le noeud dans "diagram_description" sans marque ni produit.
Si l'architecte pose une question, réponds-y dans 'recommandation'. Cite des projets réels. Pas de DTU, pas de fabricants.
Réponds UNIQUEMENT en JSON valide, sans markdown ni backticks ni commentaires.`
    : isMidStage
      ? `Tu es un expert en construction. Tu analyses des plans à l'échelle intermédiaire (1/100, 1/50).
Si l'image n'est pas un dessin ou document architectural, réponds UNIQUEMENT avec ce JSON : {"not_architecture": true, "message": "une réponse courte et drôle"}.
Si l'architecte demande un schéma de principe (dessine, schéma, principe, draw, diagram), ajoute "request_diagram": true et "diagram_description" (couches, ordre, contraintes — sans marque).
L'architecte définit ses systèmes constructifs et ses interfaces critiques.
Cite quelques règles clés adaptées : pont thermique RE2020 (Bbio), continuité de l'isolation, règles de relevé (DTU 20.12, DTU 43), calfeutrement des menuiseries, ventilation des lames d'air (DTU 31.2).
Références de projets similaires bienvenues à ce stade.
Réponds UNIQUEMENT en JSON valide, sans markdown ni backticks ni commentaires.`
      : `Tu es un expert en détails constructifs et en réglementation française.
Tu analyses des dessins de détail (1/20, 1/10) pour identifier les interfaces critiques.
Si l'image n'est pas un dessin ou document architectural, réponds UNIQUEMENT avec ce JSON : {"not_architecture": true, "message": "une réponse courte et drôle qui reconnaît ce que c'est vraiment"}.
L'architecte a posé une question spécifique — réponds directement à sa question en priorité.
Cite les DTU applicables (DTU 20.12, DTU 31.2, DTU 40.35, DTU 43.1...), les règles d'épaisseur, les tolérances d'exécution et les erreurs fréquentes à ce stade.
Réponds UNIQUEMENT en JSON valide, sans markdown ni backticks ni commentaires.`;

  const userFind = isEarlyStage
    ? `Analyse cette esquisse architecturale à grande échelle${contextText ? ` avec ce contexte : "${contextText}"` : ""}.

À ce stade (1/500 ou 1/200), identifie les grandes intentions constructives et les systèmes possibles.
Oriente vers des références de projets inspirants, pas vers des détails techniques.

Réponds avec ce JSON exact et uniquement ce JSON :
{
  "noeuds_identifies": [
    {
      "label": "intention constructive — ex : Façade légère vitrée",
      "description": "description de l'intention en une phrase, avec exemples de projets de référence",
      "position": "haut-gauche ou haut-centre ou haut-droite ou centre-gauche ou centre ou centre-droite ou bas-gauche ou bas-centre ou bas-droite"
    }
  ],
  "keywords": ["mots-clés pour références de projets : façade vitrée, toiture végétalisée, ossature bois, etc."],
  "type_document": "plan ou coupe ou esquisse masse",
  "systeme_constructif": "description générale du système envisagé",
  "recommandation": "réponse directe à la question posée si présente, sinon piste principale à explorer",
  "reponse_technique": "Réponse directe à la question de l'architecte — références de projets, approches constructives, pistes à explorer. 3-5 phrases.",
  "anecdote": "Une anecdote vraie et courte (2-3 phrases max) sur un bâtiment ou un architecte en lien avec le système ou la question. Surprenante, concrète."
}`
    : isMidStage
      ? `Analyse cette esquisse architecturale à l'échelle intermédiaire${contextText ? ` avec ce contexte : "${contextText}"` : ""}.

Identifie les interfaces constructives critiques (toiture/façade, plancher/façade, soubassement, menuiseries).
Pour chaque interface, indique sa position approximative dans l'image.

Réponds avec ce JSON exact et uniquement ce JSON :
{
  "noeuds_identifies": [
    {
      "label": "nom de l'interface — ex : Jonction toiture-façade",
      "description": "description du système et points d'attention à cette échelle",
      "position": "haut-gauche ou haut-centre ou haut-droite ou centre-gauche ou centre ou centre-droite ou bas-gauche ou bas-centre ou bas-droite"
    }
  ],
  "keywords": ["mots-clés pour recherche de références : systèmes constructifs, matériaux, interfaces"],
  "type_document": "plan ou coupe ou élévation",
  "systeme_constructif": "description du système constructif général",
  "recommandation": "réponse directe à la question posée si présente, sinon priorité principale à ce stade",
  "questions": [
    "Question 1 sur la continuité de l'isolation thermique ou le traitement des ponts thermiques",
    "Question 2 sur le système d'étanchéité à l'air ou à l'eau à définir",
    "Question 3 sur la compatibilité entre les systèmes ou les interfaces critiques"
  ],
  "anecdote": "Une anecdote vraie et courte (2-3 phrases max) sur un bâtiment, un architecte ou un chantier en lien avec la question ou le système. Surprenante, concrète.",
  "reponse_technique": "Réponse directe et précise à la question — règles, DTU applicables, points d'attention. 3-5 phrases."
}`
      : `Analyse cette esquisse architecturale${contextText ? ` avec ce contexte : "${contextText}"` : ""}.

Identifie les nœuds constructifs visibles ou implicites (jonctions mur/plancher, menuiseries, toiture, façade, soubassement, étanchéité, etc.).
Pour chaque nœud, indique sa position approximative dans l'image.

Réponds avec ce JSON exact et uniquement ce JSON :
{
  "noeuds_identifies": [
    {
      "label": "nom court du nœud — ex : Acrotère toiture",
      "description": "description technique en une phrase",
      "position": "haut-gauche ou haut-centre ou haut-droite ou centre-gauche ou centre ou centre-droite ou bas-gauche ou bas-centre ou bas-droite"
    }
  ],
  "keywords": ["mots-clés techniques pour recherche : façade, toiture, fenêtre, ITE, cloison, acrotère, soubassement, étanchéité, etc."],
  "type_document": "plan ou coupe ou detail ou esquisse",
  "systeme_constructif": "description courte du système visible",
  "recommandation": "réponse directe à la question posée si présente, sinon priorité de détail principale",
  "questions": [
    "Question 1 sur la continuité constructive ou le traitement d'une interface critique visible",
    "Question 2 sur un DTU, une règle de l'art ou une prescription fabricant à anticiper",
    "Question 3 sur un risque chantier ou un point de vigilance à ce stade"
  ],
  "anecdote": "Une anecdote vraie et courte (2-3 phrases max) sur un bâtiment, un chantier, un architecte ou un matériau en lien direct avec la question ou le nœud. Surprenante, mémorable.",
  "reponse_technique": "Réponse directe et précise à la question — DTU applicables, règles dimensionnelles, points de vigilance chantier. 3-5 phrases."
}`;

  // ── Prompt RÉSOUDRE ───────────────────────────────────────────────────────
  const systemResoudre = `Tu es un expert en construction et détails architecturaux, spécialisé dans la résolution de problèmes constructifs complexes.
Tu maîtrises les Standards français, la RE2020, les règles de l'art, et les systèmes fabricants (Knauf, Weber, Soprema, etc.).
Tu proposes des solutions précises, dimensionnées, conformes aux normes françaises.
Zones climatiques : H1 (Nord, Est, Massif Central, Alpes), H2 (Centre, Ouest, façade Atlantique), H3 (Méditerranée, DOM-TOM).
Réponds UNIQUEMENT en JSON valide, sans markdown ni backticks ni commentaires.`;

  const userResoudre = `Un architecte te soumet un problème constructif avec cette image et ce contexte :
${contextText || "Pas de contexte fourni — analyse l'image pour déduire le problème."}

Propose 3 variantes de solutions constructives avec leurs compromis. Chaque variante doit être réellement différente — pas juste des variantes de matériaux mais des approches constructives distinctes.

Réponds avec ce JSON exact et uniquement ce JSON :
{
  "noeuds_identifies": ["points critiques du problème identifiés dans l'image, max 4 items"],
  "keywords": ["mots-clés techniques pour recherche de détails similaires"],
  "type_document": "plan ou coupe ou detail ou esquisse",
  "systeme_constructif": "description du système constructif visible dans l'image",
  "variantes": [
    {
      "numero": 1,
      "titre": "titre court de la variante — ex : Console métallique ancrée",
      "principe": "description du principe constructif en 2-3 phrases",
      "avantages": ["avantage 1", "avantage 2"],
      "inconvenients": ["inconvénient 1", "inconvénient 2"],
      "materiaux": ["matériau 1 avec référence fabricant si applicable", "matériau 2"],
      "dimensions_cles": ["dimension clé 1", "dimension clé 2"],
      "dtu_applicables": ["Standards applicable"],
      "points_attention": ["point critique 1"]
    },
    {
      "numero": 2,
      "titre": "titre court de la variante",
      "principe": "description du principe constructif en 2-3 phrases",
      "avantages": ["avantage 1", "avantage 2"],
      "inconvenients": ["inconvénient 1", "inconvénient 2"],
      "materiaux": ["matériau 1", "matériau 2"],
      "dimensions_cles": ["dimension clé 1"],
      "dtu_applicables": ["Standards applicable"],
      "points_attention": ["point critique 1"]
    },
    {
      "numero": 3,
      "titre": "titre court de la variante",
      "principe": "description du principe constructif en 2-3 phrases",
      "avantages": ["avantage 1", "avantage 2"],
      "inconvenients": ["inconvénient 1", "inconvénient 2"],
      "materiaux": ["matériau 1", "matériau 2"],
      "dimensions_cles": ["dimension clé 1"],
      "dtu_applicables": ["Standards applicable"],
      "points_attention": ["point critique 1"]
    }
  ],
  "recommandation": "une phrase de synthèse sur la variante recommandée et pourquoi"
}`;

  const isResoudre = mode === "resoudre";

  // Construire le contenu avec toutes les images
  const imageBlocks = imagesData.map(({ base64, mediaType }) => ({
    type: "image",
    source: { type: "base64", media_type: mediaType, data: base64 },
  }));

  const response = await fetch("/api/analyze", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      model: "claude-sonnet-4-20250514",
      max_tokens: 2500,
      system: isResoudre ? systemResoudre : systemFind,
      messages: [
        {
          role: "user",
          content: [
            ...imageBlocks,
            { type: "text", text: isResoudre ? userResoudre : userFind },
          ],
        },
      ],
    }),
  });

  if (!response.ok) {
    throw new Error(`API error: ${response.status}`);
  }

  const data = await response.json();
  const text = data.content?.[0]?.text || "{}";
  try {
    const clean = text.replace(/```json|```/g, "").trim();
    const parsed = JSON.parse(clean);
    return parsed;
  } catch {
    return {
      keywords: [],
      noeuds_identifies: ["Analyse partiellement disponible"],
      type_document: "esquisse",
      systeme_constructif: "Non déterminé",
      recommandation: "Vérifiez la qualité de l'image uploadée.",
    };
  }
}

// ─── Matching par mots-clés IA ───────────────────────────────────────────────
function matchDetailsByAI(aiAnalysis) {
  const keywords = [
    ...(aiAnalysis.keywords || []),
    ...(aiAnalysis.noeuds_identifies || []),
    aiAnalysis.systeme_constructif || "",
  ].join(" ").toLowerCase();

  const scored = DETAILS_LIBRARY.map((detail) => {
    let score = 0;
    detail.tags.forEach((tag) => {
      if (keywords.includes(tag.toLowerCase())) score += 3;
    });
    if (keywords.includes(detail.categorie.replace("_", " ").toLowerCase())) score += 4;
    return { ...detail, score };
  });

  // Priorité aux détails avec vraie image, sinon fallback sur tous
  const withImage = scored.filter(d => !d.thumbnail?.includes("placehold.co"));
  const pool = withImage.length >= 3 ? withImage : scored;
  return pool.sort((a, b) => b.score - a.score).slice(0, 3);
}

// ─── Conversion image ────────────────────────────────────────────────────────
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

// ─── Badge fabricant ─────────────────────────────────────────────────────────
function Badge({ children }) {
  const styles = {
    knauf: { background: "#172554", color: "#93c5fd" },
    weber: { background: "#451a03", color: "#fcd34d" },
    soprema: { background: "#052e16", color: "#6ee7b7" },
  };
  const s = styles[children?.toLowerCase()] || { background: "#f5f4f2", color: "#0c0a09" };
  return (
    <span style={{ ...s, fontSize: "10px", padding: "2px 8px", borderRadius: "3px", whiteSpace: "nowrap" }}>
      {children}
    </span>
  );
}

// ─── Carte détail ─────────────────────────────────────────────────────────────
// ─── Storage REX ─────────────────────────────────────────────────────────────
const REX_KEY = "axone_rex";
const REX_COMM_KEY = "axone_rex_comm";

// REX privés agence
function getRex() {
  try { return JSON.parse(localStorage.getItem(REX_KEY) || "{}"); }
  catch { return {}; }
}

function saveRex(detailId, rex) {
  const all = getRex();
  if (!all[detailId]) all[detailId] = [];
  const entry = { ...rex, date: new Date().toISOString(), id: Date.now() };
  all[detailId].push(entry);
  localStorage.setItem(REX_KEY, JSON.stringify(all));
  if (rex.rendre_public) saveRexComm(detailId, entry);
}

function deleteRex(detailId, rexId) {
  const all = getRex();
  if (all[detailId]) {
    all[detailId] = all[detailId].filter(m => m.id !== rexId);
    if (all[detailId].length === 0) delete all[detailId];
  }
  localStorage.setItem(REX_KEY, JSON.stringify(all));
}

// REX communautaires anonymisés
function getRexComm() {
  try { return JSON.parse(localStorage.getItem(REX_COMM_KEY) || "[]"); }
  catch { return []; }
}

function saveRexComm(detailId, rex) {
  const all = getRexComm();
  all.push({
    detailId,
    categorie_rex: rex.categorie_rex,
    description: rex.description,
    severite: rex.severite,
    date: new Date().toISOString(),
    id: Date.now() + Math.random(),
  });
  localStorage.setItem(REX_COMM_KEY, JSON.stringify(all));
}

function getRexCommPourDetail(detailId, categorie) {
  return getRexComm().filter(r =>
    r.detailId === detailId ||
    DETAILS_LIBRARY.find(d => d.id === r.detailId)?.categorie === categorie
  );
}

function getAlertLevel(detailId, categorie) {
  const all = getRex();
  const comm = getRexCommPourDetail(detailId, categorie);
  if (all[detailId]?.length > 0) return "rouge";   // REX privé exact
  if (comm.length > 0) return "orange";             // REX communautaire
  const sameCateg = Object.entries(all).some(([id, list]) => {
    const d = DETAILS_LIBRARY.find(x => x.id === id);
    return d?.categorie === categorie && list.length > 0;
  });
  if (sameCateg) return "jaune";                    // REX privé même catégorie
  return null;
}

// ─── Formulaire REX ──────────────────────────────────────────────────────
function FormRex({ detailId, onSave, onCancel }) {
  const [form, setForm] = useState({
    projet: "", categorie_rex: "", description: "", severite: "majeur", rendre_public: false
  });

  const categories = [
    "Site — execution non-conformity",
    "Specification — undersized detail",
    "Product — failing manufacturer reference",
    "Leak — infiltration / waterproofing",
    "Thermal — thermal bridge / condensation",
    "Maintenance — difficult access / premature wear",
    "Sizing — dimension non-compliant with standards",
    "Other",
  ];

  const inputS = {
    width: "100%", background: "#fafaf9", border: "1px solid #d6d3cf",
    borderRadius: "3px", padding: "7px 10px", fontSize: "10px",
    color: "#0c0a09", fontFamily: "inherit",
  };

  return (
    <div style={{ padding: "14px 16px", background: "#fafaf9", borderTop: "1px solid #e5e2de" }}>
      <p style={{ fontSize: "9px", color: "#dc2626", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "12px" }}>
        Share feedback
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <input value={form.projet} onChange={e => setForm({ ...form, projet: e.target.value })}
          placeholder="Project — e.g. Riverside Apartments 2023"
          style={inputS} onFocus={e => e.target.style.borderColor = "#dc2626"} onBlur={e => e.target.style.borderColor = "#292524"} />
        <select value={form.categorie_rex} onChange={e => setForm({ ...form, categorie_rex: e.target.value })}
          style={{ ...inputS, color: form.categorie_rex ? "#e7e5e4" : "#57534e" }}>
          <option value="">REX type</option>
          {categories.map(c => <option key={c} value={c}>{c}</option>)}
        </select>
        <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
          placeholder="Problem description — what happened concretely..."
          style={{ ...inputS, minHeight: "60px", lineHeight: 1.7, resize: "vertical" }}
          onFocus={e => e.target.style.borderColor = "#dc2626"} onBlur={e => e.target.style.borderColor = "#292524"} />
        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <select value={form.severite} onChange={e => setForm({ ...form, severite: e.target.value })}
            style={{ ...inputS, width: "auto", flex: 1 }}>
            <option value="mineur">Minor — slight issue</option>
            <option value="majeur">Major — rework required</option>
            <option value="critique">Critical — incident / liability</option>
          </select>
          <button onClick={() => { if (form.projet && form.description) { saveRex(detailId, form); onSave(); } }}
            style={{ padding: "7px 16px", background: "#dc2626", color: "#fff", border: "none", borderRadius: "3px", fontSize: "10px", fontFamily: "inherit", cursor: "pointer" }}>
            Save
          </button>
          <button onClick={onCancel}
            style={{ padding: "7px 12px", background: "none", color: "#0c0a09", border: "1px solid #d6d3cf", borderRadius: "3px", fontSize: "10px", fontFamily: "inherit", cursor: "pointer" }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── DetailCard avec REXs ────────────────────────────────────────────────
function DetailCard({ detail, index, aiRelevance, earlyStage }) {
  const [expanded, setExpanded] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [rex, setRex] = useState(() => getRex()[detail.id] || []);
  const alertLevel = getAlertLevel(detail.id, detail.categorie);

  const refreshRex = () => {
    setRex(getRex()[detail.id] || []);
    setShowForm(false);
  };

  const severiteColor = { mineur: "#f59e0b", majeur: "#f97316", critique: "#dc2626" };
  const severiteLabel = { mineur: "Minor", majeur: "Major", critique: "Critical" };

  const borderColor = alertLevel === "rouge" ? "#dc2626" : alertLevel === "orange" ? "#f97316" : "#292524";

  return (
    <div style={{ border: `1px solid ${borderColor}`, background: "#ffffff", borderRadius: "5px", overflow: "hidden", animation: `fadeUp 0.4s ease ${index * 100}ms both`, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>

      {/* Alerte REX — bandeau */}
      {alertLevel && (
        <div style={{
          padding: "6px 14px",
          background: alertLevel === "rouge" ? "#fef2f2" : alertLevel === "orange" ? "#fff7ed" : "#fefce8",
          display: "flex", alignItems: "center", gap: "8px"
        }}>
          <span style={{
            fontSize: "10px", fontWeight: 700,
            color: alertLevel === "rouge" ? "#dc2626" : alertLevel === "orange" ? "#f97316" : "#f59e0b"
          }}>
            {alertLevel === "rouge" ? "⚠ Agency REX — this exact detail" :
              alertLevel === "orange" ? "⚡ Community REX — this node type" :
                "○ Agency REX — same construction family"}
          </span>
          <span style={{ fontSize: "9px", color: "#0c0a09" }}>— see Details</span>
        </div>
      )}

      {earlyStage ? (
        /* Mode grande échelle — image grande + titre en évidence */
        <div>
          <div style={{ height: "180px", overflow: "hidden", background: "#f5f4f2", position: "relative" }}>
            <img src={detail.thumbnail} alt="" style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.85 }} />
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top, rgba(0,0,0,0.5) 0%, transparent 60%)" }} />
            <div style={{ position: "absolute", bottom: "12px", left: "14px", right: "14px" }}>
              <p style={{ fontFamily: "'Fraunces', serif", fontSize: "15px", fontWeight: 300, color: "#ffffff", marginBottom: "2px", lineHeight: 1.3 }}>{detail.title}</p>
              <p style={{ fontSize: "10px", color: "rgba(255,255,255,0.7)" }}>{detail.systeme}</p>
            </div>
          </div>
          <div style={{ padding: "14px 18px" }}>
            {aiRelevance && (
              <p style={{ fontSize: "10px", color: "#b45309", marginBottom: "8px", lineHeight: 1.6 }}>
                → {aiRelevance}
              </p>
            )}
            <p style={{ fontSize: "11px", color: "#44403c", lineHeight: 1.8, marginBottom: "10px" }}>{detail.description}</p>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span style={{ fontSize: "9px", color: "#a8a29e" }}>{detail.source}</span>
              <a href={`mailto:hello@xdetail.com?subject=Feedback on: ${detail.title}`}
                style={{ fontSize: "10px", color: "#a8a29e", textDecoration: "none", borderBottom: "1px dashed #d6d3cf", paddingBottom: "1px", marginLeft: "auto" }}>
                Share thoughts
              </a>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ display: "flex" }}>
          <img src={detail.thumbnail} alt="" style={{ width: "110px", flexShrink: 0, objectFit: "cover", opacity: 0.85, background: "#f5f4f2" }} />
          <div style={{ flex: 1, padding: "15px 18px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "6px" }}>
              <div>
                <p style={{ fontFamily: "'Fraunces', serif", fontSize: "14px", fontWeight: 300, color: "#0c0a09", marginBottom: "2px" }}>{detail.title}</p>
                <p style={{ fontSize: "10px", color: "#78716c" }}>{detail.systeme}</p>
              </div>
              <Badge>{detail.fabricant}</Badge>
            </div>
            <p style={{ fontSize: "11px", color: "#44403c", lineHeight: 1.75, marginBottom: "10px" }}>{detail.description}</p>
            {aiRelevance && (
              <p style={{ fontSize: "10px", color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "3px", padding: "4px 10px", marginBottom: "10px", lineHeight: 1.6 }}>
                ↗ {aiRelevance}
              </p>
            )}
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
              <button onClick={() => setExpanded(!expanded)}
                style={{ fontSize: "10px", color: "#0c0a09", background: "none", border: "1px solid #d6d3cf", borderRadius: "3px", padding: "4px 12px", cursor: "pointer", fontFamily: "inherit" }}
                onMouseOver={e => { e.target.style.color = "#e7e5e4"; e.target.style.borderColor = "#57534e"; }}
                onMouseOut={e => { e.target.style.color = "#57534e"; e.target.style.borderColor = "#292524"; }}>
                {expanded ? "↑ Collapse" : "↓ Details"}
              </button>
              <a href={`mailto:hello@xdetail.com?subject=Feedback on: ${detail.title}&body=Detail: ${detail.title}%0A%0AYour feedback:%0A`}
                style={{ fontSize: "10px", color: "#a8a29e", textDecoration: "none", borderBottom: "1px dashed #d6d3cf", paddingBottom: "1px" }}>
                Share thoughts
              </a>
              <span style={{ fontSize: "10px", color: "#0c0a09" }}>{detail.source}</span>
            </div>
          </div>
        </div>
      )}

      {/* Détails matériaux + points clés */}
      {expanded && (
        <div style={{ borderTop: "1px solid #e5e2de", padding: "16px 18px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "28px", marginBottom: "24px" }}>
            <div>
              <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>Materials</p>
              {detail.materiaux.map((m, i) => <p key={i} style={{ fontSize: "11px", color: "#0c0a09", marginBottom: "4px" }}><span style={{ color: "#0c0a09" }}>— </span>{m}</p>)}
            </div>
            <div>
              <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>Key points</p>
              {detail.points_cles.map((p, i) => <p key={i} style={{ fontSize: "11px", color: "#0c0a09", marginBottom: "4px" }}><span style={{ color: "#f59e0b" }}>! </span>{p}</p>)}
            </div>
          </div>

          {/* Liste des REXs existantes */}
          {rex.length > 0 && (
            <div style={{ borderTop: "1px solid #e5e2de", paddingTop: "14px" }}>
              <p style={{ fontSize: "9px", color: "#dc2626", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>
                Agency REX — {rex.length}
              </p>
              {rex.map((m) => (
                <div key={m.id} style={{ background: "#120a0a", border: "1px solid #2a1010", borderRadius: "3px", padding: "10px 12px", marginBottom: "8px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "4px" }}>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      <span style={{ fontSize: "9px", fontWeight: 700, color: severiteColor[m.severite] }}>
                        {severiteLabel[m.severite].toUpperCase()}
                      </span>
                      {m.categorie_rex && (
                        <span style={{ fontSize: "9px", color: "#0c0a09" }}>{m.categorie_rex}</span>
                      )}
                    </div>
                    <button onClick={() => { deleteRex(detail.id, m.id); refreshRex(); }}
                      style={{ fontSize: "9px", color: "#0c0a09", background: "none", border: "none", cursor: "pointer", fontFamily: "inherit" }}>
                      ✕
                    </button>
                  </div>
                  <p style={{ fontSize: "10px", color: "#f87171", lineHeight: 1.6, marginBottom: "4px" }}>{m.description}</p>
                  <p style={{ fontSize: "9px", color: "#0c0a09" }}>
                    {m.projet && `${m.projet} — `}{new Date(m.date).toLocaleDateString("fr-FR")}
                  </p>
                </div>
              ))}
            </div>
          )}

          {/* REX communautaires */}
          {(() => {
            const comm = getRexCommPourDetail(detail.id, detail.categorie);
            if (comm.length === 0) return null;
            return (
              <div style={{ borderTop: "1px solid #e5e2de", paddingTop: "14px", marginTop: rex.length > 0 ? "0" : "0" }}>
                <p style={{ fontSize: "9px", color: "#f97316", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>
                  Community REX — {comm.length} report{comm.length > 1 ? "s" : ""}
                </p>
                {comm.map((r, i) => (
                  <div key={i} style={{ background: "#0f0a04", border: "1px solid #2a1a04", borderRadius: "3px", padding: "10px 12px", marginBottom: "8px" }}>
                    <div style={{ display: "flex", gap: "8px", alignItems: "center", marginBottom: "4px" }}>
                      <span style={{ fontSize: "9px", fontWeight: 700, color: r.severite === "critique" ? "#dc2626" : r.severite === "majeur" ? "#f97316" : "#f59e0b" }}>
                        {r.severite?.toUpperCase()}
                      </span>
                      <span style={{ fontSize: "9px", color: "#0c0a09" }}>{r.categorie_rex}</span>
                      <span style={{ fontSize: "8px", color: "#0c0a09", marginLeft: "auto" }}>Anonymous</span>
                    </div>
                    <p style={{ fontSize: "10px", color: "#c2864a", lineHeight: 1.6 }}>{r.description}</p>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>
      )}

      {/* Formulaire REX */}
      {showForm && <FormRex detailId={detail.id} onSave={refreshRex} onCancel={() => setShowForm(false)} />}
    </div>
  );
}

// ─── Étape d'analyse ─────────────────────────────────────────────────────────
function Step({ label, done, active }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: "12px", color: done ? "#a8a29e" : active ? "#f59e0b" : "#44403c", transition: "color 0.3s" }}>
      <div style={{
        width: "18px", height: "18px", borderRadius: "50%",
        border: `1px solid ${done ? "#57534e" : active ? "#f59e0b" : "#292524"}`,
        display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px", flexShrink: 0,
        background: done ? "#1c1917" : "transparent", transition: "all 0.3s",
      }}>
        {done ? "✓" : active ? "·" : ""}
      </div>
      <span style={{ fontSize: "12px" }}>{label}</span>
    </div>
  );
}


// ─── Nœud Zoom ───────────────────────────────────────────────────────────────




// ─── Réponse technique + Anecdote ────────────────────────────────────────────
function ReponseBlock({ reponse, anecdote, question }) {
  if (!reponse && !anecdote) return null;
  return (
    <div style={{ marginBottom: "28px" }}>
      {/* Réponse technique */}
      {reponse && (
        <div style={{ marginBottom: "20px", padding: "20px 24px", background: "#fafaf9", border: "1px solid #e5e2de", borderRadius: "4px" }}>
          <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "12px" }}>
            Response
          </p>
          {question && (
            <p style={{ fontSize: "11px", color: "#f59e0b", fontStyle: "italic", marginBottom: "10px" }}>
              "{question}"
            </p>
          )}
          <p style={{ fontSize: "13px", color: "#1c1917", lineHeight: 1.85 }}>
            {reponse}
          </p>
        </div>
      )}
      {/* Anecdote */}
      {anecdote && (
        <div style={{ padding: "18px 24px", borderLeft: "3px solid #f59e0b", background: "#fffdf7" }}>
          <p style={{ fontSize: "9px", color: "#d97706", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>
            — Anecdote
          </p>
          <p style={{ fontSize: "12px", color: "#44403c", lineHeight: 1.85, fontStyle: "italic" }}>
            {anecdote}
          </p>
        </div>
      )}
    </div>
  );
}

// ─── Détail de principe SVG ───────────────────────────────────────────────────
function DiagramPrincipe({ description, onGenerate, diagram }) {
  if (!description) return null;

  return (
    <div style={{ marginBottom: "28px", border: "1px solid #e5e2de", borderRadius: "4px", overflow: "hidden" }}>
      <div style={{ padding: "14px 18px", borderBottom: "1px solid #e5e2de", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", margin: 0 }}>
          Principle diagram
        </p>
        <span style={{ fontSize: "9px", color: "#d6d3cf" }}>No products — no brands</span>
      </div>
      {!diagram ? (
        <div style={{ padding: "24px 18px", textAlign: "center" }}>
          <p style={{ fontSize: "11px", color: "#57534e", lineHeight: 1.7, marginBottom: "16px", fontStyle: "italic" }}>
            {description}
          </p>
          <button onClick={onGenerate}
            style={{ fontSize: "11px", color: "#0c0a09", background: "none", border: "1px solid #0c0a09", borderRadius: "3px", padding: "8px 20px", cursor: "pointer", fontFamily: "inherit" }}>
            Generate diagram →
          </button>
        </div>
      ) : (
        <div style={{ padding: "18px" }}
          dangerouslySetInnerHTML={{ __html: diagram }}
        />
      )}
    </div>
  );
}

// ─── Questions to consider ───────────────────────────────────────────────────
function QuestionsBlock({ questions, echelle }) {
  const [expanded, setExpanded] = useState(true);
  if (!questions || questions.length === 0) return null;

  const isEarly = echelle.includes("1/500") || echelle.includes("1/200");
  const isMid = echelle.includes("1/100") || echelle.includes("1/50");

  const label = isEarly
    ? "Questions to open the field"
    : isMid
      ? "Questions to guide precision"
      : "Questions to check before detailing";

  const accent = isEarly ? "#6ee7b7" : isMid ? "#93c5fd" : "#f59e0b";

  return (
    <div style={{ marginBottom: "28px", borderLeft: `2px solid ${accent}`, paddingLeft: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: expanded ? "14px" : "0", cursor: "pointer" }}
        onClick={() => setExpanded(!expanded)}>
        <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", margin: 0 }}>
          {label}
        </p>
        <span style={{ fontSize: "10px", color: "#a8a29e" }}>{expanded ? "↑" : "↓"}</span>
      </div>
      {expanded && (
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {questions.map((q, i) => (
            <div key={i} style={{ display: "flex", gap: "10px", alignItems: "flex-start" }}>
              <span style={{ color: accent, fontSize: "12px", flexShrink: 0, marginTop: "1px" }}>?</span>
              <p style={{ fontSize: "12px", color: "#44403c", lineHeight: 1.75, fontStyle: "italic", margin: 0 }}>
                {q}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ─── Divisare Links — inspiration mode ───────────────────────────────────────
function DivisareLinks({ keywords, noeuds, systeme }) {
  // Construire des queries intelligentes depuis l'analyse Claude
  const buildQueries = () => {
    const queries = [];
    const combined = [
      ...(keywords || []),
      systeme || "",
      ...(noeuds || []).map(n => typeof n === "object" ? n.label : n),
    ].join(" ").toLowerCase();

    // Mapping mots-clés → queries Divisare + Archdaily
    const mappings = [
      { trigger: ["bois", "timber", "wood", "ossature bois", "claire-voie"], query: "timber architecture", label: "Timber buildings" },
      { trigger: ["béton", "concrete", "brut"], query: "concrete architecture", label: "Concrete buildings" },
      { trigger: ["acier", "steel", "métal", "metal"], query: "steel architecture", label: "Steel structures" },
      { trigger: ["pierre", "stone", "masonry", "maçonnerie"], query: "stone architecture", label: "Stone masonry" },
      { trigger: ["façade", "facade", "envelope", "enveloppe"], query: "facade architecture", label: "Facade design" },
      { trigger: ["toiture", "roof", "toit"], query: "roof architecture", label: "Roof design" },
      { trigger: ["logement", "housing", "résidentiel", "residential"], query: "housing architecture", label: "Housing projects" },
      { trigger: ["public", "équipement", "cultural", "culturel"], query: "public building architecture", label: "Public buildings" },
      { trigger: ["vitrage", "glass", "glazing", "verre"], query: "glass facade architecture", label: "Glass facades" },
      { trigger: ["extension", "addition", "rénovation", "renovation"], query: "extension renovation architecture", label: "Extensions & renovations" },
      { trigger: ["ossature", "structure", "frame"], query: "structural architecture", label: "Structural expression" },
      { trigger: ["compact", "masse", "volume", "massing"], query: "compact volume architecture", label: "Massing studies" },
    ];

    mappings.forEach(({ trigger, query, label }) => {
      if (trigger.some(t => combined.includes(t))) {
        queries.push({ query, label });
      }
    });

    // Toujours ajouter une query générale basée sur le système
    if (systeme && queries.length === 0) {
      queries.push({ query: systeme.split(" ").slice(0, 3).join(" ") + " architecture", label: "Similar projects" });
    }

    // Fallback
    if (queries.length === 0) {
      queries.push({ query: "contemporary architecture", label: "Contemporary references" });
    }

    return queries.slice(0, 4);
  };

  const queries = buildQueries();

  const platforms = [
    { name: "Divisare", base: "https://divisare.com/search?q=", color: "#0c0a09", icon: "D" },
    { name: "Archdaily", base: "https://www.archdaily.com/search/projects?q=", color: "#e63312", icon: "A" },
  ];

  return (
    <div>
      {queries.map((q, i) => (
        <div key={i} style={{ marginBottom: "12px" }}>
          <p style={{ fontSize: "11px", color: "#44403c", marginBottom: "6px", fontWeight: 500 }}>
            {q.label}
          </p>
          <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
            {platforms.map(p => (
              <a key={p.name}
                href={`${p.base}${encodeURIComponent(q.query)}`}
                target="_blank" rel="noopener noreferrer"
                style={{
                  fontSize: "10px", padding: "5px 12px",
                  border: "1px solid #e5e2de", borderRadius: "3px",
                  color: "#57534e", textDecoration: "none",
                  display: "flex", alignItems: "center", gap: "5px",
                  background: "#ffffff", transition: "all 0.15s",
                }}
                onMouseEnter={e => { e.currentTarget.style.borderColor = "#a8a29e"; e.currentTarget.style.color = "#0c0a09"; }}
                onMouseLeave={e => { e.currentTarget.style.borderColor = "#e5e2de"; e.currentTarget.style.color = "#57534e"; }}>
                <span style={{
                  width: "14px", height: "14px", borderRadius: "2px",
                  background: p.color, color: "#fff",
                  fontSize: "8px", fontWeight: 700,
                  display: "flex", alignItems: "center", justifyContent: "center",
                  flexShrink: 0,
                }}>{p.icon}</span>
                {p.name} →
              </a>
            ))}
          </div>
        </div>
      ))}
      <p style={{ fontSize: "9px", color: "#d6d3cf", marginTop: "14px", fontStyle: "italic" }}>
        Links open project databases filtered by your drawing's system
      </p>
    </div>
  );
}

function NoeudZoom({ imageUrl, noeuds, onSelectNoeud, activeNoeud, results }) {
  const [thumbIndex, setThumbIndex] = useState(0);

  // Couleurs pour chaque nœud
  const COLORS = ["#f59e0b", "#6ee7b7", "#93c5fd", "#f87171", "#c4b5fd", "#fdba74"];

  // Position des pastilles sur l'image (en %)
  const positionMap = {
    "haut-gauche": { left: "20%", top: "20%" },
    "haut-centre": { left: "50%", top: "15%" },
    "haut-droite": { left: "80%", top: "20%" },
    "centre-gauche": { left: "15%", top: "50%" },
    "centre": { left: "50%", top: "50%" },
    "centre-droite": { left: "85%", top: "50%" },
    "bas-gauche": { left: "20%", top: "80%" },
    "bas-centre": { left: "50%", top: "85%" },
    "bas-droite": { left: "80%", top: "80%" },
  };

  // Matching élargi — catégorie + tags + mots-clés du label
  const getMatchingDetails = (noeud) => {
    if (!noeud || !results) return [];
    const label = noeud.label?.toLowerCase() || "";
    const desc = noeud.description?.toLowerCase() || "";
    const combined = label + " " + desc;

    // Mots-clés extraits du label
    const keywords = combined.split(/[\s\-\/,]+/).filter(w => w.length > 3);

    const scored = results.map(d => {
      let score = 0;
      // Match tags
      d.tags?.forEach(t => { if (combined.includes(t.toLowerCase())) score += 3; });
      // Match catégorie
      if (combined.includes(d.categorie?.replace("_", " "))) score += 5;
      // Match titre
      keywords.forEach(kw => { if (d.title?.toLowerCase().includes(kw)) score += 2; });
      // Match description
      keywords.forEach(kw => { if (d.description?.toLowerCase().includes(kw)) score += 1; });
      return { ...d, score };
    });

    return scored
      .filter(d => d.score > 0)
      .sort((a, b) => b.score - a.score)
      .slice(0, 12);
  };

  const matchingDetails = activeNoeud ? getMatchingDetails(activeNoeud) : [];

  const handleSelectNoeud = (n) => {
    setThumbIndex(0);
    onSelectNoeud(n);
  };

  const currentDetail = matchingDetails[thumbIndex];
  const activeColor = activeNoeud ? COLORS[noeuds.findIndex(n => n.label === activeNoeud.label) % COLORS.length] : "#f59e0b";

  return (
    <div style={{ borderTop: "1px solid #e5e2de", paddingTop: "14px" }}>
      <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>
        Junctions — click to see references
      </p>

      {/* Boutons nœuds */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px" }}>
        {noeuds.map((n, i) => {
          const isActive = activeNoeud?.label === n.label;
          const color = COLORS[i % COLORS.length];
          return (
            <button key={i} onClick={() => handleSelectNoeud(isActive ? null : n)}
              style={{
                background: isActive ? "rgba(255,255,255,0.04)" : "none",
                border: `1px solid ${isActive ? color : "#292524"}`,
                borderRadius: "3px", padding: "4px 12px", cursor: "pointer",
                fontFamily: "inherit", fontSize: "10px",
                color: isActive ? color : "#78716c", transition: "all 0.2s",
                display: "flex", alignItems: "center", gap: "6px",
              }}>
              <span style={{ width: "7px", height: "7px", borderRadius: "50%", background: color, display: "inline-block", flexShrink: 0 }} />
              {n.label}
            </button>
          );
        })}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", alignItems: "start" }}>

        {/* Colonne gauche — image avec pastilles */}
        <div>
          <p style={{ fontSize: "8px", color: "#0c0a09", textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: "6px" }}>
            Your drawing
          </p>
          <div style={{ position: "relative", borderRadius: "3px", overflow: "hidden", border: "1px solid #d6d3cf" }}>
            <img src={imageUrl} alt="" style={{ width: "100%", display: "block", opacity: 0.75 }} />
            {/* Pastilles superposées */}
            {noeuds.map((n, i) => {
              const pos = positionMap[n.position] || { left: "50%", top: "50%" };
              const color = COLORS[i % COLORS.length];
              const isActive = activeNoeud?.label === n.label;
              return (
                <div key={i} onClick={() => handleSelectNoeud(isActive ? null : n)}
                  style={{
                    position: "absolute",
                    left: pos.left, top: pos.top,
                    transform: "translate(-50%, -50%)",
                    width: isActive ? "22px" : "16px",
                    height: isActive ? "22px" : "16px",
                    borderRadius: "50%",
                    background: color,
                    border: isActive ? `2px solid #fff` : "2px solid rgba(0,0,0,0.5)",
                    cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: "9px", fontWeight: 700, color: "#000",
                    transition: "all 0.2s",
                    boxShadow: isActive ? `0 0 10px ${color}` : "none",
                    zIndex: isActive ? 10 : 5,
                  }}>
                  {i + 1}
                </div>
              );
            })}
          </div>
          {activeNoeud && (
            <div style={{ marginTop: "8px" }}>
              <p style={{ fontSize: "10px", color: activeColor, fontWeight: 600, marginBottom: "2px" }}>{activeNoeud.label}</p>
              <p style={{ fontSize: "9px", color: "#0c0a09", lineHeight: 1.6 }}>{activeNoeud.description}</p>
            </div>
          )}
        </div>

        {/* Colonne droite — références défilantes */}
        <div>
          <p style={{ fontSize: "8px", color: "#0c0a09", textTransform: "uppercase", letterSpacing: "0.12em", marginBottom: "6px" }}>
            {activeNoeud
              ? matchingDetails.length > 0
                ? `References — ${thumbIndex + 1} / ${matchingDetails.length}`
                : "No references found"
              : "Select a junction"}
          </p>

          {currentDetail ? (
            <>
              <div style={{
                height: "180px", borderRadius: "3px", overflow: "hidden",
                border: `1px solid ${activeColor}40`, marginBottom: "8px",
                background: "#f5f4f2", position: "relative",
              }}>
                <img src={currentDetail.thumbnail} alt={currentDetail.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.85, transition: "opacity 0.3s" }} />
                {/* Flèches */}
                {matchingDetails.length > 1 && (
                  <div style={{ position: "absolute", bottom: "6px", right: "6px", display: "flex", gap: "4px" }}>
                    <button onClick={() => setThumbIndex(i => Math.max(0, i - 1))}
                      disabled={thumbIndex === 0}
                      style={{
                        width: "26px", height: "26px", background: "rgba(0,0,0,0.5)",
                        border: "1px solid #44403c", borderRadius: "2px", cursor: thumbIndex === 0 ? "default" : "pointer",
                        color: thumbIndex === 0 ? "#292524" : "#e7e5e4", fontSize: "12px",
                        fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center",
                      }}>‹</button>
                    <button onClick={() => setThumbIndex(i => Math.min(matchingDetails.length - 1, i + 1))}
                      disabled={thumbIndex === matchingDetails.length - 1}
                      style={{
                        width: "26px", height: "26px", background: "rgba(0,0,0,0.5)",
                        border: "1px solid #44403c", borderRadius: "2px", cursor: thumbIndex === matchingDetails.length - 1 ? "default" : "pointer",
                        color: thumbIndex === matchingDetails.length - 1 ? "#292524" : "#e7e5e4", fontSize: "12px",
                        fontFamily: "inherit", display: "flex", alignItems: "center", justifyContent: "center",
                      }}>›</button>
                  </div>
                )}
                {/* Pastilles navigation */}
                {matchingDetails.length > 1 && (
                  <div style={{ position: "absolute", bottom: "8px", left: "8px", display: "flex", gap: "3px", flexWrap: "wrap", maxWidth: "60%" }}>
                    {matchingDetails.map((_, idx) => (
                      <div key={idx} onClick={() => setThumbIndex(idx)}
                        style={{
                          width: idx === thumbIndex ? "12px" : "5px", height: "5px",
                          borderRadius: "3px", cursor: "pointer",
                          background: idx === thumbIndex ? activeColor : "#44403c",
                          transition: "all 0.2s",
                        }} />
                    ))}
                  </div>
                )}
              </div>
              <p style={{ fontSize: "10px", color: "#0c0a09", marginBottom: "2px", lineHeight: 1.4 }}>{currentDetail.title}</p>
              <p style={{ fontSize: "9px", color: "#0c0a09" }}>{currentDetail.source}</p>
            </>
          ) : (
            <div style={{
              height: "180px", border: "1px solid #e5e2de", borderRadius: "3px",
              display: "flex", alignItems: "center", justifyContent: "center",
            }}>
              <p style={{ fontSize: "10px", color: "#0c0a09", textAlign: "center" }}>
                {activeNoeud ? "No references found" : "← Select a junction"}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Variantes accordéon ─────────────────────────────────────────────────────
function VariantesAccordeon({ variantes }) {
  const [open, setOpen] = useState(0);
  const colors_num = ["#f59e0b", "#6ee7b7", "#93c5fd"];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {variantes.map((v, i) => (
        <div key={i} style={{ border: `1px solid ${open === i ? "#44403c" : "#1c1917"}`, borderRadius: "4px", overflow: "hidden", transition: "border-color 0.2s" }}>
          {/* Header accordéon */}
          <button
            onClick={() => setOpen(open === i ? -1 : i)}
            style={{
              width: "100%", display: "flex", alignItems: "center", gap: "12px",
              padding: "12px 14px", background: open === i ? "#1c1917" : "#0a0807",
              border: "none", cursor: "pointer", textAlign: "left", fontFamily: "inherit",
              transition: "background 0.2s",
            }}
          >
            <span style={{ fontSize: "16px", fontWeight: 700, color: colors_num[i], fontFamily: "inherit", minWidth: "24px" }}>
              {String(v.numero).padStart(2, "0")}
            </span>
            <span style={{ fontSize: "12px", color: "#0c0a09", flex: 1 }}>{v.titre}</span>
            <span style={{ fontSize: "10px", color: "#0c0a09" }}>{open === i ? "↑" : "↓"}</span>
          </button>

          {/* Contenu accordéon */}
          {open === i && (
            <div style={{ padding: "16px 14px", background: "#0d0b09" }}>
              {v.principe && (
                <p style={{ fontSize: "11px", color: "#0c0a09", lineHeight: 1.75, marginBottom: "14px" }}>{v.principe}</p>
              )}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px", marginBottom: "12px" }}>
                {v.avantages?.length > 0 && (
                  <div>
                    <p style={{ fontSize: "9px", color: "#059669", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "6px" }}>Advantages</p>
                    {v.avantages.map((a, j) => <p key={j} style={{ fontSize: "10px", color: "#6ee7b7", marginBottom: "3px" }}>+ {a}</p>)}
                  </div>
                )}
                {v.inconvenients?.length > 0 && (
                  <div>
                    <p style={{ fontSize: "9px", color: "#dc2626", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "6px" }}>Drawbacks</p>
                    {v.inconvenients.map((inc, j) => <p key={j} style={{ fontSize: "10px", color: "#f87171", marginBottom: "3px" }}>— {inc}</p>)}
                  </div>
                )}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px" }}>
                {v.materiaux?.length > 0 && (
                  <div>
                    <p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "6px" }}>Materials</p>
                    {v.materiaux.map((m, j) => <p key={j} style={{ fontSize: "10px", color: "#0c0a09", marginBottom: "3px" }}>— {m}</p>)}
                  </div>
                )}
                {v.dimensions_cles?.length > 0 && (
                  <div>
                    <p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "6px" }}>Key dimensions</p>
                    {v.dimensions_cles.map((d, j) => <p key={j} style={{ fontSize: "10px", color: "#0c0a09", marginBottom: "3px" }}>— {d}</p>)}
                  </div>
                )}
                {v.dtu_applicables?.length > 0 && (
                  <div>
                    <p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "6px" }}>Standards</p>
                    {v.dtu_applicables.map((d, j) => <p key={j} style={{ fontSize: "10px", color: "#f59e0b", marginBottom: "3px" }}>— {d}</p>)}
                  </div>
                )}
              </div>
              {v.points_attention?.length > 0 && (
                <div style={{ marginTop: "10px", padding: "8px 10px", background: "#1a0a0a", borderRadius: "3px", border: "1px solid #d6d3cf" }}>
                  <p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "6px" }}>Attention points</p>
                  {v.points_attention.map((p, j) => <p key={j} style={{ fontSize: "10px", color: "#f87171", marginBottom: "3px" }}>! {p}</p>)}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

// ─── App ──────────────────────────────────────────────────────────────────────
export default function App() {
  const [stage, setStage] = useState("upload");
  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [context, setContext] = useState("");
  const [analysisStep, setAnalysisStep] = useState(0);
  const [aiAnalysis, setAiAnalysis] = useState(null);
  const [results, setResults] = useState([]);
  const [activeNoeud, setActiveNoeud] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [currentEchelle, setCurrentEchelle] = useState("");
  const [dragOver, setDragOver] = useState(false);
  const [error, setError] = useState(null);
  const [projetType, setProjetType] = useState("");
  const [travauxType, setTravauxType] = useState("");
  const [region, setRegion] = useState("");
  const [performance, setPerformance] = useState("");
  const [mode, setMode] = useState("trouver");
  const [echelle, setEchelle] = useState("");
  const [userQuestion, setUserQuestion] = useState("");
  const [images, setImages] = useState([]); // [{url, name, file}]
  const [diagram, setDiagram] = useState(null);
  const [generatingDiagram, setGeneratingDiagram] = useState(false);
  const [problemDescription, setProblemDescription] = useState("");
  const [zoneProblem, setZoneProblem] = useState("");
  const [materiauSouhaite, setMateriauSouhaite] = useState("");
  const [contrainte, setConstraint] = useState("");
  const fileRef = useRef();

  const handleFile = useCallback((file) => {
    if (!file || !file.type.startsWith("image/")) return;
    const url = URL.createObjectURL(file);
    setImages(prev => {
      const next = [...prev, { file, url, name: file.name }];
      // Toujours garder image/imageUrl sur le premier fichier pour compatibilité
      setImage(next[0].file);
      setImageUrl(next[0].url);
      return next;
    });
    setError(null);
    setStage("context");
  }, []);

  const runAnalysis = async () => {
    setStage("analyzing");
    setAnalysisStep(1);
    setError(null);
    setCurrentEchelle(echelle);
    try {
      // Convertir TOUTES les images en base64
      const imagesData = await Promise.all(
        images.map(async (img) => ({
          base64: await fileToBase64(img.file),
          mediaType: img.file.type || "image/jpeg",
        }))
      );

      const contextFind = [
        userQuestion && `Architect's question: ${userQuestion}`,
        echelle && `Drawing scale: ${echelle}`,
        projetType && `Project type: ${projetType}`,
        materiauSouhaite && `Preferred material: ${materiauSouhaite}`,
        context && `Additional notes: ${context}`,
        images.length > 1 && `${images.length} drawings provided — analyze all of them together.`,
      ].filter(Boolean).join("\n");

      const contextResoudre = [
        echelle && `Drawing scale: ${echelle}`,
        problemDescription && `Problem to solve: ${problemDescription}`,
        zoneProblem && `Zone / interface concerned: ${zoneProblem}`,
        materiauSouhaite && `Preferred material or system: ${materiauSouhaite}`,
        contrainte && `Main constraint: ${contrainte}`,
        projetType && `Project type: ${projetType}`,
        region && `Geographic zone: ${region}`,
        performance && `Performance level: ${performance}`,
        context && `Additional notes: ${context}`,
        images.length > 1 && `${images.length} drawings provided — analyze all of them together.`,
      ].filter(Boolean).join("\n");

      setAnalysisStep(2);

      if (mode === "resoudre") {
        const [analysisResoudre, analysisFind] = await Promise.all([
          analyzeSketchWithClaude(imagesData, contextResoudre, "resoudre"),
          analyzeSketchWithClaude(imagesData, contextFind, "trouver"),
        ]);
        setAiAnalysis({ ...analysisResoudre, _trouver: analysisFind });
        setAnalysisStep(3);
        await new Promise((r) => setTimeout(r, 500));
        const matched = matchDetailsByAI(analysisFind);
        setAnalysisStep(4);
        await new Promise((r) => setTimeout(r, 400));
        setResults(matched);
      } else {
        const analysis = await analyzeSketchWithClaude(imagesData, contextFind, "trouver");
        if (analysis.not_architecture) {
          setAiAnalysis(analysis);
          setStage("not_architecture");
          return;
        }
        setAiAnalysis(analysis);
        setAnalysisStep(3);
        await new Promise((r) => setTimeout(r, 500));
        const matched = matchDetailsByAI(analysis);
        setAnalysisStep(4);
        await new Promise((r) => setTimeout(r, 400));
        setResults(matched);
      }

      setStage("results");
    } catch (err) {
      setError("Analysis error. Check your connection and try again.");
      setStage("context");
    }
  };

  const handleDrop = useCallback((e) => {
    e.preventDefault();
    setDragOver(false);
    Array.from(e.dataTransfer.files).forEach(handleFile);
  }, [handleFile]);

  const reset = () => {
    setStage("upload"); setImage(null); setImageUrl(null); setContext("");
    setProjetType(""); setTravauxType(""); setRegion(""); setPerformance("");
    setProblemDescription(""); setZoneProblem(""); setMateriauSouhaite(""); setConstraint("");
    setMode("trouver"); setAnalysisStep(0); setAiAnalysis(null); setResults([]); setError(null); setUserQuestion(""); setImages([]); setImage(null); setImageUrl(null); setDiagram(null); setStage("upload");
  };

  const removeImage = (idx) => {
    setImages(prev => {
      const next = prev.filter((_, i) => i !== idx);
      if (next.length === 0) { setStage("upload"); return []; }
      setImage(next[0].file);
      setImageUrl(next[0].url);
      return next;
    });
  };

  const selectStyle = (val) => ({
    background: "#fafaf9", border: "1px solid #d6d3cf", borderRadius: "4px",
    padding: "9px 10px", fontSize: "11px", color: val ? "#e7e5e4" : "#57534e", fontFamily: "inherit",
  });

  const inputStyle = {
    width: "100%", background: "#fafaf9", border: "1px solid #d6d3cf",
    borderRadius: "4px", padding: "9px 12px", fontSize: "11px", color: "#0c0a09", fontFamily: "inherit",
  };

  return (
    <div style={{ fontFamily: "'DM Mono', monospace", background: "#ffffff", minHeight: "100vh", color: "#0c0a09", display: "flex", flexDirection: "column" }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=Fraunces:ital,opsz,wght@0,9..144,300;0,9..144,500;1,9..144,300&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { width: 4px; }
        ::-webkit-scrollbar-track { background: #0c0a09; }
        ::-webkit-scrollbar-thumb { background: #44403c; border-radius: 2px; }
        @keyframes fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes blink { 0%,100% { opacity:1; } 50% { opacity:0.2; } }
        .fade-in { animation: fadeUp 0.45s ease both; }
        textarea:focus, input:focus { outline: none; }
        input[type=file] { display: none; }
      `}</style>

      {/* Modal QR code */}
      {showQR && (
        <div onClick={() => setShowQR(false)} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000,
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: "#fff", borderRadius: "12px", padding: "40px",
            display: "flex", flexDirection: "column", alignItems: "center", gap: "20px",
            maxWidth: "320px", width: "90%",
          }}>
            <p style={{ fontSize: "13px", color: "#0c0a09", fontWeight: 600, textAlign: "center", margin: 0 }}>
              Scan to try xdetail
            </p>
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent("https://xdetail.com")}&bgcolor=ffffff&color=1c1917&margin=10`}
              alt="QR code xdetail"
              style={{ width: "200px", height: "200px", borderRadius: "4px" }}
            />
            <p style={{ fontSize: "11px", color: "#0c0a09", textAlign: "center", margin: 0 }}>
              xdetail.com
            </p>
            <button onClick={() => setShowQR(false)} style={{
              fontSize: "11px", color: "#0c0a09", background: "none",
              border: "1px solid #e0d8cc", borderRadius: "4px", padding: "8px 20px",
              cursor: "pointer", fontFamily: "inherit",
            }}>
              Close
            </button>
          </div>
        </div>
      )}

      <header style={{ borderBottom: "1px solid #e5e2de", padding: "18px 40px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "baseline", gap: "14px" }}>
          <span style={{ fontFamily: "'Fraunces', serif", fontSize: "20px", fontWeight: 300, color: "#0c0a09" }}>
            x<span style={{ color: "#f59e0b" }}>detail</span>
          </span>
          <span style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.18em", textTransform: "uppercase" }}>From intent to detail</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button onClick={() => setShowQR(true)}
            style={{ fontSize: "10px", color: "#0c0a09", background: "none", border: "1px solid #e5e2de", borderRadius: "3px", padding: "6px 14px", cursor: "pointer", fontFamily: "inherit", display: "flex", alignItems: "center", gap: "6px" }}
            onMouseOver={e => e.currentTarget.style.borderColor = "#44403c"}
            onMouseOut={e => e.currentTarget.style.borderColor = "#1c1917"}>
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" />
              <rect x="3" y="14" width="7" height="7" /><rect x="14" y="14" width="3" height="3" />
            </svg>
            Share
          </button>
          {stage !== "upload" && (
            <button onClick={reset} style={{ fontSize: "10px", color: "#0c0a09", background: "none", border: "1px solid #e5e2de", borderRadius: "3px", padding: "6px 14px", cursor: "pointer", fontFamily: "inherit" }}
              onMouseOver={e => e.currentTarget.style.borderColor = "#44403c"}
              onMouseOut={e => e.currentTarget.style.borderColor = "#1c1917"}>
              ← New analysis
            </button>
          )}
        </div>
      </header>

      {/* Bandeau feedback */}
      <div style={{
        background: "#fffbeb", borderBottom: "1px solid #fde68a",
        padding: "10px 40px", display: "flex", alignItems: "center", justifyContent: "space-between",
      }}>
        <p style={{ fontSize: "11px", color: "#92400e", margin: 0 }}>
          🛠 xdetail is in early access — your feedback shapes this tool
        </p>
        <a href="mailto:hello@xdetail.com?subject=xdetail%20feedback"
          style={{ fontSize: "11px", color: "#b45309", fontWeight: 600, textDecoration: "none" }}>
          Tell us what you need →
        </a>
      </div>

      <main style={{ maxWidth: "820px", margin: "0 auto", padding: "56px 40px", flex: 1, width: "100%" }}>

        {stage === "upload" && (
          <div className="fade-in">
            <div style={{ marginBottom: "44px" }}>
              <h1 style={{ fontFamily: "'Fraunces', serif", fontSize: "42px", fontWeight: 300, lineHeight: 1.15, marginBottom: "16px", color: "#0c0a09" }}>
                Drop a section or plan.<br />
                <em style={{ color: "#a8a29e", fontStyle: "italic" }}>xdetail opens the field of possibilities.</em>
              </h1>
              <p style={{ fontSize: "13px", color: "#57534e", lineHeight: 1.9, maxWidth: "480px" }}>
                At any scale — from massing to execution detail — xdetail reads your drawing and helps you reach the next level of precision. References, junctions, principles.
              </p>
            </div>
            <div onClick={() => fileRef.current.click()} onDrop={handleDrop}
              onDragOver={(e) => { e.preventDefault(); setDragOver(true); }} onDragLeave={() => setDragOver(false)}
              style={{ border: `1px dashed ${dragOver ? "#f59e0b" : "#292524"}`, borderRadius: "6px", padding: "80px 40px", textAlign: "center", cursor: "pointer", background: dragOver ? "rgba(245,158,11,0.06)" : "#fafaf9", transition: "all 0.2s" }}>
              <input ref={fileRef} type="file" accept="image/*" multiple onChange={(e) => Array.from(e.target.files).forEach(handleFile)} />
              <div style={{ fontSize: "26px", opacity: 0.2, marginBottom: "14px" }}>⊕</div>
              <p style={{ fontSize: "12px", color: "#0c0a09" }}>Drop one or more drawings here, or <span style={{ color: "#0c0a09", textDecoration: "underline" }}>browse</span></p>
              <p style={{ fontSize: "10px", color: "#0c0a09", marginTop: "8px" }}>JPG · PNG — plan, section, sketch — multiple files accepted</p>
            </div>

          </div>
        )}

        {stage === "context" && (
          <div className="fade-in">

            {/* Zone images + question — layout principal */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1.2fr", gap: "40px", alignItems: "start", marginBottom: "24px" }}>

              {/* Colonne gauche — aperçu images */}
              <div>
                <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "10px" }}>
                  {images.length > 1 ? `${images.length} drawings loaded` : "Drawing loaded"}
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {images.map((img, i) => (
                    <div key={i} style={{ position: "relative" }}>
                      <img src={img.url} alt={img.name}
                        style={{ width: "100%", borderRadius: "4px", border: "1px solid #d6d3cf", display: "block", opacity: 0.85 }} />
                      <button onClick={() => removeImage(i)}
                        style={{ position: "absolute", top: "6px", right: "6px", background: "rgba(255,255,255,0.9)", border: "1px solid #d6d3cf", borderRadius: "2px", width: "20px", height: "20px", cursor: "pointer", fontSize: "10px", display: "flex", alignItems: "center", justifyContent: "center", color: "#57534e" }}>
                        ×
                      </button>
                      <p style={{ fontSize: "9px", color: "#a8a29e", marginTop: "4px" }}>{img.name}</p>
                    </div>
                  ))}
                </div>
                {/* Ajouter une image */}
                <button onClick={() => fileRef.current.click()}
                  style={{ marginTop: "10px", fontSize: "10px", color: "#a8a29e", background: "none", border: "1px dashed #d6d3cf", borderRadius: "3px", padding: "6px 14px", cursor: "pointer", fontFamily: "inherit", width: "100%", textAlign: "center" }}>
                  + Add another drawing
                </button>
              </div>

              {/* Colonne droite — question + options */}
              <div>
                <h2 style={{ fontFamily: "'Fraunces', serif", fontSize: "26px", fontWeight: 300, lineHeight: 1.35, marginBottom: "20px", color: "#0c0a09" }}>
                  What's your question?
                </h2>

                {/* Grande zone de question */}
                <textarea
                  value={userQuestion}
                  onChange={(e) => setUserQuestion(e.target.value)}
                  placeholder="Ask anything — e.g. How do I handle this junction? Any timber facade references? What thermal bridge should I anticipate?"
                  style={{
                    ...inputStyle,
                    minHeight: "140px", lineHeight: 1.8, resize: "vertical",
                    fontSize: "13px", padding: "14px 16px",
                    borderColor: userQuestion ? "#f59e0b" : "#d6d3cf",
                    marginBottom: "16px", width: "100%", boxSizing: "border-box",
                  }}
                  onFocus={e => e.target.style.borderColor = "#f59e0b"}
                  onBlur={e => e.target.style.borderColor = userQuestion ? "#f59e0b" : "#d6d3cf"}
                  autoFocus
                />

                {/* Échelle — visible */}
                <select value={echelle} onChange={(e) => setEchelle(e.target.value)} style={{ ...selectStyle(echelle), marginBottom: "12px", width: "100%", boxSizing: "border-box" }}>
                  <option value="">Drawing scale (optional)</option>
                  <optgroup label="Early design">
                    <option value="1/500 — Massing / site plan">1/500 — Massing / site plan</option>
                    <option value="1/200 — General layout (APS)">1/200 — General layout (APS)</option>
                  </optgroup>
                  <optgroup label="Design development">
                    <option value="1/100 — Floor plans / elevations (APD)">1/100 — Floor plans / elevations (APD)</option>
                    <option value="1/50 — Construction drawings (PRO)">1/50 — Construction drawings (PRO)</option>
                  </optgroup>
                  <optgroup label="Detail drawings">
                    <option value="1/20 — Construction detail (PRO/EXE)">1/20 — Construction detail (PRO/EXE)</option>
                    <option value="1/10 — Technical detail (EXE)">1/10 — Technical detail (EXE)</option>
                    <option value="1/5 — Precision detail (EXE)">1/5 — Precision detail (EXE)</option>
                  </optgroup>
                </select>

                {/* Options optionnelles — repliées par défaut */}
                <details style={{ marginBottom: "20px" }}>
                  <summary style={{ fontSize: "10px", color: "#a8a29e", cursor: "pointer", listStyle: "none", display: "flex", alignItems: "center", gap: "6px", marginBottom: "10px" }}>
                    <span>+ More context (optional)</span>
                  </summary>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px", marginTop: "10px" }}>
                    <select value={projetType} onChange={(e) => setProjetType(e.target.value)} style={selectStyle(projetType)}>
                      <option value="">Project type</option>
                      <option>Multi-family housing</option><option>Single-family housing</option>
                      <option>Public building</option><option>Office</option>
                      <option>Cultural facility</option><option>Industrial</option>
                    </select>
                    <select value={materiauSouhaite} onChange={(e) => setMateriauSouhaite(e.target.value)} style={selectStyle(materiauSouhaite)}>
                      <option value="">Material</option>
                      <option>Timber / Wood</option><option>Cross-laminated timber (CLT)</option>
                      <option>Concrete</option><option>Steel</option>
                      <option>Stone / Masonry</option><option>Aluminium</option>
                      <option>Glass</option><option>Mixed — timber + concrete</option>
                      <option>Earth / Rammed earth</option>
                    </select>
                  </div>
                </details>

                {error && <p style={{ fontSize: "11px", color: "#dc2626", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "3px", padding: "10px 14px", marginBottom: "16px", lineHeight: 1.6 }}>{error}</p>}

                {!userQuestion.trim() && (
                  <p style={{ fontSize: "10px", color: "#a8a29e", fontStyle: "italic", marginBottom: "8px", textAlign: "center" }}>
                    Ask a question to continue →
                  </p>
                )}
                <button onClick={userQuestion.trim() ? runAnalysis : undefined}
                  style={{ width: "100%", padding: "14px", background: userQuestion.trim() ? "#0c0a09" : "#e5e2de", color: userQuestion.trim() ? "#ffffff" : "#a8a29e", border: "none", borderRadius: "4px", fontSize: "13px", cursor: userQuestion.trim() ? "pointer" : "default", fontFamily: "inherit", letterSpacing: "0.05em", transition: "all 0.2s" }}
                  onMouseEnter={e => { if (userQuestion.trim()) e.currentTarget.style.background = "#292524"; }}
                  onMouseLeave={e => { if (userQuestion.trim()) e.currentTarget.style.background = "#0c0a09"; }}>
                  Ask xdetail →
                </button>
              </div>
            </div>
          </div>
        )}


        {stage === "analyzing" && (
          <div className="fade-in" style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "80px 0", gap: "48px" }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ width: "6px", height: "6px", background: "#f59e0b", borderRadius: "50%", margin: "0 auto 20px", animation: "blink 1.2s ease-in-out infinite" }} />
              <p style={{ fontFamily: "'Fraunces', serif", fontSize: "28px", fontWeight: 300 }}>
                {"Searching references…"}
              </p>
            </div>
            <div style={{ display: "flex", flexDirection: "column", gap: "18px", width: "340px" }}>
              <Step label="Lecture de l'image" done={analysisStep > 1} active={analysisStep === 1} />
              <Step label="xdetail — identifying junctions" done={analysisStep > 2} active={analysisStep === 2} />
              <Step label="Matching bibliothèque" done={analysisStep > 3} active={analysisStep === 3} />
              <Step label="Génération des propositions" done={analysisStep > 4} active={analysisStep === 4} />
            </div>
          </div>
        )}

        {stage === "not_architecture" && aiAnalysis?.not_architecture && (
          <div className="fade-in" style={{ textAlign: "center", padding: "80px 40px" }}>
            <div style={{ fontSize: "48px", marginBottom: "24px", opacity: 0.4 }}>⊘</div>
            <p style={{ fontFamily: "'Fraunces', serif", fontSize: "22px", fontWeight: 300, color: "#0c0a09", marginBottom: "12px", fontStyle: "italic" }}>
              {aiAnalysis.message || "This doesn't look like a construction drawing."}
            </p>
            <p style={{ fontSize: "12px", color: "#a8a29e", marginBottom: "32px" }}>
              xdetail works with plans, sections, elevations and sketches.
            </p>
            <button onClick={reset}
              style={{ fontSize: "11px", color: "#57534e", background: "none", border: "1px solid #d6d3cf", borderRadius: "3px", padding: "10px 24px", cursor: "pointer", fontFamily: "inherit" }}
              onMouseEnter={e => e.currentTarget.style.borderColor = "#a8a29e"}
              onMouseLeave={e => e.currentTarget.style.borderColor = "#d6d3cf"}>
              ← Try with a drawing
            </button>
          </div>
        )}

        {stage === "results" && (
          <div className="fade-in">
            <div style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "32px", alignItems: "start", marginBottom: "36px" }}>
              <div>
                <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.18em", textTransform: "uppercase", marginBottom: "8px" }}>
                  {results.length} references found
                </p>
                <h2 style={{ fontFamily: "'Fraunces', serif", fontSize: "30px", fontWeight: 300, lineHeight: 1.25, marginBottom: "12px" }}>
                  {aiAnalysis?.userQuestion_echo
                    ? `"${aiAnalysis.userQuestion_echo}"`
                    : (currentEchelle.includes("1/500") || currentEchelle.includes("1/200")
                      ? "Inspirations & references"
                      : "Construction references")}
                </h2>
                {aiAnalysis?.recommandation && !aiAnalysis?.reponse_technique && (
                  <p style={{ fontSize: "12px", color: "#57534e", lineHeight: 1.75, maxWidth: "480px" }}>{aiAnalysis.recommandation}</p>
                )}
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                {images.map((img, i) => (
                  <img key={i} src={img.url} alt={img.name}
                    style={{ width: "90px", borderRadius: "3px", border: "1px solid #e5e2de", opacity: 0.55, display: "block" }} />
                ))}
              </div>
            </div>

            {/* Bloc analyse IA avec nœuds cliquables */}
            {aiAnalysis && (
              <div style={{ background: "#fafaf9", border: "1px solid #e5e2de", borderRadius: "4px", padding: "24px", marginBottom: "32px" }}>
                <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "14px" }}>xdetail Analysis</p>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "28px", marginBottom: "24px" }}>
                  <div>
                    {aiAnalysis.type_document && (<><p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "5px" }}>Document</p><p style={{ fontSize: "11px", color: "#0c0a09", marginBottom: "12px" }}>{aiAnalysis.type_document}</p></>)}
                    {aiAnalysis.systeme_constructif && (<><p style={{ fontSize: "9px", color: "#0c0a09", marginBottom: "5px" }}>Construction system</p><p style={{ fontSize: "11px", color: "#0c0a09" }}>{aiAnalysis.systeme_constructif}</p></>)}
                  </div>

                </div>

                {/* Nœuds cliquables avec zoom image — mode Find */}
                {mode === "trouver" && imageUrl && aiAnalysis.noeuds_identifies?.length > 0 &&
                  aiAnalysis.noeuds_identifies.some(n => typeof n === "object" && n.position) && (
                    <NoeudZoom
                      imageUrl={imageUrl}
                      noeuds={aiAnalysis.noeuds_identifies.filter(n => typeof n === "object")}
                      onSelectNoeud={(noeud) => setActiveNoeud(noeud)}
                      activeNoeud={activeNoeud}
                      results={results}
                    />
                  )}

                {/* Bloc variantes — mode Solve uniquement */}
                {mode === "resoudre" && aiAnalysis.variantes?.length > 0 && (
                  <div style={{ marginTop: "0px", paddingTop: "16px", borderTop: "1px solid #e5e2de" }}>
                    <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "12px" }}>
                      {aiAnalysis.variantes.length} construction variants
                    </p>
                    <VariantesAccordeon variantes={aiAnalysis.variantes} />
                  </div>
                )}
              </div>
            )}

            {/* Réponse technique + anecdote */}
            {(aiAnalysis?.reponse_technique || aiAnalysis?.anecdote) && (
              <ReponseBlock
                reponse={aiAnalysis.reponse_technique}
                anecdote={aiAnalysis.anecdote}
                question={userQuestion}
              />
            )}

            {/* Détail de principe si demandé */}
            {aiAnalysis?.request_diagram && (
              <DiagramPrincipe
                description={aiAnalysis.diagram_description}
                diagram={diagram}
                onGenerate={async () => {
                  setGeneratingDiagram(true);
                  try {
                    const response = await fetch("https://api.anthropic.com/v1/messages", {
                      method: "POST",
                      headers: { "Content-Type": "application/json", "anthropic-version": "2023-06-01", "x-api-key": process.env.REACT_APP_ANTHROPIC_API_KEY },
                      body: JSON.stringify({
                        model: "claude-opus-4-5",
                        max_tokens: 2000,
                        messages: [{
                          role: "user",
                          content: `Génère un schéma de principe SVG pour ce nœud constructif : ${aiAnalysis.diagram_description}.
Règles strictes : pas de marque, pas de produit, couches annotées avec légendes sobres, trait noir sur fond blanc, dimensions indicatives en mm, style technique épuré.
Réponds UNIQUEMENT avec le code SVG complet (viewBox="0 0 400 300"), sans markdown ni explication.`
                        }]
                      })
                    });
                    const data = await response.json();
                    const svg = data.content?.[0]?.text || "";
                    setDiagram(svg);
                  } catch (e) { console.error(e); }
                  setGeneratingDiagram(false);
                }}
              />
            )}

            {/* Questions to consider */}
            {aiAnalysis?.questions?.length > 0 && (
              <QuestionsBlock questions={aiAnalysis.questions} echelle={currentEchelle} />
            )}

            {/* Détails similaires */}
            {results.length > 0 && (
              <>
                {mode === "resoudre" && (
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "14px", paddingTop: "8px", borderTop: "1px solid #e5e2de" }}>
                    <p style={{ fontSize: "9px", color: "#0c0a09", letterSpacing: "0.15em", textTransform: "uppercase" }}>
                      References illustrating this solution
                    </p>
                    <span style={{ fontSize: "9px", color: "#0c0a09" }}>—</span>
                    <span style={{ fontSize: "9px", color: "#0c0a09" }}>from the Detail Magazine library</span>
                  </div>
                )}
                {mode === "trouver" && !currentEchelle.includes("1/500") && !currentEchelle.includes("1/200") && (
                  <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "14px" }}>
                    Suggested details
                  </p>
                )}
                {mode === "trouver" && (currentEchelle.includes("1/500") || currentEchelle.includes("1/200")) && (
                  <div style={{ marginBottom: "28px" }}>
                    <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: "16px" }}>
                      Inspiration — Divisare
                    </p>
                    <DivisareLinks keywords={aiAnalysis?.keywords || []} noeuds={aiAnalysis?.noeuds_identifies || []} systeme={aiAnalysis?.systeme_constructif || ""} />
                    <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.15em", textTransform: "uppercase", marginTop: "28px", marginBottom: "14px" }}>
                      Library references
                    </p>
                  </div>
                )}
                <div style={{ display: "flex", flexDirection: "column", gap: "18px" }}>
                  {results.map((detail, i) => {
                    const matchedNoeud = (aiAnalysis?.noeuds_identifies || []).find((n) => {
                      const label = typeof n === "object" ? n.label : n;
                      return detail.tags.some((t) => label?.toLowerCase().includes(t.toLowerCase()));
                    });
                    const matchedLabel = matchedNoeud ? (typeof matchedNoeud === "object" ? matchedNoeud.label : matchedNoeud) : null;
                    const isEarly = currentEchelle.includes("1/500") || currentEchelle.includes("1/200");
                    return <DetailCard key={detail.id} detail={detail} index={i} aiRelevance={matchedLabel ? `${matchedLabel}` : null} earlyStage={isEarly} />;
                  })}
                </div>
              </>
            )}


          </div>
        )}
      </main>

      <footer style={{ borderTop: "1px solid #e5e2de", padding: "12px 40px", marginTop: "0px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <p style={{ fontSize: "9px", color: "#a8a29e", letterSpacing: "0.1em", margin: 0 }}>xdetail — From intent to detail</p>
        <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
          <span style={{ fontSize: "9px", color: "#a8a29e" }}>Built by Yannis —</span>
          <a href="mailto:hello@xdetail.com"
            style={{ fontSize: "9px", color: "#78716c", textDecoration: "none" }}
            onMouseEnter={e => e.target.style.color = "#0c0a09"}
            onMouseLeave={e => e.target.style.color = "#78716c"}>
            hello@xdetail.com
          </a>
          <a href="https://www.linkedin.com/in/yannismataillet/" target="_blank" rel="noopener noreferrer"
            style={{ fontSize: "9px", color: "#78716c", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}
            onMouseEnter={e => e.currentTarget.style.color = "#0c0a09"}
            onMouseLeave={e => e.currentTarget.style.color = "#78716c"}>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
            LinkedIn
          </a>
        </div>
      </footer>
    </div>
  );
}
